(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ot-client", [], factory);
	else if(typeof exports === 'object')
		exports["ot-client"] = factory();
	else
		root["ot-client"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.js");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/@babel/runtime/helpers/arrayWithoutHoles.js":
/*!******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/arrayWithoutHoles.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

module.exports = _arrayWithoutHoles;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/assertThisInitialized.js":
/*!**********************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/assertThisInitialized.js ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/classCallCheck.js":
/*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/classCallCheck.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/construct.js":
/*!**********************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/construct.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(/*! ./setPrototypeOf */ "./node_modules/@babel/runtime/helpers/setPrototypeOf.js");

function isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (isNativeReflectConstruct()) {
    module.exports = _construct = Reflect.construct;
  } else {
    module.exports = _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

module.exports = _construct;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/createClass.js":
/*!************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/createClass.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/get.js":
/*!****************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/get.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var superPropBase = __webpack_require__(/*! ./superPropBase */ "./node_modules/@babel/runtime/helpers/superPropBase.js");

function _get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    module.exports = _get = Reflect.get;
  } else {
    module.exports = _get = function _get(target, property, receiver) {
      var base = superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return _get(target, property, receiver || target);
}

module.exports = _get;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js":
/*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/getPrototypeOf.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/inherits.js":
/*!*********************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/inherits.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(/*! ./setPrototypeOf */ "./node_modules/@babel/runtime/helpers/setPrototypeOf.js");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/isNativeFunction.js":
/*!*****************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/isNativeFunction.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

module.exports = _isNativeFunction;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/iterableToArray.js":
/*!****************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/iterableToArray.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

module.exports = _iterableToArray;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/nonIterableSpread.js":
/*!******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/nonIterableSpread.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

module.exports = _nonIterableSpread;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js":
/*!**************************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js ***!
  \**************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(/*! ../helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");

var assertThisInitialized = __webpack_require__(/*! ./assertThisInitialized */ "./node_modules/@babel/runtime/helpers/assertThisInitialized.js");

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/setPrototypeOf.js":
/*!***************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/setPrototypeOf.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/superPropBase.js":
/*!**************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/superPropBase.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getPrototypeOf = __webpack_require__(/*! ./getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

module.exports = _superPropBase;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/toConsumableArray.js":
/*!******************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/toConsumableArray.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(/*! ./arrayWithoutHoles */ "./node_modules/@babel/runtime/helpers/arrayWithoutHoles.js");

var iterableToArray = __webpack_require__(/*! ./iterableToArray */ "./node_modules/@babel/runtime/helpers/iterableToArray.js");

var nonIterableSpread = __webpack_require__(/*! ./nonIterableSpread */ "./node_modules/@babel/runtime/helpers/nonIterableSpread.js");

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/typeof.js":
/*!*******************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/typeof.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),

/***/ "./node_modules/@babel/runtime/helpers/wrapNativeSuper.js":
/*!****************************************************************!*\
  !*** ./node_modules/@babel/runtime/helpers/wrapNativeSuper.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var getPrototypeOf = __webpack_require__(/*! ./getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");

var setPrototypeOf = __webpack_require__(/*! ./setPrototypeOf */ "./node_modules/@babel/runtime/helpers/setPrototypeOf.js");

var isNativeFunction = __webpack_require__(/*! ./isNativeFunction */ "./node_modules/@babel/runtime/helpers/isNativeFunction.js");

var construct = __webpack_require__(/*! ./construct */ "./node_modules/@babel/runtime/helpers/construct.js");

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  module.exports = _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return construct(Class, arguments, getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

module.exports = _wrapNativeSuper;

/***/ }),

/***/ "./node_modules/@teamwork/ot-rich-text/lib/Action.js":
/*!***********************************************************!*\
  !*** ./node_modules/@teamwork/ot-rich-text/lib/Action.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Each action is represented by an array.
// The constants below determine what data can be found at each array index.
//
// The attributes are appended to the action array.
// Each attribute occupies 2 indexes. The first is the attribute name and the second is the attribute value.
// The attributes must be sorted in the ascending order by the attribute name.
// Attribute names and values must both be strings, except for operations (as oposed to document snapshots),
// where the attibute value may be `null`, which is interpreted as an instruction to remove the attribute,
// when the operation is applied.
// ACTION_* -> number
var TYPE = 0; // ACTION_INSERT_TEXT -> string, plain text
// ACTION_INSERT_(OPEN|CLOSE|EMBED) -> string, a node id and node name
// ACTION_(RETAIN|DELETE) -> number, number of characters to retain or delete

var CONTENT = 1; // ACTION_RETAIN
// ACTION_INSERT_.*

var ATTRIBUTES = 2; // Action types

var ACTION_DELETE = -1;
var ACTION_RETAIN = 0;
var ACTION_INSERT_TEXT = 1;
var ACTION_INSERT_OPEN = 2;
var ACTION_INSERT_CLOSE = 3;
var ACTION_INSERT_EMBED = 4;

var clone = function clone(action, skipAttributes) {
  var actionLength = action.length;
  var limit = skipAttributes && actionLength > ATTRIBUTES ? ATTRIBUTES : actionLength;
  var newAction = new Array(limit);

  for (var i = 0; i < limit; ++i) {
    newAction[i] = action[i];
  }

  return newAction;
};

var createInsert = function createInsert(type) {
  return function (content, attributes) {
    var actionIndex = ATTRIBUTES;
    var attributeIndex = 0;
    var attributesLength = attributes ? attributes.length : 0;
    var action = new Array(actionIndex + attributesLength);
    action[TYPE] = type;
    action[CONTENT] = content;

    while (attributeIndex < attributesLength) {
      action[actionIndex++] = attributes[attributeIndex++];
    }

    return action;
  };
};

var createInsertText = createInsert(ACTION_INSERT_TEXT);
var createInsertOpen = createInsert(ACTION_INSERT_OPEN);
var createInsertClose = createInsert(ACTION_INSERT_CLOSE);
var createInsertEmbed = createInsert(ACTION_INSERT_EMBED);

var createRetain = function createRetain(content, attributes) {
  var attributesLength = attributes ? attributes.length : 0;
  var action = new Array(2 + attributesLength);
  action[TYPE] = ACTION_RETAIN;
  action[CONTENT] = content;
  var actionIndex = 2;
  var attributeIndex = 0;

  while (attributeIndex < attributesLength) {
    action[actionIndex++] = attributes[attributeIndex++];
  }

  return action;
};

var createDelete = function createDelete(content) {
  return [ACTION_DELETE, content];
}; // Actions should normally be read-only, so this function is intended to be used only right after creating a new
// action before any other code can access it.


var setAttribute = function setAttribute(action, name, value) {
  var insertAt = ATTRIBUTES;
  var actionLength = action.length;

  while (insertAt < actionLength && action[insertAt] < name) {
    insertAt += 2;
  }

  if (insertAt === actionLength) {
    // add new attribute at the end
    action[insertAt] = name;
    action[insertAt + 1] = value;
    return action;
  }

  if (action[insertAt] === name) {
    // set an existing attribute
    action[insertAt + 1] = value;
    return action;
  } // insert a new attribute


  while (insertAt < actionLength) {
    var previousName = action[insertAt];
    var previousValue = action[insertAt + 1];
    action[insertAt++] = name;
    action[insertAt++] = value;
    name = previousName;
    value = previousValue;
  }

  action[insertAt++] = name;
  action[insertAt++] = value;
  return action;
};

var validateLength = function validateLength(action) {
  if (action.length !== ATTRIBUTES) {
    return new Error("action.length must be ".concat(ATTRIBUTES));
  }

  return null;
};

var validateMinLength = function validateMinLength(action) {
  if (action.length < ATTRIBUTES) {
    return new Error("action.length must be at least ".concat(ATTRIBUTES));
  }

  return null;
};

var validateContentNumber = function validateContentNumber(action) {
  var content = action[CONTENT];

  if (typeof content !== 'number' || content <= 0 || !isFinite(content) || Math.floor(content) !== content) {
    return new Error('content must be a positive integer');
  }

  return null;
};

var validateContentText = function validateContentText(action) {
  var content = action[CONTENT];

  if (typeof content !== 'string' || content === '') {
    return new Error('content must be a non-empty string');
  }

  return null;
};

var validateContentNode = function validateContentNode(action) {
  var content = action[CONTENT];

  if (typeof content !== 'string') {
    return new Error('content must be a string');
  }

  if (content.length < 2) {
    return new Error('content must contain a node ID and node name');
  }

  if (content[0] < "\uE000" || content[0] > "\uF8FF") {
    return new Error('node ID must be a character in the Private Use Area of the Unicode Basic Multilingual Plane');
  }

  return null;
};

var validateAttributes = function validateAttributes(action, allowNull) {
  var length = action.length;

  if (length - ATTRIBUTES & 1) {
    return new Error('missing value for the last attribute');
  }

  for (var i = ATTRIBUTES; i < length; i += 2) {
    var name = action[i];
    var value = action[i + 1];

    if (typeof name !== 'string') {
      return new Error('attribute name must be a string');
    }

    if (!(typeof value === 'string' || allowNull && value === null)) {
      return new Error("attribute value must be a string".concat(allowNull ? ' or null' : ''));
    }

    if (i > ATTRIBUTES && action[i - 2] >= name) {
      return new Error('duplicate or not sorted attribute');
    }
  }

  return null;
}; // Returns null, if the action is valid. Otherwise returns an error.


var validate = function validate(action) {
  if (!Array.isArray(action)) {
    return new Error('action must be an array');
  }

  switch (action[TYPE]) {
    case ACTION_DELETE:
      return validateLength(action) || validateContentNumber(action);

    case ACTION_RETAIN:
      return validateMinLength(action) || validateContentNumber(action) || validateAttributes(action, true);

    case ACTION_INSERT_TEXT:
      return validateMinLength(action) || validateContentText(action) || validateAttributes(action, false);

    case ACTION_INSERT_OPEN:
    case ACTION_INSERT_CLOSE:
    case ACTION_INSERT_EMBED:
      return validateMinLength(action) || validateContentNode(action) || validateAttributes(action, false);

    default:
      return new Error('unknown action type');
  }
};

var getCount = function getCount(action) {
  return action[CONTENT];
}; // for retain and delete


var getText = function getText(action) {
  return action[CONTENT];
}; // for insert text


var getNodeIdAndName = function getNodeIdAndName(action) {
  return action[CONTENT];
}; // for insert node


var getNodeId = function getNodeId(action) {
  return action[CONTENT][0];
}; // for insert node


var getNodeName = function getNodeName(action) {
  return action[CONTENT].substring(1);
}; // for insert node


var setContent = function setContent(action, content) {
  action[CONTENT] = content;
  return action;
}; // for retain, delete and insert text


var getAttributes = function getAttributes(action, attributeNames) {
  // for insert and retain
  if (attributeNames) {
    var i1 = ATTRIBUTES; // index for action

    var i2 = 0; // index for attributeNames

    var i3 = 0; // index for attributes

    var l1 = action.length;
    var l2 = attributeNames.length;
    var _attributes = [];

    while (i1 < l1 && i2 < l2) {
      var actionAttributeName = action[i1];
      var attributeName = attributeNames[i2];
      var attributeNameLength = attributeName.length;
      var prefixMatch = attributeNameLength >= 0 && attributeName[attributeNameLength - 1] === '=';

      if (actionAttributeName < attributeName) {
        i1 += 2; // redundant attribute in action
      } else if (prefixMatch && actionAttributeName.substring(0, attributeNameLength) === attributeName) {
        // Matched an attribute by prefix.
        _attributes[i3++] = action[i1++];
        _attributes[i3++] = action[i1++];
      } else if (actionAttributeName === attributeName) {
        // Found an exact match.
        _attributes[i3++] = action[i1++];
        _attributes[i3++] = action[i1++];
        ++i2;
      } else {
        ++i2; // missing attribute in action
      }
    }

    return _attributes;
  }

  var actionLength = action.length;
  var actionIndex = ATTRIBUTES;
  var attributes = new Array(actionLength - actionIndex);
  var attributesIndex = 0;

  while (actionIndex < actionLength) {
    attributes[attributesIndex++] = action[actionIndex++];
    attributes[attributesIndex++] = action[actionIndex++];
  }

  return attributes;
};

var getAttribute = function getAttribute(action, attributeName) {
  for (var i = ATTRIBUTES, l = action.length; i < l; i += 2) {
    if (action[i] < attributeName) {} else if (action[i] === attributeName) {
      return action[i + 1];
    } else {
      break;
    }
  }

  return undefined;
};

var isDelete = function isDelete(action) {
  return action[TYPE] === ACTION_DELETE;
};

var isRetain = function isRetain(action) {
  return action[TYPE] === ACTION_RETAIN;
};

var isInsert = function isInsert(action) {
  return ACTION_INSERT_TEXT <= action[TYPE] && action[TYPE] <= ACTION_INSERT_EMBED;
};

var isInsertText = function isInsertText(action) {
  return action[TYPE] === ACTION_INSERT_TEXT;
};

var isInsertOpen = function isInsertOpen(action) {
  return action[TYPE] === ACTION_INSERT_OPEN;
};

var isInsertClose = function isInsertClose(action) {
  return action[TYPE] === ACTION_INSERT_CLOSE;
};

var isInsertEmbed = function isInsertEmbed(action) {
  return action[TYPE] === ACTION_INSERT_EMBED;
};

var getAttributesIndex = function getAttributesIndex(action) {
  return ATTRIBUTES;
};

var hasAttributes = function hasAttributes(action) {
  return action.length > ATTRIBUTES;
};

var getLength = function getLength(action) {
  switch (action[TYPE]) {
    case ACTION_INSERT_TEXT:
      return action[CONTENT].length;

    case ACTION_INSERT_OPEN:
    case ACTION_INSERT_CLOSE:
    case ACTION_INSERT_EMBED:
      return 1;

    default:
      return action[CONTENT];
  }
};

var slice = function slice(action, offset, count, length) {
  if (offset === 0 && count === length) {
    // takes care of insert open/close/embed
    return action;
  } else if (isInsertText(action)) {
    // takes care of insert text
    return setContent(clone(action, false), action[CONTENT].substr(offset, count));
  } else {
    // it must be retain or delete
    return setContent(clone(action, false), count);
  }
};

var merge = function merge(action1, action2) {
  var length = action1.length;

  if (length !== action2.length) {
    return null;
  }

  var action = action1[TYPE];

  if (action !== action2[TYPE]) {
    return null;
  }

  switch (action) {
    case ACTION_INSERT_TEXT:
    case ACTION_DELETE:
    case ACTION_RETAIN:
      for (var i = CONTENT + 1; i < length; ++i) {
        if (action1[i] !== action2[i]) {
          return null;
        }
      }

      return setContent(clone(action1, false), action1[CONTENT] + action2[CONTENT]);

    default:
      return null;
  }
};

var areEqual = function areEqual(action1, action2) {
  var length = action1.length;

  if (action2.length !== length) {
    return false;
  }

  for (var i = 0; i < length; ++i) {
    if (action1[i] !== action2[i]) {
      return false;
    }
  }

  return true;
};

var areTypesEqual = function areTypesEqual(action1, action2) {
  return action1[TYPE] === action2[TYPE];
};

var areAttributesEqual = function areAttributesEqual(action1, action2) {
  var i1 = ATTRIBUTES;
  var i2 = ATTRIBUTES;
  var length = action1.length;

  if (length - i1 !== action2.length - i2) {
    return false;
  }

  while (i1 < length) {
    if (action1[i1++] !== action2[i2++]) {
      return false;
    }
  }

  return true;
}; // Composes up to 2 actions tracked by the iterators.
// Advances the iterators past the composed actions.
// Returns a new action, or null, if the iterators have been exhausted.


var composeIterators = function composeIterators(iterator1, iterator2) {
  do {
    var action1 = iterator1.action;
    var action2 = iterator2.action;

    if (action1 === null) {
      if (action2 === null) {
        return null;
      }

      var _length = getLength(action2);

      var offset = iterator2.offset;
      var remaining = _length - offset;
      iterator2.next(remaining);
      return slice(action2, offset, remaining, _length);
    }

    if (action2 === null) {
      var _length2 = getLength(action1);

      var _offset = iterator1.offset;

      var _remaining = _length2 - _offset;

      iterator1.next(_remaining);
      return slice(action1, _offset, _remaining, _length2);
    }

    if (isInsert(action2)) {
      var _length3 = getLength(action2);

      var _offset2 = iterator2.offset;

      var _remaining2 = _length3 - _offset2;

      iterator2.next(_remaining2);
      return slice(action2, _offset2, _remaining2, _length3);
    }

    if (isDelete(action1)) {
      var _length4 = getLength(action1);

      var _offset3 = iterator1.offset;

      var _remaining3 = _length4 - _offset3;

      iterator1.next(_remaining3);
      return slice(action1, _offset3, _remaining3, _length4);
    }

    var length1 = getLength(action1);
    var length2 = getLength(action2);
    var offset1 = iterator1.offset;
    var offset2 = iterator2.offset;
    var remaining1 = length1 - offset1;
    var remaining2 = length2 - offset2;
    var length = remaining1 < remaining2 ? remaining1 : remaining2;
    iterator1.next(length);
    iterator2.next(length);

    if (isRetain(action2)) {
      // `action1` must be INSERT or RETAIN
      if (action2.length <= ATTRIBUTES || areAttributesEqual(action1, action2)) {
        // no attribute changes
        return slice(action1, offset1, length, length1);
      }

      var newAction = clone(action1, true);

      if (isRetain(newAction)) {
        newAction[CONTENT] = length;
      } else if (isInsertText(newAction)) {
        newAction[CONTENT] = newAction[CONTENT].substr(offset1, length);
      }

      var keepNull = isRetain(action1);
      var i1 = newAction.length; // attribute index in action1

      var i2 = ATTRIBUTES; // attribute index in action2

      var i3 = newAction.length; // attribute index in newAction

      var l1 = action1.length;
      var l2 = action2.length; // compose the attributes

      while (i1 < l1 && i2 < l2) {
        if (action1[i1] === action2[i2]) {
          // the same attribute name in both actions
          i1 += 2;

          if (action2[i2 + 1] !== null || keepNull) {
            newAction[i3++] = action2[i2++];
            newAction[i3++] = action2[i2++];
          } else {
            i2 += 2;
          }
        } else if (action1[i1] < action2[i2]) {
          // an attribute from action1 is not present in action2
          if (action1[i1 + 1] !== null || keepNull) {
            newAction[i3++] = action1[i1++];
            newAction[i3++] = action1[i1++];
          } else {
            i1 += 2;
          }
        } else {
          // an attribute from action2 is not present in action1
          if (action2[i2 + 1] !== null || keepNull) {
            newAction[i3++] = action2[i2++];
            newAction[i3++] = action2[i2++];
          } else {
            i2 += 2;
          }
        }
      }

      while (i2 < l2) {
        // only action2 attributes left
        if (action2[i2 + 1] !== null || keepNull) {
          newAction[i3++] = action2[i2++];
          newAction[i3++] = action2[i2++];
        } else {
          i2 += 2;
        }
      }

      while (i1 < l1) {
        // only action1 attributes left
        if (action1[i1 + 1] !== null || keepNull) {
          newAction[i3++] = action1[i1++];
          newAction[i3++] = action1[i1++];
        } else {
          i1 += 2;
        }
      }

      return newAction;
    }

    if (isDelete(action2) && isRetain(action1)) {
      return slice(action2, offset2, length, length2);
    } // `action2` must be DELETE and `action1` must be INSERT, so they
    // cancel each other out and we can move on the the next action.

  } while (true);
}; // Transforms up to 2 actions tracked by the iterators.
// Advances the iterators past the transformed actions.
// Returns a new action, or null, if iterator1 has been exhausted.


var transformIterators = function transformIterators(iterator1, iterator2, action1HasPriority) {
  do {
    var action1 = iterator1.action;
    var action2 = iterator2.action;

    if (action1 === null) {
      return null;
    }

    if (action2 === null) {
      var _length5 = getLength(action1);

      var offset = iterator1.offset;
      var remaining = _length5 - offset;
      iterator1.next(remaining);
      return slice(action1, offset, remaining, _length5);
    }

    if (action1HasPriority && isInsert(action1)) {
      var _length6 = getLength(action1);

      var _offset4 = iterator1.offset;

      var _remaining4 = _length6 - _offset4;

      iterator1.next(_remaining4);
      return slice(action1, _offset4, _remaining4, _length6);
    }

    if (isInsert(action2)) {
      var _remaining5 = getLength(action2) - iterator2.offset;

      iterator2.next(_remaining5);
      return createRetain(_remaining5);
    }

    if (isInsert(action1)) {
      var _length7 = getLength(action1);

      var _offset5 = iterator1.offset;

      var _remaining6 = _length7 - _offset5;

      iterator1.next(_remaining6);
      return slice(action1, _offset5, _remaining6, _length7);
    }

    var length1 = getLength(action1);
    var length2 = getLength(action2);
    var offset1 = iterator1.offset;
    var offset2 = iterator2.offset;
    var remaining1 = length1 - offset1;
    var remaining2 = length2 - offset2;
    var length = remaining1 < remaining2 ? remaining1 : remaining2;
    iterator1.next(length);
    iterator2.next(length);

    if (isDelete(action2)) {
      // action1 must be retain or delete - either way it's redundant
      continue;
    }

    if (isDelete(action1)) {
      return slice(action1, offset1, length, length1);
    } // action1 and action2 must be retain


    if (action1HasPriority) {
      return slice(action1, offset1, length, length1);
    }

    var newAction = createRetain(length);
    var i1 = ATTRIBUTES; // action1 attribute index

    var i2 = ATTRIBUTES; // action2 attribute index

    var i3 = ATTRIBUTES; // newAction attribute index

    var l1 = action1.length;
    var l2 = action2.length;

    while (i1 < l1) {
      if (i2 >= l2) {
        // no more attributes in action2
        newAction[i3++] = action1[i1++];
        newAction[i3++] = action1[i1++];
      } else if (action1[i1] === action2[i2]) {
        // attribute already set in action2, which has priority
        i1 += 2;
        i2 += 2;
      } else if (action1[i1] < action2[i2]) {
        // attribute from action1 is not present in action2
        newAction[i3++] = action1[i1++];
        newAction[i3++] = action1[i1++];
      } else {
        // attribute from action2 is not present in action1
        i2 += 2;
      }
    }

    return newAction;
  } while (true);
}; // Computes the difference between the 2 iterators based on the hints provided by the
// `diffType` and `diffContent` params. Emits the results through `delta1Callback` and `delta2Callback`.
//
// `iterator1`: enumerates the first operation
// `iterator2`: enumerates the second operation
// `diffType`:
//    1: `diffContent` present only in iterator2
//    0: `diffContent` present in both interator1 and iterator2
//   -1: `diffContent` present only in iterator1
// `diffContent` the content of the text difference between the iterators
// `delta1Callback`: called with an action which would convert the content of iterator2 to the content of iterator1, when applied
// `delta2Callback`: called with an action which would convert the content of iterator1 to the content of iterator2, when applied


var diffIterators = function diffIterators(iterator1, iterator2, diffType, diffContent, delta1Callback, delta2Callback) {
  var diffLength = diffContent.length;

  switch (diffType) {
    case 0:
      // `diffContent` present in both iterator1 and iterator2
      var pendingRetain = 0;

      while (diffLength > 0) {
        var action1 = iterator1.operation[iterator1.index];
        var length1 = getLength(action1);
        var offset1 = iterator1.offset;
        var remaining1 = length1 - offset1;
        var action2 = iterator2.operation[iterator2.index];
        var length2 = getLength(action2);
        var offset2 = iterator2.offset;
        var remaining2 = length2 - offset2;
        var length = diffLength <= remaining1 && diffLength <= remaining2 ? diffLength : remaining1 <= diffLength && remaining1 <= remaining2 ? remaining1 : remaining2;
        diffLength -= length;
        iterator1.next(length);
        iterator2.next(length);

        if (action1[TYPE] === action2[TYPE] && (isInsertText(action1) ? action1[CONTENT].substr(offset1, length) === action2[CONTENT].substr(offset2, length) : action1[CONTENT] === action2[CONTENT])) {
          if (areAttributesEqual(action1, action2)) {
            // This is the most common case in practice,
            // so it must be optimized as much as possible.
            pendingRetain += length;
          } else {
            if (pendingRetain > 0) {
              var deltaRetain = createRetain(pendingRetain);
              delta1Callback(deltaRetain);
              delta2Callback(deltaRetain);
              pendingRetain = 0;
            }

            var retain1 = createRetain(length);
            var retain2 = createRetain(length);
            var i1 = ATTRIBUTES; // attribute index for action1

            var i2 = ATTRIBUTES; // attribute index for action2

            var i3 = ATTRIBUTES; // attribute index for retain1

            var i4 = ATTRIBUTES; // attribute index for retain2

            var l1 = action1.length;
            var l2 = action2.length;

            while (i1 < l1 && i2 < l2) {
              if (action1[i1] === action2[i2]) {
                // the same name
                if (action1[i1 + 1] === action2[i2 + 1]) {
                  // the same value
                  i1 += 2;
                  i2 += 2;
                } else {
                  // different values
                  retain1[i3++] = action1[i1++];
                  retain1[i3++] = action1[i1++];
                  retain2[i4++] = action2[i2++];
                  retain2[i4++] = action2[i2++];
                }
              } else if (action1[i1] < action2[i2]) {
                // attribute only in action1
                var name = action1[i1++];
                var value = action1[i1++];
                retain1[i3++] = name;
                retain1[i3++] = value;
                retain2[i4++] = name;
                retain2[i4++] = null;
              } else {
                // attribute only in action2
                var _name = action2[i2++];
                var _value = action2[i2++];
                retain1[i3++] = _name;
                retain1[i3++] = null;
                retain2[i4++] = _name;
                retain2[i4++] = _value;
              }
            }

            while (i2 < l2) {
              // only action2 attributes left
              var _name2 = action2[i2++];
              var _value2 = action2[i2++];
              retain1[i3++] = _name2;
              retain1[i3++] = null;
              retain2[i4++] = _name2;
              retain2[i4++] = _value2;
            }

            while (i1 < l1) {
              // only action1 attributes left
              var _name3 = action1[i1++];
              var _value3 = action1[i1++];
              retain1[i3++] = _name3;
              retain1[i3++] = _value3;
              retain2[i4++] = _name3;
              retain2[i4++] = null;
            }

            delta1Callback(retain1);
            delta2Callback(retain2);
          }
        } else {
          if (pendingRetain > 0) {
            var _deltaRetain = createRetain(pendingRetain);

            delta1Callback(_deltaRetain);
            delta2Callback(_deltaRetain);
            pendingRetain = 0;
          }

          var deltaDelete = createDelete(length);
          delta1Callback(slice(action1, offset1, length, length1));
          delta1Callback(deltaDelete);
          delta2Callback(slice(action2, offset2, length, length2));
          delta2Callback(deltaDelete);
        }
      }

      if (pendingRetain > 0) {
        var _deltaRetain2 = createRetain(pendingRetain);

        delta1Callback(_deltaRetain2);
        delta2Callback(_deltaRetain2);
        pendingRetain = 0;
      }

      break;

    case 1:
      // `diffContent` present only in iterator2
      delta1Callback(createDelete(diffLength));

      while (diffLength > 0) {
        var _action = iterator2.operation[iterator2.index];

        var _length8 = getLength(_action);

        var _offset6 = iterator2.offset;

        var _remaining7 = _length8 - _offset6;

        var _length9 = diffLength <= _remaining7 ? diffLength : _remaining7;

        diffLength -= _length9;
        iterator2.next(_length9);
        delta2Callback(slice(_action, _offset6, _length9, _length8));
      }

      break;

    case -1:
      // `diffContent` present only in iterator1
      delta2Callback(createDelete(diffLength));

      while (diffLength > 0) {
        var _action2 = iterator1.operation[iterator1.index];

        var _length10 = getLength(_action2);

        var _offset7 = iterator1.offset;

        var _remaining8 = _length10 - _offset7;

        var _length11 = diffLength <= _remaining8 ? diffLength : _remaining8;

        diffLength -= _length11;
        iterator1.next(_length11);
        delta1Callback(slice(_action2, _offset7, _length11, _length10));
      }

      break;
  }
};

module.exports = {
  createInsertText: createInsertText,
  createInsertOpen: createInsertOpen,
  createInsertClose: createInsertClose,
  createInsertEmbed: createInsertEmbed,
  createRetain: createRetain,
  createDelete: createDelete,
  clone: clone,
  setAttribute: setAttribute,
  validate: validate,
  getCount: getCount,
  getText: getText,
  getNodeId: getNodeId,
  getNodeName: getNodeName,
  getNodeIdAndName: getNodeIdAndName,
  getAttributes: getAttributes,
  getAttribute: getAttribute,
  isDelete: isDelete,
  isRetain: isRetain,
  isInsert: isInsert,
  isInsertText: isInsertText,
  isInsertOpen: isInsertOpen,
  isInsertClose: isInsertClose,
  isInsertEmbed: isInsertEmbed,
  areEqual: areEqual,
  areTypesEqual: areTypesEqual,
  areAttributesEqual: areAttributesEqual,
  getAttributesIndex: getAttributesIndex,
  hasAttributes: hasAttributes,
  getLength: getLength,
  slice: slice,
  merge: merge,
  composeIterators: composeIterators,
  transformIterators: transformIterators,
  diffIterators: diffIterators
};

/***/ }),

/***/ "./node_modules/@teamwork/ot-rich-text/lib/Iterator.js":
/*!*************************************************************!*\
  !*** ./node_modules/@teamwork/ot-rich-text/lib/Iterator.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(/*! ./Action */ "./node_modules/@teamwork/ot-rich-text/lib/Action.js"),
    getLength = _require.getLength; // Iterates actions within the specified operation.


function Iterator(operation) {
  this.operation = operation;
  this.index = 0;
  this.offset = 0;
  this.next(0);
}

Object.defineProperties(Iterator.prototype, {
  // Gets the current action or null, if there are no more actions left.
  action: {
    get: function get() {
      return this.index < this.operation.length ? this.operation[this.index] : null;
    }
  },
  // Move at most `count` characters forward.
  next: {
    value: function value(count) {
      var operationLength = this.operation.length;

      while (this.index < operationLength) {
        var actionLength = getLength(this.operation[this.index]);

        if (this.offset + count < actionLength) {
          this.offset += count;
          break;
        } else {
          count -= actionLength - this.offset;
          this.offset = 0;
          this.index++;
        }
      }

      return this;
    }
  }
});
module.exports = Iterator;

/***/ }),

/***/ "./node_modules/@teamwork/ot-rich-text/lib/Operation.js":
/*!**************************************************************!*\
  !*** ./node_modules/@teamwork/ot-rich-text/lib/Operation.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fastDiff = __webpack_require__(/*! fast-diff */ "./node_modules/fast-diff/diff.js");

var Iterator = __webpack_require__(/*! ./Iterator */ "./node_modules/@teamwork/ot-rich-text/lib/Iterator.js");

var _require = __webpack_require__(/*! ./Action */ "./node_modules/@teamwork/ot-rich-text/lib/Action.js"),
    createRetain = _require.createRetain,
    isInsert = _require.isInsert,
    isInsertText = _require.isInsertText,
    isRetain = _require.isRetain,
    isDelete = _require.isDelete,
    getLength = _require.getLength,
    hasAttributes = _require.hasAttributes,
    getText = _require.getText,
    getNodeId = _require.getNodeId,
    areEqual = _require.areEqual,
    areTypesEqual = _require.areTypesEqual,
    merge = _require.merge,
    composeIterators = _require.composeIterators,
    transformIterators = _require.transformIterators,
    diffIterators = _require.diffIterators,
    validateAction = _require.validate;

function create(actions) {
  return Array.isArray(actions) ? actions : [];
}

function isNoop(operation) {
  return operation.length === 0;
} // Compose op1 and op2 to produce a new operation.
// The new operation must subsume the behaviour of op1 and op2.
// Specifically, apply(apply(snapshot, op1), op2) == apply(snapshot, compose(op1, op2)).
// Note: transforming by a composed operation is NOT guaranteed to produce the same result as transforming by each operation in order.


function compose(operation1, operation2) {
  var iterator1 = new Iterator(operation1);
  var iterator2 = new Iterator(operation2);
  var newOperation = [];
  var action = composeIterators(iterator1, iterator2);

  while (action !== null) {
    append(newOperation, action);
    action = composeIterators(iterator1, iterator2);
  }

  return chop(newOperation);
} // Composes 2 operations but only if the "shape" of the new operation is the
// same as the "shape" of operation1.


function composeSimilar(operation1, operation2) {
  var newOperation = compose(operation1, operation2);
  var index = 0;
  var length = operation1.length;
  var newIndex = 0;
  var newLength = newOperation.length; // Skip leading "retain" actions

  while (index < length && isRetain(operation1[index])) {
    ++index;
  }

  while (newIndex < newLength && isRetain(newOperation[newIndex])) {
    ++newIndex;
  } // Operations are not similar, if they have a different number of actions
  // following the leading retain actions.


  if (length - index !== newLength - newIndex) {
    return null;
  } // Operations are not similar, if they have differnt action types
  // following the leading retain actions.


  while (index < length) {
    if (!areTypesEqual(operation1[index++], newOperation[newIndex++])) {
      return null;
    }
  }

  return newOperation;
} // Apply an operation to a snapshot to produce a new snapshot.


function apply(snapshot, operation) {
  var iterator1 = new Iterator(snapshot);
  var iterator2 = new Iterator(operation);
  var newSnapshot = [];
  var action = composeIterators(iterator1, iterator2);

  while (action !== null && isInsert(action)) {
    append(newSnapshot, action);
    action = composeIterators(iterator1, iterator2);
  }

  return newSnapshot;
} // Apply an operation to a snapshot to produce a new snapshot and
// an inverted operation.


function applyAndInvert(snapshot, operation) {
  var editingPosition = !isNoop(operation) && isRetain(operation[0]) ? getLength(operation[0]) : 0;
  var newSnapshot = apply(snapshot, operation);
  var diffs = diffX(snapshot, newSnapshot, {
    oldRange: {
      index: editingPosition,
      length: 0
    },
    newRange: {
      index: editingPosition,
      length: 0
    }
  });
  var invertedOperation = diffs[0];
  return [newSnapshot, invertedOperation];
} // Transform op1 by op2. Return the new op1.
// Side is either 'left' or 'right'. It exists to break ties,
// for example if two operations insert at the same position in a string.
// If side === 'left', operation1 is considered to happen "first".
// Both op1 and op2 must not be modified by transform.
// Transform must conform to Transform Property 1. That is,
// apply(apply(snapshot, op1), transform(op2, op1, 'left')) == apply(apply(snapshot, op2), transform(op1, op2, 'right')).


function transform(operation1, operation2, side) {
  var operation1HasPriority = side === 'left';
  var iterator1 = new Iterator(operation1);
  var iterator2 = new Iterator(operation2);
  var newOperation = [];
  var action = transformIterators(iterator1, iterator2, operation1HasPriority);

  while (action !== null) {
    append(newOperation, action);
    action = transformIterators(iterator1, iterator2, operation1HasPriority);
  }

  return chop(newOperation);
} // Transform the specified cursor position by the provided operation.
// If isOwnOperation is true, this function returns the final editing position of the provided operation.
// If isOwnOperation is false, the cursor position moves with the content to its immediate left.


function transformCursor(cursor, operation, isOwnOperation) {
  cursor = cursor | 0;
  isOwnOperation = !!isOwnOperation;
  var iterator = new Iterator(operation);
  var offset = 0;
  var action = iterator.action;

  while (action !== null && offset <= cursor) {
    var length = getLength(action);

    if (isDelete(action)) {
      if (length < cursor - offset) {
        cursor -= length;
      } else {
        cursor = offset;
      }
    } else if (isInsert(action) && (offset < cursor || isOwnOperation)) {
      cursor += length;
      offset += length;
    } else {
      offset += length;
    }

    iterator.next(length);
    action = iterator.action;
  }

  return cursor;
} // Appends `action` to `operation`.


function append(operation, action) {
  var length = getLength(action);

  if (length === 0) {
    // takes care of invalid and empty actions
    return operation;
  }

  var operationLength = operation.length;

  if (operationLength === 0) {
    operation[operationLength] = action;
  } else {
    var lastIndex = operationLength - 1;
    var lastAction = operation[lastIndex]; // It doesn't matter, if we insert or delete first at the same index,
    // so we consistently insert first,
    // so that we have more opportunities for merging actions.

    if (isDelete(lastAction) && isInsert(action)) {
      if (operationLength === 1) {
        operation[0] = action;
        operation[operationLength] = lastAction;
      } else {
        var lastButOneIndex = lastIndex - 1;
        var lastButOneAction = operation[lastButOneIndex];
        var mergedAction = merge(lastButOneAction, action);

        if (mergedAction !== null) {
          operation[lastButOneIndex] = mergedAction;
        } else {
          operation[lastIndex] = action;
          operation[operationLength] = lastAction;
        }
      }
    } else {
      var _mergedAction = merge(lastAction, action);

      if (_mergedAction !== null) {
        operation[lastIndex] = _mergedAction;
      } else {
        operation[operationLength] = action;
      }
    }
  }

  return operation;
} // Remove trailing retain, if it does not have attributes.


function chop(operation) {
  var operationLength = operation.length;

  if (operationLength > 0) {
    var lastIndex = operationLength - 1;
    var action = operation[lastIndex];

    if (isRetain(action) && !hasAttributes(action)) {
      operation.length = lastIndex;
    }
  }

  return operation;
} // Returns null, if the `operation` is valid. Otherwise returns an error.


function validate(operation) {
  if (!Array.isArray(operation)) {
    return new Error('operation must be an array');
  }

  for (var i = 0, l = operation.length; i < l; ++i) {
    var error = validateAction(operation[i]);

    if (error !== null) {
      return new Error("Invalid action at index ".concat(i, ": ").concat(error.message));
    }
  }

  return null;
} // The operations this library produces are already normalized, so no modifications
// are needed, however, we do take the opportunity to check that the operation is valid
// and throw an Error, if it isn't.


function normalize(operation) {
  var error = validate(operation);

  if (error !== null) {
    throw error;
  }

  return operation;
} // Returns a 2 element array, where each element is an operation representing
// a difference between `snapshot1` and `snapshot2`.
// `editLocation` is optional and provides a hint to the diffing algorithm,
// so that it can return the expected diff out of the set of valid diffs.
// The first operation converts `snapshot2` to `snapshot1`, when applied.
// The second operation converts `snapshot1` to `snapshot2`, when applied.


function diffX(snapshot1, snapshot2, editLocation) {
  var oldRange = null;
  var newRange = null;

  if (typeof editLocation === 'number') {
    oldRange = {
      index: editLocation | 0,
      length: 0
    };
    editLocation = {
      oldRange: oldRange,
      newRange: newRange
    };
  } else if (editLocation && (oldRange = editLocation.oldRange || null)) {
    oldRange = {
      index: oldRange.index | 0,
      length: oldRange.length | 0
    };

    if (newRange = editLocation.newRange || null) {
      newRange = {
        index: newRange.index | 0,
        length: newRange.length | 0
      };
    }

    editLocation = {
      oldRange: oldRange,
      newRange: newRange
    };
  } else {
    editLocation = null;
  }

  var result1 = [];
  var result2 = [];

  if (snapshot1 === snapshot2) {
    return [result1, result2];
  }

  var startIndex1 = 0;
  var startIndex2 = 0;
  var endIndex1 = snapshot1.length - 1;
  var endIndex2 = snapshot2.length - 1;
  var commonPrefixLength = 0;
  var differingContent1 = '';
  var differingContent2 = ''; // calculate common prefix length

  while (startIndex1 <= endIndex1 && startIndex2 <= endIndex2) {
    var action1 = snapshot1[startIndex1];

    if (!isInsert(action1)) {
      throw new Error('not an "insert" operation');
    }

    if (!areEqual(action1, snapshot2[startIndex2])) {
      break;
    }

    commonPrefixLength += getLength(action1);
    ++startIndex1;
    ++startIndex2;
  } // skip common suffix


  while (startIndex1 <= endIndex1 && startIndex2 <= endIndex2) {
    var _action = snapshot1[endIndex1];

    if (!isInsert(_action)) {
      throw new Error('not an "insert" operation');
    }

    if (!areEqual(_action, snapshot2[endIndex2])) {
      break;
    }

    --endIndex1;
    --endIndex2;
  } // create iterators and set them to the first differing operations


  var iterator1 = new Iterator(snapshot1);
  iterator1.offset = 0;
  iterator1.index = startIndex1;
  iterator1.next(0);
  var iterator2 = new Iterator(snapshot2);
  iterator2.offset = 0;
  iterator2.index = startIndex2;
  iterator2.next(0); // calculate differingContent1

  while (startIndex1 <= endIndex1) {
    var action = snapshot1[startIndex1++];

    if (!isInsert(action)) {
      throw new Error('not an "insert" action');
    }

    differingContent1 += isInsertText(action) ? getText(action) : getNodeId(action);
  } // calculate differingContent2


  while (startIndex2 <= endIndex2) {
    var _action2 = snapshot2[startIndex2++];

    if (!isInsert(_action2)) {
      throw new Error('not an "insert" action');
    }

    differingContent2 += isInsertText(_action2) ? getText(_action2) : getNodeId(_action2);
  }

  if (oldRange) {
    if (commonPrefixLength > 0) {
      oldRange.index -= commonPrefixLength;
    }

    if (oldRange.index < 0) {
      oldRange.length += oldRange.index;
      oldRange.index = 0;
    }

    if (oldRange.length < 0) {
      oldRange.length = 0;
    }

    if (oldRange.index > differingContent1.length) {
      oldRange.index = differingContent1.length;
    }

    if (oldRange.index + oldRange.length > differingContent1.length) {
      oldRange.length = differingContent1.length - oldRange.index;
    }
  }

  if (newRange) {
    if (commonPrefixLength > 0) {
      newRange.index -= commonPrefixLength;
    }

    if (newRange.index < 0) {
      newRange.length += newRange.index;
      newRange.index = 0;
    }

    if (newRange.length < 0) {
      newRange.length = 0;
    }

    if (newRange.index > differingContent2.length) {
      newRange.index = differingContent2.length;
    }

    if (newRange.index + newRange.length > differingContent2.length) {
      newRange.length = differingContent2.length - newRange.index;
    }
  }

  var stringDiff = fastDiff(differingContent1, differingContent2, editLocation);

  var append1 = function append1(action) {
    return append(result1, action);
  };

  var append2 = function append2(action) {
    return append(result2, action);
  };

  if (commonPrefixLength > 0) {
    var retain = createRetain(commonPrefixLength);
    append1(retain);
    append2(retain);
  }

  for (var i = 0, l = stringDiff.length; i < l; ++i) {
    var diffItem = stringDiff[i];
    diffIterators(iterator1, iterator2, diffItem[0], diffItem[1], append1, append2);
  }

  return [chop(result1), chop(result2)];
}

function createPresence(presence) {
  return isValidPresence(presence) ? presence : {
    u: '',
    c: 0,
    s: []
  };
}

function transformPresence(presence, operation, isOwnOperation) {
  var user = presence.u;
  var change = presence.c;
  var selections = presence.s;
  var newSelections = new Array(selections.length);

  for (var i = 0, l = selections.length; i < l; ++i) {
    var selection = selections[i];
    var newStart = transformCursor(selection[0], operation, isOwnOperation);
    var newEnd = selection[0] === selection[1] ? newStart : transformCursor(selection[1], operation, isOwnOperation);
    newSelections[i] = [newStart, newEnd];
  }

  return {
    u: user,
    c: change,
    s: newSelections
  };
}

function comparePresence(presence1, presence2) {
  if (presence1 === presence2) {
    return true;
  }

  if (presence1 == null || presence2 == null || presence1.u !== presence2.u || presence1.c !== presence2.c || presence1.s.length !== presence2.s.length) {
    return false;
  }

  for (var i = 0, l = presence1.s.length; i < l; ++i) {
    if (presence1.s[i][0] !== presence2.s[i][0] || presence1.s[i][1] !== presence2.s[i][1]) {
      return false;
    }
  }

  return true;
}

function isValidPresence(presence) {
  if (presence == null || typeof presence.u !== 'string' || typeof presence.c !== 'number' || !isFinite(presence.c) || Math.floor(presence.c) !== presence.c || !Array.isArray(presence.s)) {
    return false;
  }

  var selections = presence.s;

  for (var i = 0, l = selections.length; i < l; ++i) {
    var selection = selections[i];

    if (!Array.isArray(selection) || selection.length !== 2 || selection[0] !== (selection[0] | 0) || selection[1] !== (selection[1] | 0)) {
      return false;
    }
  }

  return true;
}

module.exports = {
  create: create,
  isNoop: isNoop,
  compose: compose,
  composeSimilar: composeSimilar,
  apply: apply,
  applyAndInvert: applyAndInvert,
  transform: transform,
  transformCursor: transformCursor,
  append: append,
  chop: chop,
  validate: validate,
  normalize: normalize,
  diffX: diffX,
  createPresence: createPresence,
  transformPresence: transformPresence,
  comparePresence: comparePresence,
  isValidPresence: isValidPresence
};

/***/ }),

/***/ "./node_modules/@teamwork/ot-rich-text/lib/index.js":
/*!**********************************************************!*\
  !*** ./node_modules/@teamwork/ot-rich-text/lib/index.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  type: __webpack_require__(/*! ./type */ "./node_modules/@teamwork/ot-rich-text/lib/type.js"),
  Iterator: __webpack_require__(/*! ./Iterator */ "./node_modules/@teamwork/ot-rich-text/lib/Iterator.js"),
  Action: __webpack_require__(/*! ./Action */ "./node_modules/@teamwork/ot-rich-text/lib/Action.js"),
  Operation: __webpack_require__(/*! ./Operation */ "./node_modules/@teamwork/ot-rich-text/lib/Operation.js")
};

/***/ }),

/***/ "./node_modules/@teamwork/ot-rich-text/lib/type.js":
/*!*********************************************************!*\
  !*** ./node_modules/@teamwork/ot-rich-text/lib/type.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(/*! ./Operation */ "./node_modules/@teamwork/ot-rich-text/lib/Operation.js"),
    create = _require.create,
    isNoop = _require.isNoop,
    compose = _require.compose,
    composeSimilar = _require.composeSimilar,
    apply = _require.apply,
    applyAndInvert = _require.applyAndInvert,
    transform = _require.transform,
    transformCursor = _require.transformCursor,
    normalize = _require.normalize,
    diffX = _require.diffX,
    createPresence = _require.createPresence,
    transformPresence = _require.transformPresence,
    comparePresence = _require.comparePresence;

module.exports = {
  name: 'ot-rich-text',
  uri: 'https://github.com/Teamwork/ot-rich-text',
  create: create,
  isNoop: isNoop,
  compose: compose,
  composeSimilar: composeSimilar,
  apply: apply,
  applyAndInvert: applyAndInvert,
  transform: transform,
  transformCursor: transformCursor,
  normalize: normalize,
  diffX: diffX,
  createPresence: createPresence,
  transformPresence: transformPresence,
  comparePresence: comparePresence
};

/***/ }),

/***/ "./node_modules/@teamwork/sharedb/lib/client/connection.js":
/*!*****************************************************************!*\
  !*** ./node_modules/@teamwork/sharedb/lib/client/connection.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var Doc = __webpack_require__(/*! ./doc */ "./node_modules/@teamwork/sharedb/lib/client/doc.js");
var Query = __webpack_require__(/*! ./query */ "./node_modules/@teamwork/sharedb/lib/client/query.js");
var UndoManager = __webpack_require__(/*! ./undoManager */ "./node_modules/@teamwork/sharedb/lib/client/undoManager.js");
var SnapshotVersionRequest = __webpack_require__(/*! ./snapshot-request/snapshot-version-request */ "./node_modules/@teamwork/sharedb/lib/client/snapshot-request/snapshot-version-request.js");
var SnapshotTimestampRequest = __webpack_require__(/*! ./snapshot-request/snapshot-timestamp-request */ "./node_modules/@teamwork/sharedb/lib/client/snapshot-request/snapshot-timestamp-request.js");
var emitter = __webpack_require__(/*! ../emitter */ "./node_modules/@teamwork/sharedb/lib/emitter.js");
var ShareDBError = __webpack_require__(/*! ../error */ "./node_modules/@teamwork/sharedb/lib/error.js");
var types = __webpack_require__(/*! ../types */ "./node_modules/@teamwork/sharedb/lib/types.js");
var util = __webpack_require__(/*! ../util */ "./node_modules/@teamwork/sharedb/lib/util.js");
var logger = __webpack_require__(/*! ../logger */ "./node_modules/@teamwork/sharedb/lib/logger/index.js");

function connectionState(socket) {
  if (socket.readyState === 0 || socket.readyState === 1) return 'connecting';
  return 'disconnected';
}

/**
 * Handles communication with the sharejs server and provides queries and
 * documents.
 *
 * We create a connection with a socket object
 *   connection = new sharejs.Connection(sockset)
 * The socket may be any object handling the websocket protocol. See the
 * documentation of bindToSocket() for details. We then wait for the connection
 * to connect
 *   connection.on('connected', ...)
 * and are finally able to work with shared documents
 *   connection.get('food', 'steak') // Doc
 *
 * @param socket @see bindToSocket
 */
module.exports = Connection;
function Connection(socket) {
  emitter.EventEmitter.call(this);

  // Map of collection -> id -> doc object for created documents.
  // (created documents MUST BE UNIQUE)
  this.collections = {};

  // A list of active UndoManagers.
  this.undoManagers = [];

  // Each query and snapshot request is created with an id that the server uses when it sends us
  // info about the request (updates, etc)
  this.nextQueryId = 1;
  this.nextSnapshotRequestId = 1;

  // Map from query ID -> query object.
  this.queries = {};

  // Map from snapshot request ID -> snapshot request
  this._snapshotRequests = {};

  // A unique message number for the given id
  this.seq = 1;

  // Equals agent.clientId on the server
  this.id = null;

  // This direct reference from connection to agent is not used internal to
  // ShareDB, but it is handy for server-side only user code that may cache
  // state on the agent and read it in middleware
  this.agent = null;

  this.debug = false;

  this.state = connectionState(socket);

  this.bindToSocket(socket);
}
emitter.mixin(Connection);


/**
 * Use socket to communicate with server
 *
 * Socket is an object that can handle the websocket protocol. This method
 * installs the onopen, onclose, onmessage and onerror handlers on the socket to
 * handle communication and sends messages by calling socket.send(message). The
 * sockets `readyState` property is used to determine the initaial state.
 *
 * @param socket Handles the websocket protocol
 * @param socket.readyState
 * @param socket.close
 * @param socket.send
 * @param socket.onopen
 * @param socket.onclose
 * @param socket.onmessage
 * @param socket.onerror
 */
Connection.prototype.bindToSocket = function(socket) {
  if (this.socket) {
    this.socket.close();
    this.socket.onmessage = null;
    this.socket.onopen = null;
    this.socket.onerror = null;
    this.socket.onclose = null;
  }

  this.socket = socket;

  // State of the connection. The corresponding events are emitted when this changes
  //
  // - 'connecting'   The connection is still being established, or we are still
  //                    waiting on the server to send us the initialization message
  // - 'connected'    The connection is open and we have connected to a server
  //                    and recieved the initialization message
  // - 'disconnected' Connection is closed, but it will reconnect automatically
  // - 'closed'       The connection was closed by the client, and will not reconnect
  // - 'stopped'      The connection was closed by the server, and will not reconnect
  var newState = connectionState(socket);
  this._setState(newState);

  // This is a helper variable the document uses to see whether we're
  // currently in a 'live' state. It is true if and only if we're connected
  this.canSend = false;

  var connection = this;

  socket.onmessage = function(event) {
    try {
      var data = (typeof event.data === 'string') ?
        JSON.parse(event.data) : event.data;
    } catch (err) {
      logger.warn('Failed to parse message', event);
      return;
    }

    if (connection.debug) logger.info('RECV', JSON.stringify(data));

    var request = {data: data};
    connection.emit('receive', request);
    if (!request.data) return;

    try {
      connection.handleMessage(request.data);
    } catch (err) {
      process.nextTick(function() {
        connection.emit('error', err);
      });
    }
  };

  socket.onopen = function() {
    connection._setState('connecting');
  };

  socket.onerror = function(err) {
    // This isn't the same as a regular error, because it will happen normally
    // from time to time. Your connection should probably automatically
    // reconnect anyway, but that should be triggered off onclose not onerror.
    // (onclose happens when onerror gets called anyway).
    connection.emit('connection error', err);
  };

  socket.onclose = function(reason) {
    // node-browserchannel reason values:
    //   'Closed' - The socket was manually closed by calling socket.close()
    //   'Stopped by server' - The server sent the stop message to tell the client not to try connecting
    //   'Request failed' - Server didn't respond to request (temporary, usually offline)
    //   'Unknown session ID' - Server session for client is missing (temporary, will immediately reestablish)

    if (reason === 'closed' || reason === 'Closed') {
      connection._setState('closed', reason);

    } else if (reason === 'stopped' || reason === 'Stopped by server') {
      connection._setState('stopped', reason);

    } else {
      connection._setState('disconnected', reason);
    }
  };
};

/**
 * @param {object} message
 * @param {String} message.a action
 */
Connection.prototype.handleMessage = function(message) {
  var err = null;
  if (message.error) {
    // wrap in Error object so can be passed through event emitters
    err = new Error(message.error.message);
    err.code = message.error.code;
    // Add the message data to the error object for more context
    err.data = message;
    delete message.error;
  }
  // Switch on the message action. Most messages are for documents and are
  // handled in the doc class.
  switch (message.a) {
    case 'init':
      // Client initialization packet
      if (message.protocol !== 1) {
        err = new ShareDBError(4019, 'Invalid protocol version');
        return this.emit('error', err);
      }
      if (types.map[message.type] !== types.defaultType) {
        err = new ShareDBError(4020, 'Invalid default type');
        return this.emit('error', err);
      }
      if (typeof message.id !== 'string') {
        err = new ShareDBError(4021, 'Invalid client id');
        return this.emit('error', err);
      }
      this.id = message.id;

      this._setState('connected');
      return;

    case 'qf':
      var query = this.queries[message.id];
      if (query) query._handleFetch(err, message.data, message.extra);
      return;
    case 'qs':
      var query = this.queries[message.id];
      if (query) query._handleSubscribe(err, message.data, message.extra);
      return;
    case 'qu':
      // Queries are removed immediately on calls to destroy, so we ignore
      // replies to query unsubscribes. Perhaps there should be a callback for
      // destroy, but this is currently unimplemented
      return;
    case 'q':
      // Query message. Pass this to the appropriate query object.
      var query = this.queries[message.id];
      if (!query) return;
      if (err) return query._handleError(err);
      if (message.diff) query._handleDiff(message.diff);
      if (message.hasOwnProperty('extra')) query._handleExtra(message.extra);
      return;

    case 'bf':
      return this._handleBulkMessage(message, '_handleFetch');
    case 'bs':
      return this._handleBulkMessage(message, '_handleSubscribe');
    case 'bu':
      return this._handleBulkMessage(message, '_handleUnsubscribe');

    case 'nf':
    case 'nt':
      return this._handleSnapshotFetch(err, message);

    case 'f':
      var doc = this.getExisting(message.c, message.d);
      if (doc) doc._handleFetch(err, message.data);
      return;
    case 's':
      var doc = this.getExisting(message.c, message.d);
      if (doc) doc._handleSubscribe(err, message.data);
      return;
    case 'u':
      var doc = this.getExisting(message.c, message.d);
      if (doc) doc._handleUnsubscribe(err);
      return;
    case 'op':
      var doc = this.getExisting(message.c, message.d);
      if (doc) doc._handleOp(err, message);
      return;

    case 'p':
      var doc = this.getExisting(message.c, message.d);
      if (doc) doc._handlePresence(err, message);
      return;

    default:
      logger.warn('Ignoring unrecognized message', message);
  }
};

Connection.prototype._handleBulkMessage = function(message, method) {
  if (message.data) {
    for (var id in message.data) {
      var doc = this.getExisting(message.c, id);
      if (doc) doc[method](message.error, message.data[id]);
    }
  } else if (Array.isArray(message.b)) {
    for (var i = 0; i < message.b.length; i++) {
      var id = message.b[i];
      var doc = this.getExisting(message.c, id);
      if (doc) doc[method](message.error);
    }
  } else if (message.b) {
    for (var id in message.b) {
      var doc = this.getExisting(message.c, id);
      if (doc) doc[method](message.error);
    }
  } else {
    logger.error('Invalid bulk message', message);
  }
};

Connection.prototype._reset = function() {
  this.seq = 1;
  this.id = null;
  this.agent = null;
};

// Set the connection's state. The connection is basically a state machine.
Connection.prototype._setState = function(newState, reason) {
  if (this.state === newState) return;

  // I made a state diagram. The only invalid transitions are getting to
  // 'connecting' from anywhere other than 'disconnected' and getting to
  // 'connected' from anywhere other than 'connecting'.
  if (
    (newState === 'connecting' && this.state !== 'disconnected' && this.state !== 'stopped' && this.state !== 'closed') ||
    (newState === 'connected' && this.state !== 'connecting')
  ) {
    var err = new ShareDBError(5007, 'Cannot transition directly from ' + this.state + ' to ' + newState);
    return this.emit('error', err);
  }

  this.state = newState;
  this.canSend = (newState === 'connected');

  if (newState === 'disconnected' || newState === 'stopped' || newState === 'closed') this._reset();

  // Group subscribes together to help server make more efficient calls
  this.startBulk();
  // Emit the event to all queries
  for (var id in this.queries) {
    var query = this.queries[id];
    query._onConnectionStateChanged();
  }
  // Emit the event to all documents
  for (var collection in this.collections) {
    var docs = this.collections[collection];
    for (var id in docs) {
      docs[id]._onConnectionStateChanged();
    }
  }
  // Emit the event to all snapshots
  for (var id in this._snapshotRequests) {
    var snapshotRequest = this._snapshotRequests[id];
    snapshotRequest._onConnectionStateChanged();
  }
  this.endBulk();

  this.emit(newState, reason);
  this.emit('state', newState, reason);
};

Connection.prototype.startBulk = function() {
  if (!this.bulk) this.bulk = {};
};

Connection.prototype.endBulk = function() {
  if (this.bulk) {
    for (var collection in this.bulk) {
      var actions = this.bulk[collection];
      this._sendBulk('f', collection, actions.f);
      this._sendBulk('s', collection, actions.s);
      this._sendBulk('u', collection, actions.u);
    }
  }
  this.bulk = null;
};

Connection.prototype._sendBulk = function(action, collection, values) {
  if (!values) return;
  var ids = [];
  var versions = {};
  var versionsCount = 0;
  var versionId;
  for (var id in values) {
    var value = values[id];
    if (value == null) {
      ids.push(id);
    } else {
      versions[id] = value;
      versionId = id;
      versionsCount++;
    }
  }
  if (ids.length === 1) {
    var id = ids[0];
    this.send({a: action, c: collection, d: id});
  } else if (ids.length) {
    this.send({a: 'b' + action, c: collection, b: ids});
  }
  if (versionsCount === 1) {
    var version = versions[versionId];
    this.send({a: action, c: collection, d: versionId, v: version});
  } else if (versionsCount) {
    this.send({a: 'b' + action, c: collection, b: versions});
  }
};

Connection.prototype._sendAction = function(action, doc, version) {
  // Ensure the doc is registered so that it receives the reply message
  this._addDoc(doc);
  if (this.bulk) {
    // Bulk subscribe
    var actions = this.bulk[doc.collection] || (this.bulk[doc.collection] = {});
    var versions = actions[action] || (actions[action] = {});
    var isDuplicate = versions.hasOwnProperty(doc.id);
    versions[doc.id] = version;
    return isDuplicate;
  } else {
    // Send single doc subscribe message
    var message = {a: action, c: doc.collection, d: doc.id, v: version};
    this.send(message);
  }
};

Connection.prototype.sendFetch = function(doc) {
  return this._sendAction('f', doc, doc.version);
};

Connection.prototype.sendSubscribe = function(doc) {
  return this._sendAction('s', doc, doc.version);
};

Connection.prototype.sendUnsubscribe = function(doc) {
  return this._sendAction('u', doc);
};

Connection.prototype.sendOp = function(doc, op) {
  // Ensure the doc is registered so that it receives the reply message
  this._addDoc(doc);
  var message = {
    a: 'op',
    c: doc.collection,
    d: doc.id,
    v: doc.version,
    src: op.src,
    seq: op.seq
  };
  if (op.op) message.op = op.op;
  if (op.create) message.create = op.create;
  if (op.del) message.del = op.del;
  this.send(message);
};

Connection.prototype.sendPresence = function(doc, data, requestReply) {
  // Ensure the doc is registered so that it receives the reply message
  this._addDoc(doc);
  var message = {
    a: 'p',
    c: doc.collection,
    d: doc.id,
    p: data,
    v: doc.version || 0,
    seq: this.seq++
  };
  if (requestReply) {
    message.r = true;
  }
  this.send(message);
};


/**
 * Sends a message down the socket
 */
Connection.prototype.send = function(message) {
  if (this.debug) logger.info('SEND', JSON.stringify(message));

  this.emit('send', message);
  this.socket.send(JSON.stringify(message));
};


/**
 * Closes the socket and emits 'closed'
 */
Connection.prototype.close = function() {
  this.socket.close();
};

Connection.prototype.getExisting = function(collection, id) {
  if (this.collections[collection]) return this.collections[collection][id];
};


/**
 * Get or create a document.
 *
 * @param collection
 * @param id
 * @return {Doc}
 */
Connection.prototype.get = function(collection, id) {
  var docs = this.collections[collection] ||
    (this.collections[collection] = {});

  var doc = docs[id];
  if (!doc) {
    doc = docs[id] = new Doc(this, collection, id);
    this.emit('doc', doc);
  }

  return doc;
};


/**
 * Remove document from this.collections
 *
 * @private
 */
Connection.prototype._destroyDoc = function(doc) {
  var docs = this.collections[doc.collection];
  if (!docs) return;

  delete docs[doc.id];

  // Delete the collection container if its empty. This could be a source of
  // memory leaks if you slowly make a billion collections, which you probably
  // won't do anyway, but whatever.
  if (!util.hasKeys(docs)) {
    delete this.collections[doc.collection];
  }
};

Connection.prototype._addDoc = function(doc) {
  var docs = this.collections[doc.collection];
  if (!docs) {
    docs = this.collections[doc.collection] = {};
  }
  if (docs[doc.id] !== doc) {
    docs[doc.id] = doc;
  }
};

// Helper for createFetchQuery and createSubscribeQuery, below.
Connection.prototype._createQuery = function(action, collection, q, options, callback) {
  var id = this.nextQueryId++;
  var query = new Query(action, this, id, collection, q, options, callback);
  this.queries[id] = query;
  query.send();
  return query;
};

// Internal function. Use query.destroy() to remove queries.
Connection.prototype._destroyQuery = function(query) {
  delete this.queries[query.id];
};

// The query options object can contain the following fields:
//
// db: Name of the db for the query. You can attach extraDbs to ShareDB and
//   pick which one the query should hit using this parameter.

// Create a fetch query. Fetch queries are only issued once, returning the
// results directly into the callback.
//
// The callback should have the signature function(error, results, extra)
// where results is a list of Doc objects.
Connection.prototype.createFetchQuery = function(collection, q, options, callback) {
  return this._createQuery('qf', collection, q, options, callback);
};

// Create a subscribe query. Subscribe queries return with the initial data
// through the callback, then update themselves whenever the query result set
// changes via their own event emitter.
//
// If present, the callback should have the signature function(error, results, extra)
// where results is a list of Doc objects.
Connection.prototype.createSubscribeQuery = function(collection, q, options, callback) {
  return this._createQuery('qs', collection, q, options, callback);
};

Connection.prototype.hasPending = function() {
  return !!(
    this._firstDoc(hasPending) ||
    this._firstQuery(hasPending) ||
    this._firstSnapshotRequest()
  );
};
function hasPending(object) {
  return object.hasPending();
}

Connection.prototype.hasWritePending = function() {
  return !!this._firstDoc(hasWritePending);
};
function hasWritePending(object) {
  return object.hasWritePending();
}

Connection.prototype.whenNothingPending = function(callback) {
  var doc = this._firstDoc(hasPending);
  if (doc) {
    // If a document is found with a pending operation, wait for it to emit
    // that nothing is pending anymore, and then recheck all documents again.
    // We have to recheck all documents, just in case another mutation has
    // been made in the meantime as a result of an event callback
    doc.once('nothing pending', this._nothingPendingRetry(callback));
    return;
  }
  var query = this._firstQuery(hasPending);
  if (query) {
    query.once('ready', this._nothingPendingRetry(callback));
    return;
  }
  var snapshotRequest = this._firstSnapshotRequest();
  if (snapshotRequest) {
    snapshotRequest.once('ready', this._nothingPendingRetry(callback));
    return;
  }
  // Call back when no pending operations
  process.nextTick(callback);
};
Connection.prototype._nothingPendingRetry = function(callback) {
  var connection = this;
  return function() {
    process.nextTick(function() {
      connection.whenNothingPending(callback);
    });
  };
};

Connection.prototype._firstDoc = function(fn) {
  for (var collection in this.collections) {
    var docs = this.collections[collection];
    for (var id in docs) {
      var doc = docs[id];
      if (fn(doc)) {
        return doc;
      }
    }
  }
};

Connection.prototype._firstQuery = function(fn) {
  for (var id in this.queries) {
    var query = this.queries[id];
    if (fn(query)) {
      return query;
    }
  }
};

Connection.prototype.createUndoManager = function(options) {
  var undoManager = new UndoManager(this, options);
  this.undoManagers.push(undoManager);
  return undoManager;
};

Connection.prototype.removeUndoManager = function(undoManager) {
  var index = this.undoManagers.indexOf(undoManager);
  if (index >= 0) {
    this.undoManagers.splice(index, 1);
  }
};

Connection.prototype.onDocLoad = function(doc) {
  for (var i = 0; i < this.undoManagers.length; i++) {
    this.undoManagers[i].onDocLoad(doc);
  }
};

Connection.prototype.onDocDestroy = function(doc) {
  for (var i = 0; i < this.undoManagers.length; i++) {
    this.undoManagers[i].onDocDestroy(doc);
  }
};

Connection.prototype.onDocCreate = function(doc) {
  for (var i = 0; i < this.undoManagers.length; i++) {
    this.undoManagers[i].onDocCreate(doc);
  }
};

Connection.prototype.onDocDelete = function(doc) {
  for (var i = 0; i < this.undoManagers.length; i++) {
    this.undoManagers[i].onDocDelete(doc);
  }
};

Connection.prototype.onDocOp = function(doc, op, undoOp, source, undoable, fixUp) {
  for (var i = 0; i < this.undoManagers.length; i++) {
    this.undoManagers[i].onDocOp(doc, op, undoOp, source, undoable, fixUp);
  }
};

Connection.prototype._firstSnapshotRequest = function () {
  for (var id in this._snapshotRequests) {
    return this._snapshotRequests[id];
  }
};

/**
 * Fetch a read-only snapshot at a given version
 *
 * @param collection - the collection name of the snapshot
 * @param id - the ID of the snapshot
 * @param version (optional) - the version number to fetch. If null, the latest version is fetched.
 * @param callback - (error, snapshot) => void, where snapshot takes the following schema:
 *
 * {
 *   id: string;         // ID of the snapshot
 *   v: number;          // version number of the snapshot
 *   type: string;       // the OT type of the snapshot, or null if it doesn't exist or is deleted
 *   data: any;          // the snapshot
 * }
 *
 */
Connection.prototype.fetchSnapshot = function(collection, id, version, callback) {
  if (typeof version === 'function') {
    callback = version;
    version = null;
  }

  var requestId = this.nextSnapshotRequestId++;
  var snapshotRequest = new SnapshotVersionRequest(this, requestId, collection, id, version, callback);
  this._snapshotRequests[snapshotRequest.requestId] = snapshotRequest;
  snapshotRequest.send();
};

/**
 * Fetch a read-only snapshot at a given timestamp
 *
 * @param collection - the collection name of the snapshot
 * @param id - the ID of the snapshot
 * @param timestamp (optional) - the timestamp to fetch. If null, the latest version is fetched.
 * @param callback - (error, snapshot) => void, where snapshot takes the following schema:
 *
 * {
 *   id: string;         // ID of the snapshot
 *   v: number;          // version number of the snapshot
 *   type: string;       // the OT type of the snapshot, or null if it doesn't exist or is deleted
 *   data: any;          // the snapshot
 * }
 *
 */
Connection.prototype.fetchSnapshotByTimestamp = function (collection, id, timestamp, callback) {
  if (typeof timestamp === 'function') {
    callback = timestamp;
    timestamp = null;
  }

  var requestId = this.nextSnapshotRequestId++;
  var snapshotRequest = new SnapshotTimestampRequest(this, requestId, collection, id, timestamp, callback);
  this._snapshotRequests[snapshotRequest.requestId] = snapshotRequest;
  snapshotRequest.send();
};

Connection.prototype._handleSnapshotFetch = function (error, message) {
  var snapshotRequest = this._snapshotRequests[message.id];
  if (!snapshotRequest) return;
  delete this._snapshotRequests[message.id];
  snapshotRequest._handleResponse(error, message);
};

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/@teamwork/sharedb/lib/client/doc.js":
/*!**********************************************************!*\
  !*** ./node_modules/@teamwork/sharedb/lib/client/doc.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var emitter = __webpack_require__(/*! ../emitter */ "./node_modules/@teamwork/sharedb/lib/emitter.js");
var logger = __webpack_require__(/*! ../logger */ "./node_modules/@teamwork/sharedb/lib/logger/index.js");
var ShareDBError = __webpack_require__(/*! ../error */ "./node_modules/@teamwork/sharedb/lib/error.js");
var types = __webpack_require__(/*! ../types */ "./node_modules/@teamwork/sharedb/lib/types.js");

/**
 * A Doc is a client's view on a sharejs document.
 *
 * It is is uniquely identified by its `id` and `collection`.  Documents
 * should not be created directly. Create them with connection.get()
 *
 *
 * Subscriptions
 * -------------
 *
 * We can subscribe a document to stay in sync with the server.
 *   doc.subscribe(function(error) {
 *     doc.subscribed // = true
 *   })
 * The server now sends us all changes concerning this document and these are
 * applied to our data. If the subscription was successful the initial
 * data and version sent by the server are loaded into the document.
 *
 * To stop listening to the changes we call `doc.unsubscribe()`.
 *
 * If we just want to load the data but not stay up-to-date, we call
 *   doc.fetch(function(error) {
 *     doc.data // sent by server
 *   })
 *
 *
 * Presence
 * --------
 *
 * We can associate transient "presence" data with a document, eg caret position, etc.
 * The presence data is synchronized on the best-effort basis between clients subscribed to the same document.
 * Each client has their own presence data which is read-write. Other clients' data is read-only.
 *
 *
 * Events
 * ------
 *
 * You can use doc.on(eventName, callback) to subscribe to the following events:
 * - `before op (op, source)` Fired before a partial operation is applied to the data.
 *   It may be used to read the old data just before applying an operation
 * - `op (op, source)` Fired after every partial operation with this operation as the
 *   first argument
 * - `create (source)` The document was created. That means its type was
 *   set and it has some initial data.
 * - `del (data, source)` Fired after the document is deleted, that is
 *   the data is null. It is passed the data before delteion as an
 *   arguments
 * - `load ()` Fired when a new snapshot is ingested from a fetch, subscribe, or query
 * - `presence ([src])` Fired after the presence data has changed.
 */

module.exports = Doc;
function Doc(connection, collection, id) {
  emitter.EventEmitter.call(this);

  this.connection = connection;

  this.collection = collection;
  this.id = id;

  this.version = null;
  this.type = null;
  this.data = undefined;

  // The current presence data
  // Map of src -> presence data
  // Local src === ''
  this.presence = Object.create(null);
  // The presence objects received from the server
  // Map of src -> presence
  this.receivedPresence = Object.create(null);
  // The minimum amount of time to wait before removing processed presence from this.receivedPresence.
  // The processed presence is removed to avoid leaking memory, in case peers keep connecting and disconnecting a lot.
  // The processed presence is not removed immediately to enable avoiding race conditions, where messages with lower
  // sequence number arrive after messages with higher sequence numbers.
  this.receivedPresenceTimeout = 60000;
  // If set to true, then the next time the local presence is sent,
  // all other clients will be asked to reply with their own presence data.
  this.requestReplyPresence = true;
  // A list of ops sent by the server. These are needed for transforming presence data,
  // if we get that presence data for an older version of the document.
  // The ops are cached for at least 1 minute by default, which should be lots, considering that the presence
  // data is supposed to be synced in real-time.
  this.cachedOps = [];
  this.cachedOpsTimeout = 60000;
  // The sequence number of the inflight presence request.
  this.inflightPresenceSeq = 0;

  // Array of callbacks or nulls as placeholders
  this.inflightFetch = [];
  this.inflightSubscribe = [];
  this.inflightUnsubscribe = [];
  this.inflightPresence = null;
  this.pendingFetch = [];
  this.pendingPresence = null;

  // Whether we think we are subscribed on the server. Synchronously set to
  // false on calls to unsubscribe and disconnect. Should never be true when
  // this.wantSubscribe is false
  this.subscribed = false;
  // Whether to re-establish the subscription on reconnect
  this.wantSubscribe = false;

  // The op that is currently roundtripping to the server, or null.
  //
  // When the connection reconnects, the inflight op is resubmitted.
  //
  // This has the same format as an entry in pendingOps
  this.inflightOp = null;

  // All ops that are waiting for the server to acknowledge this.inflightOp
  // This used to just be a single operation, but creates & deletes can't be
  // composed with regular operations.
  //
  // This is a list of {[create:{...}], [del:true], [op:...], callbacks:[...]}
  this.pendingOps = [];

  // The OT type of this document. An uncreated document has type `null`
  this.type = null;

  // The applyStack enables us to track any ops submitted while we are
  // applying an op incrementally. This value is an array when we are
  // performing an incremental apply and null otherwise. When it is an array,
  // all submitted ops should be pushed onto it. The `_otApply` method will
  // reset it back to null when all incremental apply loops are complete.
  this.applyStack = null;

  // Disable the default behavior of composing submitted ops. This is read at
  // the time of op submit, so it may be toggled on before submitting a
  // specifc op and toggled off afterward
  this.preventCompose = false;
}
emitter.mixin(Doc);

Doc.prototype.destroy = function(callback) {
  var doc = this;
  doc.whenNothingPending(function() {
    if (doc.wantSubscribe) {
      doc.unsubscribe(function(err) {
        if (err) {
          if (callback) return callback(err);
          return doc.emit('error', err);
        }
        doc.receivedPresence = Object.create(null);
        doc.cachedOps.length = 0;
        doc.connection._destroyDoc(doc);
        doc.connection.onDocDestroy(doc);
        if (callback) callback();
      });
    } else {
      doc.receivedPresence = Object.create(null);
      doc.cachedOps.length = 0;
      doc.connection._destroyDoc(doc);
      doc.connection.onDocDestroy(doc);
      if (callback) callback();
    }
  });
};


// ****** Manipulating the document data, version and type.

// Set the document's type, and associated properties. Most of the logic in
// this function exists to update the document based on any added & removed API
// methods.
//
// @param newType OT type provided by the ottypes library or its name or uri
Doc.prototype._setType = function(newType) {
  if (typeof newType === 'string') {
    newType = types.map[newType];
  }

  if (newType) {
    this.type = newType;

  } else if (newType === null) {
    this.type = newType;
    // If we removed the type from the object, also remove its data
    this.data = undefined;

  } else {
    var err = new ShareDBError(4008, 'Missing type ' + newType);
    return this.emit('error', err);
  }
};

// Ingest snapshot data. This data must include a version, snapshot and type.
// This is used both to ingest data that was exported with a webpage and data
// that was received from the server during a fetch.
//
// @param snapshot.v    version
// @param snapshot.data
// @param snapshot.type
// @param callback
Doc.prototype.ingestSnapshot = function(snapshot, callback) {
  if (!snapshot) return callback && callback();

  if (typeof snapshot.v !== 'number') {
    var err = new ShareDBError(5008, 'Missing version in ingested snapshot. ' + this.collection + '.' + this.id);
    if (callback) return callback(err);
    return this.emit('error', err);
  }

  // If the doc is already created or there are ops pending, we cannot use the
  // ingested snapshot and need ops in order to update the document
  if (this.type || this.hasWritePending()) {
    // The version should only be null on a created document when it was
    // created locally without fetching
    if (this.version == null) {
      if (this.hasWritePending()) {
        // If we have pending ops and we get a snapshot for a locally created
        // document, we have to wait for the pending ops to complete, because
        // we don't know what version to fetch ops from. It is possible that
        // the snapshot came from our local op, but it is also possible that
        // the doc was created remotely (which would conflict and be an error)
        return callback && this.once('no write pending', callback);
      }
      // Otherwise, we've encounted an error state
      var err = new ShareDBError(5009, 'Cannot ingest snapshot in doc with null version. ' + this.collection + '.' + this.id);
      if (callback) return callback(err);
      return this.emit('error', err);
    }
    // If we got a snapshot for a version further along than the document is
    // currently, issue a fetch to get the latest ops and catch us up
    if (snapshot.v > this.version) return this.fetch(callback);
    return callback && callback();
  }

  // Ignore the snapshot if we are already at a newer version. Under no
  // circumstance should we ever set the current version backward
  if (this.version > snapshot.v) return callback && callback();

  this.version = snapshot.v;
  this.cachedOps.length = 0;
  var type = (snapshot.type === undefined) ? types.defaultType : snapshot.type;
  this._setType(type);
  this.data = (this.type && this.type.deserialize) ?
    this.type.deserialize(snapshot.data) :
    snapshot.data;
  this.connection.onDocLoad(this);
  this.emit('load');
  this._processAllReceivedPresence();
  callback && callback();
};

Doc.prototype.whenNothingPending = function(callback) {
  var doc = this;
  process.nextTick(function() {
    if (doc.hasPending()) {
      doc.once('nothing pending', callback);
      return;
    }
    callback();
  });
};

Doc.prototype.hasPending = function() {
  return !!(
    this.inflightOp ||
    this.pendingOps.length ||
    this.inflightFetch.length ||
    this.inflightSubscribe.length ||
    this.inflightUnsubscribe.length ||
    this.pendingFetch.length ||
    this.inflightPresence ||
    this.pendingPresence
  );
};

Doc.prototype.hasWritePending = function() {
  return !!(this.inflightOp || this.pendingOps.length);
};

Doc.prototype._emitNothingPending = function() {
  if (this.hasWritePending()) return;
  this.emit('no write pending');
  if (this.hasPending()) return;
  this.emit('nothing pending');
};

// **** Helpers for network messages

Doc.prototype._emitResponseError = function(err, callback) {
  if (callback) {
    callback(err);
    this._emitNothingPending();
    return;
  }
  this._emitNothingPending();
  this.emit('error', err);
};

Doc.prototype._handleFetch = function(err, snapshot) {
  var callback = this.inflightFetch.shift();
  if (err) return this._emitResponseError(err, callback);
  this.ingestSnapshot(snapshot, callback);
  this._emitNothingPending();
};

Doc.prototype._handleSubscribe = function(err, snapshot) {
  var callback = this.inflightSubscribe.shift();
  if (err) return this._emitResponseError(err, callback);
  // Indicate we are subscribed only if the client still wants to be. In the
  // time since calling subscribe and receiving a response from the server,
  // unsubscribe could have been called and we might already be unsubscribed
  // but not have received the response. Also, because requests from the
  // client are not serialized and may take different async time to process,
  // it is possible that we could hear responses back in a different order
  // from the order originally sent
  if (this.wantSubscribe) this.subscribed = true;
  this.ingestSnapshot(snapshot, callback);
  this._emitNothingPending();
  this.flush();
};

Doc.prototype._handleUnsubscribe = function(err) {
  var callback = this.inflightUnsubscribe.shift();
  if (err) return this._emitResponseError(err, callback);
  if (callback) callback();
  this._emitNothingPending();
};

Doc.prototype._handleOp = function(err, message) {
  if (err) {
    if (this.inflightOp) {
      // The server has rejected submission of the current operation. If we get
      // an error code 4002 "Op submit rejected", this was done intentionally
      // and we should roll back but not return an error to the user.
      if (err.code === 4002) err = null;
      return this._rollback(err);
    }
    return this.emit('error', err);
  }

  if (this.inflightOp &&
      message.src === this.inflightOp.src &&
      message.seq === this.inflightOp.seq) {
    // The op has already been applied locally. Just update the version
    // and pending state appropriately
    this._opAcknowledged(message);
    return;
  }

  if (this.version == null || message.v > this.version) {
    // This will happen in normal operation if we become subscribed to a
    // new document via a query. It can also happen if we get an op for
    // a future version beyond the version we are expecting next. This
    // could happen if the server doesn't publish an op for whatever reason
    // or because of a race condition. In any case, we can send a fetch
    // command to catch back up.
    //
    // Fetch only sends a new fetch command if no fetches are inflight, which
    // will act as a natural debouncing so we don't send multiple fetch
    // requests for many ops received at once.
    this.fetch();
    return;
  }

  if (message.v < this.version) {
    // We can safely ignore the old (duplicate) operation.
    return;
  }

  var serverOp = {
    src: message.src,
    time: Date.now(),
    create: !!message.create,
    op: message.op,
    del: !!message.del
  };

  if (this.inflightOp) {
    var transformErr = transformX(this.inflightOp, message);
    if (transformErr) return this._hardRollback(transformErr);
  }

  for (var i = 0; i < this.pendingOps.length; i++) {
    var transformErr = transformX(this.pendingOps[i], message);
    if (transformErr) return this._hardRollback(transformErr);
  }

  this.version++;
  try {
    this._cacheOp(serverOp);
    this._otApply(message);
    this._processAllReceivedPresence();
  } catch (error) {
    return this._hardRollback(error);
  }
  return;
};

// Called whenever (you guessed it!) the connection state changes. This will
// happen when we get disconnected & reconnect.
Doc.prototype._onConnectionStateChanged = function() {
  if (this.connection.canSend) {
    this.flush();
    this._resubscribe();
  } else {
    if (this.inflightOp) {
      this.pendingOps.unshift(this.inflightOp);
      this.inflightOp = null;
    }
    this.subscribed = false;
    if (this.inflightFetch.length || this.inflightSubscribe.length) {
      this.pendingFetch = this.pendingFetch.concat(this.inflightFetch, this.inflightSubscribe);
      this.inflightFetch.length = 0;
      this.inflightSubscribe.length = 0;
    }
    if (this.inflightUnsubscribe.length) {
      var callbacks = this.inflightUnsubscribe;
      this.inflightUnsubscribe = [];
      this._pausePresence();
      callEach(callbacks);
    } else {
      this._pausePresence();
    }
  }
};

Doc.prototype._resubscribe = function() {
  var doc = this;
  var callbacks = this.pendingFetch;
  this.pendingFetch = [];

  if (this.wantSubscribe) {
    if (callbacks.length) {
      this.subscribe(function(err) {
        var called = callEach(callbacks, err);
        if (err && !called) doc.emit('error', err);
      });
      return;
    }
    this.subscribe();
    return;
  }

  if (callbacks.length) {
    this.fetch(function(err) {
      var called = callEach(callbacks, err);
      if (err && !called) doc.emit('error', err);
    });
  }
};

// Request the current document snapshot or ops that bring us up to date
Doc.prototype.fetch = function(callback) {
  if (this.connection.canSend) {
    var isDuplicate = this.connection.sendFetch(this);
    pushActionCallback(this.inflightFetch, isDuplicate, callback);
    return;
  }
  this.pendingFetch.push(callback);
};

// Fetch the initial document and keep receiving updates
Doc.prototype.subscribe = function(callback) {
  this.wantSubscribe = true;
  if (this.connection.canSend) {
    var isDuplicate = this.connection.sendSubscribe(this);
    pushActionCallback(this.inflightSubscribe, isDuplicate, callback);
    return;
  }
  this.pendingFetch.push(callback);
};

// Unsubscribe. The data will stay around in local memory, but we'll stop
// receiving updates
Doc.prototype.unsubscribe = function(callback) {
  this.wantSubscribe = false;
  // The subscribed state should be conservative in indicating when we are
  // subscribed on the server. We'll actually be unsubscribed some time
  // between sending the message and hearing back, but we cannot know exactly
  // when. Thus, immediately mark us as not subscribed
  this.subscribed = false;
  if (this.connection.canSend) {
    var isDuplicate = this.connection.sendUnsubscribe(this);
    pushActionCallback(this.inflightUnsubscribe, isDuplicate, callback);
    this._pausePresence();
    return;
  }
  this._pausePresence();
  if (callback) process.nextTick(callback);
};

function pushActionCallback(inflight, isDuplicate, callback) {
  if (isDuplicate) {
    var lastCallback = inflight.pop();
    inflight.push(function(err) {
      lastCallback && lastCallback(err);
      callback && callback(err);
    });
  } else {
    inflight.push(callback);
  }
}


// Operations //

// Send the next pending op to the server, if we can.
//
// Only one operation can be in-flight at a time. If an operation is already on
// its way, or we're not currently connected, this method does nothing.
//
// If there are no pending ops, this method sends the pending presence data, if possible.
Doc.prototype.flush = function() {
  if (this.paused) return;

  if (this.connection.canSend && !this.inflightOp && this.pendingOps.length) {
    this._sendOp();
  }

  if (this.subscribed && !this.inflightPresence && this.pendingPresence && !this.hasWritePending()) {
    this.inflightPresence = this.pendingPresence;
    this.inflightPresenceSeq = this.connection.seq;
    this.pendingPresence = null;
    this.connection.sendPresence(this, this.presence[''], this.requestReplyPresence);
    this.requestReplyPresence = false;
  }
};

// Helper function to set op to contain a no-op.
function setNoOp(op) {
  delete op.op;
  delete op.create;
  delete op.del;
}

// Transform server op data by a client op, and vice versa. Ops are edited in place.
function transformX(client, server) {
  // Order of statements in this function matters. Be especially careful if
  // refactoring this function

  // A client delete op should dominate if both the server and the client
  // delete the document. Thus, any ops following the client delete (such as a
  // subsequent create) will be maintained, since the server op is transformed
  // to a no-op
  if (client.del) return setNoOp(server);

  if (server.del) {
    return new ShareDBError(4017, 'Document was deleted');
  }
  if (server.create) {
    return new ShareDBError(4018, 'Document alredy created');
  }

  // Ignore no-op coming from server
  if (!server.op) return;

  // I believe that this should not occur, but check just in case
  if (client.create) {
    return new ShareDBError(4018, 'Document already created');
  }

  // They both edited the document. This is the normal case for this function -
  // as in, most of the time we'll end up down here.
  //
  // You should be wondering why I'm using client.type instead of this.type.
  // The reason is, if we get ops at an old version of the document, this.type
  // might be undefined or a totally different type. By pinning the type to the
  // op data, we make sure the right type has its transform function called.
  if (client.type.transformX) {
    var result = client.type.transformX(client.op, server.op);
    client.op = result[0];
    server.op = result[1];
  } else {
    var clientOp = client.type.transform(client.op, server.op, 'left');
    var serverOp = client.type.transform(server.op, client.op, 'right');
    client.op = clientOp;
    server.op = serverOp;
  }
};

/**
 * Applies the operation to the snapshot
 *
 * If the operation is create or delete it emits `create` or `del`. Then the
 * operation is applied to the snapshot and `op` and `after op` are emitted.
 * If the type supports incremental updates and `this.incremental` is true we
 * fire `op` after every small operation.
 *
 * This is the only function to fire the above mentioned events.
 *
 * @private
 */
Doc.prototype._otApply = function(op, options) {
  var source = options && options.source || false;
  if (op.op) {
    if (!this.type) {
      // Throw here, because all usage of _otApply should be wrapped with a try/catch
      throw new ShareDBError(4015, 'Cannot apply op to uncreated document. ' + this.collection + '.' + this.id);
    }
    var undoOp = options && options.undoOp || null;
    var undoable = options && options.undoable || false;
    var fixUp = options && options.fixUp || false;

    // Iteratively apply multi-component remote operations and rollback ops
    // (source === false) for the default JSON0 OT type. It could use
    // type.shatter(), but since this code is so specific to use cases for the
    // JSON0 type and ShareDB explicitly bundles the default type, we might as
    // well write it this way and save needing to iterate through the op
    // components twice.
    //
    // Ideally, we would not need this extra complexity. However, it is
    // helpful for implementing bindings that update DOM nodes and other
    // stateful objects by translating op events directly into corresponding
    // mutations. Such bindings are most easily written as responding to
    // individual op components one at a time in order, and it is important
    // that the snapshot only include updates from the particular op component
    // at the time of emission. Eliminating this would require rethinking how
    // such external bindings are implemented.
    if (!source && this.type === types.defaultType && op.op.length > 1) {
      if (!this.applyStack) this.applyStack = [];
      var stackLength = this.applyStack.length;
      for (var i = 0; i < op.op.length; i++) {
        var component = op.op[i];
        var componentOp = {op: [component]};
        // Transform componentOp against any ops that have been submitted
        // sychronously inside of an op event handler since we began apply of
        // our operation
        for (var j = stackLength; j < this.applyStack.length; j++) {
          var transformErr = transformX(this.applyStack[j], componentOp);
          if (transformErr) return this._hardRollback(transformErr);
        }
        // Apply the individual op component
        this.emit('before op', componentOp.op, source);
        this._applyOp(componentOp, undoOp, source, undoable, fixUp);
        this._transformAllPresence(componentOp);
        this.emit('op', componentOp.op, source);
      }
      // Pop whatever was submitted since we started applying this op
      this._popApplyStack(stackLength);
      return;
    }

    // The 'before op' event enables clients to pull any necessary data out of
    // the snapshot before it gets changed
    this.emit('before op', op.op, source);
    // Apply the operation to the local data, mutating it in place
    this._applyOp(op, undoOp, source, undoable, fixUp);
    this._transformAllPresence(op);
    // Emit an 'op' event once the local data includes the changes from the
    // op. For locally submitted ops, this will be synchronously with
    // submission and before the server or other clients have received the op.
    // For ops from other clients, this will be after the op has been
    // committed to the database and published
    this.emit('op', op.op, source);
    return;
  }

  if (op.create) {
    this._setType(op.create.type);
    this.data = (this.type.deserialize) ?
      (this.type.createDeserialized) ?
        this.type.createDeserialized(op.create.data) :
        this.type.deserialize(this.type.create(op.create.data)) :
      this.type.create(op.create.data);
    this._transformAllPresence(op);
    this.connection.onDocCreate(this);
    this.emit('create', source);
    return;
  }

  if (op.del) {
    var oldData = this.data;
    this._setType(null);
    this._transformAllPresence(op);
    this.connection.onDocDelete(this);
    this.emit('del', oldData, source);
    return;
  }
};

// Applies `op` to `this.data` and updates the undo/redo stacks.
Doc.prototype._applyOp = function(op, undoOp, source, undoable, fixUp) {
  if (undoOp == null && (undoable || fixUp || op.needsUndoOp)) {
    if (this.type.applyAndInvert) {
      var result = this.type.applyAndInvert(this.data, op.op);
      this.data = result[0];
      undoOp = { op: result[1] };
    } else {
      this.data = this.type.apply(this.data, op.op);
      undoOp = { op: this.type.invert(op.op) };
    }
  } else {
    this.data = this.type.apply(this.data, op.op);
  }

  this.connection.onDocOp(this, op, undoOp, source, undoable, fixUp);
};

// ***** Sending operations

// Actually send op to the server.
Doc.prototype._sendOp = function() {
  // Wait until we have a src id from the server
  var src = this.connection.id;
  if (!src) return;

  // When there is no inflightOp, send the first item in pendingOps. If
  // there is inflightOp, try sending it again
  if (!this.inflightOp) {
    // Send first pending op
    this.inflightOp = this.pendingOps.shift();
  }
  var op = this.inflightOp;
  if (!op) {
    var err = new ShareDBError(5010, 'No op to send on call to _sendOp');
    return this.emit('error', err);
  }

  // Track data for retrying ops
  op.sentAt = Date.now();
  op.retries = (op.retries == null) ? 0 : op.retries + 1;

  // The src + seq number is a unique ID representing this operation. This tuple
  // is used on the server to detect when ops have been sent multiple times and
  // on the client to match acknowledgement of an op back to the inflightOp.
  // Note that the src could be different from this.connection.id after a
  // reconnect, since an op may still be pending after the reconnection and
  // this.connection.id will change. In case an op is sent multiple times, we
  // also need to be careful not to override the original seq value.
  if (op.seq == null) op.seq = this.connection.seq++;

  this.connection.sendOp(this, op);

  // src isn't needed on the first try, since the server session will have the
  // same id, but it must be set on the inflightOp in case it is sent again
  // after a reconnect and the connection's id has changed by then
  if (op.src == null) op.src = src;
};


// Queues the operation for submission to the server and applies it locally.
//
// Internal method called to do the actual work for submit(), create() and del().
// @private
//
// @param op
// @param [op.op]
// @param [op.del]
// @param [op.create]
// @param options { source, skipNoop, undoable, undoOp, fixUp }
// @param [callback] called when operation is submitted
Doc.prototype._submit = function(op, options, callback) {
  if (!options) options = {};

  // Locally submitted ops must always have a truthy source
  if (!options.source) options.source = true;

  // The op contains either op, create, delete, or none of the above (a no-op).
  if (op.op) {
    if (!this.type) {
      var err = new ShareDBError(4015, 'Cannot submit op. Document has not been created. ' + this.collection + '.' + this.id);
      if (callback) return callback(err);
      return this.emit('error', err);
    }
    var needsUndoOp = options.undoable || options.fixUp || op.needsUndoOp;
    if (needsUndoOp && !this.type.invert && !this.type.applyAndInvert) {
      var err = new ShareDBError(4028, 'Cannot submit op. OT type does not support invert not applyAndInvert. ' + this.collection + '.' + this.id);
      if (callback) return callback(err);
      return this.emit('error', err);
    }
    // Try to normalize the op. This removes trailing skip:0's and things like that.
    if (this.type.normalize) op.op = this.type.normalize(op.op);
    // Try to skip processing no-ops.
    if (options.skipNoop && this.type.isNoop && this.type.isNoop(op.op)) {
      if (callback) process.nextTick(callback);
      return;
    }
  }

  try {
    this._pushOp(op, callback);
    this._otApply(op, options);
  } catch (error) {
    return this._hardRollback(error);
  }

  // The call to flush is delayed so if submit() is called multiple times
  // synchronously, all the ops are combined before being sent to the server.
  var doc = this;
  process.nextTick(function() {
    doc.flush();
  });
};

Doc.prototype._pushOp = function(op, callback) {
  if (this.applyStack) {
    // If we are in the process of incrementally applying an operation, don't
    // compose the op and push it onto the applyStack so it can be transformed
    // against other components from the op or ops being applied
    this.applyStack.push(op);
  } else {
    // If the type supports composes, try to compose the operation onto the
    // end of the last pending operation.
    var composed = this._tryCompose(op);
    if (composed) {
      composed.callbacks.push(callback);
      return;
    }
  }
  // Push on to the pendingOps queue of ops to submit if we didn't compose
  op.type = this.type;
  op.callbacks = [callback];
  this.pendingOps.push(op);
};

Doc.prototype._popApplyStack = function(to) {
  if (to > 0) {
    this.applyStack.length = to;
    return;
  }
  // Once we have completed the outermost apply loop, reset to null and no
  // longer add ops to the applyStack as they are submitted
  var op = this.applyStack[0];
  this.applyStack = null;
  if (!op) return;
  // Compose the ops added since the beginning of the apply stack, since we
  // had to skip compose when they were originally pushed
  var i = this.pendingOps.indexOf(op);
  if (i === -1) return;
  var ops = this.pendingOps.splice(i);
  for (var i = 0; i < ops.length; i++) {
    var op = ops[i];
    var composed = this._tryCompose(op);
    if (composed) {
      composed.callbacks = composed.callbacks.concat(op.callbacks);
    } else {
      this.pendingOps.push(op);
    }
  }
};

// Try to compose a submitted op into the last pending op. Returns the
// composed op if it succeeds, undefined otherwise
Doc.prototype._tryCompose = function(op) {
  if (this.preventCompose) return;

  // We can only compose into the last pending op. Inflight ops have already
  // been sent to the server, so we can't modify them
  var last = this.pendingOps[this.pendingOps.length - 1];
  if (!last || last.sentAt) return;

  // Compose two ops into a single op if supported by the type. Types that
  // support compose must be able to compose any two ops together
  if (last.op && op.op && this.type.compose) {
    last.op = this.type.compose(last.op, op.op);
    return last;
  }
};

// *** Client OT entrypoints.

// Submit an operation to the document.
//
// @param component operation handled by the OT type
// @param options.source passed into 'op' event handler
// @param options.skipNoop should processing be skipped entirely, if `component` is a no-op.
// @param options.undoable should the operation be undoable
// @param options.fixUp If true, this operation is meant to fix the current invalid state of the snapshot.
//   It also updates UndoManagers accordingly. This feature requires the OT type to implement `compose`.
// @param [callback] called after operation submitted
//
// @fires before op, op
Doc.prototype.submitOp = function(component, options, callback) {
  if (typeof options === 'function') {
    callback = options;
    options = null;
  }
  var op = {op: component};
  var submitOptions = {
    source: options && options.source,
    skipNoop: options && options.skipNoop,
    undoable: options && options.undoable,
    fixUp: options && options.fixUp
  };
  this._submit(op, submitOptions, callback);
};

// Submits new content for the document.
//
// This function works only if the type supports `diff` or `diffX`.
// It diffs the current and new snapshot to generate an operation,
// which is then submitted as usual.
//
// @param snapshot new snapshot data
// @param options.source passed into 'op' event handler
// @param options.skipNoop should processing be skipped entirely, if the generated operation is a no-op.
// @param options.undoable should the operation be undoable
// @param options.fixUp If true, this operation is meant to fix the current invalid state of the snapshot.
//   It also updates UndoManagers accordingly. This feature requires the OT type to implement `compose`.
// @param options.diffHint a hint passed into diff/diffX
// @param [callback] called after operation submitted

// @fires before op, op
Doc.prototype.submitSnapshot = function(snapshot, options, callback) {
  if (typeof options === 'function') {
    callback = options;
    options = null;
  }
  if (!this.type) {
    var err = new ShareDBError(4015, 'Cannot submit snapshot. Document has not been created. ' + this.collection + '.' + this.id);
    if (callback) return callback(err);
    return this.emit('error', err);
  }
  if (!this.type.diff && !this.type.diffX) {
    var err = new ShareDBError(4027, 'Cannot submit snapshot. Document type does not support diff nor diffX. ' + this.collection + '.' + this.id);
    if (callback) return callback(err);
    return this.emit('error', err);
  }

  var undoable = !!(options && options.undoable);
  var fixUp = options && options.fixUp;
  var diffHint = options && options.diffHint;
  var needsUndoOp = undoable || fixUp;
  var op, undoOp;

  if ((needsUndoOp && this.type.diffX) || !this.type.diff) {
    var diffs = this.type.diffX(this.data, snapshot, diffHint);
    undoOp = { op: diffs[0] };
    op = { op: diffs[1] };
  } else {
    undoOp = null;
    op = { op: this.type.diff(this.data, snapshot, diffHint) };
  }

  var submitOptions = {
    source: options && options.source,
    skipNoop: options && options.skipNoop,
    undoable: undoable,
    undoOp: undoOp,
    fixUp: fixUp
  };
  this._submit(op, submitOptions, callback);
};

// Create the document, which in ShareJS semantics means to set its type. Every
// object implicitly exists in the database but has no data and no type. Create
// sets the type of the object and can optionally set some initial data on the
// object, depending on the type.
//
// @param data  initial
// @param type  OT type
// @param options  {source: ...}
// @param callback  called when operation submitted
Doc.prototype.create = function(data, type, options, callback) {
  if (typeof type === 'function') {
    callback = type;
    options = null;
    type = null;
  } else if (typeof options === 'function') {
    callback = options;
    options = null;
  }
  if (!type) {
    type = types.defaultType.uri;
  }
  if (this.type) {
    var err = new ShareDBError(4016, 'Document already exists');
    if (callback) return callback(err);
    return this.emit('error', err);
  }
  var op = {create: {type: type, data: data}};
  var source = options && options.source;
  this._submit(op, { source: source }, callback);
};

// Delete the document. This creates and submits a delete operation to the
// server. Deleting resets the object's type to null and deletes its data. The
// document still exists, and still has the version it used to have before you
// deleted it (well, old version +1).
//
// @param options  {source: ...}
// @param callback  called when operation submitted
Doc.prototype.del = function(options, callback) {
  if (typeof options === 'function') {
    callback = options;
    options = null;
  }
  if (!this.type) {
    var err = new ShareDBError(4015, 'Document does not exist');
    if (callback) return callback(err);
    return this.emit('error', err);
  }
  var op = {del: true};
  var source = options && options.source;
  this._submit(op, { source: source }, callback);
};


// Stops the document from sending any operations to the server.
Doc.prototype.pause = function() {
  this.paused = true;
};

// Continue sending operations to the server
Doc.prototype.resume = function() {
  this.paused = false;
  this.flush();
};


// *** Receiving operations

// This is called when the server acknowledges an operation from the client.
Doc.prototype._opAcknowledged = function(message) {
  if (this.inflightOp.create) {
    this.version = message.v;
    this.cachedOps.length = 0;

  } else if (message.v !== this.version) {
    // We should already be at the same version, because the server should
    // have sent all the ops that have happened before acknowledging our op
    logger.warn('Invalid version from server. Expected: ' + this.version + ' Received: ' + message.v, message);

    // Fetching should get us back to a working document state
    return this.fetch();
  }

  // The op was committed successfully. Increment the version number
  this.version++;
  this._cacheOp({
    src: this.inflightOp.src,
    time: Date.now(),
    create: !!this.inflightOp.create,
    op: this.inflightOp.op,
    del: !!this.inflightOp.del
  });

  this._clearInflightOp();
  this._processAllReceivedPresence();
};

Doc.prototype._rollback = function(err) {
  // The server has rejected submission of the current operation. Invert by
  // just the inflight op if possible. If not possible to invert, cancel all
  // pending ops and fetch the latest from the server to get us back into a
  // working state, then call back
  var op = this.inflightOp;

  if (op.op && op.type.invert) {
    op.op = op.type.invert(op.op);

    // Transform the undo operation by any pending ops.
    for (var i = 0; i < this.pendingOps.length; i++) {
      var transformErr = transformX(this.pendingOps[i], op);
      if (transformErr) return this._hardRollback(transformErr);
    }

    // ... and apply it locally, reverting the changes.
    //
    // This operation is applied to look like it comes from a remote source.
    // I'm still not 100% sure about this functionality, because its really a
    // local op. Basically, the problem is that if the client's op is rejected
    // by the server, the editor window should update to reflect the undo.
    try {
      this._otApply(op);
    } catch (error) {
      return this._hardRollback(error);
    }

    this._clearInflightOp(err);
    return;
  }

  this._hardRollback(err);
};

Doc.prototype._hardRollback = function(err) {
  var callbacks = [];
  if (this.inflightPresence) {
    callbacks.push.apply(callbacks, this.inflightPresence);
    this.inflightPresence = null;
    this.inflightPresenceSeq = 0;
  }
  if (this.pendingPresence) {
    callbacks.push.apply(callbacks, this.pendingPresence);
    this.pendingPresence = null;
  }
  if (this.inflightOp) {
    callbacks.push.apply(callbacks, this.inflightOp.callbacks);
  }
  for (var i = 0; i < this.pendingOps.length; i++) {
    callbacks.push.apply(callbacks, this.pendingOps[i].callbacks);
  }

  this._setType(null);
  this.version = null;
  this.inflightOp = null;
  this.pendingOps = [];
  this.cachedOps.length = 0;
  this.receivedPresence = Object.create(null);
  this.requestReplyPresence = true;

  var srcList = Object.keys(this.presence);
  var changedSrcList = [];
  for (var i = 0; i < srcList.length; i++) {
    var src = srcList[i];
    if (this._setPresence(src, null)) {
      changedSrcList.push(src);
    }
  }
  this._emitPresence(changedSrcList, false);

  // Fetch the latest version from the server to get us back into a working state
  var doc = this;
  this.fetch(function() {
    var called = callEach(callbacks, err);
    if (err && !called) return doc.emit('error', err);
  });
};

Doc.prototype._clearInflightOp = function(err) {
  var callbacks = this.inflightOp && this.inflightOp.callbacks;
  this.inflightOp = null;
  var called = callbacks && callEach(callbacks, err);

  this.flush();
  this._emitNothingPending();

  if (err && !called) return this.emit('error', err);
};

function callEach(callbacks, err) {
  var called = false;
  for (var i = 0; i < callbacks.length; i++) {
    var callback = callbacks[i];
    if (callback) {
      callback(err);
      called = true;
    }
  }
  return called;
}

// *** Presence

Doc.prototype.submitPresence = function (data, callback) {
  if (data != null) {
    if (!this.type) {
      var doc = this;
      return process.nextTick(function() {
        var err = new ShareDBError(4015, 'Cannot submit presence. Document has not been created. ' + doc.collection + '.' + doc.id);
        if (callback) return callback(err);
        doc.emit('error', err);
      });
    }

    if (!this.type.createPresence || !this.type.transformPresence) {
      var doc = this;
      return process.nextTick(function() {
        var err = new ShareDBError(4029, 'Cannot submit presence. Document\'s type does not support presence. ' + doc.collection + '.' + doc.id);
        if (callback) return callback(err);
        doc.emit('error', err);
      });
    }

    data = this.type.createPresence(data);
  }

  if (this._setPresence('', data, true) || this.pendingPresence || this.inflightPresence) {
    if (!this.pendingPresence) {
      this.pendingPresence = [];
    }
    if (callback) {
      this.pendingPresence.push(callback);
    }

  } else if (callback) {
    process.nextTick(callback);
  }

  var doc = this;
  process.nextTick(function() {
    doc.flush();
  });
};

Doc.prototype._handlePresence = function(err, presence) {
  if (!this.subscribed) return;

  var src = presence.src;
  if (!src) {
    // Handle the ACK for the presence data we submitted.
    // this.inflightPresenceSeq would not equal presence.seq after a hard rollback,
    // when all callbacks are flushed with an error.
    if (this.inflightPresenceSeq === presence.seq) {
      var callbacks = this.inflightPresence;
      this.inflightPresence = null;
      this.inflightPresenceSeq = 0;
      var called = callbacks && callEach(callbacks, err);
      if (err && !called) this.emit('error', err);
      this.flush();
      this._emitNothingPending();
    }
    return;
  }

  // This shouldn't happen but check just in case.
  if (err) return this.emit('error', err);

  if (presence.r && !this.pendingPresence) {
    // Another client requested us to share our current presence data
    this.pendingPresence = [];
    this.flush();
  }

  // Ignore older messages which arrived out of order
  if (
    this.receivedPresence[src] && (
      this.receivedPresence[src].seq > presence.seq ||
      (this.receivedPresence[src].seq === presence.seq && presence.v != null)
    )
  ) return;

  this.receivedPresence[src] = presence;

  if (presence.v == null) {
      // null version should happen only when the server automatically sends
      // null presence for an unsubscribed client
      presence.processedAt = Date.now();
      return this._setPresence(src, null, true);
  }

  // Get missing ops first, if necessary
  if (this.version == null || this.version < presence.v) return this.fetch();

  this._processReceivedPresence(src, true);
};

// If emit is true and presence has changed, emits a presence event.
// Returns true, if presence has changed for src. Otherwise false.
Doc.prototype._processReceivedPresence = function(src, emit) {
  if (!src) return false;
  var presence = this.receivedPresence[src];
  if (!presence) return false;

  if (presence.processedAt != null) {
    if (Date.now() >= presence.processedAt + this.receivedPresenceTimeout) {
        // Remove old received and processed presence
        delete this.receivedPresence[src];
    }
    return false;
  }

  if (this.version == null || this.version < presence.v) return false; // keep waiting for the missing snapshot or ops

  if (presence.p == null) {
    // Remove presence data as requested
    presence.processedAt = Date.now();
    return this._setPresence(src, null, emit);
  }

  if (!this.type || !this.type.createPresence || !this.type.transformPresence) {
    // Remove presence data because the document is not created or its type does not support presence
    presence.processedAt = Date.now();
    return this._setPresence(src, null, emit);
  }

  if (this.inflightOp && this.inflightOp.op == null) {
    // Remove presence data because receivedPresence can be transformed only against "op", not "create" nor "del"
    presence.processedAt = Date.now();
    return this._setPresence(src, null, emit);
  }

  for (var i = 0; i < this.pendingOps.length; i++) {
    if (this.pendingOps[i].op == null) {
      // Remove presence data because receivedPresence can be transformed only against "op", not "create" nor "del"
      presence.processedAt = Date.now();
      return this._setPresence(src, null, emit);
    }
  }

  var startIndex = this.cachedOps.length - (this.version - presence.v);
  if (startIndex < 0) {
    // Remove presence data because we can't transform receivedPresence
    presence.processedAt = Date.now();
    return this._setPresence(src, null, emit);
  }

  for (var i = startIndex; i < this.cachedOps.length; i++) {
    if (this.cachedOps[i].op == null) {
      // Remove presence data because receivedPresence can be transformed only against "op", not "create" nor "del"
      presence.processedAt = Date.now();
      return this._setPresence(src, null, emit);
    }
  }

  // Make sure the format of the data is correct
  var data = this.type.createPresence(presence.p);

  // Transform against past ops
  for (var i = startIndex; i < this.cachedOps.length; i++) {
    var op = this.cachedOps[i];
    data = this.type.transformPresence(data, op.op, presence.src === op.src);
  }

  // Transform against pending ops
  if (this.inflightOp) {
    data = this.type.transformPresence(data, this.inflightOp.op, false);
  }

  for (var i = 0; i < this.pendingOps.length; i++) {
    data = this.type.transformPresence(data, this.pendingOps[i].op, false);
  }

  // Set presence data
  presence.processedAt = Date.now();
  return this._setPresence(src, data, emit);
};

Doc.prototype._processAllReceivedPresence = function() {
  var srcList = Object.keys(this.receivedPresence);
  var changedSrcList = [];
  for (var i = 0; i < srcList.length; i++) {
    var src = srcList[i];
    if (this._processReceivedPresence(src)) {
        changedSrcList.push(src);
    }
  }
  this._emitPresence(changedSrcList, true);
};

Doc.prototype._transformPresence = function(src, op) {
  var presenceData = this.presence[src];
  if (op.op != null) {
    var isOwnOperation = src === (op.src || '');
    presenceData = this.type.transformPresence(presenceData, op.op, isOwnOperation);
  } else {
    presenceData = null;
  }
  return this._setPresence(src, presenceData);
};

Doc.prototype._transformAllPresence = function(op) {
  var srcList = Object.keys(this.presence);
  var changedSrcList = [];
  for (var i = 0; i < srcList.length; i++) {
    var src = srcList[i];
    if (this._transformPresence(src, op)) {
      changedSrcList.push(src);
    }
  }
  this._emitPresence(changedSrcList, false);
};

Doc.prototype._pausePresence = function() {
  if (this.inflightPresence) {
    this.pendingPresence =
      this.pendingPresence ?
        this.inflightPresence.concat(this.pendingPresence) :
        this.inflightPresence;
    this.inflightPresence = null;
    this.inflightPresenceSeq = 0;
  } else if (!this.pendingPresence && this.presence[''] != null) {
    this.pendingPresence = [];
  }
  this.receivedPresence = Object.create(null);
  this.requestReplyPresence = true;
  var srcList = Object.keys(this.presence);
  var changedSrcList = [];
  for (var i = 0; i < srcList.length; i++) {
    var src = srcList[i];
    if (src && this._setPresence(src, null)) {
      changedSrcList.push(src);
    }
  }
  this._emitPresence(changedSrcList, false);
};

// If emit is true and presence has changed, emits a presence event.
// Returns true, if presence has changed. Otherwise false.
Doc.prototype._setPresence = function(src, data, emit) {
  if (data == null) {
    if (this.presence[src] == null) return false;
    delete this.presence[src];
  } else {
    var isPresenceEqual =
      this.presence[src] === data ||
      (this.type.comparePresence && this.type.comparePresence(this.presence[src], data));
    if (isPresenceEqual) return false;
    this.presence[src] = data;
  }
  if (emit) this._emitPresence([ src ], true);
  return true;
};

Doc.prototype._emitPresence = function(srcList, submitted) {
  if (srcList && srcList.length > 0) {
    var doc = this;
    process.nextTick(function() {
      doc.emit('presence', srcList, submitted);
    });
  }
};

Doc.prototype._cacheOp = function(op) {
  // Remove the old ops.
  var oldOpTime = Date.now() - this.cachedOpsTimeout;
  var i;
  for (i = 0; i < this.cachedOps.length; i++) {
    if (this.cachedOps[i].time >= oldOpTime) {
      break;
    }
  }
  if (i > 0) {
    this.cachedOps.splice(0, i);
  }

  // Cache the new op.
  this.cachedOps.push(op);
};

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/@teamwork/sharedb/lib/client/index.js":
/*!************************************************************!*\
  !*** ./node_modules/@teamwork/sharedb/lib/client/index.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

exports.Connection = __webpack_require__(/*! ./connection */ "./node_modules/@teamwork/sharedb/lib/client/connection.js");
exports.Doc = __webpack_require__(/*! ./doc */ "./node_modules/@teamwork/sharedb/lib/client/doc.js");
exports.Error = __webpack_require__(/*! ../error */ "./node_modules/@teamwork/sharedb/lib/error.js");
exports.Query = __webpack_require__(/*! ./query */ "./node_modules/@teamwork/sharedb/lib/client/query.js");
exports.types = __webpack_require__(/*! ../types */ "./node_modules/@teamwork/sharedb/lib/types.js");
exports.logger = __webpack_require__(/*! ../logger */ "./node_modules/@teamwork/sharedb/lib/logger/index.js");


/***/ }),

/***/ "./node_modules/@teamwork/sharedb/lib/client/query.js":
/*!************************************************************!*\
  !*** ./node_modules/@teamwork/sharedb/lib/client/query.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var emitter = __webpack_require__(/*! ../emitter */ "./node_modules/@teamwork/sharedb/lib/emitter.js");

// Queries are live requests to the database for particular sets of fields.
//
// The server actively tells the client when there's new data that matches
// a set of conditions.
module.exports = Query;
function Query(action, connection, id, collection, query, options, callback) {
  emitter.EventEmitter.call(this);

  // 'qf' or 'qs'
  this.action = action;

  this.connection = connection;
  this.id = id;
  this.collection = collection;

  // The query itself. For mongo, this should look something like {"data.x":5}
  this.query = query;

  // A list of resulting documents. These are actual documents, complete with
  // data and all the rest. It is possible to pass in an initial results set,
  // so that a query can be serialized and then re-established
  this.results = null;
  if (options && options.results) {
    this.results = options.results;
    delete options.results;
  }
  this.extra = undefined;

  // Options to pass through with the query
  this.options = options;

  this.callback = callback;
  this.ready = false;
  this.sent = false;
}
emitter.mixin(Query);

Query.prototype.hasPending = function() {
  return !this.ready;
};

// Helper for subscribe & fetch, since they share the same message format.
//
// This function actually issues the query.
Query.prototype.send = function() {
  if (!this.connection.canSend) return;

  var message = {
    a: this.action,
    id: this.id,
    c: this.collection,
    q: this.query
  };
  if (this.options) {
    message.o = this.options;
  }
  if (this.results) {
    // Collect the version of all the documents in the current result set so we
    // don't need to be sent their snapshots again.
    var results = [];
    for (var i = 0; i < this.results.length; i++) {
      var doc = this.results[i];
      results.push([doc.id, doc.version]);
    }
    message.r = results;
  }

  this.connection.send(message);
  this.sent = true;
};

// Destroy the query object. Any subsequent messages for the query will be
// ignored by the connection.
Query.prototype.destroy = function(callback) {
  if (this.connection.canSend && this.action === 'qs') {
    this.connection.send({a: 'qu', id: this.id});
  }
  this.connection._destroyQuery(this);
  // There is a callback for consistency, but we don't actually wait for the
  // server's unsubscribe message currently
  if (callback) process.nextTick(callback);
};

Query.prototype._onConnectionStateChanged = function() {
  if (this.connection.canSend && !this.sent) {
    this.send();
  } else {
    this.sent = false;
  }
};

Query.prototype._handleFetch = function(err, data, extra) {
  // Once a fetch query gets its data, it is destroyed.
  this.connection._destroyQuery(this);
  this._handleResponse(err, data, extra);
};

Query.prototype._handleSubscribe = function(err, data, extra) {
  this._handleResponse(err, data, extra);
};

Query.prototype._handleResponse = function(err, data, extra) {
  var callback = this.callback;
  this.callback = null;
  if (err) return this._finishResponse(err, callback);
  if (!data) return this._finishResponse(null, callback);

  var query = this;
  var wait = 1;
  var finish = function(err) {
    if (err) return query._finishResponse(err, callback);
    if (--wait) return;
    query._finishResponse(null, callback);
  };

  if (Array.isArray(data)) {
    wait += data.length;
    this.results = this._ingestSnapshots(data, finish);
    this.extra = extra;

  } else {
    for (var id in data) {
      wait++;
      var snapshot = data[id];
      var doc = this.connection.get(snapshot.c || this.collection, id);
      doc.ingestSnapshot(snapshot, finish);
    }
  }

  finish();
};

Query.prototype._ingestSnapshots = function(snapshots, finish) {
  var results = [];
  for (var i = 0; i < snapshots.length; i++) {
    var snapshot = snapshots[i];
    var doc = this.connection.get(snapshot.c || this.collection, snapshot.d);
    doc.ingestSnapshot(snapshot, finish);
    results.push(doc);
  }
  return results;
};

Query.prototype._finishResponse = function(err, callback) {
  this.emit('ready');
  this.ready = true;
  if (err) {
    this.connection._destroyQuery(this);
    if (callback) return callback(err);
    return this.emit('error', err);
  }
  if (callback) callback(null, this.results, this.extra);
};

Query.prototype._handleError = function(err) {
  this.emit('error', err);
};

Query.prototype._handleDiff = function(diff) {
  // We need to go through the list twice. First, we'll ingest all the new
  // documents. After that we'll emit events and actually update our list.
  // This avoids race conditions around setting documents to be subscribed &
  // unsubscribing documents in event callbacks.
  for (var i = 0; i < diff.length; i++) {
    var d = diff[i];
    if (d.type === 'insert') d.values = this._ingestSnapshots(d.values);
  }

  for (var i = 0; i < diff.length; i++) {
    var d = diff[i];
    switch (d.type) {
      case 'insert':
        var newDocs = d.values;
        Array.prototype.splice.apply(this.results, [d.index, 0].concat(newDocs));
        this.emit('insert', newDocs, d.index);
        break;
      case 'remove':
        var howMany = d.howMany || 1;
        var removed = this.results.splice(d.index, howMany);
        this.emit('remove', removed, d.index);
        break;
      case 'move':
        var howMany = d.howMany || 1;
        var docs = this.results.splice(d.from, howMany);
        Array.prototype.splice.apply(this.results, [d.to, 0].concat(docs));
        this.emit('move', docs, d.from, d.to);
        break;
    }
  }

  this.emit('changed', this.results);
};

Query.prototype._handleExtra = function(extra) {
  this.extra = extra;
  this.emit('extra', extra);
};

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/@teamwork/sharedb/lib/client/snapshot-request/snapshot-request.js":
/*!****************************************************************************************!*\
  !*** ./node_modules/@teamwork/sharedb/lib/client/snapshot-request/snapshot-request.js ***!
  \****************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Snapshot = __webpack_require__(/*! ../../snapshot */ "./node_modules/@teamwork/sharedb/lib/snapshot.js");
var emitter = __webpack_require__(/*! ../../emitter */ "./node_modules/@teamwork/sharedb/lib/emitter.js");

module.exports = SnapshotRequest;

function SnapshotRequest(connection, requestId, collection, id, callback) {
  emitter.EventEmitter.call(this);

  if (typeof callback !== 'function') {
    throw new Error('Callback is required for SnapshotRequest');
  }

  this.requestId = requestId;
  this.connection = connection;
  this.id = id;
  this.collection = collection;
  this.callback = callback;

  this.sent = false;
}
emitter.mixin(SnapshotRequest);

SnapshotRequest.prototype.send = function () {
  if (!this.connection.canSend) {
    return;
  }

  this.connection.send(this._message());
  this.sent = true;
};

SnapshotRequest.prototype._onConnectionStateChanged = function () {
  if (this.connection.canSend) {
    if (!this.sent) this.send();
  } else {
    // If the connection can't send, then we've had a disconnection, and even if we've already sent
    // the request previously, we need to re-send it over this reconnected client, so reset the
    // sent flag to false.
    this.sent = false;
  }
};

SnapshotRequest.prototype._handleResponse = function (error, message) {
  this.emit('ready');

  if (error) {
    return this.callback(error);
  }

  var metadata = message.meta ? message.meta : null;
  var snapshot = new Snapshot(this.id, message.v, message.type, message.data, metadata);

  this.callback(null, snapshot);
};


/***/ }),

/***/ "./node_modules/@teamwork/sharedb/lib/client/snapshot-request/snapshot-timestamp-request.js":
/*!**************************************************************************************************!*\
  !*** ./node_modules/@teamwork/sharedb/lib/client/snapshot-request/snapshot-timestamp-request.js ***!
  \**************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var SnapshotRequest = __webpack_require__(/*! ./snapshot-request */ "./node_modules/@teamwork/sharedb/lib/client/snapshot-request/snapshot-request.js");
var util = __webpack_require__(/*! ../../util */ "./node_modules/@teamwork/sharedb/lib/util.js");

module.exports = SnapshotTimestampRequest;

function SnapshotTimestampRequest(connection, requestId, collection, id, timestamp, callback) {
  SnapshotRequest.call(this, connection, requestId, collection, id, callback);

  if (!util.isValidTimestamp(timestamp)) {
    throw new Error('Snapshot timestamp must be a positive integer or null');
  }

  this.timestamp = timestamp;
}

SnapshotTimestampRequest.prototype = Object.create(SnapshotRequest.prototype);

SnapshotTimestampRequest.prototype._message = function () {
  return {
    a: 'nt',
    id: this.requestId,
    c: this.collection,
    d: this.id,
    ts: this.timestamp,
  };
};


/***/ }),

/***/ "./node_modules/@teamwork/sharedb/lib/client/snapshot-request/snapshot-version-request.js":
/*!************************************************************************************************!*\
  !*** ./node_modules/@teamwork/sharedb/lib/client/snapshot-request/snapshot-version-request.js ***!
  \************************************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var SnapshotRequest = __webpack_require__(/*! ./snapshot-request */ "./node_modules/@teamwork/sharedb/lib/client/snapshot-request/snapshot-request.js");
var util = __webpack_require__(/*! ../../util */ "./node_modules/@teamwork/sharedb/lib/util.js");

module.exports = SnapshotVersionRequest;

function SnapshotVersionRequest (connection, requestId, collection, id, version, callback) {
  SnapshotRequest.call(this, connection, requestId, collection, id, callback);

  if (!util.isValidVersion(version)) {
    throw new Error('Snapshot version must be a positive integer or null');
  }

  this.version = version;
}

SnapshotVersionRequest.prototype = Object.create(SnapshotRequest.prototype);

SnapshotVersionRequest.prototype._message = function () {
  return {
    a: 'nf',
    id: this.requestId,
    c: this.collection,
    d: this.id,
    v: this.version,
  };
};


/***/ }),

/***/ "./node_modules/@teamwork/sharedb/lib/client/undoManager.js":
/*!******************************************************************!*\
  !*** ./node_modules/@teamwork/sharedb/lib/client/undoManager.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {function findLastIndex(stack, doc) {
  var index = stack.length - 1;
  while (index >= 0) {
    if (stack[index].doc === doc) break;
    index--;
  }
  return index;
}

function getLast(list) {
  var lastIndex = list.length - 1;
  /* istanbul ignore if */
  if (lastIndex < 0) throw new Error('List empty');
  return list[lastIndex];
}

function setLast(list, item) {
  var lastIndex = list.length - 1;
  /* istanbul ignore if */
  if (lastIndex < 0) throw new Error('List empty');
  list[lastIndex] = item;
}

function Op(op, doc) {
  this.op = op;
  this.doc = doc;
  this.needsUndoOp = true;
}

// Manages an undo/redo stack for all operations from the specified `source`.
module.exports = UndoManager;
function UndoManager(connection, options) {
  // The Connection which created this UndoManager.
  this._connection = connection;

  // If != null, only ops from this "source" will be undoable.
  this._source = options && options.source;

  // The max number of undo operations to keep on the stack.
  this._limit = options && typeof options.limit === 'number' ? options.limit : 100;

  // The max time difference between operations in milliseconds,
  // which still allows the operations to be composed on the undoStack.
  this._composeInterval = options && typeof options.composeInterval === 'number' ? options.composeInterval : 1000;

  // Undo stack for local operations.
  this._undoStack = [];

  // Redo stack for local operations.
  this._redoStack = [];

  // The timestamp of the previous reversible operation. Used to determine if
  // the next reversible operation can be composed on the undoStack.
  this._previousUndoableOperationTime = -Infinity;
}

UndoManager.prototype.destroy = function() {
  this._connection.removeUndoManager(this);
  this.clear();
};

// Clear the undo and redo stack.
//
// @param doc If specified, clear only the ops belonging to this doc.
UndoManager.prototype.clear = function(doc) {
  if (doc) {
    var filter = function(item) { return item.doc !== doc; };
    this._undoStack = this._undoStack.filter(filter);
    this._redoStack = this._redoStack.filter(filter);
  } else {
    this._undoStack.length = 0;
    this._redoStack.length = 0;
  }
};

// Returns true, if there are any operations on the undo stack, otherwise false.
UndoManager.prototype.canUndo = function() {
  return this._undoStack.length > 0
};

// Undoes a submitted operation.
//
// @param options {source: ...}
// @param [callback] called after operation submitted
// @fires before op, op
UndoManager.prototype.undo = function(options, callback) {
  if (typeof options === 'function') {
    callback = options;
    options = null;
  }

  if (!this.canUndo()) {
    if (callback) process.nextTick(callback);
    return;
  }

  var op = getLast(this._undoStack);
  var submitOptions = { source: options && options.source };
  op.doc._submit(op, submitOptions, callback);
};

// Returns true, if there are any operations on the redo stack, otherwise false.
UndoManager.prototype.canRedo = function() {
  return this._redoStack.length > 0;
};

// Redoes an undone operation.
//
// @param options {source: ...}
// @param [callback] called after operation submitted
// @fires before op, op
UndoManager.prototype.redo = function(options, callback) {
  if (typeof options === 'function') {
    callback = options;
    options = null;
  }

  if (!this.canRedo()) {
    if (callback) process.nextTick(callback);
    return;
  }

  var op = getLast(this._redoStack);
  var submitOptions = { source: options && options.source };
  op.doc._submit(op, submitOptions, callback);
};

UndoManager.prototype.onDocLoad = function(doc) {
  this.clear(doc);
};

UndoManager.prototype.onDocDestroy = function(doc) {
  this.clear(doc);
};

UndoManager.prototype.onDocCreate = function(doc) {
  // NOTE We don't support undo on create because we can't support undo on delete.
};

UndoManager.prototype.onDocDelete = function(doc) {
  // NOTE We can't support undo on delete because we can't generate `initialData` required for `create`.
  // See https://github.com/ottypes/docs#standard-properties.
  //
  // We could support undo on delete and create in the future but that would require some breaking changes to ShareDB.
  // Here's what we could do:
  //
  // 1. Do NOT call `create` in ShareDB - ShareDB would get a valid snapshot from the client code.
  // 2. Add `validate` to OT types.
  // 3. Call `validate` in ShareDB to ensure that the snapshot from the client is valid.
  // 4. The `create` ops would contain serialized snapshots instead of `initialData`.
  this.clear(doc);
};

UndoManager.prototype.onDocOp = function(doc, op, undoOp, source, undoable, fixUp) {
  if (this.canUndo() && getLast(this._undoStack) === op) {
    this._undoStack.pop();
    this._updateStacksUndo(doc, op.op, undoOp.op);

  } else if (this.canRedo() && getLast(this._redoStack) === op) {
    this._redoStack.pop();
    this._updateStacksRedo(doc, op.op, undoOp.op);

  } else if (!fixUp && undoable && (this._source == null || this._source === source)) {
    this._updateStacksUndoable(doc, op.op, undoOp.op);

  } else {
    this._updateStacksFixed(doc, op.op, undoOp && undoOp.op, fixUp);
  }
};

UndoManager.prototype._updateStacksUndoable = function(doc, op, undoOp) {
  var isNoop = doc.type.isNoop;

  if (isNoop && isNoop(undoOp)) {
    return
  }

  var now = Date.now();

  if (
    this._undoStack.length === 0 ||
    getLast(this._undoStack).doc !== doc ||
    now - this._previousUndoableOperationTime > this._composeInterval
  ) {
    this._undoStack.push(new Op(undoOp, doc));

  } else if (doc.type.composeSimilar) {
    var lastOp = getLast(this._undoStack);
    var composedOp = doc.type.composeSimilar(undoOp, lastOp.op);
    if (composedOp != null) {
      setLast(this._undoStack, new Op(composedOp, doc));
    } else {
      this._undoStack.push(new Op(undoOp, doc));
    }

  } else if (doc.type.compose) {
    var lastOp = getLast(this._undoStack);
    var composedOp = doc.type.compose(undoOp, lastOp.op);
    setLast(this._undoStack, new Op(composedOp, doc));

  } else {
    this._undoStack.push(new Op(undoOp, doc));
  }

  this._redoStack.length = 0;
  this._previousUndoableOperationTime = now;

  if (isNoop && isNoop(getLast(this._undoStack).op)) {
    this._undoStack.pop();
  }

  var itemsToRemove = this._undoStack.length - this._limit;
  if (itemsToRemove > 0) {
    this._undoStack.splice(0, itemsToRemove);
  }
};

UndoManager.prototype._updateStacksUndo = function(doc, op, undoOp) {
  /* istanbul ignore else */
  if (!doc.type.isNoop || !doc.type.isNoop(undoOp)) {
    this._redoStack.push(new Op(undoOp, doc));
  }
  this._previousUndoableOperationTime = -Infinity;
};

UndoManager.prototype._updateStacksRedo = function(doc, op, undoOp) {
  /* istanbul ignore else */
  if (!doc.type.isNoop || !doc.type.isNoop(undoOp)) {
    this._undoStack.push(new Op(undoOp, doc));
  }
  this._previousUndoableOperationTime = -Infinity;
};

UndoManager.prototype._updateStacksFixed = function(doc, op, undoOp, fixUp) {
  if (fixUp && undoOp != null && doc.type.compose) {
    var lastUndoIndex = findLastIndex(this._undoStack, doc);
    if (lastUndoIndex >= 0) {
      var lastOp = this._undoStack[lastUndoIndex];
      var composedOp = doc.type.compose(undoOp, lastOp.op);
      if (!doc.type.isNoop || !doc.type.isNoop(composedOp)) {
        this._undoStack[lastUndoIndex] = new Op(composedOp, doc);
      } else {
        this._undoStack.splice(lastUndoIndex, 1);
      }
    }

    var lastRedoIndex = findLastIndex(this._redoStack, doc);
    if (lastRedoIndex >= 0) {
      var lastOp = this._redoStack[lastRedoIndex];
      var composedOp = doc.type.compose(undoOp, lastOp.op);
      if (!doc.type.isNoop || !doc.type.isNoop(composedOp)) {
        this._redoStack[lastRedoIndex] = new Op(composedOp, doc);
      } else {
        this._redoStack.splice(lastRedoIndex, 1);
      }
    }

  } else {
    this._undoStack = this._transformStack(this._undoStack, doc, op);
    this._redoStack = this._transformStack(this._redoStack, doc, op);
  }
};

UndoManager.prototype._transformStack = function(stack, doc, op) {
  var transform = doc.type.transform;
  var transformX = doc.type.transformX;
  var isNoop = doc.type.isNoop;
  var newStack = [];
  var newStackIndex = 0;

  for (var i = stack.length - 1; i >= 0; --i) {
    var item = stack[i];
    if (item.doc !== doc) {
      newStack[newStackIndex++] = item;
      continue;
    }
    var stackOp = item.op;
    var transformedStackOp;
    var transformedOp;

    if (transformX) {
      var result = transformX(op, stackOp);
      transformedOp = result[0];
      transformedStackOp = result[1];
    } else {
      transformedOp = transform(op, stackOp, 'left');
      transformedStackOp = transform(stackOp, op, 'right');
    }

    if (!isNoop || !isNoop(transformedStackOp)) {
      newStack[newStackIndex++] = new Op(transformedStackOp, doc);
    }

    op = transformedOp;
  }

  return newStack.reverse();
};

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/@teamwork/sharedb/lib/emitter.js":
/*!*******************************************************!*\
  !*** ./node_modules/@teamwork/sharedb/lib/emitter.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var EventEmitter = __webpack_require__(/*! events */ "./node_modules/events/events.js").EventEmitter;

exports.EventEmitter = EventEmitter;
exports.mixin = mixin;

function mixin(Constructor) {
  for (var key in EventEmitter.prototype) {
    Constructor.prototype[key] = EventEmitter.prototype[key];
  }
}


/***/ }),

/***/ "./node_modules/@teamwork/sharedb/lib/error.js":
/*!*****************************************************!*\
  !*** ./node_modules/@teamwork/sharedb/lib/error.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var makeError = __webpack_require__(/*! make-error */ "./node_modules/make-error/index.js");

function ShareDBError(code, message) {
  ShareDBError.super.call(this, message);
  this.code = code;
}

makeError(ShareDBError);

module.exports = ShareDBError;


/***/ }),

/***/ "./node_modules/@teamwork/sharedb/lib/logger/index.js":
/*!************************************************************!*\
  !*** ./node_modules/@teamwork/sharedb/lib/logger/index.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

var Logger = __webpack_require__(/*! ./logger */ "./node_modules/@teamwork/sharedb/lib/logger/logger.js");
var logger = new Logger();
module.exports = logger;


/***/ }),

/***/ "./node_modules/@teamwork/sharedb/lib/logger/logger.js":
/*!*************************************************************!*\
  !*** ./node_modules/@teamwork/sharedb/lib/logger/logger.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

var SUPPORTED_METHODS = [
  'info',
  'warn',
  'error'
];

function Logger() {
  this.setMethods(console);
}
module.exports = Logger;

Logger.prototype.setMethods = function (overrides) {
  overrides = overrides || {};
  var logger = this;

  SUPPORTED_METHODS.forEach(function (method) {
    if (typeof overrides[method] === 'function') {
      logger[method] = overrides[method];
    }
  });
};


/***/ }),

/***/ "./node_modules/@teamwork/sharedb/lib/snapshot.js":
/*!********************************************************!*\
  !*** ./node_modules/@teamwork/sharedb/lib/snapshot.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = Snapshot;
function Snapshot(id, version, type, data, meta) {
  this.id = id;
  this.v = version;
  this.type = type;
  this.data = data;
  this.m = meta;
}


/***/ }),

/***/ "./node_modules/@teamwork/sharedb/lib/types.js":
/*!*****************************************************!*\
  !*** ./node_modules/@teamwork/sharedb/lib/types.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {


exports.defaultType = __webpack_require__(/*! ot-json0 */ "./node_modules/ot-json0/lib/index.js").type;

exports.map = {};

exports.register = function(type) {
  if (type.name) exports.map[type.name] = type;
  if (type.uri) exports.map[type.uri] = type;
};

exports.register(exports.defaultType);


/***/ }),

/***/ "./node_modules/@teamwork/sharedb/lib/util.js":
/*!****************************************************!*\
  !*** ./node_modules/@teamwork/sharedb/lib/util.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports) {


exports.doNothing = doNothing;
function doNothing() {}

exports.hasKeys = function(object) {
  for (var key in object) return true;
  return false;
};

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger#Polyfill
exports.isInteger = Number.isInteger || function (value) {
  return typeof value === 'number' &&
    isFinite(value) &&
    Math.floor(value) === value;
};

exports.isValidVersion = function (version) {
  if (version === null) return true;
  return exports.isInteger(version) && version >= 0;
};

exports.isValidTimestamp = function (timestamp) {
  return exports.isValidVersion(timestamp);
};


/***/ }),

/***/ "./node_modules/compute-scroll-into-view/es/index.js":
/*!***********************************************************!*\
  !*** ./node_modules/compute-scroll-into-view/es/index.js ***!
  \***********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
function isElement(el) {
  return el != null && typeof el === 'object' && el.nodeType === 1;
}

function canOverflow(overflow, skipOverflowHiddenElements) {
  if (skipOverflowHiddenElements && overflow === 'hidden') {
    return false;
  }

  return overflow !== 'visible' && overflow !== 'clip';
}

function isScrollable(el, skipOverflowHiddenElements) {
  if (el.clientHeight < el.scrollHeight || el.clientWidth < el.scrollWidth) {
    var style = getComputedStyle(el, null);
    return canOverflow(style.overflowY, skipOverflowHiddenElements) || canOverflow(style.overflowX, skipOverflowHiddenElements);
  }

  return false;
}

function alignNearest(scrollingEdgeStart, scrollingEdgeEnd, scrollingSize, scrollingBorderStart, scrollingBorderEnd, elementEdgeStart, elementEdgeEnd, elementSize) {
  if (elementEdgeStart < scrollingEdgeStart && elementEdgeEnd > scrollingEdgeEnd || elementEdgeStart > scrollingEdgeStart && elementEdgeEnd < scrollingEdgeEnd) {
    return 0;
  }

  if (elementEdgeStart <= scrollingEdgeStart && elementSize <= scrollingSize || elementEdgeEnd >= scrollingEdgeEnd && elementSize >= scrollingSize) {
    return elementEdgeStart - scrollingEdgeStart - scrollingBorderStart;
  }

  if (elementEdgeEnd > scrollingEdgeEnd && elementSize < scrollingSize || elementEdgeStart < scrollingEdgeStart && elementSize > scrollingSize) {
    return elementEdgeEnd - scrollingEdgeEnd + scrollingBorderEnd;
  }

  return 0;
}

/* harmony default export */ __webpack_exports__["default"] = (function (target, options) {
  var scrollMode = options.scrollMode,
      block = options.block,
      inline = options.inline,
      boundary = options.boundary,
      skipOverflowHiddenElements = options.skipOverflowHiddenElements;
  var checkBoundary = typeof boundary === 'function' ? boundary : function (node) {
    return node !== boundary;
  };

  if (!isElement(target)) {
    throw new TypeError('Invalid target');
  }

  var scrollingElement = document.scrollingElement || document.documentElement;
  var frames = [];
  var cursor = target;

  while (isElement(cursor) && checkBoundary(cursor)) {
    cursor = cursor.parentNode;

    if (cursor === scrollingElement) {
      frames.push(cursor);
      break;
    }

    if (cursor === document.body && isScrollable(cursor) && !isScrollable(document.documentElement)) {
      continue;
    }

    if (isScrollable(cursor, skipOverflowHiddenElements)) {
      frames.push(cursor);
    }
  }

  var viewportWidth = window.visualViewport ? visualViewport.width : innerWidth;
  var viewportHeight = window.visualViewport ? visualViewport.height : innerHeight;
  var viewportX = window.scrollX || pageXOffset;
  var viewportY = window.scrollY || pageYOffset;

  var _target$getBoundingCl = target.getBoundingClientRect(),
      targetHeight = _target$getBoundingCl.height,
      targetWidth = _target$getBoundingCl.width,
      targetTop = _target$getBoundingCl.top,
      targetRight = _target$getBoundingCl.right,
      targetBottom = _target$getBoundingCl.bottom,
      targetLeft = _target$getBoundingCl.left;

  var targetBlock = block === 'start' || block === 'nearest' ? targetTop : block === 'end' ? targetBottom : targetTop + targetHeight / 2;
  var targetInline = inline === 'center' ? targetLeft + targetWidth / 2 : inline === 'end' ? targetRight : targetLeft;
  var computations = [];

  for (var index = 0; index < frames.length; index++) {
    var frame = frames[index];

    var _frame$getBoundingCli = frame.getBoundingClientRect(),
        _height = _frame$getBoundingCli.height,
        _width = _frame$getBoundingCli.width,
        _top = _frame$getBoundingCli.top,
        right = _frame$getBoundingCli.right,
        bottom = _frame$getBoundingCli.bottom,
        _left = _frame$getBoundingCli.left;

    if (scrollMode === 'if-needed' && targetTop >= 0 && targetLeft >= 0 && targetBottom <= viewportHeight && targetRight <= viewportWidth && targetTop >= _top && targetBottom <= bottom && targetLeft >= _left && targetRight <= right) {
      return computations;
    }

    var frameStyle = getComputedStyle(frame);
    var borderLeft = parseInt(frameStyle.borderLeftWidth, 10);
    var borderTop = parseInt(frameStyle.borderTopWidth, 10);
    var borderRight = parseInt(frameStyle.borderRightWidth, 10);
    var borderBottom = parseInt(frameStyle.borderBottomWidth, 10);
    var blockScroll = 0;
    var inlineScroll = 0;
    var scrollbarWidth = 'offsetWidth' in frame ? frame.offsetWidth - frame.clientWidth - borderLeft - borderRight : 0;
    var scrollbarHeight = 'offsetHeight' in frame ? frame.offsetHeight - frame.clientHeight - borderTop - borderBottom : 0;

    if (scrollingElement === frame) {
      if (block === 'start') {
        blockScroll = targetBlock;
      } else if (block === 'end') {
        blockScroll = targetBlock - viewportHeight;
      } else if (block === 'nearest') {
        blockScroll = alignNearest(viewportY, viewportY + viewportHeight, viewportHeight, borderTop, borderBottom, viewportY + targetBlock, viewportY + targetBlock + targetHeight, targetHeight);
      } else {
        blockScroll = targetBlock - viewportHeight / 2;
      }

      if (inline === 'start') {
        inlineScroll = targetInline;
      } else if (inline === 'center') {
        inlineScroll = targetInline - viewportWidth / 2;
      } else if (inline === 'end') {
        inlineScroll = targetInline - viewportWidth;
      } else {
        inlineScroll = alignNearest(viewportX, viewportX + viewportWidth, viewportWidth, borderLeft, borderRight, viewportX + targetInline, viewportX + targetInline + targetWidth, targetWidth);
      }

      blockScroll = Math.max(0, blockScroll + viewportY);
      inlineScroll = Math.max(0, inlineScroll + viewportX);
    } else {
      if (block === 'start') {
        blockScroll = targetBlock - _top - borderTop;
      } else if (block === 'end') {
        blockScroll = targetBlock - bottom + borderBottom + scrollbarHeight;
      } else if (block === 'nearest') {
        blockScroll = alignNearest(_top, bottom, _height, borderTop, borderBottom + scrollbarHeight, targetBlock, targetBlock + targetHeight, targetHeight);
      } else {
        blockScroll = targetBlock - (_top + _height / 2) + scrollbarHeight / 2;
      }

      if (inline === 'start') {
        inlineScroll = targetInline - _left - borderLeft;
      } else if (inline === 'center') {
        inlineScroll = targetInline - (_left + _width / 2) + scrollbarWidth / 2;
      } else if (inline === 'end') {
        inlineScroll = targetInline - right + borderRight + scrollbarWidth;
      } else {
        inlineScroll = alignNearest(_left, right, _width, borderLeft, borderRight + scrollbarWidth, targetInline, targetInline + targetWidth, targetWidth);
      }

      var scrollLeft = frame.scrollLeft,
          scrollTop = frame.scrollTop;
      blockScroll = Math.max(0, Math.min(scrollTop + blockScroll, frame.scrollHeight - _height + scrollbarHeight));
      inlineScroll = Math.max(0, Math.min(scrollLeft + inlineScroll, frame.scrollWidth - _width + scrollbarWidth));
      targetBlock += scrollTop - blockScroll;
      targetInline += scrollLeft - inlineScroll;
    }

    computations.push({
      el: frame,
      top: blockScroll,
      left: inlineScroll
    });
  }

  return computations;
});

/***/ }),

/***/ "./node_modules/debug/src/browser.js":
/*!*******************************************!*\
  !*** ./node_modules/debug/src/browser.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* eslint-env browser */

/**
 * This is the web browser implementation of `debug()`.
 */
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
/**
 * Colors.
 */

exports.colors = ['#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC', '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF', '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC', '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF', '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC', '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033', '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366', '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933', '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC', '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF', '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */
// eslint-disable-next-line complexity

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
    return true;
  } // Internet Explorer and Edge do not support colors.


  if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
    return false;
  } // Is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632


  return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
  typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
  // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
  typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */


function formatArgs(args) {
  args[0] = (this.useColors ? '%c' : '') + this.namespace + (this.useColors ? ' %c' : ' ') + args[0] + (this.useColors ? '%c ' : ' ') + '+' + module.exports.humanize(this.diff);

  if (!this.useColors) {
    return;
  }

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit'); // The final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into

  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function (match) {
    if (match === '%%') {
      return;
    }

    index++;

    if (match === '%c') {
      // We only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });
  args.splice(lastC, 0, c);
}
/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */


function log() {
  var _console;

  // This hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return (typeof console === "undefined" ? "undefined" : _typeof(console)) === 'object' && console.log && (_console = console).log.apply(_console, arguments);
}
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */


function save(namespaces) {
  try {
    if (namespaces) {
      exports.storage.setItem('debug', namespaces);
    } else {
      exports.storage.removeItem('debug');
    }
  } catch (error) {// Swallow
    // XXX (@Qix-) should we be logging these?
  }
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */


function load() {
  var r;

  try {
    r = exports.storage.getItem('debug');
  } catch (error) {} // Swallow
  // XXX (@Qix-) should we be logging these?
  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG


  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = process.env.DEBUG;
  }

  return r;
}
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */


function localstorage() {
  try {
    // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
    // The Browser also has localStorage in the global context.
    return localStorage;
  } catch (error) {// Swallow
    // XXX (@Qix-) should we be logging these?
  }
}

module.exports = __webpack_require__(/*! ./common */ "./node_modules/debug/src/common.js")(exports);
var formatters = module.exports.formatters;
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

formatters.j = function (v) {
  try {
    return JSON.stringify(v);
  } catch (error) {
    return '[UnexpectedJSONParseError]: ' + error.message;
  }
};


/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../process/browser.js */ "./node_modules/process/browser.js")))

/***/ }),

/***/ "./node_modules/debug/src/common.js":
/*!******************************************!*\
  !*** ./node_modules/debug/src/common.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */
function setup(env) {
  createDebug.debug = createDebug;
  createDebug.default = createDebug;
  createDebug.coerce = coerce;
  createDebug.disable = disable;
  createDebug.enable = enable;
  createDebug.enabled = enabled;
  createDebug.humanize = __webpack_require__(/*! ms */ "./node_modules/ms/index.js");
  Object.keys(env).forEach(function (key) {
    createDebug[key] = env[key];
  });
  /**
  * Active `debug` instances.
  */

  createDebug.instances = [];
  /**
  * The currently active debug mode names, and names to skip.
  */

  createDebug.names = [];
  createDebug.skips = [];
  /**
  * Map of special "%n" handling functions, for the debug "format" argument.
  *
  * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
  */

  createDebug.formatters = {};
  /**
  * Selects a color for a debug namespace
  * @param {String} namespace The namespace string for the for the debug instance to be colored
  * @return {Number|String} An ANSI color code for the given namespace
  * @api private
  */

  function selectColor(namespace) {
    var hash = 0;

    for (var i = 0; i < namespace.length; i++) {
      hash = (hash << 5) - hash + namespace.charCodeAt(i);
      hash |= 0; // Convert to 32bit integer
    }

    return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
  }

  createDebug.selectColor = selectColor;
  /**
  * Create a debugger with the given `namespace`.
  *
  * @param {String} namespace
  * @return {Function}
  * @api public
  */

  function createDebug(namespace) {
    var prevTime;

    function debug() {
      // Disabled?
      if (!debug.enabled) {
        return;
      }

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      var self = debug; // Set `diff` timestamp

      var curr = Number(new Date());
      var ms = curr - (prevTime || curr);
      self.diff = ms;
      self.prev = prevTime;
      self.curr = curr;
      prevTime = curr;
      args[0] = createDebug.coerce(args[0]);

      if (typeof args[0] !== 'string') {
        // Anything else let's inspect with %O
        args.unshift('%O');
      } // Apply any `formatters` transformations


      var index = 0;
      args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
        // If we encounter an escaped % then don't increase the array index
        if (match === '%%') {
          return match;
        }

        index++;
        var formatter = createDebug.formatters[format];

        if (typeof formatter === 'function') {
          var val = args[index];
          match = formatter.call(self, val); // Now we need to remove `args[index]` since it's inlined in the `format`

          args.splice(index, 1);
          index--;
        }

        return match;
      }); // Apply env-specific formatting (colors, etc.)

      createDebug.formatArgs.call(self, args);
      var logFn = self.log || createDebug.log;
      logFn.apply(self, args);
    }

    debug.namespace = namespace;
    debug.enabled = createDebug.enabled(namespace);
    debug.useColors = createDebug.useColors();
    debug.color = selectColor(namespace);
    debug.destroy = destroy;
    debug.extend = extend; // Debug.formatArgs = formatArgs;
    // debug.rawLog = rawLog;
    // env-specific initialization logic for debug instances

    if (typeof createDebug.init === 'function') {
      createDebug.init(debug);
    }

    createDebug.instances.push(debug);
    return debug;
  }

  function destroy() {
    var index = createDebug.instances.indexOf(this);

    if (index !== -1) {
      createDebug.instances.splice(index, 1);
      return true;
    }

    return false;
  }

  function extend(namespace, delimiter) {
    return createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
  }
  /**
  * Enables a debug mode by namespaces. This can include modes
  * separated by a colon and wildcards.
  *
  * @param {String} namespaces
  * @api public
  */


  function enable(namespaces) {
    createDebug.save(namespaces);
    createDebug.names = [];
    createDebug.skips = [];
    var i;
    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
    var len = split.length;

    for (i = 0; i < len; i++) {
      if (!split[i]) {
        // ignore empty strings
        continue;
      }

      namespaces = split[i].replace(/\*/g, '.*?');

      if (namespaces[0] === '-') {
        createDebug.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
      } else {
        createDebug.names.push(new RegExp('^' + namespaces + '$'));
      }
    }

    for (i = 0; i < createDebug.instances.length; i++) {
      var instance = createDebug.instances[i];
      instance.enabled = createDebug.enabled(instance.namespace);
    }
  }
  /**
  * Disable debug output.
  *
  * @api public
  */


  function disable() {
    createDebug.enable('');
  }
  /**
  * Returns true if the given mode name is enabled, false otherwise.
  *
  * @param {String} name
  * @return {Boolean}
  * @api public
  */


  function enabled(name) {
    if (name[name.length - 1] === '*') {
      return true;
    }

    var i;
    var len;

    for (i = 0, len = createDebug.skips.length; i < len; i++) {
      if (createDebug.skips[i].test(name)) {
        return false;
      }
    }

    for (i = 0, len = createDebug.names.length; i < len; i++) {
      if (createDebug.names[i].test(name)) {
        return true;
      }
    }

    return false;
  }
  /**
  * Coerce `val`.
  *
  * @param {Mixed} val
  * @return {Mixed}
  * @api private
  */


  function coerce(val) {
    if (val instanceof Error) {
      return val.stack || val.message;
    }

    return val;
  }

  createDebug.enable(createDebug.load());
  return createDebug;
}

module.exports = setup;



/***/ }),

/***/ "./node_modules/events/events.js":
/*!***************************************!*\
  !*** ./node_modules/events/events.js ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = $getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  var args = [];
  for (var i = 0; i < arguments.length; i++) args.push(arguments[i]);
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    ReflectApply(this.listener, this.target, args);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      if (typeof listener !== 'function') {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      if (typeof listener !== 'function') {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}


/***/ }),

/***/ "./node_modules/fast-diff/diff.js":
/*!****************************************!*\
  !*** ./node_modules/fast-diff/diff.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * This library modifies the diff-patch-match library by Neil Fraser
 * by removing the patch and match functionality and certain advanced
 * options in the diff function. The original license is as follows:
 *
 * ===
 *
 * Diff Match and Patch
 *
 * Copyright 2006 Google Inc.
 * http://code.google.com/p/google-diff-match-patch/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */
var DIFF_DELETE = -1;
var DIFF_INSERT = 1;
var DIFF_EQUAL = 0;


/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {Int|Object} [cursor_pos] Edit position in text1 or object with more info
 * @return {Array} Array of diff tuples.
 */
function diff_main(text1, text2, cursor_pos, _fix_unicode) {
  // Check for equality
  if (text1 === text2) {
    if (text1) {
      return [[DIFF_EQUAL, text1]];
    }
    return [];
  }

  if (cursor_pos != null) {
    var editdiff = find_cursor_edit_diff(text1, text2, cursor_pos);
    if (editdiff) {
      return editdiff;
    }
  }

  // Trim off common prefix (speedup).
  var commonlength = diff_commonPrefix(text1, text2);
  var commonprefix = text1.substring(0, commonlength);
  text1 = text1.substring(commonlength);
  text2 = text2.substring(commonlength);

  // Trim off common suffix (speedup).
  commonlength = diff_commonSuffix(text1, text2);
  var commonsuffix = text1.substring(text1.length - commonlength);
  text1 = text1.substring(0, text1.length - commonlength);
  text2 = text2.substring(0, text2.length - commonlength);

  // Compute the diff on the middle block.
  var diffs = diff_compute_(text1, text2);

  // Restore the prefix and suffix.
  if (commonprefix) {
    diffs.unshift([DIFF_EQUAL, commonprefix]);
  }
  if (commonsuffix) {
    diffs.push([DIFF_EQUAL, commonsuffix]);
  }
  diff_cleanupMerge(diffs, _fix_unicode);
  return diffs;
};


/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 */
function diff_compute_(text1, text2) {
  var diffs;

  if (!text1) {
    // Just add some text (speedup).
    return [[DIFF_INSERT, text2]];
  }

  if (!text2) {
    // Just delete some text (speedup).
    return [[DIFF_DELETE, text1]];
  }

  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  var i = longtext.indexOf(shorttext);
  if (i !== -1) {
    // Shorter text is inside the longer text (speedup).
    diffs = [
      [DIFF_INSERT, longtext.substring(0, i)],
      [DIFF_EQUAL, shorttext],
      [DIFF_INSERT, longtext.substring(i + shorttext.length)]
    ];
    // Swap insertions for deletions if diff is reversed.
    if (text1.length > text2.length) {
      diffs[0][0] = diffs[2][0] = DIFF_DELETE;
    }
    return diffs;
  }

  if (shorttext.length === 1) {
    // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
  }

  // Check to see if the problem can be split in two.
  var hm = diff_halfMatch_(text1, text2);
  if (hm) {
    // A half-match was found, sort out the return data.
    var text1_a = hm[0];
    var text1_b = hm[1];
    var text2_a = hm[2];
    var text2_b = hm[3];
    var mid_common = hm[4];
    // Send both pairs off for separate processing.
    var diffs_a = diff_main(text1_a, text2_a);
    var diffs_b = diff_main(text1_b, text2_b);
    // Merge the results.
    return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
  }

  return diff_bisect_(text1, text2);
};


/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 * @private
 */
function diff_bisect_(text1, text2) {
  // Cache the text lengths to prevent multiple calls.
  var text1_length = text1.length;
  var text2_length = text2.length;
  var max_d = Math.ceil((text1_length + text2_length) / 2);
  var v_offset = max_d;
  var v_length = 2 * max_d;
  var v1 = new Array(v_length);
  var v2 = new Array(v_length);
  // Setting all elements to -1 is faster in Chrome & Firefox than mixing
  // integers and undefined.
  for (var x = 0; x < v_length; x++) {
    v1[x] = -1;
    v2[x] = -1;
  }
  v1[v_offset + 1] = 0;
  v2[v_offset + 1] = 0;
  var delta = text1_length - text2_length;
  // If the total number of characters is odd, then the front path will collide
  // with the reverse path.
  var front = (delta % 2 !== 0);
  // Offsets for start and end of k loop.
  // Prevents mapping of space beyond the grid.
  var k1start = 0;
  var k1end = 0;
  var k2start = 0;
  var k2end = 0;
  for (var d = 0; d < max_d; d++) {
    // Walk the front path one step.
    for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
      var k1_offset = v_offset + k1;
      var x1;
      if (k1 === -d || (k1 !== d && v1[k1_offset - 1] < v1[k1_offset + 1])) {
        x1 = v1[k1_offset + 1];
      } else {
        x1 = v1[k1_offset - 1] + 1;
      }
      var y1 = x1 - k1;
      while (
        x1 < text1_length && y1 < text2_length &&
        text1.charAt(x1) === text2.charAt(y1)
      ) {
        x1++;
        y1++;
      }
      v1[k1_offset] = x1;
      if (x1 > text1_length) {
        // Ran off the right of the graph.
        k1end += 2;
      } else if (y1 > text2_length) {
        // Ran off the bottom of the graph.
        k1start += 2;
      } else if (front) {
        var k2_offset = v_offset + delta - k1;
        if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] !== -1) {
          // Mirror x2 onto top-left coordinate system.
          var x2 = text1_length - v2[k2_offset];
          if (x1 >= x2) {
            // Overlap detected.
            return diff_bisectSplit_(text1, text2, x1, y1);
          }
        }
      }
    }

    // Walk the reverse path one step.
    for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
      var k2_offset = v_offset + k2;
      var x2;
      if (k2 === -d || (k2 !== d && v2[k2_offset - 1] < v2[k2_offset + 1])) {
        x2 = v2[k2_offset + 1];
      } else {
        x2 = v2[k2_offset - 1] + 1;
      }
      var y2 = x2 - k2;
      while (
        x2 < text1_length && y2 < text2_length &&
        text1.charAt(text1_length - x2 - 1) === text2.charAt(text2_length - y2 - 1)
      ) {
        x2++;
        y2++;
      }
      v2[k2_offset] = x2;
      if (x2 > text1_length) {
        // Ran off the left of the graph.
        k2end += 2;
      } else if (y2 > text2_length) {
        // Ran off the top of the graph.
        k2start += 2;
      } else if (!front) {
        var k1_offset = v_offset + delta - k2;
        if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] !== -1) {
          var x1 = v1[k1_offset];
          var y1 = v_offset + x1 - k1_offset;
          // Mirror x2 onto top-left coordinate system.
          x2 = text1_length - x2;
          if (x1 >= x2) {
            // Overlap detected.
            return diff_bisectSplit_(text1, text2, x1, y1);
          }
        }
      }
    }
  }
  // Diff took too long and hit the deadline or
  // number of diffs equals number of characters, no commonality at all.
  return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
};


/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @return {Array} Array of diff tuples.
 */
function diff_bisectSplit_(text1, text2, x, y) {
  var text1a = text1.substring(0, x);
  var text2a = text2.substring(0, y);
  var text1b = text1.substring(x);
  var text2b = text2.substring(y);

  // Compute both diffs serially.
  var diffs = diff_main(text1a, text2a);
  var diffsb = diff_main(text1b, text2b);

  return diffs.concat(diffsb);
};


/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */
function diff_commonPrefix(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 || text1.charAt(0) !== text2.charAt(0)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerstart = 0;
  while (pointermin < pointermid) {
    if (
      text1.substring(pointerstart, pointermid) ==
      text2.substring(pointerstart, pointermid)
    ) {
      pointermin = pointermid;
      pointerstart = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }

  if (is_surrogate_pair_start(text1.charCodeAt(pointermid - 1))) {
    pointermid--;
  }

  return pointermid;
};


/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */
function diff_commonSuffix(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 || text1.slice(-1) !== text2.slice(-1)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerend = 0;
  while (pointermin < pointermid) {
    if (
      text1.substring(text1.length - pointermid, text1.length - pointerend) ==
      text2.substring(text2.length - pointermid, text2.length - pointerend)
    ) {
      pointermin = pointermid;
      pointerend = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }

  if (is_surrogate_pair_end(text1.charCodeAt(text1.length - pointermid))) {
    pointermid--;
  }

  return pointermid;
};


/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 */
function diff_halfMatch_(text1, text2) {
  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
    return null;  // Pointless.
  }

  /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */
  function diff_halfMatchI_(longtext, shorttext, i) {
    // Start with a 1/4 length substring at position i as a seed.
    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
    var j = -1;
    var best_common = '';
    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
    while ((j = shorttext.indexOf(seed, j + 1)) !== -1) {
      var prefixLength = diff_commonPrefix(
        longtext.substring(i), shorttext.substring(j));
      var suffixLength = diff_commonSuffix(
        longtext.substring(0, i), shorttext.substring(0, j));
      if (best_common.length < suffixLength + prefixLength) {
        best_common = shorttext.substring(
          j - suffixLength, j) + shorttext.substring(j, j + prefixLength);
        best_longtext_a = longtext.substring(0, i - suffixLength);
        best_longtext_b = longtext.substring(i + prefixLength);
        best_shorttext_a = shorttext.substring(0, j - suffixLength);
        best_shorttext_b = shorttext.substring(j + prefixLength);
      }
    }
    if (best_common.length * 2 >= longtext.length) {
      return [
        best_longtext_a, best_longtext_b,
        best_shorttext_a, best_shorttext_b, best_common
      ];
    } else {
      return null;
    }
  }

  // First check if the second quarter is the seed for a half-match.
  var hm1 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 4));
  // Check again based on the third quarter.
  var hm2 = diff_halfMatchI_(longtext, shorttext, Math.ceil(longtext.length / 2));
  var hm;
  if (!hm1 && !hm2) {
    return null;
  } else if (!hm2) {
    hm = hm1;
  } else if (!hm1) {
    hm = hm2;
  } else {
    // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
  }

  // A half-match was found, sort out the return data.
  var text1_a, text1_b, text2_a, text2_b;
  if (text1.length > text2.length) {
    text1_a = hm[0];
    text1_b = hm[1];
    text2_a = hm[2];
    text2_b = hm[3];
  } else {
    text2_a = hm[0];
    text2_b = hm[1];
    text1_a = hm[2];
    text1_b = hm[3];
  }
  var mid_common = hm[4];
  return [text1_a, text1_b, text2_a, text2_b, mid_common];
};


/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {Array} diffs Array of diff tuples.
 * @param {boolean} fix_unicode Whether to normalize to a unicode-correct diff
 */
function diff_cleanupMerge(diffs, fix_unicode) {
  diffs.push([DIFF_EQUAL, '']);  // Add a dummy entry at the end.
  var pointer = 0;
  var count_delete = 0;
  var count_insert = 0;
  var text_delete = '';
  var text_insert = '';
  var commonlength;
  while (pointer < diffs.length) {
    if (pointer < diffs.length - 1 && !diffs[pointer][1]) {
      diffs.splice(pointer, 1);
      continue;
    }
    switch (diffs[pointer][0]) {
      case DIFF_INSERT:

        count_insert++;
        text_insert += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_DELETE:
        count_delete++;
        text_delete += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_EQUAL:
        var previous_equality = pointer - count_insert - count_delete - 1;
        if (fix_unicode) {
          // prevent splitting of unicode surrogate pairs.  when fix_unicode is true,
          // we assume that the old and new text in the diff are complete and correct
          // unicode-encoded JS strings, but the tuple boundaries may fall between
          // surrogate pairs.  we fix this by shaving off stray surrogates from the end
          // of the previous equality and the beginning of this equality.  this may create
          // empty equalities or a common prefix or suffix.  for example, if AB and AC are
          // emojis, `[[0, 'A'], [-1, 'BA'], [0, 'C']]` would turn into deleting 'ABAC' and
          // inserting 'AC', and then the common suffix 'AC' will be eliminated.  in this
          // particular case, both equalities go away, we absorb any previous inequalities,
          // and we keep scanning for the next equality before rewriting the tuples.
          if (previous_equality >= 0 && ends_with_pair_start(diffs[previous_equality][1])) {
            var stray = diffs[previous_equality][1].slice(-1);
            diffs[previous_equality][1] = diffs[previous_equality][1].slice(0, -1);
            text_delete = stray + text_delete;
            text_insert = stray + text_insert;
            if (!diffs[previous_equality][1]) {
              // emptied out previous equality, so delete it and include previous delete/insert
              diffs.splice(previous_equality, 1);
              pointer--;
              var k = previous_equality - 1;
              if (diffs[k] && diffs[k][0] === DIFF_INSERT) {
                count_insert++;
                text_insert = diffs[k][1] + text_insert;
                k--;
              }
              if (diffs[k] && diffs[k][0] === DIFF_DELETE) {
                count_delete++;
                text_delete = diffs[k][1] + text_delete;
                k--;
              }
              previous_equality = k;
            }
          }
          if (starts_with_pair_end(diffs[pointer][1])) {
            var stray = diffs[pointer][1].charAt(0);
            diffs[pointer][1] = diffs[pointer][1].slice(1);
            text_delete += stray;
            text_insert += stray;
          }
        }
        if (pointer < diffs.length - 1 && !diffs[pointer][1]) {
          // for empty equality not at end, wait for next equality
          diffs.splice(pointer, 1);
          break;
        }
        if (text_delete.length > 0 || text_insert.length > 0) {
          // note that diff_commonPrefix and diff_commonSuffix are unicode-aware
          if (text_delete.length > 0 && text_insert.length > 0) {
            // Factor out any common prefixes.
            commonlength = diff_commonPrefix(text_insert, text_delete);
            if (commonlength !== 0) {
              if (previous_equality >= 0) {
                diffs[previous_equality][1] += text_insert.substring(0, commonlength);
              } else {
                diffs.splice(0, 0, [DIFF_EQUAL, text_insert.substring(0, commonlength)]);
                pointer++;
              }
              text_insert = text_insert.substring(commonlength);
              text_delete = text_delete.substring(commonlength);
            }
            // Factor out any common suffixes.
            commonlength = diff_commonSuffix(text_insert, text_delete);
            if (commonlength !== 0) {
              diffs[pointer][1] =
                text_insert.substring(text_insert.length - commonlength) + diffs[pointer][1];
              text_insert = text_insert.substring(0, text_insert.length - commonlength);
              text_delete = text_delete.substring(0, text_delete.length - commonlength);
            }
          }
          // Delete the offending records and add the merged ones.
          var n = count_insert + count_delete;
          if (text_delete.length === 0 && text_insert.length === 0) {
            diffs.splice(pointer - n, n);
            pointer = pointer - n;
          } else if (text_delete.length === 0) {
            diffs.splice(pointer - n, n, [DIFF_INSERT, text_insert]);
            pointer = pointer - n + 1;
          } else if (text_insert.length === 0) {
            diffs.splice(pointer - n, n, [DIFF_DELETE, text_delete]);
            pointer = pointer - n + 1;
          } else {
            diffs.splice(pointer - n, n, [DIFF_DELETE, text_delete], [DIFF_INSERT, text_insert]);
            pointer = pointer - n + 2;
          }
        }
        if (pointer !== 0 && diffs[pointer - 1][0] === DIFF_EQUAL) {
          // Merge this equality with the previous one.
          diffs[pointer - 1][1] += diffs[pointer][1];
          diffs.splice(pointer, 1);
        } else {
          pointer++;
        }
        count_insert = 0;
        count_delete = 0;
        text_delete = '';
        text_insert = '';
        break;
    }
  }
  if (diffs[diffs.length - 1][1] === '') {
    diffs.pop();  // Remove the dummy entry at the end.
  }

  // Second pass: look for single edits surrounded on both sides by equalities
  // which can be shifted sideways to eliminate an equality.
  // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
  var changes = false;
  pointer = 1;
  // Intentionally ignore the first and last element (don't need checking).
  while (pointer < diffs.length - 1) {
    if (diffs[pointer - 1][0] === DIFF_EQUAL &&
      diffs[pointer + 1][0] === DIFF_EQUAL) {
      // This is a single edit surrounded by equalities.
      if (diffs[pointer][1].substring(diffs[pointer][1].length -
        diffs[pointer - 1][1].length) === diffs[pointer - 1][1]) {
        // Shift the edit over the previous equality.
        diffs[pointer][1] = diffs[pointer - 1][1] +
          diffs[pointer][1].substring(0, diffs[pointer][1].length -
            diffs[pointer - 1][1].length);
        diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
        diffs.splice(pointer - 1, 1);
        changes = true;
      } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) ==
        diffs[pointer + 1][1]) {
        // Shift the edit over the next equality.
        diffs[pointer - 1][1] += diffs[pointer + 1][1];
        diffs[pointer][1] =
          diffs[pointer][1].substring(diffs[pointer + 1][1].length) +
          diffs[pointer + 1][1];
        diffs.splice(pointer + 1, 1);
        changes = true;
      }
    }
    pointer++;
  }
  // If shifts were made, the diff needs reordering and another shift sweep.
  if (changes) {
    diff_cleanupMerge(diffs, fix_unicode);
  }
};

function is_surrogate_pair_start(charCode) {
  return charCode >= 0xD800 && charCode <= 0xDBFF;
}

function is_surrogate_pair_end(charCode) {
  return charCode >= 0xDC00 && charCode <= 0xDFFF;
}

function starts_with_pair_end(str) {
  return is_surrogate_pair_end(str.charCodeAt(0));
}

function ends_with_pair_start(str) {
  return is_surrogate_pair_start(str.charCodeAt(str.length - 1));
}

function remove_empty_tuples(tuples) {
  var ret = [];
  for (var i = 0; i < tuples.length; i++) {
    if (tuples[i][1].length > 0) {
      ret.push(tuples[i]);
    }
  }
  return ret;
}

function make_edit_splice(before, oldMiddle, newMiddle, after) {
  if (ends_with_pair_start(before) || starts_with_pair_end(after)) {
    return null;
  }
  return remove_empty_tuples([
    [DIFF_EQUAL, before],
    [DIFF_DELETE, oldMiddle],
    [DIFF_INSERT, newMiddle],
    [DIFF_EQUAL, after]
  ]);
}

function find_cursor_edit_diff(oldText, newText, cursor_pos) {
  // note: this runs after equality check has ruled out exact equality
  var oldRange = typeof cursor_pos === 'number' ?
    { index: cursor_pos, length: 0 } : cursor_pos.oldRange;
  var newRange = typeof cursor_pos === 'number' ?
    null : cursor_pos.newRange;
  // take into account the old and new selection to generate the best diff
  // possible for a text edit.  for example, a text change from "xxx" to "xx"
  // could be a delete or forwards-delete of any one of the x's, or the
  // result of selecting two of the x's and typing "x".
  var oldLength = oldText.length;
  var newLength = newText.length;
  if (oldRange.length === 0 && (newRange === null || newRange.length === 0)) {
    // see if we have an insert or delete before or after cursor
    var oldCursor = oldRange.index;
    var oldBefore = oldText.slice(0, oldCursor);
    var oldAfter = oldText.slice(oldCursor);
    var maybeNewCursor = newRange ? newRange.index : null;
    editBefore: {
      // is this an insert or delete right before oldCursor?
      var newCursor = oldCursor + newLength - oldLength;
      if (maybeNewCursor !== null && maybeNewCursor !== newCursor) {
        break editBefore;
      }
      if (newCursor < 0 || newCursor > newLength) {
        break editBefore;
      }
      var newBefore = newText.slice(0, newCursor);
      var newAfter = newText.slice(newCursor);
      if (newAfter !== oldAfter) {
        break editBefore;
      }
      var prefixLength = Math.min(oldCursor, newCursor);
      var oldPrefix = oldBefore.slice(0, prefixLength);
      var newPrefix = newBefore.slice(0, prefixLength);
      if (oldPrefix !== newPrefix) {
        break editBefore;
      }
      var oldMiddle = oldBefore.slice(prefixLength);
      var newMiddle = newBefore.slice(prefixLength);
      return make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldAfter);
    }
    editAfter: {
      // is this an insert or delete right after oldCursor?
      if (maybeNewCursor !== null && maybeNewCursor !== oldCursor) {
        break editAfter;
      }
      var cursor = oldCursor;
      var newBefore = newText.slice(0, cursor);
      var newAfter = newText.slice(cursor);
      if (newBefore !== oldBefore) {
        break editAfter;
      }
      var suffixLength = Math.min(oldLength - cursor, newLength - cursor);
      var oldSuffix = oldAfter.slice(oldAfter.length - suffixLength);
      var newSuffix = newAfter.slice(newAfter.length - suffixLength);
      if (oldSuffix !== newSuffix) {
        break editAfter;
      }
      var oldMiddle = oldAfter.slice(0, oldAfter.length - suffixLength);
      var newMiddle = newAfter.slice(0, newAfter.length - suffixLength);
      return make_edit_splice(oldBefore, oldMiddle, newMiddle, oldSuffix);
    }
  }
  if (oldRange.length > 0 && newRange && newRange.length === 0) {
    replaceRange: {
      // see if diff could be a splice of the old selection range
      var oldPrefix = oldText.slice(0, oldRange.index);
      var oldSuffix = oldText.slice(oldRange.index + oldRange.length);
      var prefixLength = oldPrefix.length;
      var suffixLength = oldSuffix.length;
      if (newLength < prefixLength + suffixLength) {
        break replaceRange;
      }
      var newPrefix = newText.slice(0, prefixLength);
      var newSuffix = newText.slice(newLength - suffixLength);
      if (oldPrefix !== newPrefix || oldSuffix !== newSuffix) {
        break replaceRange;
      }
      var oldMiddle = oldText.slice(prefixLength, oldLength - suffixLength);
      var newMiddle = newText.slice(prefixLength, newLength - suffixLength);
      return make_edit_splice(oldPrefix, oldMiddle, newMiddle, oldSuffix);
    }
  }

  return null;
}

function diff(text1, text2, cursor_pos) {
  // only pass fix_unicode=true at the top level, not when diff_main is
  // recursively invoked
  return diff_main(text1, text2, cursor_pos, true);
}

diff.INSERT = DIFF_INSERT;
diff.DELETE = DIFF_DELETE;
diff.EQUAL = DIFF_EQUAL;

module.exports = diff;


/***/ }),

/***/ "./node_modules/inherits/inherits_browser.js":
/*!***************************************************!*\
  !*** ./node_modules/inherits/inherits_browser.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),

/***/ "./node_modules/json3/lib/json3.js":
/*!*****************************************!*\
  !*** ./node_modules/json3/lib/json3.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! JSON v3.3.2 | https://bestiejs.github.io/json3 | Copyright 2012-2015, Kit Cambridge, Benjamin Tan | http://kit.mit-license.org */
;(function () {
  // Detect the `define` function exposed by asynchronous module loaders. The
  // strict `define` check is necessary for compatibility with `r.js`.
  var isLoader =  true && __webpack_require__(/*! !webpack amd options */ "./node_modules/webpack/buildin/amd-options.js");

  // A set of types used to distinguish objects from primitives.
  var objectTypes = {
    "function": true,
    "object": true
  };

  // Detect the `exports` object exposed by CommonJS implementations.
  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;

  // Use the `global` object exposed by Node (including Browserify via
  // `insert-module-globals`), Narwhal, and Ringo as the default context,
  // and the `window` object in browsers. Rhino exports a `global` function
  // instead.
  var root = objectTypes[typeof window] && window || this,
      freeGlobal = freeExports && objectTypes[typeof module] && module && !module.nodeType && typeof global == "object" && global;

  if (freeGlobal && (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal)) {
    root = freeGlobal;
  }

  // Public: Initializes JSON 3 using the given `context` object, attaching the
  // `stringify` and `parse` functions to the specified `exports` object.
  function runInContext(context, exports) {
    context || (context = root.Object());
    exports || (exports = root.Object());

    // Native constructor aliases.
    var Number = context.Number || root.Number,
        String = context.String || root.String,
        Object = context.Object || root.Object,
        Date = context.Date || root.Date,
        SyntaxError = context.SyntaxError || root.SyntaxError,
        TypeError = context.TypeError || root.TypeError,
        Math = context.Math || root.Math,
        nativeJSON = context.JSON || root.JSON;

    // Delegate to the native `stringify` and `parse` implementations.
    if (typeof nativeJSON == "object" && nativeJSON) {
      exports.stringify = nativeJSON.stringify;
      exports.parse = nativeJSON.parse;
    }

    // Convenience aliases.
    var objectProto = Object.prototype,
        getClass = objectProto.toString,
        isProperty = objectProto.hasOwnProperty,
        undefined;

    // Internal: Contains `try...catch` logic used by other functions.
    // This prevents other functions from being deoptimized.
    function attempt(func, errorFunc) {
      try {
        func();
      } catch (exception) {
        if (errorFunc) {
          errorFunc();
        }
      }
    }

    // Test the `Date#getUTC*` methods. Based on work by @Yaffle.
    var isExtended = new Date(-3509827334573292);
    attempt(function () {
      // The `getUTCFullYear`, `Month`, and `Date` methods return nonsensical
      // results for certain dates in Opera >= 10.53.
      isExtended = isExtended.getUTCFullYear() == -109252 && isExtended.getUTCMonth() === 0 && isExtended.getUTCDate() === 1 &&
        isExtended.getUTCHours() == 10 && isExtended.getUTCMinutes() == 37 && isExtended.getUTCSeconds() == 6 && isExtended.getUTCMilliseconds() == 708;
    });

    // Internal: Determines whether the native `JSON.stringify` and `parse`
    // implementations are spec-compliant. Based on work by Ken Snyder.
    function has(name) {
      if (has[name] != null) {
        // Return cached feature test result.
        return has[name];
      }
      var isSupported;
      if (name == "bug-string-char-index") {
        // IE <= 7 doesn't support accessing string characters using square
        // bracket notation. IE 8 only supports this for primitives.
        isSupported = "a"[0] != "a";
      } else if (name == "json") {
        // Indicates whether both `JSON.stringify` and `JSON.parse` are
        // supported.
        isSupported = has("json-stringify") && has("date-serialization") && has("json-parse");
      } else if (name == "date-serialization") {
        // Indicates whether `Date`s can be serialized accurately by `JSON.stringify`.
        isSupported = has("json-stringify") && isExtended;
        if (isSupported) {
          var stringify = exports.stringify;
          attempt(function () {
            isSupported =
              // JSON 2, Prototype <= 1.7, and older WebKit builds incorrectly
              // serialize extended years.
              stringify(new Date(-8.64e15)) == '"-271821-04-20T00:00:00.000Z"' &&
              // The milliseconds are optional in ES 5, but required in 5.1.
              stringify(new Date(8.64e15)) == '"+275760-09-13T00:00:00.000Z"' &&
              // Firefox <= 11.0 incorrectly serializes years prior to 0 as negative
              // four-digit years instead of six-digit years. Credits: @Yaffle.
              stringify(new Date(-621987552e5)) == '"-000001-01-01T00:00:00.000Z"' &&
              // Safari <= 5.1.5 and Opera >= 10.53 incorrectly serialize millisecond
              // values less than 1000. Credits: @Yaffle.
              stringify(new Date(-1)) == '"1969-12-31T23:59:59.999Z"';
          });
        }
      } else {
        var value, serialized = '{"a":[1,true,false,null,"\\u0000\\b\\n\\f\\r\\t"]}';
        // Test `JSON.stringify`.
        if (name == "json-stringify") {
          var stringify = exports.stringify, stringifySupported = typeof stringify == "function";
          if (stringifySupported) {
            // A test function object with a custom `toJSON` method.
            (value = function () {
              return 1;
            }).toJSON = value;
            attempt(function () {
              stringifySupported =
                // Firefox 3.1b1 and b2 serialize string, number, and boolean
                // primitives as object literals.
                stringify(0) === "0" &&
                // FF 3.1b1, b2, and JSON 2 serialize wrapped primitives as object
                // literals.
                stringify(new Number()) === "0" &&
                stringify(new String()) == '""' &&
                // FF 3.1b1, 2 throw an error if the value is `null`, `undefined`, or
                // does not define a canonical JSON representation (this applies to
                // objects with `toJSON` properties as well, *unless* they are nested
                // within an object or array).
                stringify(getClass) === undefined &&
                // IE 8 serializes `undefined` as `"undefined"`. Safari <= 5.1.7 and
                // FF 3.1b3 pass this test.
                stringify(undefined) === undefined &&
                // Safari <= 5.1.7 and FF 3.1b3 throw `Error`s and `TypeError`s,
                // respectively, if the value is omitted entirely.
                stringify() === undefined &&
                // FF 3.1b1, 2 throw an error if the given value is not a number,
                // string, array, object, Boolean, or `null` literal. This applies to
                // objects with custom `toJSON` methods as well, unless they are nested
                // inside object or array literals. YUI 3.0.0b1 ignores custom `toJSON`
                // methods entirely.
                stringify(value) === "1" &&
                stringify([value]) == "[1]" &&
                // Prototype <= 1.6.1 serializes `[undefined]` as `"[]"` instead of
                // `"[null]"`.
                stringify([undefined]) == "[null]" &&
                // YUI 3.0.0b1 fails to serialize `null` literals.
                stringify(null) == "null" &&
                // FF 3.1b1, 2 halts serialization if an array contains a function:
                // `[1, true, getClass, 1]` serializes as "[1,true,],". FF 3.1b3
                // elides non-JSON values from objects and arrays, unless they
                // define custom `toJSON` methods.
                stringify([undefined, getClass, null]) == "[null,null,null]" &&
                // Simple serialization test. FF 3.1b1 uses Unicode escape sequences
                // where character escape codes are expected (e.g., `\b` => `\u0008`).
                stringify({ "a": [value, true, false, null, "\x00\b\n\f\r\t"] }) == serialized &&
                // FF 3.1b1 and b2 ignore the `filter` and `width` arguments.
                stringify(null, value) === "1" &&
                stringify([1, 2], null, 1) == "[\n 1,\n 2\n]";
            }, function () {
              stringifySupported = false;
            });
          }
          isSupported = stringifySupported;
        }
        // Test `JSON.parse`.
        if (name == "json-parse") {
          var parse = exports.parse, parseSupported;
          if (typeof parse == "function") {
            attempt(function () {
              // FF 3.1b1, b2 will throw an exception if a bare literal is provided.
              // Conforming implementations should also coerce the initial argument to
              // a string prior to parsing.
              if (parse("0") === 0 && !parse(false)) {
                // Simple parsing test.
                value = parse(serialized);
                parseSupported = value["a"].length == 5 && value["a"][0] === 1;
                if (parseSupported) {
                  attempt(function () {
                    // Safari <= 5.1.2 and FF 3.1b1 allow unescaped tabs in strings.
                    parseSupported = !parse('"\t"');
                  });
                  if (parseSupported) {
                    attempt(function () {
                      // FF 4.0 and 4.0.1 allow leading `+` signs and leading
                      // decimal points. FF 4.0, 4.0.1, and IE 9-10 also allow
                      // certain octal literals.
                      parseSupported = parse("01") !== 1;
                    });
                  }
                  if (parseSupported) {
                    attempt(function () {
                      // FF 4.0, 4.0.1, and Rhino 1.7R3-R4 allow trailing decimal
                      // points. These environments, along with FF 3.1b1 and 2,
                      // also allow trailing commas in JSON objects and arrays.
                      parseSupported = parse("1.") !== 1;
                    });
                  }
                }
              }
            }, function () {
              parseSupported = false;
            });
          }
          isSupported = parseSupported;
        }
      }
      return has[name] = !!isSupported;
    }
    has["bug-string-char-index"] = has["date-serialization"] = has["json"] = has["json-stringify"] = has["json-parse"] = null;

    if (!has("json")) {
      // Common `[[Class]]` name aliases.
      var functionClass = "[object Function]",
          dateClass = "[object Date]",
          numberClass = "[object Number]",
          stringClass = "[object String]",
          arrayClass = "[object Array]",
          booleanClass = "[object Boolean]";

      // Detect incomplete support for accessing string characters by index.
      var charIndexBuggy = has("bug-string-char-index");

      // Internal: Normalizes the `for...in` iteration algorithm across
      // environments. Each enumerated key is yielded to a `callback` function.
      var forOwn = function (object, callback) {
        var size = 0, Properties, dontEnums, property;

        // Tests for bugs in the current environment's `for...in` algorithm. The
        // `valueOf` property inherits the non-enumerable flag from
        // `Object.prototype` in older versions of IE, Netscape, and Mozilla.
        (Properties = function () {
          this.valueOf = 0;
        }).prototype.valueOf = 0;

        // Iterate over a new instance of the `Properties` class.
        dontEnums = new Properties();
        for (property in dontEnums) {
          // Ignore all properties inherited from `Object.prototype`.
          if (isProperty.call(dontEnums, property)) {
            size++;
          }
        }
        Properties = dontEnums = null;

        // Normalize the iteration algorithm.
        if (!size) {
          // A list of non-enumerable properties inherited from `Object.prototype`.
          dontEnums = ["valueOf", "toString", "toLocaleString", "propertyIsEnumerable", "isPrototypeOf", "hasOwnProperty", "constructor"];
          // IE <= 8, Mozilla 1.0, and Netscape 6.2 ignore shadowed non-enumerable
          // properties.
          forOwn = function (object, callback) {
            var isFunction = getClass.call(object) == functionClass, property, length;
            var hasProperty = !isFunction && typeof object.constructor != "function" && objectTypes[typeof object.hasOwnProperty] && object.hasOwnProperty || isProperty;
            for (property in object) {
              // Gecko <= 1.0 enumerates the `prototype` property of functions under
              // certain conditions; IE does not.
              if (!(isFunction && property == "prototype") && hasProperty.call(object, property)) {
                callback(property);
              }
            }
            // Manually invoke the callback for each non-enumerable property.
            for (length = dontEnums.length; property = dontEnums[--length];) {
              if (hasProperty.call(object, property)) {
                callback(property);
              }
            }
          };
        } else {
          // No bugs detected; use the standard `for...in` algorithm.
          forOwn = function (object, callback) {
            var isFunction = getClass.call(object) == functionClass, property, isConstructor;
            for (property in object) {
              if (!(isFunction && property == "prototype") && isProperty.call(object, property) && !(isConstructor = property === "constructor")) {
                callback(property);
              }
            }
            // Manually invoke the callback for the `constructor` property due to
            // cross-environment inconsistencies.
            if (isConstructor || isProperty.call(object, (property = "constructor"))) {
              callback(property);
            }
          };
        }
        return forOwn(object, callback);
      };

      // Public: Serializes a JavaScript `value` as a JSON string. The optional
      // `filter` argument may specify either a function that alters how object and
      // array members are serialized, or an array of strings and numbers that
      // indicates which properties should be serialized. The optional `width`
      // argument may be either a string or number that specifies the indentation
      // level of the output.
      if (!has("json-stringify") && !has("date-serialization")) {
        // Internal: A map of control characters and their escaped equivalents.
        var Escapes = {
          92: "\\\\",
          34: '\\"',
          8: "\\b",
          12: "\\f",
          10: "\\n",
          13: "\\r",
          9: "\\t"
        };

        // Internal: Converts `value` into a zero-padded string such that its
        // length is at least equal to `width`. The `width` must be <= 6.
        var leadingZeroes = "000000";
        var toPaddedString = function (width, value) {
          // The `|| 0` expression is necessary to work around a bug in
          // Opera <= 7.54u2 where `0 == -0`, but `String(-0) !== "0"`.
          return (leadingZeroes + (value || 0)).slice(-width);
        };

        // Internal: Serializes a date object.
        var serializeDate = function (value) {
          var getData, year, month, date, time, hours, minutes, seconds, milliseconds;
          // Define additional utility methods if the `Date` methods are buggy.
          if (!isExtended) {
            var floor = Math.floor;
            // A mapping between the months of the year and the number of days between
            // January 1st and the first of the respective month.
            var Months = [0, 31, 59, 90, 120, 151, 181, 212, 243, 273, 304, 334];
            // Internal: Calculates the number of days between the Unix epoch and the
            // first day of the given month.
            var getDay = function (year, month) {
              return Months[month] + 365 * (year - 1970) + floor((year - 1969 + (month = +(month > 1))) / 4) - floor((year - 1901 + month) / 100) + floor((year - 1601 + month) / 400);
            };
            getData = function (value) {
              // Manually compute the year, month, date, hours, minutes,
              // seconds, and milliseconds if the `getUTC*` methods are
              // buggy. Adapted from @Yaffle's `date-shim` project.
              date = floor(value / 864e5);
              for (year = floor(date / 365.2425) + 1970 - 1; getDay(year + 1, 0) <= date; year++);
              for (month = floor((date - getDay(year, 0)) / 30.42); getDay(year, month + 1) <= date; month++);
              date = 1 + date - getDay(year, month);
              // The `time` value specifies the time within the day (see ES
              // 5.1 section 15.9.1.2). The formula `(A % B + B) % B` is used
              // to compute `A modulo B`, as the `%` operator does not
              // correspond to the `modulo` operation for negative numbers.
              time = (value % 864e5 + 864e5) % 864e5;
              // The hours, minutes, seconds, and milliseconds are obtained by
              // decomposing the time within the day. See section 15.9.1.10.
              hours = floor(time / 36e5) % 24;
              minutes = floor(time / 6e4) % 60;
              seconds = floor(time / 1e3) % 60;
              milliseconds = time % 1e3;
            };
          } else {
            getData = function (value) {
              year = value.getUTCFullYear();
              month = value.getUTCMonth();
              date = value.getUTCDate();
              hours = value.getUTCHours();
              minutes = value.getUTCMinutes();
              seconds = value.getUTCSeconds();
              milliseconds = value.getUTCMilliseconds();
            };
          }
          serializeDate = function (value) {
            if (value > -1 / 0 && value < 1 / 0) {
              // Dates are serialized according to the `Date#toJSON` method
              // specified in ES 5.1 section 15.9.5.44. See section 15.9.1.15
              // for the ISO 8601 date time string format.
              getData(value);
              // Serialize extended years correctly.
              value = (year <= 0 || year >= 1e4 ? (year < 0 ? "-" : "+") + toPaddedString(6, year < 0 ? -year : year) : toPaddedString(4, year)) +
              "-" + toPaddedString(2, month + 1) + "-" + toPaddedString(2, date) +
              // Months, dates, hours, minutes, and seconds should have two
              // digits; milliseconds should have three.
              "T" + toPaddedString(2, hours) + ":" + toPaddedString(2, minutes) + ":" + toPaddedString(2, seconds) +
              // Milliseconds are optional in ES 5.0, but required in 5.1.
              "." + toPaddedString(3, milliseconds) + "Z";
              year = month = date = hours = minutes = seconds = milliseconds = null;
            } else {
              value = null;
            }
            return value;
          };
          return serializeDate(value);
        };

        // For environments with `JSON.stringify` but buggy date serialization,
        // we override the native `Date#toJSON` implementation with a
        // spec-compliant one.
        if (has("json-stringify") && !has("date-serialization")) {
          // Internal: the `Date#toJSON` implementation used to override the native one.
          function dateToJSON (key) {
            return serializeDate(this);
          }

          // Public: `JSON.stringify`. See ES 5.1 section 15.12.3.
          var nativeStringify = exports.stringify;
          exports.stringify = function (source, filter, width) {
            var nativeToJSON = Date.prototype.toJSON;
            Date.prototype.toJSON = dateToJSON;
            var result = nativeStringify(source, filter, width);
            Date.prototype.toJSON = nativeToJSON;
            return result;
          }
        } else {
          // Internal: Double-quotes a string `value`, replacing all ASCII control
          // characters (characters with code unit values between 0 and 31) with
          // their escaped equivalents. This is an implementation of the
          // `Quote(value)` operation defined in ES 5.1 section 15.12.3.
          var unicodePrefix = "\\u00";
          var escapeChar = function (character) {
            var charCode = character.charCodeAt(0), escaped = Escapes[charCode];
            if (escaped) {
              return escaped;
            }
            return unicodePrefix + toPaddedString(2, charCode.toString(16));
          };
          var reEscape = /[\x00-\x1f\x22\x5c]/g;
          var quote = function (value) {
            reEscape.lastIndex = 0;
            return '"' +
              (
                reEscape.test(value)
                  ? value.replace(reEscape, escapeChar)
                  : value
              ) +
              '"';
          };

          // Internal: Recursively serializes an object. Implements the
          // `Str(key, holder)`, `JO(value)`, and `JA(value)` operations.
          var serialize = function (property, object, callback, properties, whitespace, indentation, stack) {
            var value, type, className, results, element, index, length, prefix, result;
            attempt(function () {
              // Necessary for host object support.
              value = object[property];
            });
            if (typeof value == "object" && value) {
              if (value.getUTCFullYear && getClass.call(value) == dateClass && value.toJSON === Date.prototype.toJSON) {
                value = serializeDate(value);
              } else if (typeof value.toJSON == "function") {
                value = value.toJSON(property);
              }
            }
            if (callback) {
              // If a replacement function was provided, call it to obtain the value
              // for serialization.
              value = callback.call(object, property, value);
            }
            // Exit early if value is `undefined` or `null`.
            if (value == undefined) {
              return value === undefined ? value : "null";
            }
            type = typeof value;
            // Only call `getClass` if the value is an object.
            if (type == "object") {
              className = getClass.call(value);
            }
            switch (className || type) {
              case "boolean":
              case booleanClass:
                // Booleans are represented literally.
                return "" + value;
              case "number":
              case numberClass:
                // JSON numbers must be finite. `Infinity` and `NaN` are serialized as
                // `"null"`.
                return value > -1 / 0 && value < 1 / 0 ? "" + value : "null";
              case "string":
              case stringClass:
                // Strings are double-quoted and escaped.
                return quote("" + value);
            }
            // Recursively serialize objects and arrays.
            if (typeof value == "object") {
              // Check for cyclic structures. This is a linear search; performance
              // is inversely proportional to the number of unique nested objects.
              for (length = stack.length; length--;) {
                if (stack[length] === value) {
                  // Cyclic structures cannot be serialized by `JSON.stringify`.
                  throw TypeError();
                }
              }
              // Add the object to the stack of traversed objects.
              stack.push(value);
              results = [];
              // Save the current indentation level and indent one additional level.
              prefix = indentation;
              indentation += whitespace;
              if (className == arrayClass) {
                // Recursively serialize array elements.
                for (index = 0, length = value.length; index < length; index++) {
                  element = serialize(index, value, callback, properties, whitespace, indentation, stack);
                  results.push(element === undefined ? "null" : element);
                }
                result = results.length ? (whitespace ? "[\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "]" : ("[" + results.join(",") + "]")) : "[]";
              } else {
                // Recursively serialize object members. Members are selected from
                // either a user-specified list of property names, or the object
                // itself.
                forOwn(properties || value, function (property) {
                  var element = serialize(property, value, callback, properties, whitespace, indentation, stack);
                  if (element !== undefined) {
                    // According to ES 5.1 section 15.12.3: "If `gap` {whitespace}
                    // is not the empty string, let `member` {quote(property) + ":"}
                    // be the concatenation of `member` and the `space` character."
                    // The "`space` character" refers to the literal space
                    // character, not the `space` {width} argument provided to
                    // `JSON.stringify`.
                    results.push(quote(property) + ":" + (whitespace ? " " : "") + element);
                  }
                });
                result = results.length ? (whitespace ? "{\n" + indentation + results.join(",\n" + indentation) + "\n" + prefix + "}" : ("{" + results.join(",") + "}")) : "{}";
              }
              // Remove the object from the traversed object stack.
              stack.pop();
              return result;
            }
          };

          // Public: `JSON.stringify`. See ES 5.1 section 15.12.3.
          exports.stringify = function (source, filter, width) {
            var whitespace, callback, properties, className;
            if (objectTypes[typeof filter] && filter) {
              className = getClass.call(filter);
              if (className == functionClass) {
                callback = filter;
              } else if (className == arrayClass) {
                // Convert the property names array into a makeshift set.
                properties = {};
                for (var index = 0, length = filter.length, value; index < length;) {
                  value = filter[index++];
                  className = getClass.call(value);
                  if (className == "[object String]" || className == "[object Number]") {
                    properties[value] = 1;
                  }
                }
              }
            }
            if (width) {
              className = getClass.call(width);
              if (className == numberClass) {
                // Convert the `width` to an integer and create a string containing
                // `width` number of space characters.
                if ((width -= width % 1) > 0) {
                  if (width > 10) {
                    width = 10;
                  }
                  for (whitespace = ""; whitespace.length < width;) {
                    whitespace += " ";
                  }
                }
              } else if (className == stringClass) {
                whitespace = width.length <= 10 ? width : width.slice(0, 10);
              }
            }
            // Opera <= 7.54u2 discards the values associated with empty string keys
            // (`""`) only if they are used directly within an object member list
            // (e.g., `!("" in { "": 1})`).
            return serialize("", (value = {}, value[""] = source, value), callback, properties, whitespace, "", []);
          };
        }
      }

      // Public: Parses a JSON source string.
      if (!has("json-parse")) {
        var fromCharCode = String.fromCharCode;

        // Internal: A map of escaped control characters and their unescaped
        // equivalents.
        var Unescapes = {
          92: "\\",
          34: '"',
          47: "/",
          98: "\b",
          116: "\t",
          110: "\n",
          102: "\f",
          114: "\r"
        };

        // Internal: Stores the parser state.
        var Index, Source;

        // Internal: Resets the parser state and throws a `SyntaxError`.
        var abort = function () {
          Index = Source = null;
          throw SyntaxError();
        };

        // Internal: Returns the next token, or `"$"` if the parser has reached
        // the end of the source string. A token may be a string, number, `null`
        // literal, or Boolean literal.
        var lex = function () {
          var source = Source, length = source.length, value, begin, position, isSigned, charCode;
          while (Index < length) {
            charCode = source.charCodeAt(Index);
            switch (charCode) {
              case 9: case 10: case 13: case 32:
                // Skip whitespace tokens, including tabs, carriage returns, line
                // feeds, and space characters.
                Index++;
                break;
              case 123: case 125: case 91: case 93: case 58: case 44:
                // Parse a punctuator token (`{`, `}`, `[`, `]`, `:`, or `,`) at
                // the current position.
                value = charIndexBuggy ? source.charAt(Index) : source[Index];
                Index++;
                return value;
              case 34:
                // `"` delimits a JSON string; advance to the next character and
                // begin parsing the string. String tokens are prefixed with the
                // sentinel `@` character to distinguish them from punctuators and
                // end-of-string tokens.
                for (value = "@", Index++; Index < length;) {
                  charCode = source.charCodeAt(Index);
                  if (charCode < 32) {
                    // Unescaped ASCII control characters (those with a code unit
                    // less than the space character) are not permitted.
                    abort();
                  } else if (charCode == 92) {
                    // A reverse solidus (`\`) marks the beginning of an escaped
                    // control character (including `"`, `\`, and `/`) or Unicode
                    // escape sequence.
                    charCode = source.charCodeAt(++Index);
                    switch (charCode) {
                      case 92: case 34: case 47: case 98: case 116: case 110: case 102: case 114:
                        // Revive escaped control characters.
                        value += Unescapes[charCode];
                        Index++;
                        break;
                      case 117:
                        // `\u` marks the beginning of a Unicode escape sequence.
                        // Advance to the first character and validate the
                        // four-digit code point.
                        begin = ++Index;
                        for (position = Index + 4; Index < position; Index++) {
                          charCode = source.charCodeAt(Index);
                          // A valid sequence comprises four hexdigits (case-
                          // insensitive) that form a single hexadecimal value.
                          if (!(charCode >= 48 && charCode <= 57 || charCode >= 97 && charCode <= 102 || charCode >= 65 && charCode <= 70)) {
                            // Invalid Unicode escape sequence.
                            abort();
                          }
                        }
                        // Revive the escaped character.
                        value += fromCharCode("0x" + source.slice(begin, Index));
                        break;
                      default:
                        // Invalid escape sequence.
                        abort();
                    }
                  } else {
                    if (charCode == 34) {
                      // An unescaped double-quote character marks the end of the
                      // string.
                      break;
                    }
                    charCode = source.charCodeAt(Index);
                    begin = Index;
                    // Optimize for the common case where a string is valid.
                    while (charCode >= 32 && charCode != 92 && charCode != 34) {
                      charCode = source.charCodeAt(++Index);
                    }
                    // Append the string as-is.
                    value += source.slice(begin, Index);
                  }
                }
                if (source.charCodeAt(Index) == 34) {
                  // Advance to the next character and return the revived string.
                  Index++;
                  return value;
                }
                // Unterminated string.
                abort();
              default:
                // Parse numbers and literals.
                begin = Index;
                // Advance past the negative sign, if one is specified.
                if (charCode == 45) {
                  isSigned = true;
                  charCode = source.charCodeAt(++Index);
                }
                // Parse an integer or floating-point value.
                if (charCode >= 48 && charCode <= 57) {
                  // Leading zeroes are interpreted as octal literals.
                  if (charCode == 48 && ((charCode = source.charCodeAt(Index + 1)), charCode >= 48 && charCode <= 57)) {
                    // Illegal octal literal.
                    abort();
                  }
                  isSigned = false;
                  // Parse the integer component.
                  for (; Index < length && ((charCode = source.charCodeAt(Index)), charCode >= 48 && charCode <= 57); Index++);
                  // Floats cannot contain a leading decimal point; however, this
                  // case is already accounted for by the parser.
                  if (source.charCodeAt(Index) == 46) {
                    position = ++Index;
                    // Parse the decimal component.
                    for (; position < length; position++) {
                      charCode = source.charCodeAt(position);
                      if (charCode < 48 || charCode > 57) {
                        break;
                      }
                    }
                    if (position == Index) {
                      // Illegal trailing decimal.
                      abort();
                    }
                    Index = position;
                  }
                  // Parse exponents. The `e` denoting the exponent is
                  // case-insensitive.
                  charCode = source.charCodeAt(Index);
                  if (charCode == 101 || charCode == 69) {
                    charCode = source.charCodeAt(++Index);
                    // Skip past the sign following the exponent, if one is
                    // specified.
                    if (charCode == 43 || charCode == 45) {
                      Index++;
                    }
                    // Parse the exponential component.
                    for (position = Index; position < length; position++) {
                      charCode = source.charCodeAt(position);
                      if (charCode < 48 || charCode > 57) {
                        break;
                      }
                    }
                    if (position == Index) {
                      // Illegal empty exponent.
                      abort();
                    }
                    Index = position;
                  }
                  // Coerce the parsed value to a JavaScript number.
                  return +source.slice(begin, Index);
                }
                // A negative sign may only precede numbers.
                if (isSigned) {
                  abort();
                }
                // `true`, `false`, and `null` literals.
                var temp = source.slice(Index, Index + 4);
                if (temp == "true") {
                  Index += 4;
                  return true;
                } else if (temp == "fals" && source.charCodeAt(Index + 4 ) == 101) {
                  Index += 5;
                  return false;
                } else if (temp == "null") {
                  Index += 4;
                  return null;
                }
                // Unrecognized token.
                abort();
            }
          }
          // Return the sentinel `$` character if the parser has reached the end
          // of the source string.
          return "$";
        };

        // Internal: Parses a JSON `value` token.
        var get = function (value) {
          var results, hasMembers;
          if (value == "$") {
            // Unexpected end of input.
            abort();
          }
          if (typeof value == "string") {
            if ((charIndexBuggy ? value.charAt(0) : value[0]) == "@") {
              // Remove the sentinel `@` character.
              return value.slice(1);
            }
            // Parse object and array literals.
            if (value == "[") {
              // Parses a JSON array, returning a new JavaScript array.
              results = [];
              for (;;) {
                value = lex();
                // A closing square bracket marks the end of the array literal.
                if (value == "]") {
                  break;
                }
                // If the array literal contains elements, the current token
                // should be a comma separating the previous element from the
                // next.
                if (hasMembers) {
                  if (value == ",") {
                    value = lex();
                    if (value == "]") {
                      // Unexpected trailing `,` in array literal.
                      abort();
                    }
                  } else {
                    // A `,` must separate each array element.
                    abort();
                  }
                } else {
                  hasMembers = true;
                }
                // Elisions and leading commas are not permitted.
                if (value == ",") {
                  abort();
                }
                results.push(get(value));
              }
              return results;
            } else if (value == "{") {
              // Parses a JSON object, returning a new JavaScript object.
              results = {};
              for (;;) {
                value = lex();
                // A closing curly brace marks the end of the object literal.
                if (value == "}") {
                  break;
                }
                // If the object literal contains members, the current token
                // should be a comma separator.
                if (hasMembers) {
                  if (value == ",") {
                    value = lex();
                    if (value == "}") {
                      // Unexpected trailing `,` in object literal.
                      abort();
                    }
                  } else {
                    // A `,` must separate each object member.
                    abort();
                  }
                } else {
                  hasMembers = true;
                }
                // Leading commas are not permitted, object property names must be
                // double-quoted strings, and a `:` must separate each property
                // name and value.
                if (value == "," || typeof value != "string" || (charIndexBuggy ? value.charAt(0) : value[0]) != "@" || lex() != ":") {
                  abort();
                }
                results[value.slice(1)] = get(lex());
              }
              return results;
            }
            // Unexpected token encountered.
            abort();
          }
          return value;
        };

        // Internal: Updates a traversed object member.
        var update = function (source, property, callback) {
          var element = walk(source, property, callback);
          if (element === undefined) {
            delete source[property];
          } else {
            source[property] = element;
          }
        };

        // Internal: Recursively traverses a parsed JSON object, invoking the
        // `callback` function for each value. This is an implementation of the
        // `Walk(holder, name)` operation defined in ES 5.1 section 15.12.2.
        var walk = function (source, property, callback) {
          var value = source[property], length;
          if (typeof value == "object" && value) {
            // `forOwn` can't be used to traverse an array in Opera <= 8.54
            // because its `Object#hasOwnProperty` implementation returns `false`
            // for array indices (e.g., `![1, 2, 3].hasOwnProperty("0")`).
            if (getClass.call(value) == arrayClass) {
              for (length = value.length; length--;) {
                update(getClass, forOwn, value, length, callback);
              }
            } else {
              forOwn(value, function (property) {
                update(value, property, callback);
              });
            }
          }
          return callback.call(source, property, value);
        };

        // Public: `JSON.parse`. See ES 5.1 section 15.12.2.
        exports.parse = function (source, callback) {
          var result, value;
          Index = 0;
          Source = "" + source;
          result = get(lex());
          // If a JSON string contains multiple tokens, it is invalid.
          if (lex() != "$") {
            abort();
          }
          // Reset the parser state.
          Index = Source = null;
          return callback && getClass.call(callback) == functionClass ? walk((value = {}, value[""] = result, value), "", callback) : result;
        };
      }
    }

    exports.runInContext = runInContext;
    return exports;
  }

  if (freeExports && !isLoader) {
    // Export for CommonJS environments.
    runInContext(root, freeExports);
  } else {
    // Export for web browsers and JavaScript engines.
    var nativeJSON = root.JSON,
        previousJSON = root.JSON3,
        isRestored = false;

    var JSON3 = runInContext(root, (root.JSON3 = {
      // Public: Restores the original value of the global `JSON` object and
      // returns a reference to the `JSON3` object.
      "noConflict": function () {
        if (!isRestored) {
          isRestored = true;
          root.JSON = nativeJSON;
          root.JSON3 = previousJSON;
          nativeJSON = previousJSON = null;
        }
        return JSON3;
      }
    }));

    root.JSON = {
      "parse": JSON3.parse,
      "stringify": JSON3.stringify
    };
  }

  // Export for asynchronous module loaders.
  if (isLoader) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
      return JSON3;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}).call(this);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../webpack/buildin/module.js */ "./node_modules/webpack/buildin/module.js")(module), __webpack_require__(/*! ./../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/lodash.throttle/index.js":
/*!***********************************************!*\
  !*** ./node_modules/lodash.throttle/index.js ***!
  \***********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/make-error/index.js":
/*!******************************************!*\
  !*** ./node_modules/make-error/index.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ISC @ Julien Fontanet



// ===================================================================

var construct = typeof Reflect !== 'undefined' ? Reflect.construct : undefined
var defineProperty = Object.defineProperty

// -------------------------------------------------------------------

var captureStackTrace = Error.captureStackTrace
if (captureStackTrace === undefined) {
  captureStackTrace = function captureStackTrace (error) {
    var container = new Error()

    defineProperty(error, 'stack', {
      configurable: true,
      get: function getStack () {
        var stack = container.stack

        // Replace property with value for faster future accesses.
        defineProperty(this, 'stack', {
          configurable: true,
          value: stack,
          writable: true
        })

        return stack
      },
      set: function setStack (stack) {
        defineProperty(error, 'stack', {
          configurable: true,
          value: stack,
          writable: true
        })
      }
    })
  }
}

// -------------------------------------------------------------------

function BaseError (message) {
  if (message !== undefined) {
    defineProperty(this, 'message', {
      configurable: true,
      value: message,
      writable: true
    })
  }

  var cname = this.constructor.name
  if (
    cname !== undefined &&
    cname !== this.name
  ) {
    defineProperty(this, 'name', {
      configurable: true,
      value: cname,
      writable: true
    })
  }

  captureStackTrace(this, this.constructor)
}

BaseError.prototype = Object.create(Error.prototype, {
  // See: https://github.com/JsCommunity/make-error/issues/4
  constructor: {
    configurable: true,
    value: BaseError,
    writable: true
  }
})

// -------------------------------------------------------------------

// Sets the name of a function if possible (depends of the JS engine).
var setFunctionName = (function () {
  function setFunctionName (fn, name) {
    return defineProperty(fn, 'name', {
      configurable: true,
      value: name
    })
  }
  try {
    var f = function () {}
    setFunctionName(f, 'foo')
    if (f.name === 'foo') {
      return setFunctionName
    }
  } catch (_) {}
})()

// -------------------------------------------------------------------

function makeError (constructor, super_) {
  if (super_ == null || super_ === Error) {
    super_ = BaseError
  } else if (typeof super_ !== 'function') {
    throw new TypeError('super_ should be a function')
  }

  var name
  if (typeof constructor === 'string') {
    name = constructor
    constructor = construct !== undefined
      ? function () { return construct(super_, arguments, this.constructor) }
      : function () { super_.apply(this, arguments) }

    // If the name can be set, do it once and for all.
    if (setFunctionName !== undefined) {
      setFunctionName(constructor, name)
      name = undefined
    }
  } else if (typeof constructor !== 'function') {
    throw new TypeError('constructor should be either a string or a function')
  }

  // Also register the super constructor also as `constructor.super_` just
  // like Node's `util.inherits()`.
  constructor.super_ = constructor['super'] = super_

  var properties = {
    constructor: {
      configurable: true,
      value: constructor,
      writable: true
    }
  }

  // If the name could not be set on the constructor, set it on the
  // prototype.
  if (name !== undefined) {
    properties.name = {
      configurable: true,
      value: name,
      writable: true
    }
  }
  constructor.prototype = Object.create(super_.prototype, properties)

  return constructor
}
exports = module.exports = makeError
exports.BaseError = BaseError


/***/ }),

/***/ "./node_modules/ms/index.js":
/*!**********************************!*\
  !*** ./node_modules/ms/index.js ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isFinite(val)) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'weeks':
    case 'week':
    case 'w':
      return n * w;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (msAbs >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (msAbs >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return plural(ms, msAbs, d, 'day');
  }
  if (msAbs >= h) {
    return plural(ms, msAbs, h, 'hour');
  }
  if (msAbs >= m) {
    return plural(ms, msAbs, m, 'minute');
  }
  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }
  return ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}


/***/ }),

/***/ "./node_modules/ot-json0/lib/bootstrapTransform.js":
/*!*********************************************************!*\
  !*** ./node_modules/ot-json0/lib/bootstrapTransform.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

// These methods let you build a transform function from a transformComponent
// function for OT types like JSON0 in which operations are lists of components
// and transforming them requires N^2 work. I find it kind of nasty that I need
// this, but I'm not really sure what a better solution is. Maybe I should do
// this automatically to types that don't have a compose function defined.

// Add transform and transformX functions for an OT type which has
// transformComponent defined.  transformComponent(destination array,
// component, other component, side)
module.exports = bootstrapTransform
function bootstrapTransform(type, transformComponent, checkValidOp, append) {
  var transformComponentX = function(left, right, destLeft, destRight) {
    transformComponent(destLeft, left, right, 'left');
    transformComponent(destRight, right, left, 'right');
  };

  var transformX = type.transformX = function(leftOp, rightOp) {
    checkValidOp(leftOp);
    checkValidOp(rightOp);
    var newRightOp = [];

    for (var i = 0; i < rightOp.length; i++) {
      var rightComponent = rightOp[i];

      // Generate newLeftOp by composing leftOp by rightComponent
      var newLeftOp = [];
      var k = 0;
      while (k < leftOp.length) {
        var nextC = [];
        transformComponentX(leftOp[k], rightComponent, newLeftOp, nextC);
        k++;

        if (nextC.length === 1) {
          rightComponent = nextC[0];
        } else if (nextC.length === 0) {
          for (var j = k; j < leftOp.length; j++) {
            append(newLeftOp, leftOp[j]);
          }
          rightComponent = null;
          break;
        } else {
          // Recurse.
          var pair = transformX(leftOp.slice(k), nextC);
          for (var l = 0; l < pair[0].length; l++) {
            append(newLeftOp, pair[0][l]);
          }
          for (var r = 0; r < pair[1].length; r++) {
            append(newRightOp, pair[1][r]);
          }
          rightComponent = null;
          break;
        }
      }

      if (rightComponent != null) {
        append(newRightOp, rightComponent);
      }
      leftOp = newLeftOp;
    }
    return [leftOp, newRightOp];
  };

  // Transforms op with specified type ('left' or 'right') by otherOp.
  type.transform = function(op, otherOp, type) {
    if (!(type === 'left' || type === 'right'))
      throw new Error("type must be 'left' or 'right'");

    if (otherOp.length === 0) return op;

    if (op.length === 1 && otherOp.length === 1)
      return transformComponent([], op[0], otherOp[0], type);

    if (type === 'left')
      return transformX(op, otherOp)[0];
    else
      return transformX(otherOp, op)[1];
  };
};


/***/ }),

/***/ "./node_modules/ot-json0/lib/index.js":
/*!********************************************!*\
  !*** ./node_modules/ot-json0/lib/index.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// Only the JSON type is exported, because the text type is deprecated
// otherwise. (If you want to use it somewhere, you're welcome to pull it out
// into a separate module that json0 can depend on).

module.exports = {
  type: __webpack_require__(/*! ./json0 */ "./node_modules/ot-json0/lib/json0.js")
};


/***/ }),

/***/ "./node_modules/ot-json0/lib/json0.js":
/*!********************************************!*\
  !*** ./node_modules/ot-json0/lib/json0.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/*
 This is the implementation of the JSON OT type.

 Spec is here: https://github.com/josephg/ShareJS/wiki/JSON-Operations

 Note: This is being made obsolete. It will soon be replaced by the JSON2 type.
*/

/**
 * UTILITY FUNCTIONS
 */

/**
 * Checks if the passed object is an Array instance. Can't use Array.isArray
 * yet because its not supported on IE8.
 *
 * @param obj
 * @returns {boolean}
 */
var isArray = function(obj) {
  return Object.prototype.toString.call(obj) == '[object Array]';
};

/**
 * Checks if the passed object is an Object instance.
 * No function call (fast) version
 *
 * @param obj
 * @returns {boolean}
 */
var isObject = function(obj) {
  return (!!obj) && (obj.constructor === Object);
};

/**
 * Clones the passed object using JSON serialization (which is slow).
 *
 * hax, copied from test/types/json. Apparently this is still the fastest way
 * to deep clone an object, assuming we have browser support for JSON.  @see
 * http://jsperf.com/cloning-an-object/12
 */
var clone = function(o) {
  return JSON.parse(JSON.stringify(o));
};

/**
 * JSON OT Type
 * @type {*}
 */
var json = {
  name: 'json0',
  uri: 'http://sharejs.org/types/JSONv0'
};

// You can register another OT type as a subtype in a JSON document using
// the following function. This allows another type to handle certain
// operations instead of the builtin JSON type.
var subtypes = {};
json.registerSubtype = function(subtype) {
  subtypes[subtype.name] = subtype;
};

json.create = function(data) {
  // Null instead of undefined if you don't pass an argument.
  return data === undefined ? null : clone(data);
};

json.invertComponent = function(c) {
  var c_ = {p: c.p};

  // handle subtype ops
  if (c.t && subtypes[c.t]) {
    c_.t = c.t;
    c_.o = subtypes[c.t].invert(c.o);
  }

  if (c.si !== void 0) c_.sd = c.si;
  if (c.sd !== void 0) c_.si = c.sd;
  if (c.oi !== void 0) c_.od = c.oi;
  if (c.od !== void 0) c_.oi = c.od;
  if (c.li !== void 0) c_.ld = c.li;
  if (c.ld !== void 0) c_.li = c.ld;
  if (c.na !== void 0) c_.na = -c.na;

  if (c.lm !== void 0) {
    c_.lm = c.p[c.p.length-1];
    c_.p = c.p.slice(0,c.p.length-1).concat([c.lm]);
  }

  return c_;
};

json.invert = function(op) {
  var op_ = op.slice().reverse();
  var iop = [];
  for (var i = 0; i < op_.length; i++) {
    iop.push(json.invertComponent(op_[i]));
  }
  return iop;
};

json.checkValidOp = function(op) {
  for (var i = 0; i < op.length; i++) {
    if (!isArray(op[i].p)) throw new Error('Missing path');
  }
};

json.checkList = function(elem) {
  if (!isArray(elem))
    throw new Error('Referenced element not a list');
};

json.checkObj = function(elem) {
  if (!isObject(elem)) {
    throw new Error("Referenced element not an object (it was " + JSON.stringify(elem) + ")");
  }
};

// helper functions to convert old string ops to and from subtype ops
function convertFromText(c) {
  c.t = 'text0';
  var o = {p: c.p.pop()};
  if (c.si != null) o.i = c.si;
  if (c.sd != null) o.d = c.sd;
  c.o = [o];
}

function convertToText(c) {
  c.p.push(c.o[0].p);
  if (c.o[0].i != null) c.si = c.o[0].i;
  if (c.o[0].d != null) c.sd = c.o[0].d;
  delete c.t;
  delete c.o;
}

json.apply = function(snapshot, op) {
  json.checkValidOp(op);

  op = clone(op);

  var container = {
    data: snapshot
  };

  for (var i = 0; i < op.length; i++) {
    var c = op[i];

    // convert old string ops to use subtype for backwards compatibility
    if (c.si != null || c.sd != null)
      convertFromText(c);

    var parent = null;
    var parentKey = null;
    var elem = container;
    var key = 'data';

    for (var j = 0; j < c.p.length; j++) {
      var p = c.p[j];

      parent = elem;
      parentKey = key;
      elem = elem[key];
      key = p;

      if (parent == null)
        throw new Error('Path invalid');
    }

    // handle subtype ops
    if (c.t && c.o !== void 0 && subtypes[c.t]) {
      elem[key] = subtypes[c.t].apply(elem[key], c.o);

    // Number add
    } else if (c.na !== void 0) {
      if (typeof elem[key] != 'number')
        throw new Error('Referenced element not a number');

      elem[key] += c.na;
    }

    // List replace
    else if (c.li !== void 0 && c.ld !== void 0) {
      json.checkList(elem);
      // Should check the list element matches c.ld
      elem[key] = c.li;
    }

    // List insert
    else if (c.li !== void 0) {
      json.checkList(elem);
      elem.splice(key,0, c.li);
    }

    // List delete
    else if (c.ld !== void 0) {
      json.checkList(elem);
      // Should check the list element matches c.ld here too.
      elem.splice(key,1);
    }

    // List move
    else if (c.lm !== void 0) {
      json.checkList(elem);
      if (c.lm != key) {
        var e = elem[key];
        // Remove it...
        elem.splice(key,1);
        // And insert it back.
        elem.splice(c.lm,0,e);
      }
    }

    // Object insert / replace
    else if (c.oi !== void 0) {
      json.checkObj(elem);

      // Should check that elem[key] == c.od
      elem[key] = c.oi;
    }

    // Object delete
    else if (c.od !== void 0) {
      json.checkObj(elem);

      // Should check that elem[key] == c.od
      delete elem[key];
    }

    else {
      throw new Error('invalid / missing instruction in op');
    }
  }

  return container.data;
};

// Helper to break an operation up into a bunch of small ops.
json.shatter = function(op) {
  var results = [];
  for (var i = 0; i < op.length; i++) {
    results.push([op[i]]);
  }
  return results;
};

// Helper for incrementally applying an operation to a snapshot. Calls yield
// after each op component has been applied.
json.incrementalApply = function(snapshot, op, _yield) {
  for (var i = 0; i < op.length; i++) {
    var smallOp = [op[i]];
    snapshot = json.apply(snapshot, smallOp);
    // I'd just call this yield, but thats a reserved keyword. Bah!
    _yield(smallOp, snapshot);
  }

  return snapshot;
};

// Checks if two paths, p1 and p2 match.
var pathMatches = json.pathMatches = function(p1, p2, ignoreLast) {
  if (p1.length != p2.length)
    return false;

  for (var i = 0; i < p1.length; i++) {
    if (p1[i] !== p2[i] && (!ignoreLast || i !== p1.length - 1))
      return false;
  }

  return true;
};

json.append = function(dest,c) {
  c = clone(c);

  if (dest.length === 0) {
    dest.push(c);
    return;
  }

  var last = dest[dest.length - 1];

  // convert old string ops to use subtype for backwards compatibility
  if ((c.si != null || c.sd != null) && (last.si != null || last.sd != null)) {
    convertFromText(c);
    convertFromText(last);
  }

  if (pathMatches(c.p, last.p)) {
    // handle subtype ops
    if (c.t && last.t && c.t === last.t && subtypes[c.t]) {
      last.o = subtypes[c.t].compose(last.o, c.o);

      // convert back to old string ops
      if (c.si != null || c.sd != null) {
        var p = c.p;
        for (var i = 0; i < last.o.length - 1; i++) {
          c.o = [last.o.pop()];
          c.p = p.slice();
          convertToText(c);
          dest.push(c);
        }

        convertToText(last);
      }
    } else if (last.na != null && c.na != null) {
      dest[dest.length - 1] = {p: last.p, na: last.na + c.na};
    } else if (last.li !== undefined && c.li === undefined && c.ld === last.li) {
      // insert immediately followed by delete becomes a noop.
      if (last.ld !== undefined) {
        // leave the delete part of the replace
        delete last.li;
      } else {
        dest.pop();
      }
    } else if (last.od !== undefined && last.oi === undefined && c.oi !== undefined && c.od === undefined) {
      last.oi = c.oi;
    } else if (last.oi !== undefined && c.od !== undefined) {
      // The last path component inserted something that the new component deletes (or replaces).
      // Just merge them.
      if (c.oi !== undefined) {
        last.oi = c.oi;
      } else if (last.od !== undefined) {
        delete last.oi;
      } else {
        // An insert directly followed by a delete turns into a no-op and can be removed.
        dest.pop();
      }
    } else if (c.lm !== undefined && c.p[c.p.length - 1] === c.lm) {
      // don't do anything
    } else {
      dest.push(c);
    }
  } else {
    // convert string ops back
    if ((c.si != null || c.sd != null) && (last.si != null || last.sd != null)) {
      convertToText(c);
      convertToText(last);
    }

    dest.push(c);
  }
};

json.compose = function(op1,op2) {
  json.checkValidOp(op1);
  json.checkValidOp(op2);

  var newOp = clone(op1);

  for (var i = 0; i < op2.length; i++) {
    json.append(newOp,op2[i]);
  }

  return newOp;
};

json.normalize = function(op) {
  var newOp = [];

  op = isArray(op) ? op : [op];

  for (var i = 0; i < op.length; i++) {
    var c = op[i];
    if (c.p == null) c.p = [];

    json.append(newOp,c);
  }

  return newOp;
};

// Returns the common length of the paths of ops a and b
json.commonLengthForOps = function(a, b) {
  var alen = a.p.length;
  var blen = b.p.length;
  if (a.na != null || a.t)
    alen++;

  if (b.na != null || b.t)
    blen++;

  if (alen === 0) return -1;
  if (blen === 0) return null;

  alen--;
  blen--;

  for (var i = 0; i < alen; i++) {
    var p = a.p[i];
    if (i >= blen || p !== b.p[i])
      return null;
  }

  return alen;
};

// Returns true if an op can affect the given path
json.canOpAffectPath = function(op, path) {
  return json.commonLengthForOps({p:path}, op) != null;
};

// transform c so it applies to a document with otherC applied.
json.transformComponent = function(dest, c, otherC, type) {
  c = clone(c);

  var common = json.commonLengthForOps(otherC, c);
  var common2 = json.commonLengthForOps(c, otherC);
  var cplength = c.p.length;
  var otherCplength = otherC.p.length;

  if (c.na != null || c.t)
    cplength++;

  if (otherC.na != null || otherC.t)
    otherCplength++;

  // if c is deleting something, and that thing is changed by otherC, we need to
  // update c to reflect that change for invertibility.
  if (common2 != null && otherCplength > cplength && c.p[common2] == otherC.p[common2]) {
    if (c.ld !== void 0) {
      var oc = clone(otherC);
      oc.p = oc.p.slice(cplength);
      c.ld = json.apply(clone(c.ld),[oc]);
    } else if (c.od !== void 0) {
      var oc = clone(otherC);
      oc.p = oc.p.slice(cplength);
      c.od = json.apply(clone(c.od),[oc]);
    }
  }

  if (common != null) {
    var commonOperand = cplength == otherCplength;

    // backward compatibility for old string ops
    var oc = otherC;
    if ((c.si != null || c.sd != null) && (otherC.si != null || otherC.sd != null)) {
      convertFromText(c);
      oc = clone(otherC);
      convertFromText(oc);
    }

    // handle subtype ops
    if (oc.t && subtypes[oc.t]) {
      if (c.t && c.t === oc.t) {
        var res = subtypes[c.t].transform(c.o, oc.o, type);

        // convert back to old string ops
        if (c.si != null || c.sd != null) {
          var p = c.p;
          for (var i = 0; i < res.length; i++) {
            c.o = [res[i]];
            c.p = p.slice();
            convertToText(c);
            json.append(dest, c);
          }
        } else if (!isArray(res) || res.length > 0) {
          c.o = res;
          json.append(dest, c);
        }

        return dest;
      }
    }

    // transform based on otherC
    else if (otherC.na !== void 0) {
      // this case is handled below
    } else if (otherC.li !== void 0 && otherC.ld !== void 0) {
      if (otherC.p[common] === c.p[common]) {
        // noop

        if (!commonOperand) {
          return dest;
        } else if (c.ld !== void 0) {
          // we're trying to delete the same element, -> noop
          if (c.li !== void 0 && type === 'left') {
            // we're both replacing one element with another. only one can survive
            c.ld = clone(otherC.li);
          } else {
            return dest;
          }
        }
      }
    } else if (otherC.li !== void 0) {
      if (c.li !== void 0 && c.ld === undefined && commonOperand && c.p[common] === otherC.p[common]) {
        // in li vs. li, left wins.
        if (type === 'right')
          c.p[common]++;
      } else if (otherC.p[common] <= c.p[common]) {
        c.p[common]++;
      }

      if (c.lm !== void 0) {
        if (commonOperand) {
          // otherC edits the same list we edit
          if (otherC.p[common] <= c.lm)
            c.lm++;
          // changing c.from is handled above.
        }
      }
    } else if (otherC.ld !== void 0) {
      if (c.lm !== void 0) {
        if (commonOperand) {
          if (otherC.p[common] === c.p[common]) {
            // they deleted the thing we're trying to move
            return dest;
          }
          // otherC edits the same list we edit
          var p = otherC.p[common];
          var from = c.p[common];
          var to = c.lm;
          if (p < to || (p === to && from < to))
            c.lm--;

        }
      }

      if (otherC.p[common] < c.p[common]) {
        c.p[common]--;
      } else if (otherC.p[common] === c.p[common]) {
        if (otherCplength < cplength) {
          // we're below the deleted element, so -> noop
          return dest;
        } else if (c.ld !== void 0) {
          if (c.li !== void 0) {
            // we're replacing, they're deleting. we become an insert.
            delete c.ld;
          } else {
            // we're trying to delete the same element, -> noop
            return dest;
          }
        }
      }

    } else if (otherC.lm !== void 0) {
      if (c.lm !== void 0 && cplength === otherCplength) {
        // lm vs lm, here we go!
        var from = c.p[common];
        var to = c.lm;
        var otherFrom = otherC.p[common];
        var otherTo = otherC.lm;
        if (otherFrom !== otherTo) {
          // if otherFrom == otherTo, we don't need to change our op.

          // where did my thing go?
          if (from === otherFrom) {
            // they moved it! tie break.
            if (type === 'left') {
              c.p[common] = otherTo;
              if (from === to) // ugh
                c.lm = otherTo;
            } else {
              return dest;
            }
          } else {
            // they moved around it
            if (from > otherFrom) c.p[common]--;
            if (from > otherTo) c.p[common]++;
            else if (from === otherTo) {
              if (otherFrom > otherTo) {
                c.p[common]++;
                if (from === to) // ugh, again
                  c.lm++;
              }
            }

            // step 2: where am i going to put it?
            if (to > otherFrom) {
              c.lm--;
            } else if (to === otherFrom) {
              if (to > from)
                c.lm--;
            }
            if (to > otherTo) {
              c.lm++;
            } else if (to === otherTo) {
              // if we're both moving in the same direction, tie break
              if ((otherTo > otherFrom && to > from) ||
                  (otherTo < otherFrom && to < from)) {
                if (type === 'right') c.lm++;
              } else {
                if (to > from) c.lm++;
                else if (to === otherFrom) c.lm--;
              }
            }
          }
        }
      } else if (c.li !== void 0 && c.ld === undefined && commonOperand) {
        // li
        var from = otherC.p[common];
        var to = otherC.lm;
        p = c.p[common];
        if (p > from) c.p[common]--;
        if (p > to) c.p[common]++;
      } else {
        // ld, ld+li, si, sd, na, oi, od, oi+od, any li on an element beneath
        // the lm
        //
        // i.e. things care about where their item is after the move.
        var from = otherC.p[common];
        var to = otherC.lm;
        p = c.p[common];
        if (p === from) {
          c.p[common] = to;
        } else {
          if (p > from) c.p[common]--;
          if (p > to) c.p[common]++;
          else if (p === to && from > to) c.p[common]++;
        }
      }
    }
    else if (otherC.oi !== void 0 && otherC.od !== void 0) {
      if (c.p[common] === otherC.p[common]) {
        if (c.oi !== void 0 && commonOperand) {
          // we inserted where someone else replaced
          if (type === 'right') {
            // left wins
            return dest;
          } else {
            // we win, make our op replace what they inserted
            c.od = otherC.oi;
          }
        } else {
          // -> noop if the other component is deleting the same object (or any parent)
          return dest;
        }
      }
    } else if (otherC.oi !== void 0) {
      if (c.oi !== void 0 && c.p[common] === otherC.p[common]) {
        // left wins if we try to insert at the same place
        if (type === 'left') {
          json.append(dest,{p: c.p, od:otherC.oi});
        } else {
          return dest;
        }
      }
    } else if (otherC.od !== void 0) {
      if (c.p[common] == otherC.p[common]) {
        if (!commonOperand)
          return dest;
        if (c.oi !== void 0) {
          delete c.od;
        } else {
          return dest;
        }
      }
    }
  }

  json.append(dest,c);
  return dest;
};

__webpack_require__(/*! ./bootstrapTransform */ "./node_modules/ot-json0/lib/bootstrapTransform.js")(json, json.transformComponent, json.checkValidOp, json.append);

/**
 * Register a subtype for string operations, using the text0 type.
 */
var text = __webpack_require__(/*! ./text0 */ "./node_modules/ot-json0/lib/text0.js");

json.registerSubtype(text);
module.exports = json;



/***/ }),

/***/ "./node_modules/ot-json0/lib/text0.js":
/*!********************************************!*\
  !*** ./node_modules/ot-json0/lib/text0.js ***!
  \********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

// DEPRECATED!
//
// This type works, but is not exported. Its included here because the JSON0
// embedded string operations use this library.


// A simple text implementation
//
// Operations are lists of components. Each component either inserts or deletes
// at a specified position in the document.
//
// Components are either:
//  {i:'str', p:100}: Insert 'str' at position 100 in the document
//  {d:'str', p:100}: Delete 'str' at position 100 in the document
//
// Components in an operation are executed sequentially, so the position of components
// assumes previous components have already executed.
//
// Eg: This op:
//   [{i:'abc', p:0}]
// is equivalent to this op:
//   [{i:'a', p:0}, {i:'b', p:1}, {i:'c', p:2}]

var text = module.exports = {
  name: 'text0',
  uri: 'http://sharejs.org/types/textv0',
  create: function(initial) {
    if ((initial != null) && typeof initial !== 'string') {
      throw new Error('Initial data must be a string');
    }
    return initial || '';
  }
};

/** Insert s2 into s1 at pos. */
var strInject = function(s1, pos, s2) {
  return s1.slice(0, pos) + s2 + s1.slice(pos);
};

/** Check that an operation component is valid. Throws if its invalid. */
var checkValidComponent = function(c) {
  if (typeof c.p !== 'number')
    throw new Error('component missing position field');

  if ((typeof c.i === 'string') === (typeof c.d === 'string'))
    throw new Error('component needs an i or d field');

  if (c.p < 0)
    throw new Error('position cannot be negative');
};

/** Check that an operation is valid */
var checkValidOp = function(op) {
  for (var i = 0; i < op.length; i++) {
    checkValidComponent(op[i]);
  }
};

/** Apply op to snapshot */
text.apply = function(snapshot, op) {
  var deleted;

  checkValidOp(op);
  for (var i = 0; i < op.length; i++) {
    var component = op[i];
    if (component.i != null) {
      snapshot = strInject(snapshot, component.p, component.i);
    } else {
      deleted = snapshot.slice(component.p, component.p + component.d.length);
      if (component.d !== deleted)
        throw new Error("Delete component '" + component.d + "' does not match deleted text '" + deleted + "'");

      snapshot = snapshot.slice(0, component.p) + snapshot.slice(component.p + component.d.length);
    }
  }
  return snapshot;
};

/**
 * Append a component to the end of newOp. Exported for use by the random op
 * generator and the JSON0 type.
 */
var append = text._append = function(newOp, c) {
  if (c.i === '' || c.d === '') return;

  if (newOp.length === 0) {
    newOp.push(c);
  } else {
    var last = newOp[newOp.length - 1];

    if (last.i != null && c.i != null && last.p <= c.p && c.p <= last.p + last.i.length) {
      // Compose the insert into the previous insert
      newOp[newOp.length - 1] = {i:strInject(last.i, c.p - last.p, c.i), p:last.p};

    } else if (last.d != null && c.d != null && c.p <= last.p && last.p <= c.p + c.d.length) {
      // Compose the deletes together
      newOp[newOp.length - 1] = {d:strInject(c.d, last.p - c.p, last.d), p:c.p};

    } else {
      newOp.push(c);
    }
  }
};

/** Compose op1 and op2 together */
text.compose = function(op1, op2) {
  checkValidOp(op1);
  checkValidOp(op2);
  var newOp = op1.slice();
  for (var i = 0; i < op2.length; i++) {
    append(newOp, op2[i]);
  }
  return newOp;
};

/** Clean up an op */
text.normalize = function(op) {
  var newOp = [];

  // Normalize should allow ops which are a single (unwrapped) component:
  // {i:'asdf', p:23}.
  // There's no good way to test if something is an array:
  // http://perfectionkills.com/instanceof-considered-harmful-or-how-to-write-a-robust-isarray/
  // so this is probably the least bad solution.
  if (op.i != null || op.p != null) op = [op];

  for (var i = 0; i < op.length; i++) {
    var c = op[i];
    if (c.p == null) c.p = 0;

    append(newOp, c);
  }

  return newOp;
};

// This helper method transforms a position by an op component.
//
// If c is an insert, insertAfter specifies whether the transform
// is pushed after the insert (true) or before it (false).
//
// insertAfter is optional for deletes.
var transformPosition = function(pos, c, insertAfter) {
  // This will get collapsed into a giant ternary by uglify.
  if (c.i != null) {
    if (c.p < pos || (c.p === pos && insertAfter)) {
      return pos + c.i.length;
    } else {
      return pos;
    }
  } else {
    // I think this could also be written as: Math.min(c.p, Math.min(c.p -
    // otherC.p, otherC.d.length)) but I think its harder to read that way, and
    // it compiles using ternary operators anyway so its no slower written like
    // this.
    if (pos <= c.p) {
      return pos;
    } else if (pos <= c.p + c.d.length) {
      return c.p;
    } else {
      return pos - c.d.length;
    }
  }
};

// Helper method to transform a cursor position as a result of an op.
//
// Like transformPosition above, if c is an insert, insertAfter specifies
// whether the cursor position is pushed after an insert (true) or before it
// (false).
text.transformCursor = function(position, op, side) {
  var insertAfter = side === 'right';
  for (var i = 0; i < op.length; i++) {
    position = transformPosition(position, op[i], insertAfter);
  }

  return position;
};

// Transform an op component by another op component. Asymmetric.
// The result will be appended to destination.
//
// exported for use in JSON type
var transformComponent = text._tc = function(dest, c, otherC, side) {
  //var cIntersect, intersectEnd, intersectStart, newC, otherIntersect, s;

  checkValidComponent(c);
  checkValidComponent(otherC);

  if (c.i != null) {
    // Insert.
    append(dest, {i:c.i, p:transformPosition(c.p, otherC, side === 'right')});
  } else {
    // Delete
    if (otherC.i != null) {
      // Delete vs insert
      var s = c.d;
      if (c.p < otherC.p) {
        append(dest, {d:s.slice(0, otherC.p - c.p), p:c.p});
        s = s.slice(otherC.p - c.p);
      }
      if (s !== '')
        append(dest, {d: s, p: c.p + otherC.i.length});

    } else {
      // Delete vs delete
      if (c.p >= otherC.p + otherC.d.length)
        append(dest, {d: c.d, p: c.p - otherC.d.length});
      else if (c.p + c.d.length <= otherC.p)
        append(dest, c);
      else {
        // They overlap somewhere.
        var newC = {d: '', p: c.p};

        if (c.p < otherC.p)
          newC.d = c.d.slice(0, otherC.p - c.p);

        if (c.p + c.d.length > otherC.p + otherC.d.length)
          newC.d += c.d.slice(otherC.p + otherC.d.length - c.p);

        // This is entirely optional - I'm just checking the deleted text in
        // the two ops matches
        var intersectStart = Math.max(c.p, otherC.p);
        var intersectEnd = Math.min(c.p + c.d.length, otherC.p + otherC.d.length);
        var cIntersect = c.d.slice(intersectStart - c.p, intersectEnd - c.p);
        var otherIntersect = otherC.d.slice(intersectStart - otherC.p, intersectEnd - otherC.p);
        if (cIntersect !== otherIntersect)
          throw new Error('Delete ops delete different text in the same region of the document');

        if (newC.d !== '') {
          newC.p = transformPosition(newC.p, otherC);
          append(dest, newC);
        }
      }
    }
  }

  return dest;
};

var invertComponent = function(c) {
  return (c.i != null) ? {d:c.i, p:c.p} : {i:c.d, p:c.p};
};

// No need to use append for invert, because the components won't be able to
// cancel one another.
text.invert = function(op) {
  // Shallow copy & reverse that sucka.
  op = op.slice().reverse();
  for (var i = 0; i < op.length; i++) {
    op[i] = invertComponent(op[i]);
  }
  return op;
};

__webpack_require__(/*! ./bootstrapTransform */ "./node_modules/ot-json0/lib/bootstrapTransform.js")(text, transformComponent, checkValidOp, append);


/***/ }),

/***/ "./node_modules/process/browser.js":
/*!*****************************************!*\
  !*** ./node_modules/process/browser.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ "./node_modules/querystringify/index.js":
/*!**********************************************!*\
  !*** ./node_modules/querystringify/index.js ***!
  \**********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var has = Object.prototype.hasOwnProperty
  , undef;

/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */
function decode(input) {
  try {
    return decodeURIComponent(input.replace(/\+/g, ' '));
  } catch (e) {
    return null;
  }
}

/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */
function encode(input) {
  try {
    return encodeURIComponent(input);
  } catch (e) {
    return null;
  }
}

/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */
function querystring(query) {
  var parser = /([^=?&]+)=?([^&]*)/g
    , result = {}
    , part;

  while (part = parser.exec(query)) {
    var key = decode(part[1])
      , value = decode(part[2]);

    //
    // Prevent overriding of existing properties. This ensures that build-in
    // methods like `toString` or __proto__ are not overriden by malicious
    // querystrings.
    //
    // In the case if failed decoding, we want to omit the key/value pairs
    // from the result.
    //
    if (key === null || value === null || key in result) continue;
    result[key] = value;
  }

  return result;
}

/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */
function querystringify(obj, prefix) {
  prefix = prefix || '';

  var pairs = []
    , value
    , key;

  //
  // Optionally prefix with a '?' if needed
  //
  if ('string' !== typeof prefix) prefix = '?';

  for (key in obj) {
    if (has.call(obj, key)) {
      value = obj[key];

      //
      // Edge cases where we actually want to encode the value to an empty
      // string instead of the stringified value.
      //
      if (!value && (value === null || value === undef || isNaN(value))) {
        value = '';
      }

      key = encodeURIComponent(key);
      value = encodeURIComponent(value);

      //
      // If we failed to encode the strings, we should bail out as we don't
      // want to add invalid strings to the query.
      //
      if (key === null || value === null) continue;
      pairs.push(key +'='+ value);
    }
  }

  return pairs.length ? prefix + pairs.join('&') : '';
}

//
// Expose the module.
//
exports.stringify = querystringify;
exports.parse = querystring;


/***/ }),

/***/ "./node_modules/requires-port/index.js":
/*!*********************************************!*\
  !*** ./node_modules/requires-port/index.js ***!
  \*********************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */
module.exports = function required(port, protocol) {
  protocol = protocol.split(':')[0];
  port = +port;

  if (!port) return false;

  switch (protocol) {
    case 'http':
    case 'ws':
    return port !== 80;

    case 'https':
    case 'wss':
    return port !== 443;

    case 'ftp':
    return port !== 21;

    case 'gopher':
    return port !== 70;

    case 'file':
    return false;
  }

  return port !== 0;
};


/***/ }),

/***/ "./node_modules/scroll-into-view-if-needed/es/index.js":
/*!*************************************************************!*\
  !*** ./node_modules/scroll-into-view-if-needed/es/index.js ***!
  \*************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var compute_scroll_into_view__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! compute-scroll-into-view */ "./node_modules/compute-scroll-into-view/es/index.js");


function isOptionsObject(options) {
  return options === Object(options) && Object.keys(options).length !== 0;
}

function defaultBehavior(actions, behavior) {
  if (behavior === void 0) {
    behavior = 'auto';
  }

  var canSmoothScroll = 'scrollBehavior' in document.body.style;
  actions.forEach(function (_ref) {
    var el = _ref.el,
        top = _ref.top,
        left = _ref.left;

    if (el.scroll && canSmoothScroll) {
      el.scroll({
        top: top,
        left: left,
        behavior: behavior
      });
    } else {
      el.scrollTop = top;
      el.scrollLeft = left;
    }
  });
}

function getOptions(options) {
  if (options === false) {
    return {
      block: 'end',
      inline: 'nearest'
    };
  }

  if (isOptionsObject(options)) {
    return options;
  }

  return {
    block: 'start',
    inline: 'nearest'
  };
}

function scrollIntoView(target, options) {
  var targetIsDetached = !target.ownerDocument.documentElement.contains(target);

  if (isOptionsObject(options) && typeof options.behavior === 'function') {
    return options.behavior(targetIsDetached ? [] : Object(compute_scroll_into_view__WEBPACK_IMPORTED_MODULE_0__["default"])(target, options));
  }

  if (targetIsDetached) {
    return;
  }

  var computeOptions = getOptions(options);
  return defaultBehavior(Object(compute_scroll_into_view__WEBPACK_IMPORTED_MODULE_0__["default"])(target, computeOptions), computeOptions.behavior);
}

/* harmony default export */ __webpack_exports__["default"] = (scrollIntoView);

/***/ }),

/***/ "./node_modules/sockjs-client/lib/entry.js":
/*!*************************************************!*\
  !*** ./node_modules/sockjs-client/lib/entry.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var transportList = __webpack_require__(/*! ./transport-list */ "./node_modules/sockjs-client/lib/transport-list.js");

module.exports = __webpack_require__(/*! ./main */ "./node_modules/sockjs-client/lib/main.js")(transportList);

// TODO can't get rid of this until all servers do
if ('_sockjs_onload' in global) {
  setTimeout(global._sockjs_onload, 1);
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/sockjs-client/lib/event/close.js":
/*!*******************************************************!*\
  !*** ./node_modules/sockjs-client/lib/event/close.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
  , Event = __webpack_require__(/*! ./event */ "./node_modules/sockjs-client/lib/event/event.js")
  ;

function CloseEvent() {
  Event.call(this);
  this.initEvent('close', false, false);
  this.wasClean = false;
  this.code = 0;
  this.reason = '';
}

inherits(CloseEvent, Event);

module.exports = CloseEvent;


/***/ }),

/***/ "./node_modules/sockjs-client/lib/event/emitter.js":
/*!*********************************************************!*\
  !*** ./node_modules/sockjs-client/lib/event/emitter.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
  , EventTarget = __webpack_require__(/*! ./eventtarget */ "./node_modules/sockjs-client/lib/event/eventtarget.js")
  ;

function EventEmitter() {
  EventTarget.call(this);
}

inherits(EventEmitter, EventTarget);

EventEmitter.prototype.removeAllListeners = function(type) {
  if (type) {
    delete this._listeners[type];
  } else {
    this._listeners = {};
  }
};

EventEmitter.prototype.once = function(type, listener) {
  var self = this
    , fired = false;

  function g() {
    self.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  this.on(type, g);
};

EventEmitter.prototype.emit = function() {
  var type = arguments[0];
  var listeners = this._listeners[type];
  if (!listeners) {
    return;
  }
  // equivalent of Array.prototype.slice.call(arguments, 1);
  var l = arguments.length;
  var args = new Array(l - 1);
  for (var ai = 1; ai < l; ai++) {
    args[ai - 1] = arguments[ai];
  }
  for (var i = 0; i < listeners.length; i++) {
    listeners[i].apply(this, args);
  }
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener = EventTarget.prototype.addEventListener;
EventEmitter.prototype.removeListener = EventTarget.prototype.removeEventListener;

module.exports.EventEmitter = EventEmitter;


/***/ }),

/***/ "./node_modules/sockjs-client/lib/event/event.js":
/*!*******************************************************!*\
  !*** ./node_modules/sockjs-client/lib/event/event.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function Event(eventType) {
  this.type = eventType;
}

Event.prototype.initEvent = function(eventType, canBubble, cancelable) {
  this.type = eventType;
  this.bubbles = canBubble;
  this.cancelable = cancelable;
  this.timeStamp = +new Date();
  return this;
};

Event.prototype.stopPropagation = function() {};
Event.prototype.preventDefault = function() {};

Event.CAPTURING_PHASE = 1;
Event.AT_TARGET = 2;
Event.BUBBLING_PHASE = 3;

module.exports = Event;


/***/ }),

/***/ "./node_modules/sockjs-client/lib/event/eventtarget.js":
/*!*************************************************************!*\
  !*** ./node_modules/sockjs-client/lib/event/eventtarget.js ***!
  \*************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* Simplified implementation of DOM2 EventTarget.
 *   http://www.w3.org/TR/DOM-Level-2-Events/events.html#Events-EventTarget
 */

function EventTarget() {
  this._listeners = {};
}

EventTarget.prototype.addEventListener = function(eventType, listener) {
  if (!(eventType in this._listeners)) {
    this._listeners[eventType] = [];
  }
  var arr = this._listeners[eventType];
  // #4
  if (arr.indexOf(listener) === -1) {
    // Make a copy so as not to interfere with a current dispatchEvent.
    arr = arr.concat([listener]);
  }
  this._listeners[eventType] = arr;
};

EventTarget.prototype.removeEventListener = function(eventType, listener) {
  var arr = this._listeners[eventType];
  if (!arr) {
    return;
  }
  var idx = arr.indexOf(listener);
  if (idx !== -1) {
    if (arr.length > 1) {
      // Make a copy so as not to interfere with a current dispatchEvent.
      this._listeners[eventType] = arr.slice(0, idx).concat(arr.slice(idx + 1));
    } else {
      delete this._listeners[eventType];
    }
    return;
  }
};

EventTarget.prototype.dispatchEvent = function() {
  var event = arguments[0];
  var t = event.type;
  // equivalent of Array.prototype.slice.call(arguments, 0);
  var args = arguments.length === 1 ? [event] : Array.apply(null, arguments);
  // TODO: This doesn't match the real behavior; per spec, onfoo get
  // their place in line from the /first/ time they're set from
  // non-null. Although WebKit bumps it to the end every time it's
  // set.
  if (this['on' + t]) {
    this['on' + t].apply(this, args);
  }
  if (t in this._listeners) {
    // Grab a reference to the listeners list. removeEventListener may alter the list.
    var listeners = this._listeners[t];
    for (var i = 0; i < listeners.length; i++) {
      listeners[i].apply(this, args);
    }
  }
};

module.exports = EventTarget;


/***/ }),

/***/ "./node_modules/sockjs-client/lib/event/trans-message.js":
/*!***************************************************************!*\
  !*** ./node_modules/sockjs-client/lib/event/trans-message.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
  , Event = __webpack_require__(/*! ./event */ "./node_modules/sockjs-client/lib/event/event.js")
  ;

function TransportMessageEvent(data) {
  Event.call(this);
  this.initEvent('message', false, false);
  this.data = data;
}

inherits(TransportMessageEvent, Event);

module.exports = TransportMessageEvent;


/***/ }),

/***/ "./node_modules/sockjs-client/lib/facade.js":
/*!**************************************************!*\
  !*** ./node_modules/sockjs-client/lib/facade.js ***!
  \**************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var JSON3 = __webpack_require__(/*! json3 */ "./node_modules/json3/lib/json3.js")
  , iframeUtils = __webpack_require__(/*! ./utils/iframe */ "./node_modules/sockjs-client/lib/utils/iframe.js")
  ;

function FacadeJS(transport) {
  this._transport = transport;
  transport.on('message', this._transportMessage.bind(this));
  transport.on('close', this._transportClose.bind(this));
}

FacadeJS.prototype._transportClose = function(code, reason) {
  iframeUtils.postMessage('c', JSON3.stringify([code, reason]));
};
FacadeJS.prototype._transportMessage = function(frame) {
  iframeUtils.postMessage('t', frame);
};
FacadeJS.prototype._send = function(data) {
  this._transport.send(data);
};
FacadeJS.prototype._close = function() {
  this._transport.close();
  this._transport.removeAllListeners();
};

module.exports = FacadeJS;


/***/ }),

/***/ "./node_modules/sockjs-client/lib/iframe-bootstrap.js":
/*!************************************************************!*\
  !*** ./node_modules/sockjs-client/lib/iframe-bootstrap.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var urlUtils = __webpack_require__(/*! ./utils/url */ "./node_modules/sockjs-client/lib/utils/url.js")
  , eventUtils = __webpack_require__(/*! ./utils/event */ "./node_modules/sockjs-client/lib/utils/event.js")
  , JSON3 = __webpack_require__(/*! json3 */ "./node_modules/json3/lib/json3.js")
  , FacadeJS = __webpack_require__(/*! ./facade */ "./node_modules/sockjs-client/lib/facade.js")
  , InfoIframeReceiver = __webpack_require__(/*! ./info-iframe-receiver */ "./node_modules/sockjs-client/lib/info-iframe-receiver.js")
  , iframeUtils = __webpack_require__(/*! ./utils/iframe */ "./node_modules/sockjs-client/lib/utils/iframe.js")
  , loc = __webpack_require__(/*! ./location */ "./node_modules/sockjs-client/lib/location.js")
  ;

var debug = function() {};
if (true) {
  debug = __webpack_require__(/*! debug */ "./node_modules/debug/src/browser.js")('sockjs-client:iframe-bootstrap');
}

module.exports = function(SockJS, availableTransports) {
  var transportMap = {};
  availableTransports.forEach(function(at) {
    if (at.facadeTransport) {
      transportMap[at.facadeTransport.transportName] = at.facadeTransport;
    }
  });

  // hard-coded for the info iframe
  // TODO see if we can make this more dynamic
  transportMap[InfoIframeReceiver.transportName] = InfoIframeReceiver;
  var parentOrigin;

  /* eslint-disable camelcase */
  SockJS.bootstrap_iframe = function() {
    /* eslint-enable camelcase */
    var facade;
    iframeUtils.currentWindowId = loc.hash.slice(1);
    var onMessage = function(e) {
      if (e.source !== parent) {
        return;
      }
      if (typeof parentOrigin === 'undefined') {
        parentOrigin = e.origin;
      }
      if (e.origin !== parentOrigin) {
        return;
      }

      var iframeMessage;
      try {
        iframeMessage = JSON3.parse(e.data);
      } catch (ignored) {
        debug('bad json', e.data);
        return;
      }

      if (iframeMessage.windowId !== iframeUtils.currentWindowId) {
        return;
      }
      switch (iframeMessage.type) {
      case 's':
        var p;
        try {
          p = JSON3.parse(iframeMessage.data);
        } catch (ignored) {
          debug('bad json', iframeMessage.data);
          break;
        }
        var version = p[0];
        var transport = p[1];
        var transUrl = p[2];
        var baseUrl = p[3];
        debug(version, transport, transUrl, baseUrl);
        // change this to semver logic
        if (version !== SockJS.version) {
          throw new Error('Incompatible SockJS! Main site uses:' +
                    ' "' + version + '", the iframe:' +
                    ' "' + SockJS.version + '".');
        }

        if (!urlUtils.isOriginEqual(transUrl, loc.href) ||
            !urlUtils.isOriginEqual(baseUrl, loc.href)) {
          throw new Error('Can\'t connect to different domain from within an ' +
                    'iframe. (' + loc.href + ', ' + transUrl + ', ' + baseUrl + ')');
        }
        facade = new FacadeJS(new transportMap[transport](transUrl, baseUrl));
        break;
      case 'm':
        facade._send(iframeMessage.data);
        break;
      case 'c':
        if (facade) {
          facade._close();
        }
        facade = null;
        break;
      }
    };

    eventUtils.attachEvent('message', onMessage);

    // Start
    iframeUtils.postMessage('s');
  };
};


/***/ }),

/***/ "./node_modules/sockjs-client/lib/info-ajax.js":
/*!*****************************************************!*\
  !*** ./node_modules/sockjs-client/lib/info-ajax.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var EventEmitter = __webpack_require__(/*! events */ "./node_modules/sockjs-client/lib/event/emitter.js").EventEmitter
  , inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
  , JSON3 = __webpack_require__(/*! json3 */ "./node_modules/json3/lib/json3.js")
  , objectUtils = __webpack_require__(/*! ./utils/object */ "./node_modules/sockjs-client/lib/utils/object.js")
  ;

var debug = function() {};
if (true) {
  debug = __webpack_require__(/*! debug */ "./node_modules/debug/src/browser.js")('sockjs-client:info-ajax');
}

function InfoAjax(url, AjaxObject) {
  EventEmitter.call(this);

  var self = this;
  var t0 = +new Date();
  this.xo = new AjaxObject('GET', url);

  this.xo.once('finish', function(status, text) {
    var info, rtt;
    if (status === 200) {
      rtt = (+new Date()) - t0;
      if (text) {
        try {
          info = JSON3.parse(text);
        } catch (e) {
          debug('bad json', text);
        }
      }

      if (!objectUtils.isObject(info)) {
        info = {};
      }
    }
    self.emit('finish', info, rtt);
    self.removeAllListeners();
  });
}

inherits(InfoAjax, EventEmitter);

InfoAjax.prototype.close = function() {
  this.removeAllListeners();
  this.xo.close();
};

module.exports = InfoAjax;


/***/ }),

/***/ "./node_modules/sockjs-client/lib/info-iframe-receiver.js":
/*!****************************************************************!*\
  !*** ./node_modules/sockjs-client/lib/info-iframe-receiver.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
  , EventEmitter = __webpack_require__(/*! events */ "./node_modules/sockjs-client/lib/event/emitter.js").EventEmitter
  , JSON3 = __webpack_require__(/*! json3 */ "./node_modules/json3/lib/json3.js")
  , XHRLocalObject = __webpack_require__(/*! ./transport/sender/xhr-local */ "./node_modules/sockjs-client/lib/transport/sender/xhr-local.js")
  , InfoAjax = __webpack_require__(/*! ./info-ajax */ "./node_modules/sockjs-client/lib/info-ajax.js")
  ;

function InfoReceiverIframe(transUrl) {
  var self = this;
  EventEmitter.call(this);

  this.ir = new InfoAjax(transUrl, XHRLocalObject);
  this.ir.once('finish', function(info, rtt) {
    self.ir = null;
    self.emit('message', JSON3.stringify([info, rtt]));
  });
}

inherits(InfoReceiverIframe, EventEmitter);

InfoReceiverIframe.transportName = 'iframe-info-receiver';

InfoReceiverIframe.prototype.close = function() {
  if (this.ir) {
    this.ir.close();
    this.ir = null;
  }
  this.removeAllListeners();
};

module.exports = InfoReceiverIframe;


/***/ }),

/***/ "./node_modules/sockjs-client/lib/info-iframe.js":
/*!*******************************************************!*\
  !*** ./node_modules/sockjs-client/lib/info-iframe.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var EventEmitter = __webpack_require__(/*! events */ "./node_modules/sockjs-client/lib/event/emitter.js").EventEmitter
  , inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
  , JSON3 = __webpack_require__(/*! json3 */ "./node_modules/json3/lib/json3.js")
  , utils = __webpack_require__(/*! ./utils/event */ "./node_modules/sockjs-client/lib/utils/event.js")
  , IframeTransport = __webpack_require__(/*! ./transport/iframe */ "./node_modules/sockjs-client/lib/transport/iframe.js")
  , InfoReceiverIframe = __webpack_require__(/*! ./info-iframe-receiver */ "./node_modules/sockjs-client/lib/info-iframe-receiver.js")
  ;

var debug = function() {};
if (true) {
  debug = __webpack_require__(/*! debug */ "./node_modules/debug/src/browser.js")('sockjs-client:info-iframe');
}

function InfoIframe(baseUrl, url) {
  var self = this;
  EventEmitter.call(this);

  var go = function() {
    var ifr = self.ifr = new IframeTransport(InfoReceiverIframe.transportName, url, baseUrl);

    ifr.once('message', function(msg) {
      if (msg) {
        var d;
        try {
          d = JSON3.parse(msg);
        } catch (e) {
          debug('bad json', msg);
          self.emit('finish');
          self.close();
          return;
        }

        var info = d[0], rtt = d[1];
        self.emit('finish', info, rtt);
      }
      self.close();
    });

    ifr.once('close', function() {
      self.emit('finish');
      self.close();
    });
  };

  // TODO this seems the same as the 'needBody' from transports
  if (!global.document.body) {
    utils.attachEvent('load', go);
  } else {
    go();
  }
}

inherits(InfoIframe, EventEmitter);

InfoIframe.enabled = function() {
  return IframeTransport.enabled();
};

InfoIframe.prototype.close = function() {
  if (this.ifr) {
    this.ifr.close();
  }
  this.removeAllListeners();
  this.ifr = null;
};

module.exports = InfoIframe;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/sockjs-client/lib/info-receiver.js":
/*!*********************************************************!*\
  !*** ./node_modules/sockjs-client/lib/info-receiver.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var EventEmitter = __webpack_require__(/*! events */ "./node_modules/sockjs-client/lib/event/emitter.js").EventEmitter
  , inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
  , urlUtils = __webpack_require__(/*! ./utils/url */ "./node_modules/sockjs-client/lib/utils/url.js")
  , XDR = __webpack_require__(/*! ./transport/sender/xdr */ "./node_modules/sockjs-client/lib/transport/sender/xdr.js")
  , XHRCors = __webpack_require__(/*! ./transport/sender/xhr-cors */ "./node_modules/sockjs-client/lib/transport/sender/xhr-cors.js")
  , XHRLocal = __webpack_require__(/*! ./transport/sender/xhr-local */ "./node_modules/sockjs-client/lib/transport/sender/xhr-local.js")
  , XHRFake = __webpack_require__(/*! ./transport/sender/xhr-fake */ "./node_modules/sockjs-client/lib/transport/sender/xhr-fake.js")
  , InfoIframe = __webpack_require__(/*! ./info-iframe */ "./node_modules/sockjs-client/lib/info-iframe.js")
  , InfoAjax = __webpack_require__(/*! ./info-ajax */ "./node_modules/sockjs-client/lib/info-ajax.js")
  ;

var debug = function() {};
if (true) {
  debug = __webpack_require__(/*! debug */ "./node_modules/debug/src/browser.js")('sockjs-client:info-receiver');
}

function InfoReceiver(baseUrl, urlInfo) {
  debug(baseUrl);
  var self = this;
  EventEmitter.call(this);

  setTimeout(function() {
    self.doXhr(baseUrl, urlInfo);
  }, 0);
}

inherits(InfoReceiver, EventEmitter);

// TODO this is currently ignoring the list of available transports and the whitelist

InfoReceiver._getReceiver = function(baseUrl, url, urlInfo) {
  // determine method of CORS support (if needed)
  if (urlInfo.sameOrigin) {
    return new InfoAjax(url, XHRLocal);
  }
  if (XHRCors.enabled) {
    return new InfoAjax(url, XHRCors);
  }
  if (XDR.enabled && urlInfo.sameScheme) {
    return new InfoAjax(url, XDR);
  }
  if (InfoIframe.enabled()) {
    return new InfoIframe(baseUrl, url);
  }
  return new InfoAjax(url, XHRFake);
};

InfoReceiver.prototype.doXhr = function(baseUrl, urlInfo) {
  var self = this
    , url = urlUtils.addPath(baseUrl, '/info')
    ;
  debug('doXhr', url);

  this.xo = InfoReceiver._getReceiver(baseUrl, url, urlInfo);

  this.timeoutRef = setTimeout(function() {
    debug('timeout');
    self._cleanup(false);
    self.emit('finish');
  }, InfoReceiver.timeout);

  this.xo.once('finish', function(info, rtt) {
    debug('finish', info, rtt);
    self._cleanup(true);
    self.emit('finish', info, rtt);
  });
};

InfoReceiver.prototype._cleanup = function(wasClean) {
  debug('_cleanup');
  clearTimeout(this.timeoutRef);
  this.timeoutRef = null;
  if (!wasClean && this.xo) {
    this.xo.close();
  }
  this.xo = null;
};

InfoReceiver.prototype.close = function() {
  debug('close');
  this.removeAllListeners();
  this._cleanup(false);
};

InfoReceiver.timeout = 8000;

module.exports = InfoReceiver;


/***/ }),

/***/ "./node_modules/sockjs-client/lib/location.js":
/*!****************************************************!*\
  !*** ./node_modules/sockjs-client/lib/location.js ***!
  \****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

module.exports = global.location || {
  origin: 'http://localhost:80'
, protocol: 'http:'
, host: 'localhost'
, port: 80
, href: 'http://localhost/'
, hash: ''
};

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/sockjs-client/lib/main.js":
/*!************************************************!*\
  !*** ./node_modules/sockjs-client/lib/main.js ***!
  \************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

__webpack_require__(/*! ./shims */ "./node_modules/sockjs-client/lib/shims.js");

var URL = __webpack_require__(/*! url-parse */ "./node_modules/url-parse/index.js")
  , inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
  , JSON3 = __webpack_require__(/*! json3 */ "./node_modules/json3/lib/json3.js")
  , random = __webpack_require__(/*! ./utils/random */ "./node_modules/sockjs-client/lib/utils/random.js")
  , escape = __webpack_require__(/*! ./utils/escape */ "./node_modules/sockjs-client/lib/utils/escape.js")
  , urlUtils = __webpack_require__(/*! ./utils/url */ "./node_modules/sockjs-client/lib/utils/url.js")
  , eventUtils = __webpack_require__(/*! ./utils/event */ "./node_modules/sockjs-client/lib/utils/event.js")
  , transport = __webpack_require__(/*! ./utils/transport */ "./node_modules/sockjs-client/lib/utils/transport.js")
  , objectUtils = __webpack_require__(/*! ./utils/object */ "./node_modules/sockjs-client/lib/utils/object.js")
  , browser = __webpack_require__(/*! ./utils/browser */ "./node_modules/sockjs-client/lib/utils/browser.js")
  , log = __webpack_require__(/*! ./utils/log */ "./node_modules/sockjs-client/lib/utils/log.js")
  , Event = __webpack_require__(/*! ./event/event */ "./node_modules/sockjs-client/lib/event/event.js")
  , EventTarget = __webpack_require__(/*! ./event/eventtarget */ "./node_modules/sockjs-client/lib/event/eventtarget.js")
  , loc = __webpack_require__(/*! ./location */ "./node_modules/sockjs-client/lib/location.js")
  , CloseEvent = __webpack_require__(/*! ./event/close */ "./node_modules/sockjs-client/lib/event/close.js")
  , TransportMessageEvent = __webpack_require__(/*! ./event/trans-message */ "./node_modules/sockjs-client/lib/event/trans-message.js")
  , InfoReceiver = __webpack_require__(/*! ./info-receiver */ "./node_modules/sockjs-client/lib/info-receiver.js")
  ;

var debug = function() {};
if (true) {
  debug = __webpack_require__(/*! debug */ "./node_modules/debug/src/browser.js")('sockjs-client:main');
}

var transports;

// follow constructor steps defined at http://dev.w3.org/html5/websockets/#the-websocket-interface
function SockJS(url, protocols, options) {
  if (!(this instanceof SockJS)) {
    return new SockJS(url, protocols, options);
  }
  if (arguments.length < 1) {
    throw new TypeError("Failed to construct 'SockJS: 1 argument required, but only 0 present");
  }
  EventTarget.call(this);

  this.readyState = SockJS.CONNECTING;
  this.extensions = '';
  this.protocol = '';

  // non-standard extension
  options = options || {};
  if (options.protocols_whitelist) {
    log.warn("'protocols_whitelist' is DEPRECATED. Use 'transports' instead.");
  }
  this._transportsWhitelist = options.transports;
  this._transportOptions = options.transportOptions || {};
  this._timeout = options.timeout || 0;

  var sessionId = options.sessionId || 8;
  if (typeof sessionId === 'function') {
    this._generateSessionId = sessionId;
  } else if (typeof sessionId === 'number') {
    this._generateSessionId = function() {
      return random.string(sessionId);
    };
  } else {
    throw new TypeError('If sessionId is used in the options, it needs to be a number or a function.');
  }

  this._server = options.server || random.numberString(1000);

  // Step 1 of WS spec - parse and validate the url. Issue #8
  var parsedUrl = new URL(url);
  if (!parsedUrl.host || !parsedUrl.protocol) {
    throw new SyntaxError("The URL '" + url + "' is invalid");
  } else if (parsedUrl.hash) {
    throw new SyntaxError('The URL must not contain a fragment');
  } else if (parsedUrl.protocol !== 'http:' && parsedUrl.protocol !== 'https:') {
    throw new SyntaxError("The URL's scheme must be either 'http:' or 'https:'. '" + parsedUrl.protocol + "' is not allowed.");
  }

  var secure = parsedUrl.protocol === 'https:';
  // Step 2 - don't allow secure origin with an insecure protocol
  if (loc.protocol === 'https:' && !secure) {
    throw new Error('SecurityError: An insecure SockJS connection may not be initiated from a page loaded over HTTPS');
  }

  // Step 3 - check port access - no need here
  // Step 4 - parse protocols argument
  if (!protocols) {
    protocols = [];
  } else if (!Array.isArray(protocols)) {
    protocols = [protocols];
  }

  // Step 5 - check protocols argument
  var sortedProtocols = protocols.sort();
  sortedProtocols.forEach(function(proto, i) {
    if (!proto) {
      throw new SyntaxError("The protocols entry '" + proto + "' is invalid.");
    }
    if (i < (sortedProtocols.length - 1) && proto === sortedProtocols[i + 1]) {
      throw new SyntaxError("The protocols entry '" + proto + "' is duplicated.");
    }
  });

  // Step 6 - convert origin
  var o = urlUtils.getOrigin(loc.href);
  this._origin = o ? o.toLowerCase() : null;

  // remove the trailing slash
  parsedUrl.set('pathname', parsedUrl.pathname.replace(/\/+$/, ''));

  // store the sanitized url
  this.url = parsedUrl.href;
  debug('using url', this.url);

  // Step 7 - start connection in background
  // obtain server info
  // http://sockjs.github.io/sockjs-protocol/sockjs-protocol-0.3.3.html#section-26
  this._urlInfo = {
    nullOrigin: !browser.hasDomain()
  , sameOrigin: urlUtils.isOriginEqual(this.url, loc.href)
  , sameScheme: urlUtils.isSchemeEqual(this.url, loc.href)
  };

  this._ir = new InfoReceiver(this.url, this._urlInfo);
  this._ir.once('finish', this._receiveInfo.bind(this));
}

inherits(SockJS, EventTarget);

function userSetCode(code) {
  return code === 1000 || (code >= 3000 && code <= 4999);
}

SockJS.prototype.close = function(code, reason) {
  // Step 1
  if (code && !userSetCode(code)) {
    throw new Error('InvalidAccessError: Invalid code');
  }
  // Step 2.4 states the max is 123 bytes, but we are just checking length
  if (reason && reason.length > 123) {
    throw new SyntaxError('reason argument has an invalid length');
  }

  // Step 3.1
  if (this.readyState === SockJS.CLOSING || this.readyState === SockJS.CLOSED) {
    return;
  }

  // TODO look at docs to determine how to set this
  var wasClean = true;
  this._close(code || 1000, reason || 'Normal closure', wasClean);
};

SockJS.prototype.send = function(data) {
  // #13 - convert anything non-string to string
  // TODO this currently turns objects into [object Object]
  if (typeof data !== 'string') {
    data = '' + data;
  }
  if (this.readyState === SockJS.CONNECTING) {
    throw new Error('InvalidStateError: The connection has not been established yet');
  }
  if (this.readyState !== SockJS.OPEN) {
    return;
  }
  this._transport.send(escape.quote(data));
};

SockJS.version = __webpack_require__(/*! ./version */ "./node_modules/sockjs-client/lib/version.js");

SockJS.CONNECTING = 0;
SockJS.OPEN = 1;
SockJS.CLOSING = 2;
SockJS.CLOSED = 3;

SockJS.prototype._receiveInfo = function(info, rtt) {
  debug('_receiveInfo', rtt);
  this._ir = null;
  if (!info) {
    this._close(1002, 'Cannot connect to server');
    return;
  }

  // establish a round-trip timeout (RTO) based on the
  // round-trip time (RTT)
  this._rto = this.countRTO(rtt);
  // allow server to override url used for the actual transport
  this._transUrl = info.base_url ? info.base_url : this.url;
  info = objectUtils.extend(info, this._urlInfo);
  debug('info', info);
  // determine list of desired and supported transports
  var enabledTransports = transports.filterToEnabled(this._transportsWhitelist, info);
  this._transports = enabledTransports.main;
  debug(this._transports.length + ' enabled transports');

  this._connect();
};

SockJS.prototype._connect = function() {
  for (var Transport = this._transports.shift(); Transport; Transport = this._transports.shift()) {
    debug('attempt', Transport.transportName);
    if (Transport.needBody) {
      if (!global.document.body ||
          (typeof global.document.readyState !== 'undefined' &&
            global.document.readyState !== 'complete' &&
            global.document.readyState !== 'interactive')) {
        debug('waiting for body');
        this._transports.unshift(Transport);
        eventUtils.attachEvent('load', this._connect.bind(this));
        return;
      }
    }

    // calculate timeout based on RTO and round trips. Default to 5s
    var timeoutMs = Math.max(this._timeout, (this._rto * Transport.roundTrips) || 5000);
    this._transportTimeoutId = setTimeout(this._transportTimeout.bind(this), timeoutMs);
    debug('using timeout', timeoutMs);

    var transportUrl = urlUtils.addPath(this._transUrl, '/' + this._server + '/' + this._generateSessionId());
    var options = this._transportOptions[Transport.transportName];
    debug('transport url', transportUrl);
    var transportObj = new Transport(transportUrl, this._transUrl, options);
    transportObj.on('message', this._transportMessage.bind(this));
    transportObj.once('close', this._transportClose.bind(this));
    transportObj.transportName = Transport.transportName;
    this._transport = transportObj;

    return;
  }
  this._close(2000, 'All transports failed', false);
};

SockJS.prototype._transportTimeout = function() {
  debug('_transportTimeout');
  if (this.readyState === SockJS.CONNECTING) {
    if (this._transport) {
      this._transport.close();
    }

    this._transportClose(2007, 'Transport timed out');
  }
};

SockJS.prototype._transportMessage = function(msg) {
  debug('_transportMessage', msg);
  var self = this
    , type = msg.slice(0, 1)
    , content = msg.slice(1)
    , payload
    ;

  // first check for messages that don't need a payload
  switch (type) {
    case 'o':
      this._open();
      return;
    case 'h':
      this.dispatchEvent(new Event('heartbeat'));
      debug('heartbeat', this.transport);
      return;
  }

  if (content) {
    try {
      payload = JSON3.parse(content);
    } catch (e) {
      debug('bad json', content);
    }
  }

  if (typeof payload === 'undefined') {
    debug('empty payload', content);
    return;
  }

  switch (type) {
    case 'a':
      if (Array.isArray(payload)) {
        payload.forEach(function(p) {
          debug('message', self.transport, p);
          self.dispatchEvent(new TransportMessageEvent(p));
        });
      }
      break;
    case 'm':
      debug('message', this.transport, payload);
      this.dispatchEvent(new TransportMessageEvent(payload));
      break;
    case 'c':
      if (Array.isArray(payload) && payload.length === 2) {
        this._close(payload[0], payload[1], true);
      }
      break;
  }
};

SockJS.prototype._transportClose = function(code, reason) {
  debug('_transportClose', this.transport, code, reason);
  if (this._transport) {
    this._transport.removeAllListeners();
    this._transport = null;
    this.transport = null;
  }

  if (!userSetCode(code) && code !== 2000 && this.readyState === SockJS.CONNECTING) {
    this._connect();
    return;
  }

  this._close(code, reason);
};

SockJS.prototype._open = function() {
  debug('_open', this._transport && this._transport.transportName, this.readyState);
  if (this.readyState === SockJS.CONNECTING) {
    if (this._transportTimeoutId) {
      clearTimeout(this._transportTimeoutId);
      this._transportTimeoutId = null;
    }
    this.readyState = SockJS.OPEN;
    this.transport = this._transport.transportName;
    this.dispatchEvent(new Event('open'));
    debug('connected', this.transport);
  } else {
    // The server might have been restarted, and lost track of our
    // connection.
    this._close(1006, 'Server lost session');
  }
};

SockJS.prototype._close = function(code, reason, wasClean) {
  debug('_close', this.transport, code, reason, wasClean, this.readyState);
  var forceFail = false;

  if (this._ir) {
    forceFail = true;
    this._ir.close();
    this._ir = null;
  }
  if (this._transport) {
    this._transport.close();
    this._transport = null;
    this.transport = null;
  }

  if (this.readyState === SockJS.CLOSED) {
    throw new Error('InvalidStateError: SockJS has already been closed');
  }

  this.readyState = SockJS.CLOSING;
  setTimeout(function() {
    this.readyState = SockJS.CLOSED;

    if (forceFail) {
      this.dispatchEvent(new Event('error'));
    }

    var e = new CloseEvent('close');
    e.wasClean = wasClean || false;
    e.code = code || 1000;
    e.reason = reason;

    this.dispatchEvent(e);
    this.onmessage = this.onclose = this.onerror = null;
    debug('disconnected');
  }.bind(this), 0);
};

// See: http://www.erg.abdn.ac.uk/~gerrit/dccp/notes/ccid2/rto_estimator/
// and RFC 2988.
SockJS.prototype.countRTO = function(rtt) {
  // In a local environment, when using IE8/9 and the `jsonp-polling`
  // transport the time needed to establish a connection (the time that pass
  // from the opening of the transport to the call of `_dispatchOpen`) is
  // around 200msec (the lower bound used in the article above) and this
  // causes spurious timeouts. For this reason we calculate a value slightly
  // larger than that used in the article.
  if (rtt > 100) {
    return 4 * rtt; // rto > 400msec
  }
  return 300 + rtt; // 300msec < rto <= 400msec
};

module.exports = function(availableTransports) {
  transports = transport(availableTransports);
  __webpack_require__(/*! ./iframe-bootstrap */ "./node_modules/sockjs-client/lib/iframe-bootstrap.js")(SockJS, availableTransports);
  return SockJS;
};

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/sockjs-client/lib/shims.js":
/*!*************************************************!*\
  !*** ./node_modules/sockjs-client/lib/shims.js ***!
  \*************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* eslint-disable */
/* jscs: disable */


// pulled specific shims from https://github.com/es-shims/es5-shim

var ArrayPrototype = Array.prototype;
var ObjectPrototype = Object.prototype;
var FunctionPrototype = Function.prototype;
var StringPrototype = String.prototype;
var array_slice = ArrayPrototype.slice;

var _toString = ObjectPrototype.toString;
var isFunction = function (val) {
    return ObjectPrototype.toString.call(val) === '[object Function]';
};
var isArray = function isArray(obj) {
    return _toString.call(obj) === '[object Array]';
};
var isString = function isString(obj) {
    return _toString.call(obj) === '[object String]';
};

var supportsDescriptors = Object.defineProperty && (function () {
    try {
        Object.defineProperty({}, 'x', {});
        return true;
    } catch (e) { /* this is ES3 */
        return false;
    }
}());

// Define configurable, writable and non-enumerable props
// if they don't exist.
var defineProperty;
if (supportsDescriptors) {
    defineProperty = function (object, name, method, forceAssign) {
        if (!forceAssign && (name in object)) { return; }
        Object.defineProperty(object, name, {
            configurable: true,
            enumerable: false,
            writable: true,
            value: method
        });
    };
} else {
    defineProperty = function (object, name, method, forceAssign) {
        if (!forceAssign && (name in object)) { return; }
        object[name] = method;
    };
}
var defineProperties = function (object, map, forceAssign) {
    for (var name in map) {
        if (ObjectPrototype.hasOwnProperty.call(map, name)) {
          defineProperty(object, name, map[name], forceAssign);
        }
    }
};

var toObject = function (o) {
    if (o == null) { // this matches both null and undefined
        throw new TypeError("can't convert " + o + ' to object');
    }
    return Object(o);
};

//
// Util
// ======
//

// ES5 9.4
// http://es5.github.com/#x9.4
// http://jsperf.com/to-integer

function toInteger(num) {
    var n = +num;
    if (n !== n) { // isNaN
        n = 0;
    } else if (n !== 0 && n !== (1 / 0) && n !== -(1 / 0)) {
        n = (n > 0 || -1) * Math.floor(Math.abs(n));
    }
    return n;
}

function ToUint32(x) {
    return x >>> 0;
}

//
// Function
// ========
//

// ES-5 15.3.4.5
// http://es5.github.com/#x15.3.4.5

function Empty() {}

defineProperties(FunctionPrototype, {
    bind: function bind(that) { // .length is 1
        // 1. Let Target be the this value.
        var target = this;
        // 2. If IsCallable(Target) is false, throw a TypeError exception.
        if (!isFunction(target)) {
            throw new TypeError('Function.prototype.bind called on incompatible ' + target);
        }
        // 3. Let A be a new (possibly empty) internal list of all of the
        //   argument values provided after thisArg (arg1, arg2 etc), in order.
        // XXX slicedArgs will stand in for "A" if used
        var args = array_slice.call(arguments, 1); // for normal call
        // 4. Let F be a new native ECMAScript object.
        // 11. Set the [[Prototype]] internal property of F to the standard
        //   built-in Function prototype object as specified in 15.3.3.1.
        // 12. Set the [[Call]] internal property of F as described in
        //   15.3.4.5.1.
        // 13. Set the [[Construct]] internal property of F as described in
        //   15.3.4.5.2.
        // 14. Set the [[HasInstance]] internal property of F as described in
        //   15.3.4.5.3.
        var binder = function () {

            if (this instanceof bound) {
                // 15.3.4.5.2 [[Construct]]
                // When the [[Construct]] internal method of a function object,
                // F that was created using the bind function is called with a
                // list of arguments ExtraArgs, the following steps are taken:
                // 1. Let target be the value of F's [[TargetFunction]]
                //   internal property.
                // 2. If target has no [[Construct]] internal method, a
                //   TypeError exception is thrown.
                // 3. Let boundArgs be the value of F's [[BoundArgs]] internal
                //   property.
                // 4. Let args be a new list containing the same values as the
                //   list boundArgs in the same order followed by the same
                //   values as the list ExtraArgs in the same order.
                // 5. Return the result of calling the [[Construct]] internal
                //   method of target providing args as the arguments.

                var result = target.apply(
                    this,
                    args.concat(array_slice.call(arguments))
                );
                if (Object(result) === result) {
                    return result;
                }
                return this;

            } else {
                // 15.3.4.5.1 [[Call]]
                // When the [[Call]] internal method of a function object, F,
                // which was created using the bind function is called with a
                // this value and a list of arguments ExtraArgs, the following
                // steps are taken:
                // 1. Let boundArgs be the value of F's [[BoundArgs]] internal
                //   property.
                // 2. Let boundThis be the value of F's [[BoundThis]] internal
                //   property.
                // 3. Let target be the value of F's [[TargetFunction]] internal
                //   property.
                // 4. Let args be a new list containing the same values as the
                //   list boundArgs in the same order followed by the same
                //   values as the list ExtraArgs in the same order.
                // 5. Return the result of calling the [[Call]] internal method
                //   of target providing boundThis as the this value and
                //   providing args as the arguments.

                // equiv: target.call(this, ...boundArgs, ...args)
                return target.apply(
                    that,
                    args.concat(array_slice.call(arguments))
                );

            }

        };

        // 15. If the [[Class]] internal property of Target is "Function", then
        //     a. Let L be the length property of Target minus the length of A.
        //     b. Set the length own property of F to either 0 or L, whichever is
        //       larger.
        // 16. Else set the length own property of F to 0.

        var boundLength = Math.max(0, target.length - args.length);

        // 17. Set the attributes of the length own property of F to the values
        //   specified in 15.3.5.1.
        var boundArgs = [];
        for (var i = 0; i < boundLength; i++) {
            boundArgs.push('$' + i);
        }

        // XXX Build a dynamic function with desired amount of arguments is the only
        // way to set the length property of a function.
        // In environments where Content Security Policies enabled (Chrome extensions,
        // for ex.) all use of eval or Function costructor throws an exception.
        // However in all of these environments Function.prototype.bind exists
        // and so this code will never be executed.
        var bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this, arguments); }')(binder);

        if (target.prototype) {
            Empty.prototype = target.prototype;
            bound.prototype = new Empty();
            // Clean up dangling references.
            Empty.prototype = null;
        }

        // TODO
        // 18. Set the [[Extensible]] internal property of F to true.

        // TODO
        // 19. Let thrower be the [[ThrowTypeError]] function Object (13.2.3).
        // 20. Call the [[DefineOwnProperty]] internal method of F with
        //   arguments "caller", PropertyDescriptor {[[Get]]: thrower, [[Set]]:
        //   thrower, [[Enumerable]]: false, [[Configurable]]: false}, and
        //   false.
        // 21. Call the [[DefineOwnProperty]] internal method of F with
        //   arguments "arguments", PropertyDescriptor {[[Get]]: thrower,
        //   [[Set]]: thrower, [[Enumerable]]: false, [[Configurable]]: false},
        //   and false.

        // TODO
        // NOTE Function objects created using Function.prototype.bind do not
        // have a prototype property or the [[Code]], [[FormalParameters]], and
        // [[Scope]] internal properties.
        // XXX can't delete prototype in pure-js.

        // 22. Return F.
        return bound;
    }
});

//
// Array
// =====
//

// ES5 15.4.3.2
// http://es5.github.com/#x15.4.3.2
// https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/isArray
defineProperties(Array, { isArray: isArray });


var boxedString = Object('a');
var splitString = boxedString[0] !== 'a' || !(0 in boxedString);

var properlyBoxesContext = function properlyBoxed(method) {
    // Check node 0.6.21 bug where third parameter is not boxed
    var properlyBoxesNonStrict = true;
    var properlyBoxesStrict = true;
    if (method) {
        method.call('foo', function (_, __, context) {
            if (typeof context !== 'object') { properlyBoxesNonStrict = false; }
        });

        method.call([1], function () {
            'use strict';
            properlyBoxesStrict = typeof this === 'string';
        }, 'x');
    }
    return !!method && properlyBoxesNonStrict && properlyBoxesStrict;
};

defineProperties(ArrayPrototype, {
    forEach: function forEach(fun /*, thisp*/) {
        var object = toObject(this),
            self = splitString && isString(this) ? this.split('') : object,
            thisp = arguments[1],
            i = -1,
            length = self.length >>> 0;

        // If no callback function or if callback is not a callable function
        if (!isFunction(fun)) {
            throw new TypeError(); // TODO message
        }

        while (++i < length) {
            if (i in self) {
                // Invoke the callback function with call, passing arguments:
                // context, property value, property key, thisArg object
                // context
                fun.call(thisp, self[i], i, object);
            }
        }
    }
}, !properlyBoxesContext(ArrayPrototype.forEach));

// ES5 15.4.4.14
// http://es5.github.com/#x15.4.4.14
// https://developer.mozilla.org/en/JavaScript/Reference/Global_Objects/Array/indexOf
var hasFirefox2IndexOfBug = Array.prototype.indexOf && [0, 1].indexOf(1, 2) !== -1;
defineProperties(ArrayPrototype, {
    indexOf: function indexOf(sought /*, fromIndex */ ) {
        var self = splitString && isString(this) ? this.split('') : toObject(this),
            length = self.length >>> 0;

        if (!length) {
            return -1;
        }

        var i = 0;
        if (arguments.length > 1) {
            i = toInteger(arguments[1]);
        }

        // handle negative indices
        i = i >= 0 ? i : Math.max(0, length + i);
        for (; i < length; i++) {
            if (i in self && self[i] === sought) {
                return i;
            }
        }
        return -1;
    }
}, hasFirefox2IndexOfBug);

//
// String
// ======
//

// ES5 15.5.4.14
// http://es5.github.com/#x15.5.4.14

// [bugfix, IE lt 9, firefox 4, Konqueror, Opera, obscure browsers]
// Many browsers do not split properly with regular expressions or they
// do not perform the split correctly under obscure conditions.
// See http://blog.stevenlevithan.com/archives/cross-browser-split
// I've tested in many browsers and this seems to cover the deviant ones:
//    'ab'.split(/(?:ab)*/) should be ["", ""], not [""]
//    '.'.split(/(.?)(.?)/) should be ["", ".", "", ""], not ["", ""]
//    'tesst'.split(/(s)*/) should be ["t", undefined, "e", "s", "t"], not
//       [undefined, "t", undefined, "e", ...]
//    ''.split(/.?/) should be [], not [""]
//    '.'.split(/()()/) should be ["."], not ["", "", "."]

var string_split = StringPrototype.split;
if (
    'ab'.split(/(?:ab)*/).length !== 2 ||
    '.'.split(/(.?)(.?)/).length !== 4 ||
    'tesst'.split(/(s)*/)[1] === 't' ||
    'test'.split(/(?:)/, -1).length !== 4 ||
    ''.split(/.?/).length ||
    '.'.split(/()()/).length > 1
) {
    (function () {
        var compliantExecNpcg = /()??/.exec('')[1] === void 0; // NPCG: nonparticipating capturing group

        StringPrototype.split = function (separator, limit) {
            var string = this;
            if (separator === void 0 && limit === 0) {
                return [];
            }

            // If `separator` is not a regex, use native split
            if (_toString.call(separator) !== '[object RegExp]') {
                return string_split.call(this, separator, limit);
            }

            var output = [],
                flags = (separator.ignoreCase ? 'i' : '') +
                        (separator.multiline  ? 'm' : '') +
                        (separator.extended   ? 'x' : '') + // Proposed for ES6
                        (separator.sticky     ? 'y' : ''), // Firefox 3+
                lastLastIndex = 0,
                // Make `global` and avoid `lastIndex` issues by working with a copy
                separator2, match, lastIndex, lastLength;
            separator = new RegExp(separator.source, flags + 'g');
            string += ''; // Type-convert
            if (!compliantExecNpcg) {
                // Doesn't need flags gy, but they don't hurt
                separator2 = new RegExp('^' + separator.source + '$(?!\\s)', flags);
            }
            /* Values for `limit`, per the spec:
             * If undefined: 4294967295 // Math.pow(2, 32) - 1
             * If 0, Infinity, or NaN: 0
             * If positive number: limit = Math.floor(limit); if (limit > 4294967295) limit -= 4294967296;
             * If negative number: 4294967296 - Math.floor(Math.abs(limit))
             * If other: Type-convert, then use the above rules
             */
            limit = limit === void 0 ?
                -1 >>> 0 : // Math.pow(2, 32) - 1
                ToUint32(limit);
            while (match = separator.exec(string)) {
                // `separator.lastIndex` is not reliable cross-browser
                lastIndex = match.index + match[0].length;
                if (lastIndex > lastLastIndex) {
                    output.push(string.slice(lastLastIndex, match.index));
                    // Fix browsers whose `exec` methods don't consistently return `undefined` for
                    // nonparticipating capturing groups
                    if (!compliantExecNpcg && match.length > 1) {
                        match[0].replace(separator2, function () {
                            for (var i = 1; i < arguments.length - 2; i++) {
                                if (arguments[i] === void 0) {
                                    match[i] = void 0;
                                }
                            }
                        });
                    }
                    if (match.length > 1 && match.index < string.length) {
                        ArrayPrototype.push.apply(output, match.slice(1));
                    }
                    lastLength = match[0].length;
                    lastLastIndex = lastIndex;
                    if (output.length >= limit) {
                        break;
                    }
                }
                if (separator.lastIndex === match.index) {
                    separator.lastIndex++; // Avoid an infinite loop
                }
            }
            if (lastLastIndex === string.length) {
                if (lastLength || !separator.test('')) {
                    output.push('');
                }
            } else {
                output.push(string.slice(lastLastIndex));
            }
            return output.length > limit ? output.slice(0, limit) : output;
        };
    }());

// [bugfix, chrome]
// If separator is undefined, then the result array contains just one String,
// which is the this value (converted to a String). If limit is not undefined,
// then the output array is truncated so that it contains no more than limit
// elements.
// "0".split(undefined, 0) -> []
} else if ('0'.split(void 0, 0).length) {
    StringPrototype.split = function split(separator, limit) {
        if (separator === void 0 && limit === 0) { return []; }
        return string_split.call(this, separator, limit);
    };
}

// ECMA-262, 3rd B.2.3
// Not an ECMAScript standard, although ECMAScript 3rd Edition has a
// non-normative section suggesting uniform semantics and it should be
// normalized across all browsers
// [bugfix, IE lt 9] IE < 9 substr() with negative value not working in IE
var string_substr = StringPrototype.substr;
var hasNegativeSubstrBug = ''.substr && '0b'.substr(-1) !== 'b';
defineProperties(StringPrototype, {
    substr: function substr(start, length) {
        return string_substr.call(
            this,
            start < 0 ? ((start = this.length + start) < 0 ? 0 : start) : start,
            length
        );
    }
}, hasNegativeSubstrBug);


/***/ }),

/***/ "./node_modules/sockjs-client/lib/transport-list.js":
/*!**********************************************************!*\
  !*** ./node_modules/sockjs-client/lib/transport-list.js ***!
  \**********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = [
  // streaming transports
  __webpack_require__(/*! ./transport/websocket */ "./node_modules/sockjs-client/lib/transport/websocket.js")
, __webpack_require__(/*! ./transport/xhr-streaming */ "./node_modules/sockjs-client/lib/transport/xhr-streaming.js")
, __webpack_require__(/*! ./transport/xdr-streaming */ "./node_modules/sockjs-client/lib/transport/xdr-streaming.js")
, __webpack_require__(/*! ./transport/eventsource */ "./node_modules/sockjs-client/lib/transport/eventsource.js")
, __webpack_require__(/*! ./transport/lib/iframe-wrap */ "./node_modules/sockjs-client/lib/transport/lib/iframe-wrap.js")(__webpack_require__(/*! ./transport/eventsource */ "./node_modules/sockjs-client/lib/transport/eventsource.js"))

  // polling transports
, __webpack_require__(/*! ./transport/htmlfile */ "./node_modules/sockjs-client/lib/transport/htmlfile.js")
, __webpack_require__(/*! ./transport/lib/iframe-wrap */ "./node_modules/sockjs-client/lib/transport/lib/iframe-wrap.js")(__webpack_require__(/*! ./transport/htmlfile */ "./node_modules/sockjs-client/lib/transport/htmlfile.js"))
, __webpack_require__(/*! ./transport/xhr-polling */ "./node_modules/sockjs-client/lib/transport/xhr-polling.js")
, __webpack_require__(/*! ./transport/xdr-polling */ "./node_modules/sockjs-client/lib/transport/xdr-polling.js")
, __webpack_require__(/*! ./transport/lib/iframe-wrap */ "./node_modules/sockjs-client/lib/transport/lib/iframe-wrap.js")(__webpack_require__(/*! ./transport/xhr-polling */ "./node_modules/sockjs-client/lib/transport/xhr-polling.js"))
, __webpack_require__(/*! ./transport/jsonp-polling */ "./node_modules/sockjs-client/lib/transport/jsonp-polling.js")
];


/***/ }),

/***/ "./node_modules/sockjs-client/lib/transport/browser/abstract-xhr.js":
/*!**************************************************************************!*\
  !*** ./node_modules/sockjs-client/lib/transport/browser/abstract-xhr.js ***!
  \**************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var EventEmitter = __webpack_require__(/*! events */ "./node_modules/sockjs-client/lib/event/emitter.js").EventEmitter
  , inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
  , utils = __webpack_require__(/*! ../../utils/event */ "./node_modules/sockjs-client/lib/utils/event.js")
  , urlUtils = __webpack_require__(/*! ../../utils/url */ "./node_modules/sockjs-client/lib/utils/url.js")
  , XHR = global.XMLHttpRequest
  ;

var debug = function() {};
if (true) {
  debug = __webpack_require__(/*! debug */ "./node_modules/debug/src/browser.js")('sockjs-client:browser:xhr');
}

function AbstractXHRObject(method, url, payload, opts) {
  debug(method, url);
  var self = this;
  EventEmitter.call(this);

  setTimeout(function () {
    self._start(method, url, payload, opts);
  }, 0);
}

inherits(AbstractXHRObject, EventEmitter);

AbstractXHRObject.prototype._start = function(method, url, payload, opts) {
  var self = this;

  try {
    this.xhr = new XHR();
  } catch (x) {
    // intentionally empty
  }

  if (!this.xhr) {
    debug('no xhr');
    this.emit('finish', 0, 'no xhr support');
    this._cleanup();
    return;
  }

  // several browsers cache POSTs
  url = urlUtils.addQuery(url, 't=' + (+new Date()));

  // Explorer tends to keep connection open, even after the
  // tab gets closed: http://bugs.jquery.com/ticket/5280
  this.unloadRef = utils.unloadAdd(function() {
    debug('unload cleanup');
    self._cleanup(true);
  });
  try {
    this.xhr.open(method, url, true);
    if (this.timeout && 'timeout' in this.xhr) {
      this.xhr.timeout = this.timeout;
      this.xhr.ontimeout = function() {
        debug('xhr timeout');
        self.emit('finish', 0, '');
        self._cleanup(false);
      };
    }
  } catch (e) {
    debug('exception', e);
    // IE raises an exception on wrong port.
    this.emit('finish', 0, '');
    this._cleanup(false);
    return;
  }

  if ((!opts || !opts.noCredentials) && AbstractXHRObject.supportsCORS) {
    debug('withCredentials');
    // Mozilla docs says https://developer.mozilla.org/en/XMLHttpRequest :
    // "This never affects same-site requests."

    this.xhr.withCredentials = true;
  }
  if (opts && opts.headers) {
    for (var key in opts.headers) {
      this.xhr.setRequestHeader(key, opts.headers[key]);
    }
  }

  this.xhr.onreadystatechange = function() {
    if (self.xhr) {
      var x = self.xhr;
      var text, status;
      debug('readyState', x.readyState);
      switch (x.readyState) {
      case 3:
        // IE doesn't like peeking into responseText or status
        // on Microsoft.XMLHTTP and readystate=3
        try {
          status = x.status;
          text = x.responseText;
        } catch (e) {
          // intentionally empty
        }
        debug('status', status);
        // IE returns 1223 for 204: http://bugs.jquery.com/ticket/1450
        if (status === 1223) {
          status = 204;
        }

        // IE does return readystate == 3 for 404 answers.
        if (status === 200 && text && text.length > 0) {
          debug('chunk');
          self.emit('chunk', status, text);
        }
        break;
      case 4:
        status = x.status;
        debug('status', status);
        // IE returns 1223 for 204: http://bugs.jquery.com/ticket/1450
        if (status === 1223) {
          status = 204;
        }
        // IE returns this for a bad port
        // http://msdn.microsoft.com/en-us/library/windows/desktop/aa383770(v=vs.85).aspx
        if (status === 12005 || status === 12029) {
          status = 0;
        }

        debug('finish', status, x.responseText);
        self.emit('finish', status, x.responseText);
        self._cleanup(false);
        break;
      }
    }
  };

  try {
    self.xhr.send(payload);
  } catch (e) {
    self.emit('finish', 0, '');
    self._cleanup(false);
  }
};

AbstractXHRObject.prototype._cleanup = function(abort) {
  debug('cleanup');
  if (!this.xhr) {
    return;
  }
  this.removeAllListeners();
  utils.unloadDel(this.unloadRef);

  // IE needs this field to be a function
  this.xhr.onreadystatechange = function() {};
  if (this.xhr.ontimeout) {
    this.xhr.ontimeout = null;
  }

  if (abort) {
    try {
      this.xhr.abort();
    } catch (x) {
      // intentionally empty
    }
  }
  this.unloadRef = this.xhr = null;
};

AbstractXHRObject.prototype.close = function() {
  debug('close');
  this._cleanup(true);
};

AbstractXHRObject.enabled = !!XHR;
// override XMLHttpRequest for IE6/7
// obfuscate to avoid firewalls
var axo = ['Active'].concat('Object').join('X');
if (!AbstractXHRObject.enabled && (axo in global)) {
  debug('overriding xmlhttprequest');
  XHR = function() {
    try {
      return new global[axo]('Microsoft.XMLHTTP');
    } catch (e) {
      return null;
    }
  };
  AbstractXHRObject.enabled = !!new XHR();
}

var cors = false;
try {
  cors = 'withCredentials' in new XHR();
} catch (ignored) {
  // intentionally empty
}

AbstractXHRObject.supportsCORS = cors;

module.exports = AbstractXHRObject;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/sockjs-client/lib/transport/browser/eventsource.js":
/*!*************************************************************************!*\
  !*** ./node_modules/sockjs-client/lib/transport/browser/eventsource.js ***!
  \*************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global.EventSource;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/sockjs-client/lib/transport/browser/websocket.js":
/*!***********************************************************************!*\
  !*** ./node_modules/sockjs-client/lib/transport/browser/websocket.js ***!
  \***********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var Driver = global.WebSocket || global.MozWebSocket;
if (Driver) {
	module.exports = function WebSocketBrowserDriver(url) {
		return new Driver(url);
	};
} else {
	module.exports = undefined;
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/sockjs-client/lib/transport/eventsource.js":
/*!*****************************************************************!*\
  !*** ./node_modules/sockjs-client/lib/transport/eventsource.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
  , AjaxBasedTransport = __webpack_require__(/*! ./lib/ajax-based */ "./node_modules/sockjs-client/lib/transport/lib/ajax-based.js")
  , EventSourceReceiver = __webpack_require__(/*! ./receiver/eventsource */ "./node_modules/sockjs-client/lib/transport/receiver/eventsource.js")
  , XHRCorsObject = __webpack_require__(/*! ./sender/xhr-cors */ "./node_modules/sockjs-client/lib/transport/sender/xhr-cors.js")
  , EventSourceDriver = __webpack_require__(/*! eventsource */ "./node_modules/sockjs-client/lib/transport/browser/eventsource.js")
  ;

function EventSourceTransport(transUrl) {
  if (!EventSourceTransport.enabled()) {
    throw new Error('Transport created when disabled');
  }

  AjaxBasedTransport.call(this, transUrl, '/eventsource', EventSourceReceiver, XHRCorsObject);
}

inherits(EventSourceTransport, AjaxBasedTransport);

EventSourceTransport.enabled = function() {
  return !!EventSourceDriver;
};

EventSourceTransport.transportName = 'eventsource';
EventSourceTransport.roundTrips = 2;

module.exports = EventSourceTransport;


/***/ }),

/***/ "./node_modules/sockjs-client/lib/transport/htmlfile.js":
/*!**************************************************************!*\
  !*** ./node_modules/sockjs-client/lib/transport/htmlfile.js ***!
  \**************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
  , HtmlfileReceiver = __webpack_require__(/*! ./receiver/htmlfile */ "./node_modules/sockjs-client/lib/transport/receiver/htmlfile.js")
  , XHRLocalObject = __webpack_require__(/*! ./sender/xhr-local */ "./node_modules/sockjs-client/lib/transport/sender/xhr-local.js")
  , AjaxBasedTransport = __webpack_require__(/*! ./lib/ajax-based */ "./node_modules/sockjs-client/lib/transport/lib/ajax-based.js")
  ;

function HtmlFileTransport(transUrl) {
  if (!HtmlfileReceiver.enabled) {
    throw new Error('Transport created when disabled');
  }
  AjaxBasedTransport.call(this, transUrl, '/htmlfile', HtmlfileReceiver, XHRLocalObject);
}

inherits(HtmlFileTransport, AjaxBasedTransport);

HtmlFileTransport.enabled = function(info) {
  return HtmlfileReceiver.enabled && info.sameOrigin;
};

HtmlFileTransport.transportName = 'htmlfile';
HtmlFileTransport.roundTrips = 2;

module.exports = HtmlFileTransport;


/***/ }),

/***/ "./node_modules/sockjs-client/lib/transport/iframe.js":
/*!************************************************************!*\
  !*** ./node_modules/sockjs-client/lib/transport/iframe.js ***!
  \************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Few cool transports do work only for same-origin. In order to make
// them work cross-domain we shall use iframe, served from the
// remote domain. New browsers have capabilities to communicate with
// cross domain iframe using postMessage(). In IE it was implemented
// from IE 8+, but of course, IE got some details wrong:
//    http://msdn.microsoft.com/en-us/library/cc197015(v=VS.85).aspx
//    http://stevesouders.com/misc/test-postmessage.php

var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
  , JSON3 = __webpack_require__(/*! json3 */ "./node_modules/json3/lib/json3.js")
  , EventEmitter = __webpack_require__(/*! events */ "./node_modules/sockjs-client/lib/event/emitter.js").EventEmitter
  , version = __webpack_require__(/*! ../version */ "./node_modules/sockjs-client/lib/version.js")
  , urlUtils = __webpack_require__(/*! ../utils/url */ "./node_modules/sockjs-client/lib/utils/url.js")
  , iframeUtils = __webpack_require__(/*! ../utils/iframe */ "./node_modules/sockjs-client/lib/utils/iframe.js")
  , eventUtils = __webpack_require__(/*! ../utils/event */ "./node_modules/sockjs-client/lib/utils/event.js")
  , random = __webpack_require__(/*! ../utils/random */ "./node_modules/sockjs-client/lib/utils/random.js")
  ;

var debug = function() {};
if (true) {
  debug = __webpack_require__(/*! debug */ "./node_modules/debug/src/browser.js")('sockjs-client:transport:iframe');
}

function IframeTransport(transport, transUrl, baseUrl) {
  if (!IframeTransport.enabled()) {
    throw new Error('Transport created when disabled');
  }
  EventEmitter.call(this);

  var self = this;
  this.origin = urlUtils.getOrigin(baseUrl);
  this.baseUrl = baseUrl;
  this.transUrl = transUrl;
  this.transport = transport;
  this.windowId = random.string(8);

  var iframeUrl = urlUtils.addPath(baseUrl, '/iframe.html') + '#' + this.windowId;
  debug(transport, transUrl, iframeUrl);

  this.iframeObj = iframeUtils.createIframe(iframeUrl, function(r) {
    debug('err callback');
    self.emit('close', 1006, 'Unable to load an iframe (' + r + ')');
    self.close();
  });

  this.onmessageCallback = this._message.bind(this);
  eventUtils.attachEvent('message', this.onmessageCallback);
}

inherits(IframeTransport, EventEmitter);

IframeTransport.prototype.close = function() {
  debug('close');
  this.removeAllListeners();
  if (this.iframeObj) {
    eventUtils.detachEvent('message', this.onmessageCallback);
    try {
      // When the iframe is not loaded, IE raises an exception
      // on 'contentWindow'.
      this.postMessage('c');
    } catch (x) {
      // intentionally empty
    }
    this.iframeObj.cleanup();
    this.iframeObj = null;
    this.onmessageCallback = this.iframeObj = null;
  }
};

IframeTransport.prototype._message = function(e) {
  debug('message', e.data);
  if (!urlUtils.isOriginEqual(e.origin, this.origin)) {
    debug('not same origin', e.origin, this.origin);
    return;
  }

  var iframeMessage;
  try {
    iframeMessage = JSON3.parse(e.data);
  } catch (ignored) {
    debug('bad json', e.data);
    return;
  }

  if (iframeMessage.windowId !== this.windowId) {
    debug('mismatched window id', iframeMessage.windowId, this.windowId);
    return;
  }

  switch (iframeMessage.type) {
  case 's':
    this.iframeObj.loaded();
    // window global dependency
    this.postMessage('s', JSON3.stringify([
      version
    , this.transport
    , this.transUrl
    , this.baseUrl
    ]));
    break;
  case 't':
    this.emit('message', iframeMessage.data);
    break;
  case 'c':
    var cdata;
    try {
      cdata = JSON3.parse(iframeMessage.data);
    } catch (ignored) {
      debug('bad json', iframeMessage.data);
      return;
    }
    this.emit('close', cdata[0], cdata[1]);
    this.close();
    break;
  }
};

IframeTransport.prototype.postMessage = function(type, data) {
  debug('postMessage', type, data);
  this.iframeObj.post(JSON3.stringify({
    windowId: this.windowId
  , type: type
  , data: data || ''
  }), this.origin);
};

IframeTransport.prototype.send = function(message) {
  debug('send', message);
  this.postMessage('m', message);
};

IframeTransport.enabled = function() {
  return iframeUtils.iframeEnabled;
};

IframeTransport.transportName = 'iframe';
IframeTransport.roundTrips = 2;

module.exports = IframeTransport;


/***/ }),

/***/ "./node_modules/sockjs-client/lib/transport/jsonp-polling.js":
/*!*******************************************************************!*\
  !*** ./node_modules/sockjs-client/lib/transport/jsonp-polling.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// The simplest and most robust transport, using the well-know cross
// domain hack - JSONP. This transport is quite inefficient - one
// message could use up to one http request. But at least it works almost
// everywhere.
// Known limitations:
//   o you will get a spinning cursor
//   o for Konqueror a dumb timer is needed to detect errors

var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
  , SenderReceiver = __webpack_require__(/*! ./lib/sender-receiver */ "./node_modules/sockjs-client/lib/transport/lib/sender-receiver.js")
  , JsonpReceiver = __webpack_require__(/*! ./receiver/jsonp */ "./node_modules/sockjs-client/lib/transport/receiver/jsonp.js")
  , jsonpSender = __webpack_require__(/*! ./sender/jsonp */ "./node_modules/sockjs-client/lib/transport/sender/jsonp.js")
  ;

function JsonPTransport(transUrl) {
  if (!JsonPTransport.enabled()) {
    throw new Error('Transport created when disabled');
  }
  SenderReceiver.call(this, transUrl, '/jsonp', jsonpSender, JsonpReceiver);
}

inherits(JsonPTransport, SenderReceiver);

JsonPTransport.enabled = function() {
  return !!global.document;
};

JsonPTransport.transportName = 'jsonp-polling';
JsonPTransport.roundTrips = 1;
JsonPTransport.needBody = true;

module.exports = JsonPTransport;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/sockjs-client/lib/transport/lib/ajax-based.js":
/*!********************************************************************!*\
  !*** ./node_modules/sockjs-client/lib/transport/lib/ajax-based.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
  , urlUtils = __webpack_require__(/*! ../../utils/url */ "./node_modules/sockjs-client/lib/utils/url.js")
  , SenderReceiver = __webpack_require__(/*! ./sender-receiver */ "./node_modules/sockjs-client/lib/transport/lib/sender-receiver.js")
  ;

var debug = function() {};
if (true) {
  debug = __webpack_require__(/*! debug */ "./node_modules/debug/src/browser.js")('sockjs-client:ajax-based');
}

function createAjaxSender(AjaxObject) {
  return function(url, payload, callback) {
    debug('create ajax sender', url, payload);
    var opt = {};
    if (typeof payload === 'string') {
      opt.headers = {'Content-type': 'text/plain'};
    }
    var ajaxUrl = urlUtils.addPath(url, '/xhr_send');
    var xo = new AjaxObject('POST', ajaxUrl, payload, opt);
    xo.once('finish', function(status) {
      debug('finish', status);
      xo = null;

      if (status !== 200 && status !== 204) {
        return callback(new Error('http status ' + status));
      }
      callback();
    });
    return function() {
      debug('abort');
      xo.close();
      xo = null;

      var err = new Error('Aborted');
      err.code = 1000;
      callback(err);
    };
  };
}

function AjaxBasedTransport(transUrl, urlSuffix, Receiver, AjaxObject) {
  SenderReceiver.call(this, transUrl, urlSuffix, createAjaxSender(AjaxObject), Receiver, AjaxObject);
}

inherits(AjaxBasedTransport, SenderReceiver);

module.exports = AjaxBasedTransport;


/***/ }),

/***/ "./node_modules/sockjs-client/lib/transport/lib/buffered-sender.js":
/*!*************************************************************************!*\
  !*** ./node_modules/sockjs-client/lib/transport/lib/buffered-sender.js ***!
  \*************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
  , EventEmitter = __webpack_require__(/*! events */ "./node_modules/sockjs-client/lib/event/emitter.js").EventEmitter
  ;

var debug = function() {};
if (true) {
  debug = __webpack_require__(/*! debug */ "./node_modules/debug/src/browser.js")('sockjs-client:buffered-sender');
}

function BufferedSender(url, sender) {
  debug(url);
  EventEmitter.call(this);
  this.sendBuffer = [];
  this.sender = sender;
  this.url = url;
}

inherits(BufferedSender, EventEmitter);

BufferedSender.prototype.send = function(message) {
  debug('send', message);
  this.sendBuffer.push(message);
  if (!this.sendStop) {
    this.sendSchedule();
  }
};

// For polling transports in a situation when in the message callback,
// new message is being send. If the sending connection was started
// before receiving one, it is possible to saturate the network and
// timeout due to the lack of receiving socket. To avoid that we delay
// sending messages by some small time, in order to let receiving
// connection be started beforehand. This is only a halfmeasure and
// does not fix the big problem, but it does make the tests go more
// stable on slow networks.
BufferedSender.prototype.sendScheduleWait = function() {
  debug('sendScheduleWait');
  var self = this;
  var tref;
  this.sendStop = function() {
    debug('sendStop');
    self.sendStop = null;
    clearTimeout(tref);
  };
  tref = setTimeout(function() {
    debug('timeout');
    self.sendStop = null;
    self.sendSchedule();
  }, 25);
};

BufferedSender.prototype.sendSchedule = function() {
  debug('sendSchedule', this.sendBuffer.length);
  var self = this;
  if (this.sendBuffer.length > 0) {
    var payload = '[' + this.sendBuffer.join(',') + ']';
    this.sendStop = this.sender(this.url, payload, function(err) {
      self.sendStop = null;
      if (err) {
        debug('error', err);
        self.emit('close', err.code || 1006, 'Sending error: ' + err);
        self.close();
      } else {
        self.sendScheduleWait();
      }
    });
    this.sendBuffer = [];
  }
};

BufferedSender.prototype._cleanup = function() {
  debug('_cleanup');
  this.removeAllListeners();
};

BufferedSender.prototype.close = function() {
  debug('close');
  this._cleanup();
  if (this.sendStop) {
    this.sendStop();
    this.sendStop = null;
  }
};

module.exports = BufferedSender;


/***/ }),

/***/ "./node_modules/sockjs-client/lib/transport/lib/iframe-wrap.js":
/*!*********************************************************************!*\
  !*** ./node_modules/sockjs-client/lib/transport/lib/iframe-wrap.js ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
  , IframeTransport = __webpack_require__(/*! ../iframe */ "./node_modules/sockjs-client/lib/transport/iframe.js")
  , objectUtils = __webpack_require__(/*! ../../utils/object */ "./node_modules/sockjs-client/lib/utils/object.js")
  ;

module.exports = function(transport) {

  function IframeWrapTransport(transUrl, baseUrl) {
    IframeTransport.call(this, transport.transportName, transUrl, baseUrl);
  }

  inherits(IframeWrapTransport, IframeTransport);

  IframeWrapTransport.enabled = function(url, info) {
    if (!global.document) {
      return false;
    }

    var iframeInfo = objectUtils.extend({}, info);
    iframeInfo.sameOrigin = true;
    return transport.enabled(iframeInfo) && IframeTransport.enabled();
  };

  IframeWrapTransport.transportName = 'iframe-' + transport.transportName;
  IframeWrapTransport.needBody = true;
  IframeWrapTransport.roundTrips = IframeTransport.roundTrips + transport.roundTrips - 1; // html, javascript (2) + transport - no CORS (1)

  IframeWrapTransport.facadeTransport = transport;

  return IframeWrapTransport;
};

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/sockjs-client/lib/transport/lib/polling.js":
/*!*****************************************************************!*\
  !*** ./node_modules/sockjs-client/lib/transport/lib/polling.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
  , EventEmitter = __webpack_require__(/*! events */ "./node_modules/sockjs-client/lib/event/emitter.js").EventEmitter
  ;

var debug = function() {};
if (true) {
  debug = __webpack_require__(/*! debug */ "./node_modules/debug/src/browser.js")('sockjs-client:polling');
}

function Polling(Receiver, receiveUrl, AjaxObject) {
  debug(receiveUrl);
  EventEmitter.call(this);
  this.Receiver = Receiver;
  this.receiveUrl = receiveUrl;
  this.AjaxObject = AjaxObject;
  this._scheduleReceiver();
}

inherits(Polling, EventEmitter);

Polling.prototype._scheduleReceiver = function() {
  debug('_scheduleReceiver');
  var self = this;
  var poll = this.poll = new this.Receiver(this.receiveUrl, this.AjaxObject);

  poll.on('message', function(msg) {
    debug('message', msg);
    self.emit('message', msg);
  });

  poll.once('close', function(code, reason) {
    debug('close', code, reason, self.pollIsClosing);
    self.poll = poll = null;

    if (!self.pollIsClosing) {
      if (reason === 'network') {
        self._scheduleReceiver();
      } else {
        self.emit('close', code || 1006, reason);
        self.removeAllListeners();
      }
    }
  });
};

Polling.prototype.abort = function() {
  debug('abort');
  this.removeAllListeners();
  this.pollIsClosing = true;
  if (this.poll) {
    this.poll.abort();
  }
};

module.exports = Polling;


/***/ }),

/***/ "./node_modules/sockjs-client/lib/transport/lib/sender-receiver.js":
/*!*************************************************************************!*\
  !*** ./node_modules/sockjs-client/lib/transport/lib/sender-receiver.js ***!
  \*************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
  , urlUtils = __webpack_require__(/*! ../../utils/url */ "./node_modules/sockjs-client/lib/utils/url.js")
  , BufferedSender = __webpack_require__(/*! ./buffered-sender */ "./node_modules/sockjs-client/lib/transport/lib/buffered-sender.js")
  , Polling = __webpack_require__(/*! ./polling */ "./node_modules/sockjs-client/lib/transport/lib/polling.js")
  ;

var debug = function() {};
if (true) {
  debug = __webpack_require__(/*! debug */ "./node_modules/debug/src/browser.js")('sockjs-client:sender-receiver');
}

function SenderReceiver(transUrl, urlSuffix, senderFunc, Receiver, AjaxObject) {
  var pollUrl = urlUtils.addPath(transUrl, urlSuffix);
  debug(pollUrl);
  var self = this;
  BufferedSender.call(this, transUrl, senderFunc);

  this.poll = new Polling(Receiver, pollUrl, AjaxObject);
  this.poll.on('message', function(msg) {
    debug('poll message', msg);
    self.emit('message', msg);
  });
  this.poll.once('close', function(code, reason) {
    debug('poll close', code, reason);
    self.poll = null;
    self.emit('close', code, reason);
    self.close();
  });
}

inherits(SenderReceiver, BufferedSender);

SenderReceiver.prototype.close = function() {
  BufferedSender.prototype.close.call(this);
  debug('close');
  this.removeAllListeners();
  if (this.poll) {
    this.poll.abort();
    this.poll = null;
  }
};

module.exports = SenderReceiver;


/***/ }),

/***/ "./node_modules/sockjs-client/lib/transport/receiver/eventsource.js":
/*!**************************************************************************!*\
  !*** ./node_modules/sockjs-client/lib/transport/receiver/eventsource.js ***!
  \**************************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
  , EventEmitter = __webpack_require__(/*! events */ "./node_modules/sockjs-client/lib/event/emitter.js").EventEmitter
  , EventSourceDriver = __webpack_require__(/*! eventsource */ "./node_modules/sockjs-client/lib/transport/browser/eventsource.js")
  ;

var debug = function() {};
if (true) {
  debug = __webpack_require__(/*! debug */ "./node_modules/debug/src/browser.js")('sockjs-client:receiver:eventsource');
}

function EventSourceReceiver(url) {
  debug(url);
  EventEmitter.call(this);

  var self = this;
  var es = this.es = new EventSourceDriver(url);
  es.onmessage = function(e) {
    debug('message', e.data);
    self.emit('message', decodeURI(e.data));
  };
  es.onerror = function(e) {
    debug('error', es.readyState, e);
    // ES on reconnection has readyState = 0 or 1.
    // on network error it's CLOSED = 2
    var reason = (es.readyState !== 2 ? 'network' : 'permanent');
    self._cleanup();
    self._close(reason);
  };
}

inherits(EventSourceReceiver, EventEmitter);

EventSourceReceiver.prototype.abort = function() {
  debug('abort');
  this._cleanup();
  this._close('user');
};

EventSourceReceiver.prototype._cleanup = function() {
  debug('cleanup');
  var es = this.es;
  if (es) {
    es.onmessage = es.onerror = null;
    es.close();
    this.es = null;
  }
};

EventSourceReceiver.prototype._close = function(reason) {
  debug('close', reason);
  var self = this;
  // Safari and chrome < 15 crash if we close window before
  // waiting for ES cleanup. See:
  // https://code.google.com/p/chromium/issues/detail?id=89155
  setTimeout(function() {
    self.emit('close', null, reason);
    self.removeAllListeners();
  }, 200);
};

module.exports = EventSourceReceiver;


/***/ }),

/***/ "./node_modules/sockjs-client/lib/transport/receiver/htmlfile.js":
/*!***********************************************************************!*\
  !*** ./node_modules/sockjs-client/lib/transport/receiver/htmlfile.js ***!
  \***********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
  , iframeUtils = __webpack_require__(/*! ../../utils/iframe */ "./node_modules/sockjs-client/lib/utils/iframe.js")
  , urlUtils = __webpack_require__(/*! ../../utils/url */ "./node_modules/sockjs-client/lib/utils/url.js")
  , EventEmitter = __webpack_require__(/*! events */ "./node_modules/sockjs-client/lib/event/emitter.js").EventEmitter
  , random = __webpack_require__(/*! ../../utils/random */ "./node_modules/sockjs-client/lib/utils/random.js")
  ;

var debug = function() {};
if (true) {
  debug = __webpack_require__(/*! debug */ "./node_modules/debug/src/browser.js")('sockjs-client:receiver:htmlfile');
}

function HtmlfileReceiver(url) {
  debug(url);
  EventEmitter.call(this);
  var self = this;
  iframeUtils.polluteGlobalNamespace();

  this.id = 'a' + random.string(6);
  url = urlUtils.addQuery(url, 'c=' + decodeURIComponent(iframeUtils.WPrefix + '.' + this.id));

  debug('using htmlfile', HtmlfileReceiver.htmlfileEnabled);
  var constructFunc = HtmlfileReceiver.htmlfileEnabled ?
      iframeUtils.createHtmlfile : iframeUtils.createIframe;

  global[iframeUtils.WPrefix][this.id] = {
    start: function() {
      debug('start');
      self.iframeObj.loaded();
    }
  , message: function(data) {
      debug('message', data);
      self.emit('message', data);
    }
  , stop: function() {
      debug('stop');
      self._cleanup();
      self._close('network');
    }
  };
  this.iframeObj = constructFunc(url, function() {
    debug('callback');
    self._cleanup();
    self._close('permanent');
  });
}

inherits(HtmlfileReceiver, EventEmitter);

HtmlfileReceiver.prototype.abort = function() {
  debug('abort');
  this._cleanup();
  this._close('user');
};

HtmlfileReceiver.prototype._cleanup = function() {
  debug('_cleanup');
  if (this.iframeObj) {
    this.iframeObj.cleanup();
    this.iframeObj = null;
  }
  delete global[iframeUtils.WPrefix][this.id];
};

HtmlfileReceiver.prototype._close = function(reason) {
  debug('_close', reason);
  this.emit('close', null, reason);
  this.removeAllListeners();
};

HtmlfileReceiver.htmlfileEnabled = false;

// obfuscate to avoid firewalls
var axo = ['Active'].concat('Object').join('X');
if (axo in global) {
  try {
    HtmlfileReceiver.htmlfileEnabled = !!new global[axo]('htmlfile');
  } catch (x) {
    // intentionally empty
  }
}

HtmlfileReceiver.enabled = HtmlfileReceiver.htmlfileEnabled || iframeUtils.iframeEnabled;

module.exports = HtmlfileReceiver;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/sockjs-client/lib/transport/receiver/jsonp.js":
/*!********************************************************************!*\
  !*** ./node_modules/sockjs-client/lib/transport/receiver/jsonp.js ***!
  \********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var utils = __webpack_require__(/*! ../../utils/iframe */ "./node_modules/sockjs-client/lib/utils/iframe.js")
  , random = __webpack_require__(/*! ../../utils/random */ "./node_modules/sockjs-client/lib/utils/random.js")
  , browser = __webpack_require__(/*! ../../utils/browser */ "./node_modules/sockjs-client/lib/utils/browser.js")
  , urlUtils = __webpack_require__(/*! ../../utils/url */ "./node_modules/sockjs-client/lib/utils/url.js")
  , inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
  , EventEmitter = __webpack_require__(/*! events */ "./node_modules/sockjs-client/lib/event/emitter.js").EventEmitter
  ;

var debug = function() {};
if (true) {
  debug = __webpack_require__(/*! debug */ "./node_modules/debug/src/browser.js")('sockjs-client:receiver:jsonp');
}

function JsonpReceiver(url) {
  debug(url);
  var self = this;
  EventEmitter.call(this);

  utils.polluteGlobalNamespace();

  this.id = 'a' + random.string(6);
  var urlWithId = urlUtils.addQuery(url, 'c=' + encodeURIComponent(utils.WPrefix + '.' + this.id));

  global[utils.WPrefix][this.id] = this._callback.bind(this);
  this._createScript(urlWithId);

  // Fallback mostly for Konqueror - stupid timer, 35 seconds shall be plenty.
  this.timeoutId = setTimeout(function() {
    debug('timeout');
    self._abort(new Error('JSONP script loaded abnormally (timeout)'));
  }, JsonpReceiver.timeout);
}

inherits(JsonpReceiver, EventEmitter);

JsonpReceiver.prototype.abort = function() {
  debug('abort');
  if (global[utils.WPrefix][this.id]) {
    var err = new Error('JSONP user aborted read');
    err.code = 1000;
    this._abort(err);
  }
};

JsonpReceiver.timeout = 35000;
JsonpReceiver.scriptErrorTimeout = 1000;

JsonpReceiver.prototype._callback = function(data) {
  debug('_callback', data);
  this._cleanup();

  if (this.aborting) {
    return;
  }

  if (data) {
    debug('message', data);
    this.emit('message', data);
  }
  this.emit('close', null, 'network');
  this.removeAllListeners();
};

JsonpReceiver.prototype._abort = function(err) {
  debug('_abort', err);
  this._cleanup();
  this.aborting = true;
  this.emit('close', err.code, err.message);
  this.removeAllListeners();
};

JsonpReceiver.prototype._cleanup = function() {
  debug('_cleanup');
  clearTimeout(this.timeoutId);
  if (this.script2) {
    this.script2.parentNode.removeChild(this.script2);
    this.script2 = null;
  }
  if (this.script) {
    var script = this.script;
    // Unfortunately, you can't really abort script loading of
    // the script.
    script.parentNode.removeChild(script);
    script.onreadystatechange = script.onerror =
        script.onload = script.onclick = null;
    this.script = null;
  }
  delete global[utils.WPrefix][this.id];
};

JsonpReceiver.prototype._scriptError = function() {
  debug('_scriptError');
  var self = this;
  if (this.errorTimer) {
    return;
  }

  this.errorTimer = setTimeout(function() {
    if (!self.loadedOkay) {
      self._abort(new Error('JSONP script loaded abnormally (onerror)'));
    }
  }, JsonpReceiver.scriptErrorTimeout);
};

JsonpReceiver.prototype._createScript = function(url) {
  debug('_createScript', url);
  var self = this;
  var script = this.script = global.document.createElement('script');
  var script2;  // Opera synchronous load trick.

  script.id = 'a' + random.string(8);
  script.src = url;
  script.type = 'text/javascript';
  script.charset = 'UTF-8';
  script.onerror = this._scriptError.bind(this);
  script.onload = function() {
    debug('onload');
    self._abort(new Error('JSONP script loaded abnormally (onload)'));
  };

  // IE9 fires 'error' event after onreadystatechange or before, in random order.
  // Use loadedOkay to determine if actually errored
  script.onreadystatechange = function() {
    debug('onreadystatechange', script.readyState);
    if (/loaded|closed/.test(script.readyState)) {
      if (script && script.htmlFor && script.onclick) {
        self.loadedOkay = true;
        try {
          // In IE, actually execute the script.
          script.onclick();
        } catch (x) {
          // intentionally empty
        }
      }
      if (script) {
        self._abort(new Error('JSONP script loaded abnormally (onreadystatechange)'));
      }
    }
  };
  // IE: event/htmlFor/onclick trick.
  // One can't rely on proper order for onreadystatechange. In order to
  // make sure, set a 'htmlFor' and 'event' properties, so that
  // script code will be installed as 'onclick' handler for the
  // script object. Later, onreadystatechange, manually execute this
  // code. FF and Chrome doesn't work with 'event' and 'htmlFor'
  // set. For reference see:
  //   http://jaubourg.net/2010/07/loading-script-as-onclick-handler-of.html
  // Also, read on that about script ordering:
  //   http://wiki.whatwg.org/wiki/Dynamic_Script_Execution_Order
  if (typeof script.async === 'undefined' && global.document.attachEvent) {
    // According to mozilla docs, in recent browsers script.async defaults
    // to 'true', so we may use it to detect a good browser:
    // https://developer.mozilla.org/en/HTML/Element/script
    if (!browser.isOpera()) {
      // Naively assume we're in IE
      try {
        script.htmlFor = script.id;
        script.event = 'onclick';
      } catch (x) {
        // intentionally empty
      }
      script.async = true;
    } else {
      // Opera, second sync script hack
      script2 = this.script2 = global.document.createElement('script');
      script2.text = "try{var a = document.getElementById('" + script.id + "'); if(a)a.onerror();}catch(x){};";
      script.async = script2.async = false;
    }
  }
  if (typeof script.async !== 'undefined') {
    script.async = true;
  }

  var head = global.document.getElementsByTagName('head')[0];
  head.insertBefore(script, head.firstChild);
  if (script2) {
    head.insertBefore(script2, head.firstChild);
  }
};

module.exports = JsonpReceiver;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/sockjs-client/lib/transport/receiver/xhr.js":
/*!******************************************************************!*\
  !*** ./node_modules/sockjs-client/lib/transport/receiver/xhr.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
  , EventEmitter = __webpack_require__(/*! events */ "./node_modules/sockjs-client/lib/event/emitter.js").EventEmitter
  ;

var debug = function() {};
if (true) {
  debug = __webpack_require__(/*! debug */ "./node_modules/debug/src/browser.js")('sockjs-client:receiver:xhr');
}

function XhrReceiver(url, AjaxObject) {
  debug(url);
  EventEmitter.call(this);
  var self = this;

  this.bufferPosition = 0;

  this.xo = new AjaxObject('POST', url, null);
  this.xo.on('chunk', this._chunkHandler.bind(this));
  this.xo.once('finish', function(status, text) {
    debug('finish', status, text);
    self._chunkHandler(status, text);
    self.xo = null;
    var reason = status === 200 ? 'network' : 'permanent';
    debug('close', reason);
    self.emit('close', null, reason);
    self._cleanup();
  });
}

inherits(XhrReceiver, EventEmitter);

XhrReceiver.prototype._chunkHandler = function(status, text) {
  debug('_chunkHandler', status);
  if (status !== 200 || !text) {
    return;
  }

  for (var idx = -1; ; this.bufferPosition += idx + 1) {
    var buf = text.slice(this.bufferPosition);
    idx = buf.indexOf('\n');
    if (idx === -1) {
      break;
    }
    var msg = buf.slice(0, idx);
    if (msg) {
      debug('message', msg);
      this.emit('message', msg);
    }
  }
};

XhrReceiver.prototype._cleanup = function() {
  debug('_cleanup');
  this.removeAllListeners();
};

XhrReceiver.prototype.abort = function() {
  debug('abort');
  if (this.xo) {
    this.xo.close();
    debug('close');
    this.emit('close', null, 'user');
    this.xo = null;
  }
  this._cleanup();
};

module.exports = XhrReceiver;


/***/ }),

/***/ "./node_modules/sockjs-client/lib/transport/sender/jsonp.js":
/*!******************************************************************!*\
  !*** ./node_modules/sockjs-client/lib/transport/sender/jsonp.js ***!
  \******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var random = __webpack_require__(/*! ../../utils/random */ "./node_modules/sockjs-client/lib/utils/random.js")
  , urlUtils = __webpack_require__(/*! ../../utils/url */ "./node_modules/sockjs-client/lib/utils/url.js")
  ;

var debug = function() {};
if (true) {
  debug = __webpack_require__(/*! debug */ "./node_modules/debug/src/browser.js")('sockjs-client:sender:jsonp');
}

var form, area;

function createIframe(id) {
  debug('createIframe', id);
  try {
    // ie6 dynamic iframes with target="" support (thanks Chris Lambacher)
    return global.document.createElement('<iframe name="' + id + '">');
  } catch (x) {
    var iframe = global.document.createElement('iframe');
    iframe.name = id;
    return iframe;
  }
}

function createForm() {
  debug('createForm');
  form = global.document.createElement('form');
  form.style.display = 'none';
  form.style.position = 'absolute';
  form.method = 'POST';
  form.enctype = 'application/x-www-form-urlencoded';
  form.acceptCharset = 'UTF-8';

  area = global.document.createElement('textarea');
  area.name = 'd';
  form.appendChild(area);

  global.document.body.appendChild(form);
}

module.exports = function(url, payload, callback) {
  debug(url, payload);
  if (!form) {
    createForm();
  }
  var id = 'a' + random.string(8);
  form.target = id;
  form.action = urlUtils.addQuery(urlUtils.addPath(url, '/jsonp_send'), 'i=' + id);

  var iframe = createIframe(id);
  iframe.id = id;
  iframe.style.display = 'none';
  form.appendChild(iframe);

  try {
    area.value = payload;
  } catch (e) {
    // seriously broken browsers get here
  }
  form.submit();

  var completed = function(err) {
    debug('completed', id, err);
    if (!iframe.onerror) {
      return;
    }
    iframe.onreadystatechange = iframe.onerror = iframe.onload = null;
    // Opera mini doesn't like if we GC iframe
    // immediately, thus this timeout.
    setTimeout(function() {
      debug('cleaning up', id);
      iframe.parentNode.removeChild(iframe);
      iframe = null;
    }, 500);
    area.value = '';
    // It is not possible to detect if the iframe succeeded or
    // failed to submit our form.
    callback(err);
  };
  iframe.onerror = function() {
    debug('onerror', id);
    completed();
  };
  iframe.onload = function() {
    debug('onload', id);
    completed();
  };
  iframe.onreadystatechange = function(e) {
    debug('onreadystatechange', id, iframe.readyState, e);
    if (iframe.readyState === 'complete') {
      completed();
    }
  };
  return function() {
    debug('aborted', id);
    completed(new Error('Aborted'));
  };
};

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/sockjs-client/lib/transport/sender/xdr.js":
/*!****************************************************************!*\
  !*** ./node_modules/sockjs-client/lib/transport/sender/xdr.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var EventEmitter = __webpack_require__(/*! events */ "./node_modules/sockjs-client/lib/event/emitter.js").EventEmitter
  , inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
  , eventUtils = __webpack_require__(/*! ../../utils/event */ "./node_modules/sockjs-client/lib/utils/event.js")
  , browser = __webpack_require__(/*! ../../utils/browser */ "./node_modules/sockjs-client/lib/utils/browser.js")
  , urlUtils = __webpack_require__(/*! ../../utils/url */ "./node_modules/sockjs-client/lib/utils/url.js")
  ;

var debug = function() {};
if (true) {
  debug = __webpack_require__(/*! debug */ "./node_modules/debug/src/browser.js")('sockjs-client:sender:xdr');
}

// References:
//   http://ajaxian.com/archives/100-line-ajax-wrapper
//   http://msdn.microsoft.com/en-us/library/cc288060(v=VS.85).aspx

function XDRObject(method, url, payload) {
  debug(method, url);
  var self = this;
  EventEmitter.call(this);

  setTimeout(function() {
    self._start(method, url, payload);
  }, 0);
}

inherits(XDRObject, EventEmitter);

XDRObject.prototype._start = function(method, url, payload) {
  debug('_start');
  var self = this;
  var xdr = new global.XDomainRequest();
  // IE caches even POSTs
  url = urlUtils.addQuery(url, 't=' + (+new Date()));

  xdr.onerror = function() {
    debug('onerror');
    self._error();
  };
  xdr.ontimeout = function() {
    debug('ontimeout');
    self._error();
  };
  xdr.onprogress = function() {
    debug('progress', xdr.responseText);
    self.emit('chunk', 200, xdr.responseText);
  };
  xdr.onload = function() {
    debug('load');
    self.emit('finish', 200, xdr.responseText);
    self._cleanup(false);
  };
  this.xdr = xdr;
  this.unloadRef = eventUtils.unloadAdd(function() {
    self._cleanup(true);
  });
  try {
    // Fails with AccessDenied if port number is bogus
    this.xdr.open(method, url);
    if (this.timeout) {
      this.xdr.timeout = this.timeout;
    }
    this.xdr.send(payload);
  } catch (x) {
    this._error();
  }
};

XDRObject.prototype._error = function() {
  this.emit('finish', 0, '');
  this._cleanup(false);
};

XDRObject.prototype._cleanup = function(abort) {
  debug('cleanup', abort);
  if (!this.xdr) {
    return;
  }
  this.removeAllListeners();
  eventUtils.unloadDel(this.unloadRef);

  this.xdr.ontimeout = this.xdr.onerror = this.xdr.onprogress = this.xdr.onload = null;
  if (abort) {
    try {
      this.xdr.abort();
    } catch (x) {
      // intentionally empty
    }
  }
  this.unloadRef = this.xdr = null;
};

XDRObject.prototype.close = function() {
  debug('close');
  this._cleanup(true);
};

// IE 8/9 if the request target uses the same scheme - #79
XDRObject.enabled = !!(global.XDomainRequest && browser.hasDomain());

module.exports = XDRObject;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/sockjs-client/lib/transport/sender/xhr-cors.js":
/*!*********************************************************************!*\
  !*** ./node_modules/sockjs-client/lib/transport/sender/xhr-cors.js ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
  , XhrDriver = __webpack_require__(/*! ../driver/xhr */ "./node_modules/sockjs-client/lib/transport/browser/abstract-xhr.js")
  ;

function XHRCorsObject(method, url, payload, opts) {
  XhrDriver.call(this, method, url, payload, opts);
}

inherits(XHRCorsObject, XhrDriver);

XHRCorsObject.enabled = XhrDriver.enabled && XhrDriver.supportsCORS;

module.exports = XHRCorsObject;


/***/ }),

/***/ "./node_modules/sockjs-client/lib/transport/sender/xhr-fake.js":
/*!*********************************************************************!*\
  !*** ./node_modules/sockjs-client/lib/transport/sender/xhr-fake.js ***!
  \*********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var EventEmitter = __webpack_require__(/*! events */ "./node_modules/sockjs-client/lib/event/emitter.js").EventEmitter
  , inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
  ;

function XHRFake(/* method, url, payload, opts */) {
  var self = this;
  EventEmitter.call(this);

  this.to = setTimeout(function() {
    self.emit('finish', 200, '{}');
  }, XHRFake.timeout);
}

inherits(XHRFake, EventEmitter);

XHRFake.prototype.close = function() {
  clearTimeout(this.to);
};

XHRFake.timeout = 2000;

module.exports = XHRFake;


/***/ }),

/***/ "./node_modules/sockjs-client/lib/transport/sender/xhr-local.js":
/*!**********************************************************************!*\
  !*** ./node_modules/sockjs-client/lib/transport/sender/xhr-local.js ***!
  \**********************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
  , XhrDriver = __webpack_require__(/*! ../driver/xhr */ "./node_modules/sockjs-client/lib/transport/browser/abstract-xhr.js")
  ;

function XHRLocalObject(method, url, payload /*, opts */) {
  XhrDriver.call(this, method, url, payload, {
    noCredentials: true
  });
}

inherits(XHRLocalObject, XhrDriver);

XHRLocalObject.enabled = XhrDriver.enabled;

module.exports = XHRLocalObject;


/***/ }),

/***/ "./node_modules/sockjs-client/lib/transport/websocket.js":
/*!***************************************************************!*\
  !*** ./node_modules/sockjs-client/lib/transport/websocket.js ***!
  \***************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(/*! ../utils/event */ "./node_modules/sockjs-client/lib/utils/event.js")
  , urlUtils = __webpack_require__(/*! ../utils/url */ "./node_modules/sockjs-client/lib/utils/url.js")
  , inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
  , EventEmitter = __webpack_require__(/*! events */ "./node_modules/sockjs-client/lib/event/emitter.js").EventEmitter
  , WebsocketDriver = __webpack_require__(/*! ./driver/websocket */ "./node_modules/sockjs-client/lib/transport/browser/websocket.js")
  ;

var debug = function() {};
if (true) {
  debug = __webpack_require__(/*! debug */ "./node_modules/debug/src/browser.js")('sockjs-client:websocket');
}

function WebSocketTransport(transUrl, ignore, options) {
  if (!WebSocketTransport.enabled()) {
    throw new Error('Transport created when disabled');
  }

  EventEmitter.call(this);
  debug('constructor', transUrl);

  var self = this;
  var url = urlUtils.addPath(transUrl, '/websocket');
  if (url.slice(0, 5) === 'https') {
    url = 'wss' + url.slice(5);
  } else {
    url = 'ws' + url.slice(4);
  }
  this.url = url;

  this.ws = new WebsocketDriver(this.url, [], options);
  this.ws.onmessage = function(e) {
    debug('message event', e.data);
    self.emit('message', e.data);
  };
  // Firefox has an interesting bug. If a websocket connection is
  // created after onunload, it stays alive even when user
  // navigates away from the page. In such situation let's lie -
  // let's not open the ws connection at all. See:
  // https://github.com/sockjs/sockjs-client/issues/28
  // https://bugzilla.mozilla.org/show_bug.cgi?id=696085
  this.unloadRef = utils.unloadAdd(function() {
    debug('unload');
    self.ws.close();
  });
  this.ws.onclose = function(e) {
    debug('close event', e.code, e.reason);
    self.emit('close', e.code, e.reason);
    self._cleanup();
  };
  this.ws.onerror = function(e) {
    debug('error event', e);
    self.emit('close', 1006, 'WebSocket connection broken');
    self._cleanup();
  };
}

inherits(WebSocketTransport, EventEmitter);

WebSocketTransport.prototype.send = function(data) {
  var msg = '[' + data + ']';
  debug('send', msg);
  this.ws.send(msg);
};

WebSocketTransport.prototype.close = function() {
  debug('close');
  var ws = this.ws;
  this._cleanup();
  if (ws) {
    ws.close();
  }
};

WebSocketTransport.prototype._cleanup = function() {
  debug('_cleanup');
  var ws = this.ws;
  if (ws) {
    ws.onmessage = ws.onclose = ws.onerror = null;
  }
  utils.unloadDel(this.unloadRef);
  this.unloadRef = this.ws = null;
  this.removeAllListeners();
};

WebSocketTransport.enabled = function() {
  debug('enabled');
  return !!WebsocketDriver;
};
WebSocketTransport.transportName = 'websocket';

// In theory, ws should require 1 round trip. But in chrome, this is
// not very stable over SSL. Most likely a ws connection requires a
// separate SSL connection, in which case 2 round trips are an
// absolute minumum.
WebSocketTransport.roundTrips = 2;

module.exports = WebSocketTransport;


/***/ }),

/***/ "./node_modules/sockjs-client/lib/transport/xdr-polling.js":
/*!*****************************************************************!*\
  !*** ./node_modules/sockjs-client/lib/transport/xdr-polling.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
  , AjaxBasedTransport = __webpack_require__(/*! ./lib/ajax-based */ "./node_modules/sockjs-client/lib/transport/lib/ajax-based.js")
  , XdrStreamingTransport = __webpack_require__(/*! ./xdr-streaming */ "./node_modules/sockjs-client/lib/transport/xdr-streaming.js")
  , XhrReceiver = __webpack_require__(/*! ./receiver/xhr */ "./node_modules/sockjs-client/lib/transport/receiver/xhr.js")
  , XDRObject = __webpack_require__(/*! ./sender/xdr */ "./node_modules/sockjs-client/lib/transport/sender/xdr.js")
  ;

function XdrPollingTransport(transUrl) {
  if (!XDRObject.enabled) {
    throw new Error('Transport created when disabled');
  }
  AjaxBasedTransport.call(this, transUrl, '/xhr', XhrReceiver, XDRObject);
}

inherits(XdrPollingTransport, AjaxBasedTransport);

XdrPollingTransport.enabled = XdrStreamingTransport.enabled;
XdrPollingTransport.transportName = 'xdr-polling';
XdrPollingTransport.roundTrips = 2; // preflight, ajax

module.exports = XdrPollingTransport;


/***/ }),

/***/ "./node_modules/sockjs-client/lib/transport/xdr-streaming.js":
/*!*******************************************************************!*\
  !*** ./node_modules/sockjs-client/lib/transport/xdr-streaming.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
  , AjaxBasedTransport = __webpack_require__(/*! ./lib/ajax-based */ "./node_modules/sockjs-client/lib/transport/lib/ajax-based.js")
  , XhrReceiver = __webpack_require__(/*! ./receiver/xhr */ "./node_modules/sockjs-client/lib/transport/receiver/xhr.js")
  , XDRObject = __webpack_require__(/*! ./sender/xdr */ "./node_modules/sockjs-client/lib/transport/sender/xdr.js")
  ;

// According to:
//   http://stackoverflow.com/questions/1641507/detect-browser-support-for-cross-domain-xmlhttprequests
//   http://hacks.mozilla.org/2009/07/cross-site-xmlhttprequest-with-cors/

function XdrStreamingTransport(transUrl) {
  if (!XDRObject.enabled) {
    throw new Error('Transport created when disabled');
  }
  AjaxBasedTransport.call(this, transUrl, '/xhr_streaming', XhrReceiver, XDRObject);
}

inherits(XdrStreamingTransport, AjaxBasedTransport);

XdrStreamingTransport.enabled = function(info) {
  if (info.cookie_needed || info.nullOrigin) {
    return false;
  }
  return XDRObject.enabled && info.sameScheme;
};

XdrStreamingTransport.transportName = 'xdr-streaming';
XdrStreamingTransport.roundTrips = 2; // preflight, ajax

module.exports = XdrStreamingTransport;


/***/ }),

/***/ "./node_modules/sockjs-client/lib/transport/xhr-polling.js":
/*!*****************************************************************!*\
  !*** ./node_modules/sockjs-client/lib/transport/xhr-polling.js ***!
  \*****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
  , AjaxBasedTransport = __webpack_require__(/*! ./lib/ajax-based */ "./node_modules/sockjs-client/lib/transport/lib/ajax-based.js")
  , XhrReceiver = __webpack_require__(/*! ./receiver/xhr */ "./node_modules/sockjs-client/lib/transport/receiver/xhr.js")
  , XHRCorsObject = __webpack_require__(/*! ./sender/xhr-cors */ "./node_modules/sockjs-client/lib/transport/sender/xhr-cors.js")
  , XHRLocalObject = __webpack_require__(/*! ./sender/xhr-local */ "./node_modules/sockjs-client/lib/transport/sender/xhr-local.js")
  ;

function XhrPollingTransport(transUrl) {
  if (!XHRLocalObject.enabled && !XHRCorsObject.enabled) {
    throw new Error('Transport created when disabled');
  }
  AjaxBasedTransport.call(this, transUrl, '/xhr', XhrReceiver, XHRCorsObject);
}

inherits(XhrPollingTransport, AjaxBasedTransport);

XhrPollingTransport.enabled = function(info) {
  if (info.nullOrigin) {
    return false;
  }

  if (XHRLocalObject.enabled && info.sameOrigin) {
    return true;
  }
  return XHRCorsObject.enabled;
};

XhrPollingTransport.transportName = 'xhr-polling';
XhrPollingTransport.roundTrips = 2; // preflight, ajax

module.exports = XhrPollingTransport;


/***/ }),

/***/ "./node_modules/sockjs-client/lib/transport/xhr-streaming.js":
/*!*******************************************************************!*\
  !*** ./node_modules/sockjs-client/lib/transport/xhr-streaming.js ***!
  \*******************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var inherits = __webpack_require__(/*! inherits */ "./node_modules/inherits/inherits_browser.js")
  , AjaxBasedTransport = __webpack_require__(/*! ./lib/ajax-based */ "./node_modules/sockjs-client/lib/transport/lib/ajax-based.js")
  , XhrReceiver = __webpack_require__(/*! ./receiver/xhr */ "./node_modules/sockjs-client/lib/transport/receiver/xhr.js")
  , XHRCorsObject = __webpack_require__(/*! ./sender/xhr-cors */ "./node_modules/sockjs-client/lib/transport/sender/xhr-cors.js")
  , XHRLocalObject = __webpack_require__(/*! ./sender/xhr-local */ "./node_modules/sockjs-client/lib/transport/sender/xhr-local.js")
  , browser = __webpack_require__(/*! ../utils/browser */ "./node_modules/sockjs-client/lib/utils/browser.js")
  ;

function XhrStreamingTransport(transUrl) {
  if (!XHRLocalObject.enabled && !XHRCorsObject.enabled) {
    throw new Error('Transport created when disabled');
  }
  AjaxBasedTransport.call(this, transUrl, '/xhr_streaming', XhrReceiver, XHRCorsObject);
}

inherits(XhrStreamingTransport, AjaxBasedTransport);

XhrStreamingTransport.enabled = function(info) {
  if (info.nullOrigin) {
    return false;
  }
  // Opera doesn't support xhr-streaming #60
  // But it might be able to #92
  if (browser.isOpera()) {
    return false;
  }

  return XHRCorsObject.enabled;
};

XhrStreamingTransport.transportName = 'xhr-streaming';
XhrStreamingTransport.roundTrips = 2; // preflight, ajax

// Safari gets confused when a streaming ajax request is started
// before onload. This causes the load indicator to spin indefinetely.
// Only require body when used in a browser
XhrStreamingTransport.needBody = !!global.document;

module.exports = XhrStreamingTransport;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/sockjs-client/lib/utils/browser-crypto.js":
/*!****************************************************************!*\
  !*** ./node_modules/sockjs-client/lib/utils/browser-crypto.js ***!
  \****************************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

if (global.crypto && global.crypto.getRandomValues) {
  module.exports.randomBytes = function(length) {
    var bytes = new Uint8Array(length);
    global.crypto.getRandomValues(bytes);
    return bytes;
  };
} else {
  module.exports.randomBytes = function(length) {
    var bytes = new Array(length);
    for (var i = 0; i < length; i++) {
      bytes[i] = Math.floor(Math.random() * 256);
    }
    return bytes;
  };
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/sockjs-client/lib/utils/browser.js":
/*!*********************************************************!*\
  !*** ./node_modules/sockjs-client/lib/utils/browser.js ***!
  \*********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

module.exports = {
  isOpera: function() {
    return global.navigator &&
      /opera/i.test(global.navigator.userAgent);
  }

, isKonqueror: function() {
    return global.navigator &&
      /konqueror/i.test(global.navigator.userAgent);
  }

  // #187 wrap document.domain in try/catch because of WP8 from file:///
, hasDomain: function () {
    // non-browser client always has a domain
    if (!global.document) {
      return true;
    }

    try {
      return !!global.document.domain;
    } catch (e) {
      return false;
    }
  }
};

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/sockjs-client/lib/utils/escape.js":
/*!********************************************************!*\
  !*** ./node_modules/sockjs-client/lib/utils/escape.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var JSON3 = __webpack_require__(/*! json3 */ "./node_modules/json3/lib/json3.js");

// Some extra characters that Chrome gets wrong, and substitutes with
// something else on the wire.
// eslint-disable-next-line no-control-regex
var extraEscapable = /[\x00-\x1f\ud800-\udfff\ufffe\uffff\u0300-\u0333\u033d-\u0346\u034a-\u034c\u0350-\u0352\u0357-\u0358\u035c-\u0362\u0374\u037e\u0387\u0591-\u05af\u05c4\u0610-\u0617\u0653-\u0654\u0657-\u065b\u065d-\u065e\u06df-\u06e2\u06eb-\u06ec\u0730\u0732-\u0733\u0735-\u0736\u073a\u073d\u073f-\u0741\u0743\u0745\u0747\u07eb-\u07f1\u0951\u0958-\u095f\u09dc-\u09dd\u09df\u0a33\u0a36\u0a59-\u0a5b\u0a5e\u0b5c-\u0b5d\u0e38-\u0e39\u0f43\u0f4d\u0f52\u0f57\u0f5c\u0f69\u0f72-\u0f76\u0f78\u0f80-\u0f83\u0f93\u0f9d\u0fa2\u0fa7\u0fac\u0fb9\u1939-\u193a\u1a17\u1b6b\u1cda-\u1cdb\u1dc0-\u1dcf\u1dfc\u1dfe\u1f71\u1f73\u1f75\u1f77\u1f79\u1f7b\u1f7d\u1fbb\u1fbe\u1fc9\u1fcb\u1fd3\u1fdb\u1fe3\u1feb\u1fee-\u1fef\u1ff9\u1ffb\u1ffd\u2000-\u2001\u20d0-\u20d1\u20d4-\u20d7\u20e7-\u20e9\u2126\u212a-\u212b\u2329-\u232a\u2adc\u302b-\u302c\uaab2-\uaab3\uf900-\ufa0d\ufa10\ufa12\ufa15-\ufa1e\ufa20\ufa22\ufa25-\ufa26\ufa2a-\ufa2d\ufa30-\ufa6d\ufa70-\ufad9\ufb1d\ufb1f\ufb2a-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufb4e\ufff0-\uffff]/g
  , extraLookup;

// This may be quite slow, so let's delay until user actually uses bad
// characters.
var unrollLookup = function(escapable) {
  var i;
  var unrolled = {};
  var c = [];
  for (i = 0; i < 65536; i++) {
    c.push( String.fromCharCode(i) );
  }
  escapable.lastIndex = 0;
  c.join('').replace(escapable, function(a) {
    unrolled[ a ] = '\\u' + ('0000' + a.charCodeAt(0).toString(16)).slice(-4);
    return '';
  });
  escapable.lastIndex = 0;
  return unrolled;
};

// Quote string, also taking care of unicode characters that browsers
// often break. Especially, take care of unicode surrogates:
// http://en.wikipedia.org/wiki/Mapping_of_Unicode_characters#Surrogates
module.exports = {
  quote: function(string) {
    var quoted = JSON3.stringify(string);

    // In most cases this should be very fast and good enough.
    extraEscapable.lastIndex = 0;
    if (!extraEscapable.test(quoted)) {
      return quoted;
    }

    if (!extraLookup) {
      extraLookup = unrollLookup(extraEscapable);
    }

    return quoted.replace(extraEscapable, function(a) {
      return extraLookup[a];
    });
  }
};


/***/ }),

/***/ "./node_modules/sockjs-client/lib/utils/event.js":
/*!*******************************************************!*\
  !*** ./node_modules/sockjs-client/lib/utils/event.js ***!
  \*******************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var random = __webpack_require__(/*! ./random */ "./node_modules/sockjs-client/lib/utils/random.js");

var onUnload = {}
  , afterUnload = false
    // detect google chrome packaged apps because they don't allow the 'unload' event
  , isChromePackagedApp = global.chrome && global.chrome.app && global.chrome.app.runtime
  ;

module.exports = {
  attachEvent: function(event, listener) {
    if (typeof global.addEventListener !== 'undefined') {
      global.addEventListener(event, listener, false);
    } else if (global.document && global.attachEvent) {
      // IE quirks.
      // According to: http://stevesouders.com/misc/test-postmessage.php
      // the message gets delivered only to 'document', not 'window'.
      global.document.attachEvent('on' + event, listener);
      // I get 'window' for ie8.
      global.attachEvent('on' + event, listener);
    }
  }

, detachEvent: function(event, listener) {
    if (typeof global.addEventListener !== 'undefined') {
      global.removeEventListener(event, listener, false);
    } else if (global.document && global.detachEvent) {
      global.document.detachEvent('on' + event, listener);
      global.detachEvent('on' + event, listener);
    }
  }

, unloadAdd: function(listener) {
    if (isChromePackagedApp) {
      return null;
    }

    var ref = random.string(8);
    onUnload[ref] = listener;
    if (afterUnload) {
      setTimeout(this.triggerUnloadCallbacks, 0);
    }
    return ref;
  }

, unloadDel: function(ref) {
    if (ref in onUnload) {
      delete onUnload[ref];
    }
  }

, triggerUnloadCallbacks: function() {
    for (var ref in onUnload) {
      onUnload[ref]();
      delete onUnload[ref];
    }
  }
};

var unloadTriggered = function() {
  if (afterUnload) {
    return;
  }
  afterUnload = true;
  module.exports.triggerUnloadCallbacks();
};

// 'unload' alone is not reliable in opera within an iframe, but we
// can't use `beforeunload` as IE fires it on javascript: links.
if (!isChromePackagedApp) {
  module.exports.attachEvent('unload', unloadTriggered);
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/sockjs-client/lib/utils/iframe.js":
/*!********************************************************!*\
  !*** ./node_modules/sockjs-client/lib/utils/iframe.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var eventUtils = __webpack_require__(/*! ./event */ "./node_modules/sockjs-client/lib/utils/event.js")
  , JSON3 = __webpack_require__(/*! json3 */ "./node_modules/json3/lib/json3.js")
  , browser = __webpack_require__(/*! ./browser */ "./node_modules/sockjs-client/lib/utils/browser.js")
  ;

var debug = function() {};
if (true) {
  debug = __webpack_require__(/*! debug */ "./node_modules/debug/src/browser.js")('sockjs-client:utils:iframe');
}

module.exports = {
  WPrefix: '_jp'
, currentWindowId: null

, polluteGlobalNamespace: function() {
    if (!(module.exports.WPrefix in global)) {
      global[module.exports.WPrefix] = {};
    }
  }

, postMessage: function(type, data) {
    if (global.parent !== global) {
      global.parent.postMessage(JSON3.stringify({
        windowId: module.exports.currentWindowId
      , type: type
      , data: data || ''
      }), '*');
    } else {
      debug('Cannot postMessage, no parent window.', type, data);
    }
  }

, createIframe: function(iframeUrl, errorCallback) {
    var iframe = global.document.createElement('iframe');
    var tref, unloadRef;
    var unattach = function() {
      debug('unattach');
      clearTimeout(tref);
      // Explorer had problems with that.
      try {
        iframe.onload = null;
      } catch (x) {
        // intentionally empty
      }
      iframe.onerror = null;
    };
    var cleanup = function() {
      debug('cleanup');
      if (iframe) {
        unattach();
        // This timeout makes chrome fire onbeforeunload event
        // within iframe. Without the timeout it goes straight to
        // onunload.
        setTimeout(function() {
          if (iframe) {
            iframe.parentNode.removeChild(iframe);
          }
          iframe = null;
        }, 0);
        eventUtils.unloadDel(unloadRef);
      }
    };
    var onerror = function(err) {
      debug('onerror', err);
      if (iframe) {
        cleanup();
        errorCallback(err);
      }
    };
    var post = function(msg, origin) {
      debug('post', msg, origin);
      setTimeout(function() {
        try {
          // When the iframe is not loaded, IE raises an exception
          // on 'contentWindow'.
          if (iframe && iframe.contentWindow) {
            iframe.contentWindow.postMessage(msg, origin);
          }
        } catch (x) {
          // intentionally empty
        }
      }, 0);
    };

    iframe.src = iframeUrl;
    iframe.style.display = 'none';
    iframe.style.position = 'absolute';
    iframe.onerror = function() {
      onerror('onerror');
    };
    iframe.onload = function() {
      debug('onload');
      // `onload` is triggered before scripts on the iframe are
      // executed. Give it few seconds to actually load stuff.
      clearTimeout(tref);
      tref = setTimeout(function() {
        onerror('onload timeout');
      }, 2000);
    };
    global.document.body.appendChild(iframe);
    tref = setTimeout(function() {
      onerror('timeout');
    }, 15000);
    unloadRef = eventUtils.unloadAdd(cleanup);
    return {
      post: post
    , cleanup: cleanup
    , loaded: unattach
    };
  }

/* eslint no-undef: "off", new-cap: "off" */
, createHtmlfile: function(iframeUrl, errorCallback) {
    var axo = ['Active'].concat('Object').join('X');
    var doc = new global[axo]('htmlfile');
    var tref, unloadRef;
    var iframe;
    var unattach = function() {
      clearTimeout(tref);
      iframe.onerror = null;
    };
    var cleanup = function() {
      if (doc) {
        unattach();
        eventUtils.unloadDel(unloadRef);
        iframe.parentNode.removeChild(iframe);
        iframe = doc = null;
        CollectGarbage();
      }
    };
    var onerror = function(r) {
      debug('onerror', r);
      if (doc) {
        cleanup();
        errorCallback(r);
      }
    };
    var post = function(msg, origin) {
      try {
        // When the iframe is not loaded, IE raises an exception
        // on 'contentWindow'.
        setTimeout(function() {
          if (iframe && iframe.contentWindow) {
              iframe.contentWindow.postMessage(msg, origin);
          }
        }, 0);
      } catch (x) {
        // intentionally empty
      }
    };

    doc.open();
    doc.write('<html><s' + 'cript>' +
              'document.domain="' + global.document.domain + '";' +
              '</s' + 'cript></html>');
    doc.close();
    doc.parentWindow[module.exports.WPrefix] = global[module.exports.WPrefix];
    var c = doc.createElement('div');
    doc.body.appendChild(c);
    iframe = doc.createElement('iframe');
    c.appendChild(iframe);
    iframe.src = iframeUrl;
    iframe.onerror = function() {
      onerror('onerror');
    };
    tref = setTimeout(function() {
      onerror('timeout');
    }, 15000);
    unloadRef = eventUtils.unloadAdd(cleanup);
    return {
      post: post
    , cleanup: cleanup
    , loaded: unattach
    };
  }
};

module.exports.iframeEnabled = false;
if (global.document) {
  // postMessage misbehaves in konqueror 4.6.5 - the messages are delivered with
  // huge delay, or not at all.
  module.exports.iframeEnabled = (typeof global.postMessage === 'function' ||
    typeof global.postMessage === 'object') && (!browser.isKonqueror());
}

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/sockjs-client/lib/utils/log.js":
/*!*****************************************************!*\
  !*** ./node_modules/sockjs-client/lib/utils/log.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var logObject = {};
['log', 'debug', 'warn'].forEach(function (level) {
  var levelExists;

  try {
    levelExists = global.console && global.console[level] && global.console[level].apply;
  } catch(e) {
    // do nothing
  }

  logObject[level] = levelExists ? function () {
    return global.console[level].apply(global.console, arguments);
  } : (level === 'log' ? function () {} : logObject.log);
});

module.exports = logObject;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../../../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/sockjs-client/lib/utils/object.js":
/*!********************************************************!*\
  !*** ./node_modules/sockjs-client/lib/utils/object.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isObject: function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  }

, extend: function(obj) {
    if (!this.isObject(obj)) {
      return obj;
    }
    var source, prop;
    for (var i = 1, length = arguments.length; i < length; i++) {
      source = arguments[i];
      for (prop in source) {
        if (Object.prototype.hasOwnProperty.call(source, prop)) {
          obj[prop] = source[prop];
        }
      }
    }
    return obj;
  }
};


/***/ }),

/***/ "./node_modules/sockjs-client/lib/utils/random.js":
/*!********************************************************!*\
  !*** ./node_modules/sockjs-client/lib/utils/random.js ***!
  \********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* global crypto:true */
var crypto = __webpack_require__(/*! crypto */ "./node_modules/sockjs-client/lib/utils/browser-crypto.js");

// This string has length 32, a power of 2, so the modulus doesn't introduce a
// bias.
var _randomStringChars = 'abcdefghijklmnopqrstuvwxyz012345';
module.exports = {
  string: function(length) {
    var max = _randomStringChars.length;
    var bytes = crypto.randomBytes(length);
    var ret = [];
    for (var i = 0; i < length; i++) {
      ret.push(_randomStringChars.substr(bytes[i] % max, 1));
    }
    return ret.join('');
  }

, number: function(max) {
    return Math.floor(Math.random() * max);
  }

, numberString: function(max) {
    var t = ('' + (max - 1)).length;
    var p = new Array(t + 1).join('0');
    return (p + this.number(max)).slice(-t);
  }
};


/***/ }),

/***/ "./node_modules/sockjs-client/lib/utils/transport.js":
/*!***********************************************************!*\
  !*** ./node_modules/sockjs-client/lib/utils/transport.js ***!
  \***********************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var debug = function() {};
if (true) {
  debug = __webpack_require__(/*! debug */ "./node_modules/debug/src/browser.js")('sockjs-client:utils:transport');
}

module.exports = function(availableTransports) {
  return {
    filterToEnabled: function(transportsWhitelist, info) {
      var transports = {
        main: []
      , facade: []
      };
      if (!transportsWhitelist) {
        transportsWhitelist = [];
      } else if (typeof transportsWhitelist === 'string') {
        transportsWhitelist = [transportsWhitelist];
      }

      availableTransports.forEach(function(trans) {
        if (!trans) {
          return;
        }

        if (trans.transportName === 'websocket' && info.websocket === false) {
          debug('disabled from server', 'websocket');
          return;
        }

        if (transportsWhitelist.length &&
            transportsWhitelist.indexOf(trans.transportName) === -1) {
          debug('not in whitelist', trans.transportName);
          return;
        }

        if (trans.enabled(info)) {
          debug('enabled', trans.transportName);
          transports.main.push(trans);
          if (trans.facadeTransport) {
            transports.facade.push(trans.facadeTransport);
          }
        } else {
          debug('disabled', trans.transportName);
        }
      });
      return transports;
    }
  };
};


/***/ }),

/***/ "./node_modules/sockjs-client/lib/utils/url.js":
/*!*****************************************************!*\
  !*** ./node_modules/sockjs-client/lib/utils/url.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var URL = __webpack_require__(/*! url-parse */ "./node_modules/url-parse/index.js");

var debug = function() {};
if (true) {
  debug = __webpack_require__(/*! debug */ "./node_modules/debug/src/browser.js")('sockjs-client:utils:url');
}

module.exports = {
  getOrigin: function(url) {
    if (!url) {
      return null;
    }

    var p = new URL(url);
    if (p.protocol === 'file:') {
      return null;
    }

    var port = p.port;
    if (!port) {
      port = (p.protocol === 'https:') ? '443' : '80';
    }

    return p.protocol + '//' + p.hostname + ':' + port;
  }

, isOriginEqual: function(a, b) {
    var res = this.getOrigin(a) === this.getOrigin(b);
    debug('same', a, b, res);
    return res;
  }

, isSchemeEqual: function(a, b) {
    return (a.split(':')[0] === b.split(':')[0]);
  }

, addPath: function (url, path) {
    var qs = url.split('?');
    return qs[0] + path + (qs[1] ? '?' + qs[1] : '');
  }

, addQuery: function (url, q) {
    return url + (url.indexOf('?') === -1 ? ('?' + q) : ('&' + q));
  }
};


/***/ }),

/***/ "./node_modules/sockjs-client/lib/version.js":
/*!***************************************************!*\
  !*** ./node_modules/sockjs-client/lib/version.js ***!
  \***************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = '1.4.0';


/***/ }),

/***/ "./node_modules/url-parse/index.js":
/*!*****************************************!*\
  !*** ./node_modules/url-parse/index.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var required = __webpack_require__(/*! requires-port */ "./node_modules/requires-port/index.js")
  , qs = __webpack_require__(/*! querystringify */ "./node_modules/querystringify/index.js")
  , slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//
  , protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\S\s]*)/i
  , whitespace = '[\\x09\\x0A\\x0B\\x0C\\x0D\\x20\\xA0\\u1680\\u180E\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200A\\u202F\\u205F\\u3000\\u2028\\u2029\\uFEFF]'
  , left = new RegExp('^'+ whitespace +'+');

/**
 * Trim a given string.
 *
 * @param {String} str String to trim.
 * @public
 */
function trimLeft(str) {
  return (str ? str : '').toString().replace(left, '');
}

/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */
var rules = [
  ['#', 'hash'],                        // Extract from the back.
  ['?', 'query'],                       // Extract from the back.
  function sanitize(address) {          // Sanitize what is left of the address
    return address.replace('\\', '/');
  },
  ['/', 'pathname'],                    // Extract from the back.
  ['@', 'auth', 1],                     // Extract from the front.
  [NaN, 'host', undefined, 1, 1],       // Set left over value.
  [/:(\d+)$/, 'port', undefined, 1],    // RegExp the back.
  [NaN, 'hostname', undefined, 1, 1]    // Set left over.
];

/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */
var ignore = { hash: 1, query: 1 };

/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */
function lolcation(loc) {
  var globalVar;

  if (typeof window !== 'undefined') globalVar = window;
  else if (typeof global !== 'undefined') globalVar = global;
  else if (typeof self !== 'undefined') globalVar = self;
  else globalVar = {};

  var location = globalVar.location || {};
  loc = loc || location;

  var finaldestination = {}
    , type = typeof loc
    , key;

  if ('blob:' === loc.protocol) {
    finaldestination = new Url(unescape(loc.pathname), {});
  } else if ('string' === type) {
    finaldestination = new Url(loc, {});
    for (key in ignore) delete finaldestination[key];
  } else if ('object' === type) {
    for (key in loc) {
      if (key in ignore) continue;
      finaldestination[key] = loc[key];
    }

    if (finaldestination.slashes === undefined) {
      finaldestination.slashes = slashes.test(loc.href);
    }
  }

  return finaldestination;
}

/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */

/**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @return {ProtocolExtract} Extracted information.
 * @private
 */
function extractProtocol(address) {
  address = trimLeft(address);
  var match = protocolre.exec(address);

  return {
    protocol: match[1] ? match[1].toLowerCase() : '',
    slashes: !!match[2],
    rest: match[3]
  };
}

/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */
function resolve(relative, base) {
  if (relative === '') return base;

  var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/'))
    , i = path.length
    , last = path[i - 1]
    , unshift = false
    , up = 0;

  while (i--) {
    if (path[i] === '.') {
      path.splice(i, 1);
    } else if (path[i] === '..') {
      path.splice(i, 1);
      up++;
    } else if (up) {
      if (i === 0) unshift = true;
      path.splice(i, 1);
      up--;
    }
  }

  if (unshift) path.unshift('');
  if (last === '.' || last === '..') path.push('');

  return path.join('/');
}

/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */
function Url(address, location, parser) {
  address = trimLeft(address);

  if (!(this instanceof Url)) {
    return new Url(address, location, parser);
  }

  var relative, extracted, parse, instruction, index, key
    , instructions = rules.slice()
    , type = typeof location
    , url = this
    , i = 0;

  //
  // The following if statements allows this module two have compatibility with
  // 2 different API:
  //
  // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
  //    where the boolean indicates that the query string should also be parsed.
  //
  // 2. The `URL` interface of the browser which accepts a URL, object as
  //    arguments. The supplied object will be used as default values / fall-back
  //    for relative paths.
  //
  if ('object' !== type && 'string' !== type) {
    parser = location;
    location = null;
  }

  if (parser && 'function' !== typeof parser) parser = qs.parse;

  location = lolcation(location);

  //
  // Extract protocol information before running the instructions.
  //
  extracted = extractProtocol(address || '');
  relative = !extracted.protocol && !extracted.slashes;
  url.slashes = extracted.slashes || relative && location.slashes;
  url.protocol = extracted.protocol || location.protocol || '';
  address = extracted.rest;

  //
  // When the authority component is absent the URL starts with a path
  // component.
  //
  if (!extracted.slashes) instructions[3] = [/(.*)/, 'pathname'];

  for (; i < instructions.length; i++) {
    instruction = instructions[i];

    if (typeof instruction === 'function') {
      address = instruction(address);
      continue;
    }

    parse = instruction[0];
    key = instruction[1];

    if (parse !== parse) {
      url[key] = address;
    } else if ('string' === typeof parse) {
      if (~(index = address.indexOf(parse))) {
        if ('number' === typeof instruction[2]) {
          url[key] = address.slice(0, index);
          address = address.slice(index + instruction[2]);
        } else {
          url[key] = address.slice(index);
          address = address.slice(0, index);
        }
      }
    } else if ((index = parse.exec(address))) {
      url[key] = index[1];
      address = address.slice(0, index.index);
    }

    url[key] = url[key] || (
      relative && instruction[3] ? location[key] || '' : ''
    );

    //
    // Hostname, host and protocol should be lowercased so they can be used to
    // create a proper `origin`.
    //
    if (instruction[4]) url[key] = url[key].toLowerCase();
  }

  //
  // Also parse the supplied query string in to an object. If we're supplied
  // with a custom parser as function use that instead of the default build-in
  // parser.
  //
  if (parser) url.query = parser(url.query);

  //
  // If the URL is relative, resolve the pathname against the base URL.
  //
  if (
      relative
    && location.slashes
    && url.pathname.charAt(0) !== '/'
    && (url.pathname !== '' || location.pathname !== '')
  ) {
    url.pathname = resolve(url.pathname, location.pathname);
  }

  //
  // We should not add port numbers if they are already the default port number
  // for a given protocol. As the host also contains the port number we're going
  // override it with the hostname which contains no port number.
  //
  if (!required(url.port, url.protocol)) {
    url.host = url.hostname;
    url.port = '';
  }

  //
  // Parse down the `auth` for the username and password.
  //
  url.username = url.password = '';
  if (url.auth) {
    instruction = url.auth.split(':');
    url.username = instruction[0] || '';
    url.password = instruction[1] || '';
  }

  url.origin = url.protocol && url.host && url.protocol !== 'file:'
    ? url.protocol +'//'+ url.host
    : 'null';

  //
  // The href is just the compiled result.
  //
  url.href = url.toString();
}

/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */
function set(part, value, fn) {
  var url = this;

  switch (part) {
    case 'query':
      if ('string' === typeof value && value.length) {
        value = (fn || qs.parse)(value);
      }

      url[part] = value;
      break;

    case 'port':
      url[part] = value;

      if (!required(value, url.protocol)) {
        url.host = url.hostname;
        url[part] = '';
      } else if (value) {
        url.host = url.hostname +':'+ value;
      }

      break;

    case 'hostname':
      url[part] = value;

      if (url.port) value += ':'+ url.port;
      url.host = value;
      break;

    case 'host':
      url[part] = value;

      if (/:\d+$/.test(value)) {
        value = value.split(':');
        url.port = value.pop();
        url.hostname = value.join(':');
      } else {
        url.hostname = value;
        url.port = '';
      }

      break;

    case 'protocol':
      url.protocol = value.toLowerCase();
      url.slashes = !fn;
      break;

    case 'pathname':
    case 'hash':
      if (value) {
        var char = part === 'pathname' ? '/' : '#';
        url[part] = value.charAt(0) !== char ? char + value : value;
      } else {
        url[part] = value;
      }
      break;

    default:
      url[part] = value;
  }

  for (var i = 0; i < rules.length; i++) {
    var ins = rules[i];

    if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
  }

  url.origin = url.protocol && url.host && url.protocol !== 'file:'
    ? url.protocol +'//'+ url.host
    : 'null';

  url.href = url.toString();

  return url;
}

/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */
function toString(stringify) {
  if (!stringify || 'function' !== typeof stringify) stringify = qs.stringify;

  var query
    , url = this
    , protocol = url.protocol;

  if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';

  var result = protocol + (url.slashes ? '//' : '');

  if (url.username) {
    result += url.username;
    if (url.password) result += ':'+ url.password;
    result += '@';
  }

  result += url.host + url.pathname;

  query = 'object' === typeof url.query ? stringify(url.query) : url.query;
  if (query) result += '?' !== query.charAt(0) ? '?'+ query : query;

  if (url.hash) result += url.hash;

  return result;
}

Url.prototype = { set: set, toString: toString };

//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
Url.extractProtocol = extractProtocol;
Url.location = lolcation;
Url.trimLeft = trimLeft;
Url.qs = qs;

module.exports = Url;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(/*! ./../webpack/buildin/global.js */ "./node_modules/webpack/buildin/global.js")))

/***/ }),

/***/ "./node_modules/webpack/buildin/amd-options.js":
/*!****************************************!*\
  !*** (webpack)/buildin/amd-options.js ***!
  \****************************************/
/*! no static exports found */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(this, {}))

/***/ }),

/***/ "./node_modules/webpack/buildin/global.js":
/*!***********************************!*\
  !*** (webpack)/buildin/global.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "./node_modules/webpack/buildin/module.js":
/*!***********************************!*\
  !*** (webpack)/buildin/module.js ***!
  \***********************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function(module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "./src/OtClient.js":
/*!*************************!*\
  !*** ./src/OtClient.js ***!
  \*************************/
/*! exports provided: OtClient */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OtClient", function() { return OtClient; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "./node_modules/@babel/runtime/helpers/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _teamwork_ot_rich_text_lib_Operation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @teamwork/ot-rich-text/lib/Operation */ "./node_modules/@teamwork/ot-rich-text/lib/Operation.js");
/* harmony import */ var _teamwork_ot_rich_text_lib_Operation__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_teamwork_ot_rich_text_lib_Operation__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var events__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! events */ "./node_modules/events/events.js");
/* harmony import */ var events__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(events__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var sockjs_client__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! sockjs-client */ "./node_modules/sockjs-client/lib/entry.js");
/* harmony import */ var sockjs_client__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(sockjs_client__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _util_ShareDB__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./util/ShareDB */ "./src/util/ShareDB.js");
/* harmony import */ var _tinymce_TinyMceSync__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./tinymce/TinyMceSync */ "./src/tinymce/TinyMceSync.js");
/* harmony import */ var _codeMirror_CodeMirrorSync__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./codeMirror/CodeMirrorSync */ "./src/codeMirror/CodeMirrorSync.js");
/* harmony import */ var _util_misc__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./util/misc */ "./src/util/misc.js");













var OtClient =
/*#__PURE__*/
function (_EventEmitter) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(OtClient, _EventEmitter);

  function OtClient() {
    var _this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        _ref$collectionName = _ref.collectionName,
        collectionName = _ref$collectionName === void 0 ? 'test' : _ref$collectionName,
        _ref$documentId = _ref.documentId,
        documentId = _ref$documentId === void 0 ? '1' : _ref$documentId,
        _ref$domNode = _ref.domNode,
        domNode = _ref$domNode === void 0 ? null : _ref$domNode,
        _ref$url = _ref.url,
        url = _ref$url === void 0 ? '' : _ref$url,
        _ref$debug = _ref.debug,
        debug = _ref$debug === void 0 ? false : _ref$debug,
        _ref$getAccessToken = _ref.getAccessToken,
        getAccessToken = _ref$getAccessToken === void 0 ? function (callback) {
      return setTimeout(callback, 0, null, '');
    } : _ref$getAccessToken,
        _ref$reconnectMinDela = _ref.reconnectMinDelay,
        reconnectMinDelay = _ref$reconnectMinDela === void 0 ? 5000 : _ref$reconnectMinDela,
        _ref$reconnectMaxDela = _ref.reconnectMaxDelay,
        reconnectMaxDelay = _ref$reconnectMaxDela === void 0 ? 60000 : _ref$reconnectMaxDela,
        _ref$reconnectDelayFa = _ref.reconnectDelayFactor,
        reconnectDelayFactor = _ref$reconnectDelayFa === void 0 ? 1.5 : _ref$reconnectDelayFa,
        _ref$counterResetDela = _ref.counterResetDelay,
        counterResetDelay = _ref$counterResetDela === void 0 ? 60000 : _ref$counterResetDela,
        config = _ref.config,
        presenceEnabled = _ref.presenceEnabled,
        presenceDelay = _ref.presenceDelay,
        asyncScrollUpdate = _ref.asyncScrollUpdate,
        _ref$shouldConnect = _ref.shouldConnect,
        shouldConnect = _ref$shouldConnect === void 0 ? true : _ref$shouldConnect,
        _ref$betaAuth = _ref.betaAuth,
        betaAuth = _ref$betaAuth === void 0 ? null : _ref$betaAuth,
        _ref$codeMirror = _ref.codeMirror,
        codeMirror = _ref$codeMirror === void 0 ? null : _ref$codeMirror;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, OtClient);

    _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(OtClient).call(this));
    _this._collectionName = collectionName;
    _this._documentId = documentId;
    _this._domNode = domNode;
    _this._betaAuth = betaAuth;
    _this._url = url;
    _this._reconnectMinDelay = reconnectMinDelay;
    _this._reconnectMaxDelay = reconnectMaxDelay;
    _this._reconnectDelayFactor = reconnectDelayFactor;
    _this._counterResetDelay = counterResetDelay;
    _this._shouldConnect = !!shouldConnect;
    _this._connecting = false;
    _this._connected = false;
    _this._connectionTime = 0;
    _this._reconnectAttempt = -1;
    _this._connectionTimeoutHandle = null;
    _this._socket = {
      readyState: 3,
      // CLOSED
      close: function close() {}
    };
    _this._getAccessToken = getAccessToken;
    _this._connection = new _util_ShareDB__WEBPACK_IMPORTED_MODULE_9__["default"].Connection(_this._socket);
    _this._doc = _this._connection.get(_this._collectionName, _this._documentId);
    _this._sync = codeMirror ? new _codeMirror_CodeMirrorSync__WEBPACK_IMPORTED_MODULE_11__["CodeMirrorSync"]({
      doc: _this._doc,
      codeMirror: codeMirror
    }) : new _tinymce_TinyMceSync__WEBPACK_IMPORTED_MODULE_10__["TinyMceSync"]({
      doc: _this._doc,
      domNode: domNode,
      debug: debug,
      config: config,
      presenceEnabled: presenceEnabled,
      presenceDelay: presenceDelay,
      asyncScrollUpdate: asyncScrollUpdate
    });

    _this._sync.on('presence', _this._onPresence = _this._onEvent.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this), 'presence'));

    _this._doc.on('load', _this._onLoad = _this._onEvent.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this), 'load'));

    _this._doc.on('op', _this._onOperation = _this._onEvent.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this), 'operation'));

    _this._doc.on('nothing pending', _this._onNothingPending = _this._onEvent.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this), 'nothingPending'));

    _this._doc.on('error', _this._onDocumentError = _this._onEvent.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this), 'documentError'));

    _this._connection.on('error', _this._onError = _this._onEvent.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this), 'error'));

    _this._connection.on('connection error', _this._onConnectionError = _this._onEvent.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this), 'connectionError'));

    _this._connection.on('connecting', _this._onConnecting = _this._onEvent.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this), 'connecting'));

    _this._connection.on('connected', _this._onConnected = _this._onEvent.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this), 'connected'));

    _this._connection.on('closed', _this._onClosed = _this._onEvent.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this), 'disconnected'));

    _this._connection.on('stopped', _this._onStopped = _this._onEvent.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this), 'disconnected'));

    _this._connection.on('disconnected', _this._onDisconnected = _this._onEvent.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this), 'disconnected'));

    _this._connection.on('state', _this._onState = _this._onState.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this)));

    _this._doc.subscribe();

    _this._updateConnection();

    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(OtClient, [{
    key: "dispose",
    value: function dispose() {
      if (this._getAccessToken == null) {
        return; // Already disposed
      }

      this._getAccessToken = null;
      clearTimeout(this._connectionTimeoutHandle);
      this.removeAllListeners();

      this._sync.removeListener('presence', this._onPresence);

      this._doc.removeListener('load', this._onLoad);

      this._doc.removeListener('op', this._onOperation);

      this._doc.removeListener('nothing pending', this._onNothingPending);

      this._doc.removeListener('error', this._onDocumentError);

      this._connection.removeListener('error', this._onError);

      this._connection.removeListener('connection error', this._onConnectionError);

      this._connection.removeListener('connecting', this._onConnecting);

      this._connection.removeListener('connected', this._onConnected);

      this._connection.removeListener('closed', this._onClosed);

      this._connection.removeListener('stopped', this._onStopped);

      this._connection.removeListener('disconnected', this._onDisconnected);

      this._connection.removeListener('state', this._onState);

      this._sync.dispose(); // Destroying a document sends an unsubscribe message to the server and
      // removes the document from the connection.
      // Unsubscribe is not needed because we're closing the connection,
      // so the server will perform any necessary cleanup anyway.
      // Removing the document from the connection is not needed,
      // because we're throwing away the entire connection, so both objects will be GCed.
      // So, we're not destroying the doc because it's not needed and because doing so causes
      // an Error when publishing a notebook in Projects, which results from ShareDB not recognizing
      // the WebSockets CLOSING state.
      // this._doc.destroy()


      this._connection.close();
    }
  }, {
    key: "canUndo",
    value: function canUndo() {
      return this._sync.canUndo();
    }
  }, {
    key: "canRedo",
    value: function canRedo() {
      return this._sync.canRedo();
    }
  }, {
    key: "undo",
    value: function undo() {
      this._sync.undo();
    }
  }, {
    key: "redo",
    value: function redo() {
      this._sync.redo();
    }
  }, {
    key: "hasPending",
    value: function hasPending() {
      return this._doc.hasPending();
    }
  }, {
    key: "whenNothingPending",
    value: function whenNothingPending(callback) {
      this._doc.whenNothingPending(callback);
    }
  }, {
    key: "contentToOtModel",
    value: function contentToOtModel(html) {
      return this._sync.contentToOtModel(html);
    }
  }, {
    key: "compareOtModels",
    value: function compareOtModels(otModel1, otModel2, options) {
      return Object(_util_misc__WEBPACK_IMPORTED_MODULE_12__["compareOtModels"])(otModel1, otModel2, options);
    }
  }, {
    key: "getRootAttribute",
    value: function getRootAttribute(name) {
      return this._sync.getRootAttribute(name);
    }
  }, {
    key: "setRootAttribute",
    value: function setRootAttribute(name, value) {
      this._sync.setRootAttribute(name, value);
    }
  }, {
    key: "diff",
    value: function diff(oldHtml, newHtml) {
      var oldOtModel = this._sync.contentToOtModel(oldHtml);

      var newOtModel = this._sync.contentToOtModel(newHtml);

      return Object(_teamwork_ot_rich_text_lib_Operation__WEBPACK_IMPORTED_MODULE_6__["diffX"])(oldOtModel, newOtModel)[1];
    }
  }, {
    key: "_updateConnection",
    value: function _updateConnection() {
      if (this._shouldConnect === this._connected || this._connecting) {
        return;
      }

      if (this._shouldConnect) {
        this._connect();
      } else {
        this._connection.close();
      }
    }
  }, {
    key: "_connect",
    value: function _connect() {
      var _this2 = this;

      var delay = this._reconnectAttempt < 0 ? this._reconnectAttempt = 0 : Math.min(this._reconnectMaxDelay, Math.round(Math.pow(this._reconnectDelayFactor, this._reconnectAttempt++) * this._reconnectMinDelay));
      this._connecting = true;
      this._connectionTimeoutHandle = setTimeout(function () {
        if (!_this2._shouldConnect) {
          _this2._connecting = false;
          return;
        }

        _this2._getAccessToken(function (error, accessToken) {
          if (!_this2._getAccessToken) {
            return; // disposed
          }

          if (!_this2._shouldConnect) {
            _this2._connecting = false;
            return;
          }

          if (error) {
            _this2._connect();

            _this2.emit('connectionError', error);

            return;
          }

          _this2._createSocket(accessToken, function (error, socket) {
            if (!_this2._getAccessToken) {
              socket && socket.close();
              return; // disposed
            }

            if (!_this2._shouldConnect) {
              _this2._connecting = false;
              socket && socket.close();
              return;
            }

            if (error) {
              _this2._connect();

              _this2.emit('connectionError', error);

              return;
            }

            _this2._socket = socket;

            _this2._connection.bindToSocket(_this2._socket);
          });
        });
      }, delay);
    }
  }, {
    key: "_onEvent",
    value: function _onEvent() {
      this.emit.apply(this, arguments);
    }
  }, {
    key: "_onState",
    value: function _onState(state) {
      if (state === 'connected') {
        this._connectionTime = Date.now();
        this._connecting = false;
        this._connected = true;

        this._updateConnection();
      } else if (state === 'disconnected' || state === 'stopped' || state === 'closed') {
        if (this._connectionTime + this._counterResetDelay <= Date.now()) {
          this._reconnectAttempt = 0;
        }

        this._connecting = false;
        this._connected = false;

        this._updateConnection();
      }
    }
  }, {
    key: "_createSocket",
    value: function _createSocket(accessToken, callback) {
      return this._auth(new sockjs_client__WEBPACK_IMPORTED_MODULE_8___default.a(this._url + '/ot/v2/ot', undefined, {
        transports: ['websocket', 'xhr-streaming'],
        // Set Session ID to be 32 characters long
        // with each character containing 5 secure random bits
        // for the total of 160 secure random bits.
        // See https://www.owasp.org/index.php/Insufficient_Session-ID_Length
        sessionId: 32
      }), accessToken, callback);
    }
  }, {
    key: "_auth",
    value: function _auth(socket, accessToken, callback) {
      var _this3 = this;

      var onOpen = function onOpen() {
        var message = {
          collectionName: _this3._collectionName,
          documentId: _this3._documentId,
          accessToken: accessToken
        };
        message.beta = _this3._betaAuth;
        socket.send(JSON.stringify(message));
      };

      var onMessage = function onMessage(_ref2) {
        var data = _ref2.data;
        removeListeners();
        var message = JSON.parse(data);

        if (message.status === 'OK') {
          callback(null, socket);
        } else {
          socket.close();
          var error = new Error('Auth failed');
          error.statusCode = message.statusCode;
          error.statusMessage = message.statusMessage;
          callback(error);
        }
      };

      var onError = function onError(error) {
        removeListeners();
        socket.close();
        callback(error);
      };

      var onClose = function onClose() {
        removeListeners();
        callback(new Error('Socket closed before auth completed'));
      };

      socket.addEventListener('open', onOpen);
      socket.addEventListener('message', onMessage);
      socket.addEventListener('error', onError);
      socket.addEventListener('close', onClose);

      function removeListeners() {
        socket.removeEventListener('open', onOpen);
        socket.removeEventListener('message', onMessage);
        socket.removeEventListener('error', onError);
        socket.removeEventListener('close', onClose);
      }
    }
  }, {
    key: "version",
    get: function get() {
      return this._doc.version;
    }
  }, {
    key: "otModel",
    get: function get() {
      return this._doc.data;
    }
  }, {
    key: "virtualDom",
    get: function get() {
      return this._sync.virtualDom;
    }
  }, {
    key: "realDom",
    get: function get() {
      return this._sync.realDom;
    }
  }, {
    key: "presenceEnabled",
    get: function get() {
      return this._sync.presenceEnabled;
    },
    set: function set(presenceEnabled) {
      this._sync.presenceEnabled = presenceEnabled;
    }
  }, {
    key: "presence",
    get: function get() {
      return this._sync.presence;
    }
  }, {
    key: "connectionState",
    get: function get() {
      var state = this._connection.state;
      return state === 'connected' || state === 'connecting' ? state : 'disconnected';
    }
  }, {
    key: "debug",
    get: function get() {
      return this._sync.debug;
    },
    set: function set(enabled) {
      this._sync.debug = enabled;
    }
  }, {
    key: "shouldConnect",
    get: function get() {
      return this._shouldConnect;
    },
    set: function set(shouldConnect) {
      this._reconnectAttempt = -1;
      this._shouldConnect = !!shouldConnect;

      this._updateConnection();
    }
  }]);

  return OtClient;
}(events__WEBPACK_IMPORTED_MODULE_7__["EventEmitter"]);

/***/ }),

/***/ "./src/codeMirror/CodeMirrorPresence.js":
/*!**********************************************!*\
  !*** ./src/codeMirror/CodeMirrorPresence.js ***!
  \**********************************************/
/*! exports provided: CodeMirrorPresence */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CodeMirrorPresence", function() { return CodeMirrorPresence; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "./node_modules/@babel/runtime/helpers/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var events__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! events */ "./node_modules/events/events.js");
/* harmony import */ var events__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(events__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _util_colors__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../util/colors */ "./src/util/colors.js");








var CodeMirrorPresence =
/*#__PURE__*/
function (_EventEmitter) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(CodeMirrorPresence, _EventEmitter);

  function CodeMirrorPresence(codeMirror, src, userId) {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, CodeMirrorPresence);

    _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(CodeMirrorPresence).call(this));
    _this.codeMirror = codeMirror;
    _this.src = src;
    _this.userId = userId;
    _this.color = '#fff';
    _this.backgroundColor = Object(_util_colors__WEBPACK_IMPORTED_MODULE_7__["claimColor"])(_this.codeMirror, _this.userId);
    _this.custom = null;
    _this.numberOfChanges = 0;
    _this.showingLabel = false;
    _this.hoveringLabel = false;
    _this.caret = null;
    _this.barNode = document.createElement('DIV');
    _this.barNode.style.position = 'absolute';
    _this.barNode.style.top = '0';
    _this.barNode.style.left = '-1px';
    _this.barNode.style.width = '2px';
    _this.barNode.style.height = '100%';
    _this.barNode.style.backgroundColor = _this.backgroundColor;
    _this.headNode = document.createElement('DIV');
    _this.headNode.style.position = 'absolute';
    _this.headNode.style.bottom = '100%';
    _this.headNode.style.left = '-4px';
    _this.headNode.style.width = '8px';
    _this.headNode.style.height = '8px';
    _this.headNode.style.opacity = '0.9';
    _this.headNode.style.transition = 'opacity 0.15s ease';
    _this.headNode.style.borderRadius = '4px';
    _this.headNode.style.backgroundColor = _this.backgroundColor;
    _this.onImageError = _this.onImageError.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this));
    _this.avatarNode = document.createElement('IMG');

    _this.avatarNode.classList.add('ot-caret__avatar');

    _this.avatarNode.style.width = '16px';
    _this.avatarNode.style.height = '16px';
    _this.avatarNode.style.maxWidth = 'none';
    _this.avatarNode.style.margin = '0 3px -4px 0';
    _this.avatarNode.style.borderRadius = '8px';
    _this.avatarNode.style.border = '1px solid';
    _this.avatarNode.style.borderColor = _this.color;

    _this.avatarNode.addEventListener('error', _this.onImageError);

    _this.textNode = document.createTextNode('');
    _this.labelNode = document.createElement('DIV');

    _this.labelNode.classList.add('ot-caret__label');

    _this.labelNode.style.position = 'absolute';
    _this.labelNode.style.left = '-4px';
    _this.labelNode.style.bottom = '100%';
    _this.labelNode.style.padding = '4px';
    _this.labelNode.style.whiteSpace = 'nowrap';
    _this.labelNode.style.opacity = '0';
    _this.labelNode.style.transition = 'opacity 0.15s ease';
    _this.labelNode.style.zIndex = '1';
    _this.labelNode.style.borderRadius = '4px';
    _this.labelNode.style.color = _this.color;
    _this.labelNode.style.backgroundColor = _this.backgroundColor;

    _this.labelNode.appendChild(_this.avatarNode);

    _this.labelNode.appendChild(_this.textNode);

    _this.onMouseEnter = _this.onMouseEnter.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this));
    _this.onMouseLeave = _this.onMouseLeave.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this));
    _this.node = document.createElement('DIV');

    _this.node.classList.add('ot-caret');

    _this.node.style.position = 'absolute';
    _this.node.style.left = '0';
    _this.node.style.width = '0';
    _this.node.style.userSelect = 'none';

    _this.node.addEventListener('mouseenter', _this.onMouseEnter);

    _this.node.addEventListener('mouseleave', _this.onMouseLeave);

    _this.node.appendChild(_this.headNode);

    _this.node.appendChild(_this.barNode);

    _this.node.appendChild(_this.labelNode);

    _this.containerNode = document.createElement('SPAN');
    _this.containerNode.style.position = 'relative';

    _this.containerNode.appendChild(_this.node);

    _this.caretOptions = {
      widget: _this.containerNode,
      handleMouseEvents: true
    };
    _this.labelTimeoutHandle = null;
    _this.onLabelTimeout = _this.onLabelTimeout.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this));
    _this.selection = null;
    _this.selectionOptions = {
      css: "background-color: ".concat(Object(_util_colors__WEBPACK_IMPORTED_MODULE_7__["colorWithOpacity"])(_this.backgroundColor, '0.2'), ";"),
      handleMouseEvents: true
    };
    _this.selectionTimeoutHandle = null;
    _this.onSelectionTimeout = _this.onSelectionTimeout.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this));
    _this.label = '';
    _this.avatar = '';
    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(CodeMirrorPresence, [{
    key: "scrollIntoView",
    value: function scrollIntoView() {
      if (this.caret) {
        var pos = this.caret.find();

        if (pos) {
          this.codeMirror.scrollIntoView(pos, scrollIntoViewMargin);
          this.showLabel();

          if (!this.hoveringLabel) {
            this.setLabelTimeout();
          }
        }
      }
    }
  }, {
    key: "update",
    value: function update(data, submitted) {
      var selection = data.s[0];
      this.setCaret(selection);

      if (submitted) {
        this.setSelectionTimeout();
      }

      if (!this.selectionExpired) {
        this.setSelection(selection);
      }

      if (submitted) {
        var numberOfChanges = data.c;
        var madeChanges = this.numberOfChanges !== numberOfChanges;
        this.numberOfChanges = numberOfChanges;
        this.showLabel();

        if (!this.hoveringLabel) {
          this.setLabelTimeout();
        }

        this.emit('activity', madeChanges);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      Object(_util_colors__WEBPACK_IMPORTED_MODULE_7__["releaseColor"])(this.codeMirror, this.userId);
      this.clearCaret();
      this.clearLabelTimeout();
      this.clearSelection();
      this.clearSelectionTimeout();
    }
  }, {
    key: "setCaret",
    value: function setCaret(selection) {
      this.clearCaret();

      if (selection) {
        var focus = selection[1] - 1;
        var pos = this.codeMirror.posFromIndex(focus);
        this.caret = this.codeMirror.setBookmark(pos, this.caretOptions); // Size and position the caret correctly.
        // It is a bit hacky, however, I couldn't find any better way.

        var coords = this.codeMirror.cursorCoords(pos, 'local');
        var height = coords.bottom - coords.top;
        this.node.style.height = height + 'px';

        if (this.containerNode.parentNode.getBoundingClientRect().height === 0) {
          this.node.style.top = '0';
          this.node.style.marginTop = '0';
        } else {
          this.node.style.top = '50%';
          this.node.style.marginTop = -Math.floor(height / 2) + 'px';
        }
      }
    }
  }, {
    key: "clearCaret",
    value: function clearCaret() {
      if (this.caret) {
        this.caret.clear();
        this.caret = null;
      }
    }
  }, {
    key: "showLabel",
    value: function showLabel() {
      if (!this.showingLabel) {
        this.showingLabel = true;
        this.labelNode.style.opacity = '0.9';
        this.headNode.style.opacity = '0';
      }
    }
  }, {
    key: "hideLabel",
    value: function hideLabel() {
      if (this.showingLabel) {
        this.showingLabel = false;
        this.labelNode.style.opacity = '0';
        this.headNode.style.opacity = '0.9';
      }
    }
  }, {
    key: "setLabelTimeout",
    value: function setLabelTimeout() {
      this.clearLabelTimeout();
      this.labelTimeoutHandle = setTimeout(this.onLabelTimeout, labelTimeout);
    }
  }, {
    key: "clearLabelTimeout",
    value: function clearLabelTimeout() {
      if (this.labelTimeoutHandle) {
        clearTimeout(this.labelTimeoutHandle);
        this.labelTimeoutHandle = null;
      }
    }
  }, {
    key: "onLabelTimeout",
    value: function onLabelTimeout() {
      this.clearLabelTimeout();
      this.hideLabel();
    }
  }, {
    key: "onImageError",
    value: function onImageError() {
      this.avatarNode.style.display = 'none';
    }
  }, {
    key: "onMouseEnter",
    value: function onMouseEnter() {
      this.hoveringLabel = true;
      this.showLabel();
      this.clearLabelTimeout();
    }
  }, {
    key: "onMouseLeave",
    value: function onMouseLeave() {
      this.hoveringLabel = false;
      this.setLabelTimeout();
    }
  }, {
    key: "setSelection",
    value: function setSelection(selection) {
      this.clearSelection();

      if (selection) {
        var anchor = selection[0] - 1;
        var focus = selection[1] - 1;

        if (anchor !== focus) {
          var start = Math.min(anchor, focus);
          var end = Math.max(anchor, focus);
          var from = this.codeMirror.posFromIndex(start);
          var to = this.codeMirror.posFromIndex(end);
          this.selection = this.codeMirror.markText(from, to, this.selectionOptions);
        }
      }
    }
  }, {
    key: "clearSelection",
    value: function clearSelection() {
      if (this.selection) {
        this.selection.clear();
        this.selection = null;
      }
    }
  }, {
    key: "setSelectionTimeout",
    value: function setSelectionTimeout() {
      this.clearSelectionTimeout();
      this.selectionTimeoutHandle = setTimeout(this.onSelectionTimeout, selectionTimeout);
    }
  }, {
    key: "clearSelectionTimeout",
    value: function clearSelectionTimeout() {
      if (this.selectionTimeoutHandle) {
        clearTimeout(this.selectionTimeoutHandle);
        this.selectionTimeoutHandle = null;
      }
    }
  }, {
    key: "onSelectionTimeout",
    value: function onSelectionTimeout() {
      this.clearSelectionTimeout();
      this.clearSelection();
    }
  }, {
    key: "label",
    get: function get() {
      return this._label;
    },
    set: function set(label) {
      this._label = '' + label;
      this.textNode.data = this.label;
    }
  }, {
    key: "avatar",
    get: function get() {
      return this._avatar;
    },
    set: function set(avatar) {
      this._avatar = '' + avatar;

      if (this.avatar) {
        this.avatarNode.style.display = '';
        this.avatarNode.setAttribute('src', this.avatar);
      } else {
        this.avatarNode.style.display = 'none';
        this.avatarNode.removeAttribute('src');
      }
    }
  }, {
    key: "selectionExpired",
    get: function get() {
      return this.selectionTimeoutHandle === null;
    }
  }]);

  return CodeMirrorPresence;
}(events__WEBPACK_IMPORTED_MODULE_6__["EventEmitter"]);
var labelTimeout = 1000; // ms

var selectionTimeout = 20000; // ms

var scrollIntoViewMargin = 50; // px

/***/ }),

/***/ "./src/codeMirror/CodeMirrorSync.js":
/*!******************************************!*\
  !*** ./src/codeMirror/CodeMirrorSync.js ***!
  \******************************************/
/*! exports provided: CodeMirrorSync */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CodeMirrorSync", function() { return CodeMirrorSync; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "./node_modules/@babel/runtime/helpers/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @teamwork/ot-rich-text/lib/Action */ "./node_modules/@teamwork/ot-rich-text/lib/Action.js");
/* harmony import */ var _teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _teamwork_ot_rich_text_lib_Operation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @teamwork/ot-rich-text/lib/Operation */ "./node_modules/@teamwork/ot-rich-text/lib/Operation.js");
/* harmony import */ var _teamwork_ot_rich_text_lib_Operation__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_teamwork_ot_rich_text_lib_Operation__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var events__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! events */ "./node_modules/events/events.js");
/* harmony import */ var events__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(events__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! lodash.throttle */ "./node_modules/lodash.throttle/index.js");
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _CodeMirrorPresence__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./CodeMirrorPresence */ "./src/codeMirror/CodeMirrorPresence.js");











var CodeMirrorSync =
/*#__PURE__*/
function (_EventEmitter) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(CodeMirrorSync, _EventEmitter);

  function CodeMirrorSync(_ref) {
    var _this;

    var codeMirror = _ref.codeMirror,
        doc = _ref.doc,
        _ref$presenceDelay = _ref.presenceDelay,
        presenceDelay = _ref$presenceDelay === void 0 ? 500 : _ref$presenceDelay;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, CodeMirrorSync);

    _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(CodeMirrorSync).call(this));
    _this.codeMirror = codeMirror;
    _this.doc = doc;
    _this.undoManager = doc.connection.createUndoManager();
    _this.settingEditorContent = false;
    _this.lastSelection = null;
    _this.changeNumber = 0;
    _this.presence = Object.create(null);
    _this.rootNodeOpen = null;
    _this.rootNodeClose = null;
    _this.scheduleSubmitPresence = lodash_throttle__WEBPACK_IMPORTED_MODULE_9___default()(_this.submitPresence.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this)), presenceDelay, {
      leading: false
    });
    _this.onLoad = _this.onLoad.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this));
    _this.onOperation = _this.onOperation.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this));
    _this.onPresence = _this.onPresence.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this));
    _this.onBeforeChange = _this.onBeforeChange.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this));
    _this.onChange = _this.onChange.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this));
    _this.onCursorActivity = _this.onCursorActivity.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this));

    _this.doc.on('load', _this.onLoad);

    _this.doc.on('op', _this.onOperation);

    _this.doc.on('presence', _this.onPresence);

    _this.codeMirror.doc.on('beforeChange', _this.onBeforeChange);

    _this.codeMirror.doc.on('change', _this.onChange);

    _this.codeMirror.doc.on('cursorActivity', _this.onCursorActivity);

    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(CodeMirrorSync, [{
    key: "dispose",
    value: function dispose() {
      this.doc.removeListener('load', this.onLoad);
      this.doc.removeListener('op', this.onOperation);
      this.doc.removeListener('presence', this.onPresence);
      this.codeMirror.doc.off('beforeChange', this.onBeforeChange);
      this.codeMirror.doc.off('change', this.onChange);
      this.codeMirror.doc.off('cursorActivity', this.onCursorActivity);
      this.scheduleSubmitPresence.cancel();
    }
  }, {
    key: "canUndo",
    value: function canUndo() {
      return this.undoManager.canUndo();
    }
  }, {
    key: "undo",
    value: function undo() {
      this.undoManager.undo({
        source: 'undo'
      });
    }
  }, {
    key: "canRedo",
    value: function canRedo() {
      return this.undoManager.canRedo();
    }
  }, {
    key: "redo",
    value: function redo() {
      this.undoManager.redo({
        source: 'redo'
      });
    }
  }, {
    key: "onLoad",
    value: function onLoad() {
      if (this.doc.data == null) {
        this.doc.create(this.getContent(), 'ot-rich-text');
      }

      this.setContent(this.doc.data);
      this.setSelection({
        anchor: 0,
        focus: 0
      });
      this.doc.submitSnapshot(this.getContent(), {
        fixUp: true,
        skipNoop: true,
        source: 'script'
      });
    }
  }, {
    key: "onOperation",
    value: function onOperation(operation, source) {
      if (source === 'undo' || source === 'redo') {
        this.updateContent(operation) || this.setContent(this.doc.data);
        this.setSelection(getSelectionFromOperation(operation));
        this.codeMirror.scrollIntoView();
      } else if (source !== 'user') {
        var selection = this.getSelection();
        var editPosition = getEditPosition(operation);

        var _this$codeMirror$getS = this.codeMirror.getScrollInfo(),
            top = _this$codeMirror$getS.top,
            oldHeight = _this$codeMirror$getS.height;

        this.updateContent(operation) || this.setContent(this.doc.data);
        this.setSelection(transformSelection(selection, operation));

        if (selection.focus < editPosition) {
          this.codeMirror.scrollTo(null, top);
        } else {
          var _this$codeMirror$getS2 = this.codeMirror.getScrollInfo(),
              newHeight = _this$codeMirror$getS2.height;

          this.codeMirror.scrollTo(null, top + newHeight - oldHeight);
        }
      } // Let other users know that we changed the document.


      if (source === 'user' || source === 'undo' || source === 'redo') {
        this.changeNumber++;
        this.submitPresence();
      }

      this.doc.submitSnapshot(this.getContent(), {
        fixUp: true,
        skipNoop: true,
        source: 'script'
      });
    }
  }, {
    key: "onPresence",
    value: function onPresence(srcList, submitted) {
      for (var i = 0, l = srcList.length; i < l; ++i) {
        var src = srcList[i];

        if (!src) {
          continue; // Ignore own presence.
        }

        var data = this.doc.presence[src];
        var presence = this.presence[src];

        if (data) {
          if (!presence) {
            presence = new _CodeMirrorPresence__WEBPACK_IMPORTED_MODULE_10__["CodeMirrorPresence"](this.codeMirror, src, data.u);
            this.presence[src] = presence;
            this.emit('presence', src, presence);
          }

          presence.update(data, submitted);
        } else {
          if (presence) {
            presence.destroy();
            delete this.presence[src];
            this.emit('presence', src, null);
          }
        }
      }
    }
  }, {
    key: "onBeforeChange",
    value: function onBeforeChange(_doc, _change) {
      if (this.settingEditorContent) {
        return;
      }

      this.lastSelection = this.getSelection();
    }
  }, {
    key: "onChange",
    value: function onChange(_doc, _change) {
      if (this.settingEditorContent) {
        return;
      }

      var lastSelection = this.lastSelection;
      var currentSelection = this.getSelection();
      var lastAnchor = lastSelection.anchor,
          lastFocus = lastSelection.focus;
      var currentAnchor = currentSelection.anchor,
          currentFocus = currentSelection.focus;
      var lastStart = Math.min(lastAnchor, lastFocus);
      var lastEnd = Math.max(lastAnchor, lastFocus);
      var currentStart = Math.min(currentAnchor, currentFocus);
      var currentEnd = Math.max(currentAnchor, currentFocus);
      var diffHint = {
        oldRange: lastStart < 0 ? null : {
          index: lastStart,
          length: lastEnd - lastStart
        },
        newRange: currentStart < 0 ? null : {
          index: currentStart,
          length: currentEnd - currentStart
        }
      };
      this.doc.submitSnapshot(this.getContent(), {
        diffHint: diffHint,
        skipNoop: true,
        source: 'user',
        undoable: true
      });
    }
  }, {
    key: "onCursorActivity",
    value: function onCursorActivity() {
      if (this.settingEditorContent) {
        return;
      }

      this.scheduleSubmitPresence();
    }
  }, {
    key: "submitPresence",
    value: function submitPresence() {
      if (this.doc.data == null) {
        this.doc.submitPresence(null);
        return;
      }

      var selection = this.getSelection();
      this.doc.submitPresence({
        u: '',
        c: this.changeNumber,
        s: [[selection.anchor, selection.focus]]
      });
    }
  }, {
    key: "getContent",
    value: function getContent() {
      if (!this.rootNodeOpen) {
        this.rootNodeOpen = defaultRootOpen;
        this.rootNodeClose = defaultRootClose;
      }

      var model = [];
      model.push(this.rootNodeOpen);
      this.codeMirror.doc.eachLine(function (_ref2) {
        var text = _ref2.text;

        if (text) {
          model.push(Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__["createInsertText"])(text));
        }

        model.push(newLineEmbed);
      }); // Remove the redundant new line.

      model.pop();
      model.push(this.rootNodeClose);
      return model;
    }
  }, {
    key: "setContent",
    value: function setContent(model) {
      try {
        this.settingEditorContent = true;

        if (model.length > 0) {
          var rootNodeOpen = model[0];
          var rootNodeClose = model[model.length - 1];
          this.rootNodeOpen = Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__["isInsertOpen"])(rootNodeOpen) && Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__["getNodeName"])(rootNodeOpen) === '#root' ? rootNodeOpen : defaultRootOpen;
          this.rootNodeClose = Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__["isInsertClose"])(rootNodeClose) && Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__["getNodeName"])(rootNodeClose) === '#root' ? rootNodeClose : defaultRootClose;
        } else {
          this.rootNodeOpen = defaultRootOpen;
          this.rootNodeClose = defaultRootClose;
        }

        var text = '';

        for (var i = 0, l = model.length; i < l; ++i) {
          var action = model[i];

          if (Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__["isInsertText"])(action)) {
            text += Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__["getText"])(action);
          } else if (isValidNewLine(action)) {
            text += '\n';
          }
        }

        this.codeMirror.doc.setValue(text);
      } finally {
        this.settingEditorContent = false;
      }
    }
    /**
     * Updates the editor's content based on simple operations only.
     * Returns true, if content was updated, otherwise false.
     */

  }, {
    key: "updateContent",
    value: function updateContent(operation) {
      try {
        this.settingEditorContent = true;
        var offset;
        var action;

        if (operation.length === 2) {
          if (Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__["isRetain"])(operation[0]) && !Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__["hasAttributes"])(operation[0]) && Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__["getLength"])(operation[0]) > 0) {
            offset = Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__["getLength"])(operation[0]) - 1;
            action = operation[1];
          } else {
            return false;
          }
        } else {
          return false;
        }

        if (isValidText(action)) {
          this.codeMirror.replaceRange(Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__["getText"])(action), this.codeMirror.posFromIndex(offset));
          return true;
        } else if (isValidNewLine(action)) {
          this.codeMirror.replaceRange('\n', this.codeMirror.posFromIndex(offset));
          return true;
        } else if (Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__["isDelete"])(action)) {
          this.codeMirror.replaceRange('', this.codeMirror.posFromIndex(offset), this.codeMirror.posFromIndex(offset + Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__["getLength"])(action)));
          return true;
        } else {
          return false;
        }
      } finally {
        this.settingEditorContent = false;
      }
    }
    /**
     * Gets the primary selection as a pair of document offsets.
     */

  }, {
    key: "getSelection",
    value: function getSelection() {
      return {
        anchor: this.codeMirror.doc.indexFromPos(this.codeMirror.doc.getCursor('anchor')) + 1,
        focus: this.codeMirror.doc.indexFromPos(this.codeMirror.doc.getCursor('head')) + 1
      };
    }
    /**
     * Sets the selection to a pair of document offsets.
     */

  }, {
    key: "setSelection",
    value: function setSelection(_ref3) {
      var anchor = _ref3.anchor,
          focus = _ref3.focus;
      this.codeMirror.doc.setSelection(this.codeMirror.doc.posFromIndex(anchor - 1), this.codeMirror.doc.posFromIndex(focus - 1), noScroll);
    }
  }, {
    key: "getRootAttribute",
    value: function getRootAttribute(attributeName) {
      if (typeof attributeName !== 'string') {
        throw new Error('attributeName must be a string');
      }

      var attributeValue = this.doc.data && this.doc.data.length > 0 && Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__["isInsertOpen"])(this.doc.data[0]) && Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__["getNodeName"])(this.doc.data[0]) === '#root' ? Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__["getAttribute"])(this.doc.data[0], attributeName) : null;
      return typeof attributeValue === 'string' ? attributeValue : null;
    }
  }, {
    key: "setRootAttribute",
    value: function setRootAttribute(attributeName, attributeValue) {
      if (typeof attributeName !== 'string') {
        throw new Error('attributeName must be a string');
      }

      if (typeof attributeValue !== 'string' && attributeValue !== null) {
        throw new Error('attributeValue must be a string or null');
      }

      var operation = [Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__["createRetain"])(1, [attributeName, attributeValue])];
      this.doc.submitOp(operation, {
        undoable: false,
        source: 'script'
      });
    }
  }, {
    key: "contentToOtModel",
    value: function contentToOtModel(text) {
      var model = [defaultRootOpen];
      var lines = text.split(/\r\n|\n|\r/);

      for (var i = 0, l = lines.length; i < l; ++i) {
        var line = lines[i];

        if (line) {
          model.push(Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__["createInsertText"])(line));
        }

        model.push(newLineEmbed);
      } // Remove the redundant new line.


      model.pop();
      model.push(defaultRootClose);
      return model;
    }
  }]);

  return CodeMirrorSync;
}(events__WEBPACK_IMPORTED_MODULE_8__["EventEmitter"]);
var defaultRootOpen = Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__["createInsertOpen"])("\uE000#root");
var defaultRootClose = Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__["createInsertClose"])("\uE000#root");
var newLineEmbed = Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__["createInsertEmbed"])("\uE000BR");
var noScroll = {
  scroll: false
};

function isValidText(action) {
  return Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__["isInsertText"])(action) && !/[\r\n]/.test(Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__["getText"])(action));
}

function isValidNewLine(action) {
  return Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__["isInsertEmbed"])(action) && Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__["getNodeName"])(action) === 'BR';
}

function transformSelection(_ref4, operation) {
  var anchor = _ref4.anchor,
      focus = _ref4.focus;
  var newAnchor = anchor < 0 ? anchor : Object(_teamwork_ot_rich_text_lib_Operation__WEBPACK_IMPORTED_MODULE_7__["transformCursor"])(anchor, operation, false);
  var newFocus = anchor === focus ? newAnchor : focus < 0 ? focus : Object(_teamwork_ot_rich_text_lib_Operation__WEBPACK_IMPORTED_MODULE_7__["transformCursor"])(focus, operation, false);
  return {
    anchor: newAnchor,
    focus: newFocus
  };
}

function getEditPosition(operation) {
  var position = 0;

  for (var i = 0, l = operation.length; i < l; ++i) {
    var action = operation[i];

    if (Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__["isRetain"])(action)) {
      position += Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__["getLength"])(action);
    } else {
      break;
    }
  }

  return position;
} // This function approximates the previous selection after undo/redo operations.
// Selections will eventually be stored on the undo/redo stacks,
// at which point this function won't be needed.


function getSelectionFromOperation(operation) {
  var position = 0;

  for (var i = 0, l = operation.length; i < l; ++i) {
    var action = operation[i];

    if (Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__["isInsert"])(action) || Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__["isRetain"])(action)) {
      position += Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_6__["getLength"])(action);
    }
  }

  return {
    anchor: position,
    focus: position
  };
}

/***/ }),

/***/ "./src/codeMirror/plugin.js":
/*!**********************************!*\
  !*** ./src/codeMirror/plugin.js ***!
  \**********************************/
/*! exports provided: register */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "register", function() { return register; });
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "./node_modules/@babel/runtime/helpers/typeof.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _OtClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../OtClient */ "./src/OtClient.js");


function register(CodeMirror) {
  CodeMirror.commands.undo = undo;
  CodeMirror.commands.redo = redo;
  CodeMirror.defineOption('ot', null, function (codeMirror, option) {
    if (codeMirror.ot) {
      codeMirror.setOption('undoDepth', 200);
      codeMirror.ot.client.dispose();
      codeMirror.ot = null;
    }

    if (_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_0___default()(option) === 'object' && option !== null) {
      codeMirror.setOption('undoDepth', 0);
      codeMirror.ot = {
        client: new _OtClient__WEBPACK_IMPORTED_MODULE_1__["OtClient"]({
          codeMirror: codeMirror,
          collectionName: option.collectionName,
          documentId: option.documentId,
          url: option.url,
          getAccessToken: option.getAccessToken,
          shouldConnect: option.shouldConnect,
          betaAuth: option.betaAuth
        })
      };
    }
  });
}

function undo(codeMirror) {
  if (codeMirror.ot) {
    codeMirror.ot.client.undo();
  } else {
    codeMirror.undo();
  }
}

function redo(codeMirror) {
  if (codeMirror.ot) {
    codeMirror.ot.client.redo();
  } else {
    codeMirror.redo();
  }
}

/***/ }),

/***/ "./src/components/AComponent.js":
/*!**************************************!*\
  !*** ./src/components/AComponent.js ***!
  \**************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/wrapNativeSuper */ "./node_modules/@babel/runtime/helpers/wrapNativeSuper.js");
/* harmony import */ var _babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_5__);






var invalidHrefRegex = /^\s*(javascript:|data:)/i;

function define() {
  var w = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;

  if (w.customElements.get('ot-built-in-a')) {
    return;
  }

  var originalHTMLAnchorElement = window.HTMLAnchorElement;
  window.HTMLAnchorElement = w.HTMLAnchorElement;

  var AComponent =
  /*#__PURE__*/
  function (_HTMLAnchorElement) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(AComponent, _HTMLAnchorElement);

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(AComponent, null, [{
      key: "observedAttributes",
      get: function get() {
        return ['href'];
      }
    }]);

    function AComponent(self) {
      var _this;

      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, AComponent);

      // Keep the custom elements polyfill happy.
      // See https://github.com/WebReflection/document-register-element#upgrading-the-constructor-context.
      self = _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2___default()(AComponent).call(this, self));
      return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default()(_this, self);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(AComponent, [{
      key: "init",
      value: function init() {
        this.updating = false;
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        this.fixHref();
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback() {
        if (!this.updating) {
          this.fixHref();
        }
      }
    }, {
      key: "fixHref",
      value: function fixHref() {
        if (invalidHrefRegex.test(this.getAttribute('href'))) {
          this.updating = true;
          this.setAttribute('href', '');
          this.updating = false;
        }
      }
    }]);

    return AComponent;
  }(_babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_5___default()(HTMLAnchorElement));

  window.HTMLAnchorElement = originalHTMLAnchorElement;
  w.customElements.define('ot-built-in-a', AComponent, {
    extends: 'a'
  });
}

/* harmony default export */ __webpack_exports__["default"] = ({
  define: define
});

/***/ }),

/***/ "./src/components/HeadingComponent.js":
/*!********************************************!*\
  !*** ./src/components/HeadingComponent.js ***!
  \********************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/wrapNativeSuper */ "./node_modules/@babel/runtime/helpers/wrapNativeSuper.js");
/* harmony import */ var _babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _util_misc__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../util/misc */ "./src/util/misc.js");







var observerConfig = {
  childList: true,
  characterData: true,
  subtree: true
};

var defineOne = function defineOne(w) {
  return function (h) {
    if (w.customElements.get("ot-built-in-".concat(h))) {
      return;
    }

    var originalHTMLHeadingElement = window.HTMLHeadingElement;
    window.HTMLHeadingElement = w.HTMLHeadingElement;

    var HeadingComponent =
    /*#__PURE__*/
    function (_HTMLHeadingElement) {
      _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(HeadingComponent, _HTMLHeadingElement);

      _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(HeadingComponent, [{
        key: "rootNode",
        get: function get() {
          var node = this;

          while ((!node[_util_misc__WEBPACK_IMPORTED_MODULE_6__["vNodeKey"]] || node[_util_misc__WEBPACK_IMPORTED_MODULE_6__["vNodeKey"]].nodeName !== '#root') && node.parentNode) {
            node = node.parentNode;
          }

          return node;
        }
      }], [{
        key: "observedAttributes",
        get: function get() {
          return ['id', 'data-ot-auto-id'];
        }
      }]);

      function HeadingComponent(self) {
        var _this;

        _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, HeadingComponent);

        // Keep the custom elements polyfill happy.
        // See https://github.com/WebReflection/document-register-element#upgrading-the-constructor-context.
        self = _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2___default()(HeadingComponent).call(this, self));
        return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default()(_this, self);
      }

      _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(HeadingComponent, [{
        key: "init",
        value: function init() {
          var _this2 = this;

          this.anchorNode = null;
          this._connected = false;
          this._observer = new this.ownerDocument.defaultView.MutationObserver(function () {
            if (_this2._connected) {
              _this2.updateId();
            }
          });
        }
      }, {
        key: "connectedCallback",
        value: function connectedCallback() {
          var _this3 = this;

          this._observer.observe(this, observerConfig);

          this._connected = true;
          Object(_util_misc__WEBPACK_IMPORTED_MODULE_6__["nextTick"])(function () {
            if (_this3._connected) {
              _this3.updateId();

              _this3.updateAnchorNode();
            }
          });
        }
      }, {
        key: "disconnectedCallback",
        value: function disconnectedCallback() {
          this._connected = false;

          this._observer.disconnect();

          this.removeAnchorNode();
        }
      }, {
        key: "attributeChangedCallback",
        value: function attributeChangedCallback(attributeName) {
          if (this._connected) {
            if (attributeName === 'data-ot-auto-id') {
              this.updateId();
            } else if (attributeName === 'id') {
              this.updateId(); // Update ID just in case it was set to a wrong value.

              this.updateAnchorNode();
            }
          }
        }
      }, {
        key: "updateId",
        value: function updateId() {
          var autoId = this.getAttribute('data-ot-auto-id');

          if (autoId === 'false') {
            // Never generate.
            return;
          }

          var currentId = this.getAttribute('id');

          if (autoId !== 'true') {
            if (currentId) {
              // Don't generate, as we already have an id.
              if (autoId !== null) {
                // Remove unnecessary attribute.
                this.removeAttribute('data-ot-auto-id');
              }

              return;
            } // Fix attribute value.


            this.setAttribute('data-ot-auto-id', 'true');
          }

          var node;
          var rootNode = this.rootNode; // Get all text in heading.

          var id = Object(_util_misc__WEBPACK_IMPORTED_MODULE_6__["getTextContent"])(this); // Remove some common punctuation characters.
          // https://stackoverflow.com/a/4328722/706807

          id = id.replace(/[~`!@#%^&*(){}[\];:"'<,.>?/\\|_+=-]/g, ''); // Remove white space from start and end.

          id = id.trim(); // Replace white space with '-'.

          id = id.replace(/\s+/g, '-'); // Ensure it's not empty.

          id = id || 'content'; // Make it lowercase.

          id = id.toLowerCase();

          if ((node = rootNode.querySelector("[id='".concat(id, "']"))) && node !== this) {
            var suffixNumber = 1;
            var idWithSuffix;

            do {
              idWithSuffix = id + '-' + suffixNumber++;
            } while ((node = rootNode.querySelector("[id='".concat(idWithSuffix, "']"))) && node !== this);

            id = idWithSuffix;
          }

          if (id !== currentId) {
            this.setAttribute('id', id);
          }
        }
      }, {
        key: "updateAnchorNode",
        value: function updateAnchorNode() {
          if (!this.anchorNode) {
            if (this.firstChild && this.firstChild.nodeName === 'A' && this.firstChild.getAttribute('data-mce-bogus') === 'all' && this.firstChild.classList.contains('ot-anchor')) {
              this.anchorNode = this.firstChild;
            } else {
              this.anchorNode = this.ownerDocument.createElement('A');
              this.anchorNode.classList.add('ot-anchor');
              this.anchorNode.setAttribute('data-mce-bogus', 'all');
            }
          }

          var id = this.getAttribute('id');

          if (id) {
            this.anchorNode.setAttribute('href', "#".concat(id));

            if (this.firstChild !== this.anchorNode) {
              this.insertBefore(this.anchorNode, this.firstChild);
            }
          } else if (this.anchorNode.parentNode) {
            this.anchorNode.parentNode.removeChild(this.anchorNode);
          }
        }
      }, {
        key: "removeAnchorNode",
        value: function removeAnchorNode() {
          if (this.anchorNode) {
            if (this.anchorNode.parentNode) {
              this.anchorNode.parentNode.removeChild(this.anchorNode);
            }

            this.anchorNode = null;
          }
        }
      }]);

      return HeadingComponent;
    }(_babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_5___default()(HTMLHeadingElement));

    window.HTMLHeadingElement = originalHTMLHeadingElement;
    w.customElements.define("ot-built-in-".concat(h), HeadingComponent, {
      extends: h
    });
  };
};

function define() {
  var w = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
  ;
  ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].forEach(defineOne(w));
}

/* harmony default export */ __webpack_exports__["default"] = ({
  define: define
});

/***/ }),

/***/ "./src/components/IFrameComponent.js":
/*!*******************************************!*\
  !*** ./src/components/IFrameComponent.js ***!
  \*******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/wrapNativeSuper */ "./node_modules/@babel/runtime/helpers/wrapNativeSuper.js");
/* harmony import */ var _babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_5__);






var invalidSrcRegex = /^\s*(javascript:|data:)/i;

function define() {
  var w = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;

  if (w.customElements.get('ot-built-in-iframe')) {
    return;
  }

  var originalHTMLIFrameElement = window.HTMLIFrameElement;
  window.HTMLIFrameElement = w.HTMLIFrameElement;

  var IFrameComponent =
  /*#__PURE__*/
  function (_HTMLIFrameElement) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(IFrameComponent, _HTMLIFrameElement);

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(IFrameComponent, null, [{
      key: "observedAttributes",
      get: function get() {
        return ['src'];
      }
    }]);

    function IFrameComponent(self) {
      var _this;

      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, IFrameComponent);

      // Keep the custom elements polyfill happy.
      // See https://github.com/WebReflection/document-register-element#upgrading-the-constructor-context.
      self = _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2___default()(IFrameComponent).call(this, self));
      return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default()(_this, self);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(IFrameComponent, [{
      key: "init",
      value: function init() {
        this.updating = false;
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        // Set contenteditable=false to improve UX in TinyMCE.
        this.setAttribute('contenteditable', 'false');
        this.fixSrc();
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback() {
        if (!this.updating) {
          this.fixSrc();
        }
      }
    }, {
      key: "fixSrc",
      value: function fixSrc() {
        if (invalidSrcRegex.test(this.getAttribute('src'))) {
          this.updating = true;
          this.setAttribute('src', '');
          this.updating = false;
        }
      }
    }]);

    return IFrameComponent;
  }(_babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_5___default()(HTMLIFrameElement));

  window.HTMLIFrameElement = originalHTMLIFrameElement;
  w.customElements.define('ot-built-in-iframe', IFrameComponent, {
    extends: 'iframe'
  });
}

/* harmony default export */ __webpack_exports__["default"] = ({
  define: define
});

/***/ }),

/***/ "./src/components/ImgComponent.js":
/*!****************************************!*\
  !*** ./src/components/ImgComponent.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/wrapNativeSuper */ "./node_modules/@babel/runtime/helpers/wrapNativeSuper.js");
/* harmony import */ var _babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_5__);






var invalidSrcRegex = /^\s*(blob:|javascript:|data:(?!image\/))/i;
var blobSrcRegex = /^\s*blob:/i;
var mutationObservers = new WeakMap();
var observerOptions = {
  attributes: true,
  attributeFilter: ['src', 'width', 'height', 'data-ot-src', 'data-ot-width', 'data-ot-height']
};

function handleMutations(mutations) {
  var syncFromOtMap = new Map();

  for (var i = 0, l = mutations.length; i < l; ++i) {
    var _mutations$i = mutations[i],
        target = _mutations$i.target,
        attributeName = _mutations$i.attributeName;

    if (attributeName === 'data-ot-src' || attributeName === 'data-ot-width' || attributeName === 'data-ot-height') {
      syncFromOtMap.set(target, true);
    } else if (!syncFromOtMap.has(target)) {
      syncFromOtMap.set(target, false);
    }
  }

  syncFromOtMap.forEach(function (syncFromOt, target) {
    if (syncFromOt) {
      target.syncFromOt();
    } else {
      target.syncToOt();
    }
  });
}

function define() {
  var w = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;

  if (w.customElements.get('ot-built-in-img')) {
    return;
  }

  var originalHTMLImageElement = window.HTMLImageElement;
  window.HTMLImageElement = w.HTMLImageElement;

  var ImgComponent =
  /*#__PURE__*/
  function (_HTMLImageElement) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(ImgComponent, _HTMLImageElement);

    function ImgComponent(self) {
      var _this;

      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, ImgComponent);

      // Keep the custom elements polyfill happy.
      // See https://github.com/WebReflection/document-register-element#upgrading-the-constructor-context.
      self = _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(ImgComponent).call(this, self));
      return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(_this, self);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(ImgComponent, [{
      key: "init",
      value: function init() {
        var window = this.ownerDocument.defaultView;
        var observer = mutationObservers.get(window);

        if (!observer) {
          observer = new window.MutationObserver(handleMutations);
          mutationObservers.set(window, observer);
        } // We a `MutationObserver` instead of `attributeChangedCallback` to ensure asynchronous change handling,
        // so that the order in which the attributes are updated does not affect the correcness of the algorithm.


        observer.observe(this, observerOptions);
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        if (this.hasAttribute('data-ot-src') || this.hasAttribute('data-ot-width') || this.hasAttribute('data-ot-height')) {
          this.syncFromOt();
        } else {
          this.syncToOt();
        }
      }
    }, {
      key: "syncFromOt",
      value: function syncFromOt() {
        var src = this.getAttribute('data-ot-src');

        if (invalidSrcRegex.test(src)) {
          this.setAttribute('data-ot-src', '');
        }

        this.syncAttribute('data-ot-src', 'src');
        this.syncAttribute('data-ot-width', 'width');
        this.syncAttribute('data-ot-height', 'height');
      }
    }, {
      key: "syncToOt",
      value: function syncToOt() {
        var src = this.getAttribute('src');

        if (blobSrcRegex.test(src)) {
          return;
        }

        if (invalidSrcRegex.test(src)) {
          this.setAttribute('src', '');
        }

        this.syncAttribute('src', 'data-ot-src');
        this.syncAttribute('width', 'data-ot-width');
        this.syncAttribute('height', 'data-ot-height');
      }
    }, {
      key: "syncAttribute",
      value: function syncAttribute(sourceName, destinationName) {
        var sourceValue = this.getAttribute(sourceName);
        var destinationValue = this.getAttribute(destinationName);

        if (sourceValue !== destinationValue) {
          if (sourceValue === null) {
            this.removeAttribute(destinationName);
          } else {
            this.setAttribute(destinationName, sourceValue);
          }
        }
      }
    }]);

    return ImgComponent;
  }(_babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_5___default()(HTMLImageElement));

  window.HTMLImageElement = originalHTMLImageElement;
  w.customElements.define('ot-built-in-img', ImgComponent, {
    extends: 'img'
  });
}

/* harmony default export */ __webpack_exports__["default"] = ({
  define: define
});

/***/ }),

/***/ "./src/components/PreComponent.js":
/*!****************************************!*\
  !*** ./src/components/PreComponent.js ***!
  \****************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/wrapNativeSuper */ "./node_modules/@babel/runtime/helpers/wrapNativeSuper.js");
/* harmony import */ var _babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_5__);






var mutationObserverConfig = {
  childList: true,
  attributes: true,
  characterData: true,
  subtree: true,
  attributeFilter: ['data-content', 'data-language', 'class']
};

var normalizeLanguage = function normalizeLanguage(language) {
  return typeof language === 'string' && /^\w+$/.test(language) ? language : 'undefined';
};

var normalizeContent = function normalizeContent(content) {
  return (// Remove zero-width (breaking and non-breaking) white space.
    // They are sometimes added by TinyMCE, probably as a result of a bug.
    typeof content === 'string' ? content.replace(/[\uFEFF\u200B]/g, '') : ''
  );
};

var classNameToLanguage = function classNameToLanguage(className) {
  if (typeof className === 'string') {
    var match = /(?:^|\s)language-(\w+)(?:$|\s)/.exec(className);

    if (match) {
      return match[1];
    }
  }

  return 'undefined';
};

var languageToClassName = function languageToClassName(language) {
  return 'language-' + language;
};

function define() {
  var w = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;

  if (w.customElements.get('ot-built-in-pre')) {
    return;
  }

  var originalHTMLPreElement = window.HTMLPreElement;
  window.HTMLPreElement = w.HTMLPreElement;

  var PreComponent =
  /*#__PURE__*/
  function (_HTMLPreElement) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(PreComponent, _HTMLPreElement);

    function PreComponent(self) {
      var _this;

      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, PreComponent);

      // Keep the custom elements polyfill happy.
      // See https://github.com/WebReflection/document-register-element#upgrading-the-constructor-context.
      self = _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(PreComponent).call(this, self));
      return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(_this, self);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(PreComponent, [{
      key: "init",
      value: function init() {
        var _this2 = this;

        this.observer = new this.ownerDocument.defaultView.MutationObserver(function (mutations) {
          return _this2.mutationsCallback(mutations);
        });
      }
    }, {
      key: "watch",
      value: function watch() {
        this.observer.observe(this, mutationObserverConfig);
      }
    }, {
      key: "unwatch",
      value: function unwatch() {
        this.observer.disconnect();
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        if (this.parentNode.hasAttribute('data-mce-bogus')) {
          // Do nothing, if in a TinyMCE bogus node.
          return;
        }

        var content = this.getAttribute('data-content');
        var language = this.getAttribute('data-language');
        var normalizedContent = content !== null ? normalizeContent(content) : normalizeContent(this.textContent);
        var normalizedLanguage = language !== null ? normalizeLanguage(language) : classNameToLanguage(this.getAttribute('class'));
        this.setAttribute('contenteditable', 'false');
        this.setAttribute('data-content', normalizedContent);
        this.setAttribute('data-language', normalizedLanguage);
        this.highlightCode(normalizedContent, normalizedLanguage);
        this.watch();
      }
    }, {
      key: "disconnectedCallback",
      value: function disconnectedCallback() {
        this.unwatch();
      }
    }, {
      key: "mutationsCallback",
      value: function mutationsCallback(mutations) {
        this.unwatch();
        var textContentChanged = false;
        var contentAttributeChanged = false;
        var classAttributeChanged = false;
        var languageAttributeChanged = false;

        for (var i = 0, l = mutations.length; i < l; ++i) {
          var _mutations$i = mutations[i],
              type = _mutations$i.type,
              target = _mutations$i.target,
              attributeName = _mutations$i.attributeName;

          if (type === 'characterData' || type === 'childList') {
            textContentChanged = true;
          } else if (type === 'attributes' && target === this) {
            if (attributeName === 'data-content') {
              contentAttributeChanged = true;
            } else if (attributeName === 'data-language') {
              languageAttributeChanged = true;
            } else if (attributeName === 'class') {
              classAttributeChanged = true;
            }
          }
        }

        if (textContentChanged || contentAttributeChanged || classAttributeChanged || languageAttributeChanged) {
          var content = contentAttributeChanged || !textContentChanged ? normalizeContent(this.getAttribute('data-content')) : normalizeContent(this.textContent);
          var language = languageAttributeChanged || !classAttributeChanged ? normalizeLanguage(this.getAttribute('data-language')) : classNameToLanguage(this.getAttribute('class'));
          this.setAttribute('data-content', content);
          this.setAttribute('data-language', language);
          this.highlightCode(content, language);
        }

        this.watch();
      }
    }, {
      key: "highlightCode",
      value: function highlightCode(content, language) {
        var Prism = window.Prism;
        this.setAttribute('class', languageToClassName(language));

        if (Prism && language && Prism.languages[language]) {
          this.innerHTML = Prism.highlight(content, Prism.languages[language]);
        } else {
          this.textContent = content;
        }
      }
    }]);

    return PreComponent;
  }(_babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_5___default()(HTMLPreElement));

  window.HTMLPreElement = originalHTMLPreElement;
  w.customElements.define('ot-built-in-pre', PreComponent, {
    extends: 'pre'
  });
}

/* harmony default export */ __webpack_exports__["default"] = ({
  define: define
});

/***/ }),

/***/ "./src/components/VideoComponent.js":
/*!******************************************!*\
  !*** ./src/components/VideoComponent.js ***!
  \******************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/wrapNativeSuper */ "./node_modules/@babel/runtime/helpers/wrapNativeSuper.js");
/* harmony import */ var _babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_5__);






var invalidSrcRegex = /^\s*(javascript:|data:(?!video\/))/i;
var invalidPosterRegex = /^\s*(javascript:|data:(?!image\/))/i;

function define() {
  var w = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;

  if (w.customElements.get('ot-built-in-video')) {
    return;
  }

  var originalVideoHTMLElement = window.HTMLVideoElement;
  window.HTMLVideoElement = w.HTMLVideoElement;

  var VideoComponent =
  /*#__PURE__*/
  function (_HTMLVideoElement) {
    _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(VideoComponent, _HTMLVideoElement);

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(VideoComponent, null, [{
      key: "observedAttributes",
      get: function get() {
        return ['src', 'poster'];
      }
    }]);

    function VideoComponent(self) {
      var _this;

      _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, VideoComponent);

      // Keep the custom elements polyfill happy.
      // See https://github.com/WebReflection/document-register-element#upgrading-the-constructor-context.
      self = _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_2___default()(VideoComponent).call(this, self));
      return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_1___default()(_this, self);
    }

    _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_3___default()(VideoComponent, [{
      key: "init",
      value: function init() {
        this.updating = false;
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        this.setAttribute('contenteditable', 'false');
        this.fixAttribute('src');
        this.fixAttribute('poster');
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(name) {
        if (!this.updating) {
          this.fixAttribute(name);
        }
      }
    }, {
      key: "fixAttribute",
      value: function fixAttribute(name) {
        var value = this.getAttribute(name);
        var needsFixing = typeof value === 'string' && (name === 'src' ? invalidSrcRegex.test(value) : name === 'poster' ? invalidPosterRegex.test(value) : false);

        if (needsFixing) {
          this.updating = true;
          this.setAttribute(name, '');
          this.updating = false;
        }
      }
    }]);

    return VideoComponent;
  }(_babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_5___default()(HTMLVideoElement));

  window.HTMLVideoElement = originalVideoHTMLElement;
  w.customElements.define('ot-built-in-video', VideoComponent, {
    extends: 'video'
  });
}

/* harmony default export */ __webpack_exports__["default"] = ({
  define: define
});

/***/ }),

/***/ "./src/components/index.js":
/*!*********************************!*\
  !*** ./src/components/index.js ***!
  \*********************************/
/*! exports provided: registerComponents */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerComponents", function() { return registerComponents; });
/* harmony import */ var _AComponent__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./AComponent */ "./src/components/AComponent.js");
/* harmony import */ var _HeadingComponent__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./HeadingComponent */ "./src/components/HeadingComponent.js");
/* harmony import */ var _IFrameComponent__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./IFrameComponent */ "./src/components/IFrameComponent.js");
/* harmony import */ var _ImgComponent__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./ImgComponent */ "./src/components/ImgComponent.js");
/* harmony import */ var _PreComponent__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./PreComponent */ "./src/components/PreComponent.js");
/* harmony import */ var _VideoComponent__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./VideoComponent */ "./src/components/VideoComponent.js");






function registerComponents() {
  var w = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
  _AComponent__WEBPACK_IMPORTED_MODULE_0__["default"].define(w);
  _HeadingComponent__WEBPACK_IMPORTED_MODULE_1__["default"].define(w);
  _IFrameComponent__WEBPACK_IMPORTED_MODULE_2__["default"].define(w);
  _ImgComponent__WEBPACK_IMPORTED_MODULE_3__["default"].define(w);
  _PreComponent__WEBPACK_IMPORTED_MODULE_4__["default"].define(w);
  _VideoComponent__WEBPACK_IMPORTED_MODULE_5__["default"].define(w);
}

/***/ }),

/***/ "./src/config/Config.js":
/*!******************************!*\
  !*** ./src/config/Config.js ***!
  \******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Config; });
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _util_misc__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../util/misc */ "./src/util/misc.js");





var Config =
/*#__PURE__*/
function () {
  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(Config, null, [{
    key: "create",
    value: function create(params) {
      return new Config(params);
    }
  }]);

  function Config(params) {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, Config);

    var attributeAliasMap = params.attributeAliasMap ? params.attributeAliasMap.clone().freeze() : null;
    var childNodeAliasMap = params.childNodeAliasMap ? params.childNodeAliasMap.clone().freeze() : null;
    this.formats = Object.freeze(params.formats.map(function (format, index) {
      return format.clone().withIndex(index).freeze();
    }));
    this.nodes = Object.freeze(params.nodes.map(function (node) {
      node = node.clone();

      if (attributeAliasMap && node.attributeNames) {
        node.withAttributeNames(attributeAliasMap.resolveAll(node.attributeNames).sort());
      }

      if (childNodeAliasMap) {
        node.withValidChildNodes(childNodeAliasMap.resolveAll(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()(Object(_util_misc__WEBPACK_IMPORTED_MODULE_3__["toArray"])(node.validChildNodes))));

        if (node.invalidChildNodes) {
          node.withInvalidChildNodes(childNodeAliasMap.resolveAll(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()(Object(_util_misc__WEBPACK_IMPORTED_MODULE_3__["toArray"])(node.invalidChildNodes))));
        }
      }

      if (node.invalidChildNodes) {
        node.withValidChildNodes(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()(Object(_util_misc__WEBPACK_IMPORTED_MODULE_3__["toArray"])(node.validChildNodes)).filter(function (x) {
          return !node.invalidChildNodes.has(x);
        }));
        node.withInvalidChildNodes(null);
      }

      return node.freeze();
    }));

    this._createFormats();

    this._createNodes();

    this._validate();

    Object.freeze(this);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(Config, [{
    key: "_createFormats",
    value: function _createFormats() {
      var _this = this;

      this.formatsByDom = Object.create(null);
      this.formatsByOt = Object.create(null);
      this.formats.forEach(function (format) {
        if (_this.formatsByDom[format.domKey]) {
          throw new Error("this.formatsByDom[".concat(format.domKey, "] already exists"));
        }

        if (!format.deprecated) {
          if (_this.formatsByOt[format.otKey]) {
            throw new Error("this.formatsByOt[".concat(format.otKey, "] already exists"));
          }

          _this.formatsByOt[format.otKey] = format;
        }

        _this.formatsByDom[format.domKey] = format;
      });
      Object.freeze(this.formatsByDom);
      Object.freeze(this.formatsByOt);
    }
  }, {
    key: "_createNodes",
    value: function _createNodes() {
      var _this2 = this;

      var allNodeTypes = ['structure', 'embed', 'format', 'text', 'root', 'unknown'];
      this.configByNodeName = Object.create(null);
      this.nodes.forEach(function (config) {
        if (allNodeTypes.indexOf(config.nodeType) < 0) {
          throw new Error("Invalid nodeType ".concat(config.nodeType, " for ").concat(config.nodeName));
        }

        if (!_this2.configByNodeName[config.nodeName]) {
          _this2.configByNodeName[config.nodeName] = {
            structure: null,
            embed: null,
            format: null,
            text: null,
            root: null,
            unknown: null,
            $default: config
          };
        } else if (_this2.configByNodeName[config.nodeName][config.nodeType]) {
          throw new Error("Config already exists for ".concat(config.nodeType, " ").concat(config.nodeName));
        }

        _this2.configByNodeName[config.nodeName][config.nodeType] = config;
      });
      Object.keys(this.configByNodeName).forEach(function (nodeName) {
        return Object.freeze(_this2.configByNodeName[nodeName]);
      });
      Object.freeze(this.configByNodeName);
    }
  }, {
    key: "_validate",
    value: function _validate() {
      var _this3 = this;

      // Prepare the expected format attribute names based on `this.formats`.
      var formatAttributeNames = Object.create(null);
      this.formats.forEach(function (format) {
        var attributeNames = formatAttributeNames[format.nodeName] = formatAttributeNames[format.nodeName] || [];

        if (format.attributeName && attributeNames.indexOf(format.attributeName) < 0) {
          attributeNames.push(format.attributeName);
          attributeNames.sort();
        }
      }); // These span attributes are necessary to support TinyMCE's way of typing text with formatting.

      var spanAttributeNames = formatAttributeNames['SPAN'] = formatAttributeNames['SPAN'] || [];
      var requiredSpanAttributeNames = ['@data-mce-bogus', '@data-mce-type', '@id'];
      requiredSpanAttributeNames.forEach(function (attributeName) {
        if (spanAttributeNames.indexOf(attributeName)) {
          spanAttributeNames.push(attributeName);
        }
      });
      spanAttributeNames.sort(); // Validate `attributeNames`.

      this.nodes.forEach(function (_ref) {
        var nodeType = _ref.nodeType,
            nodeName = _ref.nodeName,
            attributeNames = _ref.attributeNames;

        if (nodeType === 'text' || nodeType === 'unknown') {
          if (attributeNames !== null) {
            throw new Error('`attributeNames` must be null for a text node');
          }

          return;
        }

        if (!Array.isArray(attributeNames)) {
          throw new Error("'attributeNames' must be an Array for ".concat(nodeType, " ").concat(nodeName));
        }

        var previousAttributeName = '';

        for (var i = 0, l = attributeNames.length; i < l; ++i) {
          var attributeName = attributeNames[i];

          if (typeof attributeName !== 'string') {
            throw new Error("Attribute names must be of type \"string\" for ".concat(nodeType, " ").concat(nodeName));
          }

          if (attributeName === '@style') {
            throw new Error("'style' attribute must not be synchronized directly  for ".concat(nodeType, " ").concat(nodeName));
          }

          if (!/^(@[a-z][a-z0-9-]*=?|\$[a-z][a-z0-9-]*)$/.test(attributeName)) {
            throw new Error("Invalid attribute name '".concat(attributeName, "' for ").concat(nodeType, " ").concat(nodeName));
          }

          if (previousAttributeName && attributeName <= previousAttributeName) {
            throw new Error("Attribute names must be sorted and cannot contain duplicates for ".concat(nodeType, " ").concat(nodeName));
          }

          previousAttributeName = attributeName;
        }
      });
      var allNodeNames = Object.keys(this.configByNodeName);
      var formatNodeNames = Object.keys(formatAttributeNames); // Make sure that basic nodes are always defined.

      if (!this.configByNodeName['#root'] || !this.configByNodeName['#root']['root']) {
        throw new Error('#root must be defined');
      }

      if (!this.configByNodeName['#unknown'] || !this.configByNodeName['#unknown']['unknown']) {
        throw new Error('#unknown must be defined');
      }

      if (!this.configByNodeName['#text'] || !this.configByNodeName['#text']['text']) {
        throw new Error('#text must be defined');
      } // I wish this wasn't necessary, unfortunately, both the browser and TinyMCE add <BR> elements to ensure that
      // caret can be placed in certain empty elements. The same could be accomplished using simple styling but that's
      // not the chosen approach. :-( Maybe one day I'll figure out a way to avoid those bogus BRs...


      if (!this.configByNodeName['BR'] || !this.configByNodeName['BR']['embed']) {
        throw new Error('Embed BR must be defined');
      } // I wish it wasn't necessary, unfortunately, TinyMCE requires a SPAN with specific attributes, containing a
      // text node starting with \uFEFF, to support formatting.


      if (!this.configByNodeName['SPAN'] || !this.configByNodeName['SPAN']['format']) {
        throw new Error('Format SPAN must be defined');
      } // Check that all formats are properly represented in this.configByNodeName


      formatNodeNames.forEach(function (nodeName) {
        if (!_this3.configByNodeName[nodeName] || !_this3.configByNodeName[nodeName]['format']) {
          throw new Error("Config missing in nodes for format ".concat(nodeName));
        }

        var expectedAttributeNames = formatAttributeNames[nodeName];
        var actualAttributeNames = _this3.configByNodeName[nodeName]['format'].attributeNames;

        if (!actualAttributeNames || !Object(_util_misc__WEBPACK_IMPORTED_MODULE_3__["areArraysEqual"])(expectedAttributeNames, actualAttributeNames)) {
          throw new Error("Expected attributes in nodes for format ".concat(nodeName, " are ") + "".concat(JSON.stringify(expectedAttributeNames), " but found ").concat(JSON.stringify(actualAttributeNames)));
        }
      }); // Make sure that each node has at least one valid parent node.

      allNodeNames.forEach(function (childNodeName) {
        var hasValidParent = childNodeName === '#root' || childNodeName === '#unknown' || allNodeNames.some(function (parentNodeName) {
          return Object.keys(_this3.configByNodeName[parentNodeName]).some(function (parentNodeType) {
            return _this3.configByNodeName[parentNodeName][parentNodeType] && _this3.configByNodeName[parentNodeName][parentNodeType].validChildNodes.has(childNodeName);
          });
        });

        if (!hasValidParent) {
          throw new Error("".concat(childNodeName, " doesn't have any valid parent node."));
        }
      }); // Make sure all formats can be nested and can contain text.

      allNodeNames.forEach(function (parentNodeName) {
        var parentConfig = _this3.configByNodeName[parentNodeName]['format'];

        if (!parentConfig) {
          return;
        }

        allNodeNames.forEach(function (childNodeName) {
          var childConfig = _this3.configByNodeName[childNodeName]['format'] || _this3.configByNodeName[childNodeName]['text'];

          if (!childConfig) {
            return;
          }

          if (!parentConfig.validChildNodes.has(childConfig.nodeName)) {
            throw new Error("".concat(childNodeName, " must be a valid child of ").concat(parentNodeName));
          }
        });
      }); // Validate defaultChildNode, validChildNodes and needsBr.

      allNodeNames.forEach(function (nodeName) {
        Object.keys(_this3.configByNodeName[nodeName]).forEach(function (nodeType) {
          var config = _this3.configByNodeName[nodeName][nodeType];

          if (!config) {
            return;
          } // Make sure that all validChildNodes refer only to defined nodes.


          config.validChildNodes.forEach(function (validChildNode) {
            if (!_this3.configByNodeName[validChildNode]) {
              throw new Error("Invalid node ".concat(validChildNode, " in validChildNodes of ").concat(nodeType, " ").concat(nodeName));
            }
          }); // Make sure only root and structure nodes have defaultChildNode.

          if (config.defaultChildNode && config.nodeType !== 'root' && config.nodeType !== 'structure') {
            throw new Error("".concat(nodeType, " ").concat(nodeName, " must not define defaultChildNode"));
          } // Make sure #root is not a valid child of any node.


          if (config.validChildNodes.has('#root')) {
            throw new Error("#root must not be in validChildNodes of ".concat(nodeType, " ").concat(nodeName));
          } // Make sure #unknown is not a valid child of any node.


          if (config.validChildNodes.has('#unknown')) {
            throw new Error("#unknown must not be in validChildNodes of ".concat(nodeType, " ").concat(nodeName));
          } // Make sure defaultChildNode is in validChildNodes for each node.


          if (config.defaultChildNode && !config.validChildNodes.has(config.defaultChildNode)) {
            throw new Error("defaultChildNode is not in validChildNodes for ".concat(nodeType, " ").concat(nodeName));
          } // Make sure defaultChildNode is a structure.


          if (config.defaultChildNode && !_this3.configByNodeName[config.defaultChildNode].structure) {
            throw new Error("defaultChildNode ".concat(config.defaultChildNode, " for ").concat(nodeType, " ").concat(nodeName, " must be a structure"));
          } // Make sure that needsBr is false, if defaultChildNode is set.


          if (config.defaultChildNode && config.needsBr) {
            throw new Error("needsBr must be false, if defaultChildNode is set for ".concat(nodeType, " ").concat(nodeName));
          } // Make sure that BR is in validChildNodes, if needsBr is true.


          if (config.needsBr && !config.validChildNodes.has('BR')) {
            throw new Error("BR must be in validChildNodes for ".concat(nodeType, " ").concat(nodeName, " because needsBr is true"));
          } // Make sure that defaultChildNode transitions do not form a loop.


          var defaultChildNode = config.defaultChildNode;
          var limit = 5;

          while (defaultChildNode) {
            if (--limit < 0) {
              throw new Error("defaultChildNode transitions form a loop for ".concat(nodeType, " ").concat(nodeName));
            }

            defaultChildNode = _this3.configByNodeName[defaultChildNode]['structure'] && _this3.configByNodeName[defaultChildNode]['structure'].defaultChildNode;
          }
        });
      }); // Validate formats.

      this.formats.forEach(function (format) {
        if (!/^[@$A-Za-z][A-Za-z0-9-]*=?$/.test(format.name)) {
          throw new Error("Invalid format name: '".concat(format.name, "'"));
        }
      });
    }
  }]);

  return Config;
}();



/***/ }),

/***/ "./src/config/Format.js":
/*!******************************!*\
  !*** ./src/config/Format.js ***!
  \******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Format; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);



var Format =
/*#__PURE__*/
function () {
  function Format(name, nodeName, attributeName, attributeValue) {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, Format);

    // The name of the OT attribute.
    this.name = name; // The name of the DOM Element used to represent this format.

    this.nodeName = nodeName || name || null; // The name of the DOM Attribute or Style used to represent this format.

    this.attributeName = attributeName || null; // The value of the DOM Attribute or Style used to represent this format.

    this.attributeValue = attributeValue || null; // Is this format deprecated.

    this.deprecated = false; // Indicates the order of format used for building a DOM tree.

    this.index = 0;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(Format, [{
    key: "withDeprecated",
    value: function withDeprecated(deprecated) {
      this.deprecated = deprecated;
      return this;
    }
  }, {
    key: "withIndex",
    value: function withIndex(index) {
      this.index = index;
      return this;
    }
  }, {
    key: "freeze",
    value: function freeze() {
      return Object.freeze(this);
    }
  }, {
    key: "clone",
    value: function clone() {
      return new Format(this.name, this.nodeName, this.attributeName, this.attributeValue).withDeprecated(this.deprecated);
    }
  }, {
    key: "otKey",
    get: function get() {
      return this.name;
    }
  }, {
    key: "domKey",
    get: function get() {
      return this.nodeName + (!this.attributeName ? '' : this.attributeName + (!this.attributeValue ? '' : '=' + this.attributeValue));
    }
  }]);

  return Format;
}();



/***/ }),

/***/ "./src/config/VNodeConfig.js":
/*!***********************************!*\
  !*** ./src/config/VNodeConfig.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return VNodeConfig; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _util_misc__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../util/misc */ "./src/util/misc.js");




var VNodeConfig =
/*#__PURE__*/
function () {
  function VNodeConfig(VNodeConstructor, nodeName, nodeType) {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, VNodeConfig);

    this.VNodeConstructor = VNodeConstructor;
    this.nodeName = nodeName;
    this.nodeType = nodeType;
    this.attributeNames = nodeType === 'text' || nodeType === 'unknown' ? null : [];
    this.needsBr = false;
    this.validChildNodes = Object(_util_misc__WEBPACK_IMPORTED_MODULE_2__["createSet"])();
    this.invalidChildNodes = null;
    this.defaultChildNode = '';
    this.empty = false;
    this.customElementName = '';
    this.hasChildNodes = nodeType === 'root' || nodeType === 'structure' || nodeType === 'format' || nodeType === 'unknown';
    this.hasNodeValue = nodeType === 'root' || nodeType === 'structure' || nodeType === 'embed' || nodeType === 'text';
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(VNodeConfig, [{
    key: "withAttributeNames",
    value: function withAttributeNames(attributeNames) {
      this.attributeNames = attributeNames;
      return this;
    }
  }, {
    key: "withNeedsBr",
    value: function withNeedsBr(needsBr) {
      this.needsBr = needsBr;
      return this;
    }
  }, {
    key: "withValidChildNodes",
    value: function withValidChildNodes(validChildNodes) {
      this.validChildNodes = validChildNodes == null || validChildNodes instanceof Set ? validChildNodes : Object(_util_misc__WEBPACK_IMPORTED_MODULE_2__["createSet"])(validChildNodes);
      return this;
    }
  }, {
    key: "withInvalidChildNodes",
    value: function withInvalidChildNodes(invalidChildNodes) {
      this.invalidChildNodes = invalidChildNodes == null || invalidChildNodes instanceof Set ? invalidChildNodes : Object(_util_misc__WEBPACK_IMPORTED_MODULE_2__["createSet"])(invalidChildNodes);
      return this;
    }
  }, {
    key: "withDefaultChildNode",
    value: function withDefaultChildNode(defaultChildNode) {
      this.defaultChildNode = defaultChildNode;
      return this;
    }
  }, {
    key: "withEmpty",
    value: function withEmpty(empty) {
      this.empty = empty;
      return this;
    }
  }, {
    key: "withCustomElementName",
    value: function withCustomElementName(customElementName) {
      this.customElementName = customElementName;
      return this;
    }
  }, {
    key: "createVNode",
    value: function createVNode(nodeValue, realNode) {
      return new this.VNodeConstructor(this, nodeValue, realNode);
    }
  }, {
    key: "freeze",
    value: function freeze() {
      Object.freeze(this);
      Object.freeze(this.validChildNodes);

      if (this.invalidChildNodes) {
        Object.freeze(this.invalidChildNodes);
      }

      if (this.attributeNames) {
        Object.freeze(this.attributeNames);
      }

      return this;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new VNodeConfig(this.VNodeConstructor, this.nodeName, this.nodeType).withAttributeNames(this.attributeNames ? this.attributeNames.slice(0) : this.attributeNames).withNeedsBr(this.needsBr).withValidChildNodes(Object(_util_misc__WEBPACK_IMPORTED_MODULE_2__["createSet"])(this.validChildNodes)).withInvalidChildNodes(this.invalidChildNodes ? Object(_util_misc__WEBPACK_IMPORTED_MODULE_2__["createSet"])(this.invalidChildNodes) : null).withDefaultChildNode(this.defaultChildNode).withEmpty(this.empty).withCustomElementName(this.customElementName);
    }
  }]);

  return VNodeConfig;
}();



/***/ }),

/***/ "./src/config/default.js":
/*!*******************************!*\
  !*** ./src/config/default.js ***!
  \*******************************/
/*! exports provided: formats, nodes, attributeAliasMap, childNodeAliasMap, default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formats", function() { return formats; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nodes", function() { return nodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "attributeAliasMap", function() { return attributeAliasMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "childNodeAliasMap", function() { return childNodeAliasMap; });
/* harmony import */ var _Format__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./Format */ "./src/config/Format.js");
/* harmony import */ var _nodes_ElementVNode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../nodes/ElementVNode */ "./src/nodes/ElementVNode.js");
/* harmony import */ var _nodes_TextVNode__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../nodes/TextVNode */ "./src/nodes/TextVNode.js");
/* harmony import */ var _nodes_AVNode__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../nodes/AVNode */ "./src/nodes/AVNode.js");
/* harmony import */ var _nodes_HeadingVNode__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../nodes/HeadingVNode */ "./src/nodes/HeadingVNode.js");
/* harmony import */ var _nodes_PreVNode__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../nodes/PreVNode */ "./src/nodes/PreVNode.js");
/* harmony import */ var _nodes_IFrameVNode__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../nodes/IFrameVNode */ "./src/nodes/IFrameVNode.js");
/* harmony import */ var _nodes_ImgVNode__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../nodes/ImgVNode */ "./src/nodes/ImgVNode.js");
/* harmony import */ var _nodes_VideoVNode__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../nodes/VideoVNode */ "./src/nodes/VideoVNode.js");
/* harmony import */ var _nodes_RootVNode__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../nodes/RootVNode */ "./src/nodes/RootVNode.js");
/* harmony import */ var _util_AliasMap__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../util/AliasMap */ "./src/util/AliasMap.js");











var structure = _nodes_ElementVNode__WEBPACK_IMPORTED_MODULE_1__["default"].structureConfig;
var embed = _nodes_ElementVNode__WEBPACK_IMPORTED_MODULE_1__["default"].embedConfig;
var format = _nodes_ElementVNode__WEBPACK_IMPORTED_MODULE_1__["default"].formatConfig;
var a = _nodes_AVNode__WEBPACK_IMPORTED_MODULE_3__["default"].config;
var heading = _nodes_HeadingVNode__WEBPACK_IMPORTED_MODULE_4__["default"].config;
var root = _nodes_RootVNode__WEBPACK_IMPORTED_MODULE_9__["default"].config;
var structurePre = _nodes_PreVNode__WEBPACK_IMPORTED_MODULE_5__["default"].structureConfig;
var embedPre = _nodes_PreVNode__WEBPACK_IMPORTED_MODULE_5__["default"].embedConfig;
var iframe = _nodes_IFrameVNode__WEBPACK_IMPORTED_MODULE_6__["default"].config;
var img = _nodes_ImgVNode__WEBPACK_IMPORTED_MODULE_7__["default"].config;
var video = _nodes_VideoVNode__WEBPACK_IMPORTED_MODULE_8__["default"].config;
var text = _nodes_TextVNode__WEBPACK_IMPORTED_MODULE_2__["default"].config;
var unknown = _nodes_ElementVNode__WEBPACK_IMPORTED_MODULE_1__["default"].unknownConfig; // A list of all supported formats. The earlier a format is in this list,
// the higher in the DOM hierarchy it will appear.

var formats = Object.freeze([// Keep the characters together to render correctly.
new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('BDO', 'BDO', '@dir'), new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('BDI', 'BDI', '@dir'), // Keep the characters together as much as possible to preserve the semantics.
new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('Q'), new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('CITE'), new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('CODE'), new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('DATA', 'DATA', '@value'), new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('TIME', 'TIME', '@datetime'), new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('VAR'), new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('DFN'), new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('ABBR', 'ABBR', '@title'), // should be after `dfn`
// Keep the characters together, if possible, because there's some semantics associated with these tags.
new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('STRONG'), new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('EM'), new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('MARK'), new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('SUB'), new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('SUP'), new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('SAMP'), new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('KBD'), // should be after `samp`
new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('B'), new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('I'), new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('S'), new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('U'), // These are just for styling, so don't care about keeping the characters together.
new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('font-size', 'SPAN', '$font-size'), new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('color', 'SPAN', '$color'), new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('background-color', 'SPAN', '$background-color'), new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('underline', 'SPAN', '$text-decoration', 'underline'), new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('line-through', 'SPAN', '$text-decoration', 'line-through'), new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('overline', 'SPAN', '$text-decoration', 'overline'), new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('BIG', 'SPAN', '$font-size', 'larger'), new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('BIG').withDeprecated(true), new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('SMALL', 'SPAN', '$font-size', 'smaller'), new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('SMALL').withDeprecated(true), // Associate some data with text.
// Stores the selectionId referenced by inline comments.
new _Format__WEBPACK_IMPORTED_MODULE_0__["default"]('@data-tw-inline-comments=', 'TW-SPAN', '@data-tw-inline-comments=')].map(function (format) {
  return format.freeze();
}));
var nodes = Object.freeze([structure('ADDRESS', true, ['blockAttributes'], ['flowContent']).withInvalidChildNodes(['outlineContent', 'ADDRESS']), structure('ARTICLE', true, ['blockAttributes'], ['flowContent']), structure('ASIDE', true, ['blockAttributes'], ['flowContent']), structure('BLOCKQUOTE', true, ['blockAttributes'], ['flowContent']), structure('CAPTION', true, ['blockAttributes'], ['flowContent']), structure('COLGROUP', false, ['@span', '@bgcolor', 'blockAttributes'], ['COL']), structure('DD', true, ['blockAttributes'], ['flowContent']), structure('DEL', false, ['@cite', '@datetime'], ['phrasingContent', 'flowContent']), structure('DIV', true, ['blockAttributes'], ['flowContent']), structure('DL', false, ['blockAttributes'], ['DT', 'DD']).withDefaultChildNode('DD'), structure('DT', true, ['blockAttributes'], ['flowContent']).withInvalidChildNodes(['outlineContent']), structure('FIGCAPTION', true, ['blockAttributes'], ['flowContent']), structure('FIGURE', true, ['blockAttributes'], ['flowContent', 'FIGCAPTION']), structure('FOOTER', true, ['blockAttributes'], ['flowContent']).withInvalidChildNodes(['headerAndFooter']), structure('HEADER', true, ['blockAttributes'], ['flowContent']).withInvalidChildNodes(['headerAndFooter']), structure('HGROUP', false, ['blockAttributes'], ['headings']).withDefaultChildNode('H1'), structure('INS', false, ['@cite', '@datetime'], ['phrasingContent', 'flowContent']), structure('LI', true, ['blockAttributes'], ['flowContent']), structure('MAIN', true, ['blockAttributes'], ['flowContent']), structure('NAV', true, ['blockAttributes'], ['flowContent']), structure('OL', false, ['@reversed', '@start', '@type', 'blockAttributes'], ['LI']).withDefaultChildNode('LI'), structure('P', true, ['blockAttributes'], ['phrasingContent']), structure('SECTION', true, ['blockAttributes'], ['flowContent']), structure('TABLE', false, ['table'], ['tableContent']).withDefaultChildNode('TBODY'), structure('TBODY', false, ['tableSection'], ['TR']).withDefaultChildNode('TR'), structure('TFOOT', false, ['tableSection'], ['TR']).withDefaultChildNode('TR'), structure('THEAD', false, ['tableSection'], ['TR']).withDefaultChildNode('TR'), structure('TH', true, ['tableCell'], ['flowContent']).withInvalidChildNodes(['outlineContent']), structure('TR', false, ['tableRow'], ['TD', 'TH']).withDefaultChildNode('TD'), structure('TD', true, ['tableCell'], ['flowContent']), structure('TW-JSON', false, ['@name', '@type'], ['TW-JSON', '#text']), structure('UL', false, ['blockAttributes'], ['LI']).withDefaultChildNode('LI'), format('BDO', ['@dir'], ['phrasingContent']), format('BDI', ['@dir'], ['phrasingContent']), format('Q', [], ['phrasingContent']), format('CITE', [], ['phrasingContent']), format('CODE', [], ['phrasingContent']), format('DATA', ['@value'], ['phrasingContent']), format('TIME', ['@datetime'], ['phrasingContent']), format('VAR', [], ['phrasingContent']), format('DFN', [], ['phrasingContent']), format('ABBR', ['@title'], ['phrasingContent']), format('STRONG', [], ['phrasingContent']), format('EM', [], ['phrasingContent']), format('BIG', [], ['phrasingContent']), format('SMALL', [], ['phrasingContent']), format('MARK', [], ['phrasingContent']), format('SUB', [], ['phrasingContent']), format('SUP', [], ['phrasingContent']), format('SAMP', [], ['phrasingContent']), format('KBD', [], ['phrasingContent']), format('B', [], ['phrasingContent']), format('I', [], ['phrasingContent']), format('S', [], ['phrasingContent']), format('U', [], ['phrasingContent']), format('SPAN', ['span'], ['phrasingContent']), format('TW-SPAN', ['@data-tw-inline-comments='], ['phrasingContent']), embed('BR', ['padding', 'margin']).withEmpty(true), embed('COL', ['@bgcolor', '@width', '@span', 'padding', 'margin']).withEmpty(true), embed('HR', ['padding', 'margin']).withEmpty(true), a(['@id', '@href', '@target', '@title', '@rel', 'padding', '$text-align'], ['phrasingContent', 'flowContent']), heading('H1', ['@id', '@data-ot-auto-id', 'blockAttributes'], ['phrasingContent']), heading('H2', ['@id', '@data-ot-auto-id', 'blockAttributes'], ['phrasingContent']), heading('H3', ['@id', '@data-ot-auto-id', 'blockAttributes'], ['phrasingContent']), heading('H4', ['@id', '@data-ot-auto-id', 'blockAttributes'], ['phrasingContent']), heading('H5', ['@id', '@data-ot-auto-id', 'blockAttributes'], ['phrasingContent']), heading('H6', ['@id', '@data-ot-auto-id', 'blockAttributes'], ['phrasingContent']), structurePre(['padding'], ['phrasingContent']), embedPre(['@data-content', '@data-language', 'padding']), iframe(['iframe']), img(['@src', '@alt', 'size', 'border', 'padding', 'margin']), video(['@src', '@poster', 'size', 'padding', '@controls']), text(), root([// The hash number of the document's schema.
'@data-tw-schema-hash', // The time at which the document's schema was updated.
'@data-tw-schema-time', // The published version number of the document's content.
'@data-tw-version-number', // The time at which the document's content has been published.
'@data-tw-version-time'], ['rootContent']).withDefaultChildNode('P'), unknown()].map(function (node) {
  return node.freeze();
}));
var attributeAliasMap = new _util_AliasMap__WEBPACK_IMPORTED_MODULE_10__["default"]().set('size', ['@width', '@height']).set('padding', ['$padding-left', '$padding-right', '$padding-top', '$padding-bottom']).set('margin', ['$margin-left', '$margin-right', '$margin-top', '$margin-bottom']).set('border', ['$border-top-width', '$border-right-width', '$border-bottom-width', '$border-left-width', '$border-top-color', '$border-right-color', '$border-bottom-color', '$border-left-color', '$border-top-style', '$border-right-style', '$border-bottom-style', '$border-left-style']).set('blockAttributes', ['$text-align', '$line-height', 'padding', 'margin']).set('table', ['size', '@border', '@cellspacing', '@cellpadding', '@bgcolor', '$width', '$height', '$float', '$background-color', '$table-layout', '$border-collapse', '$border-spacing', 'border', 'blockAttributes']).set('tableCell', ['@colspan', '@rowspan', '@scope', '@align', '@valign', '@bgcolor', '$width', '$height', '$vertical-align', '$background-color', 'border', 'blockAttributes']).set('tableRow', ['$height', '$background-color', '@bgcolor', 'border', 'blockAttributes']).set('tableSection', ['@bgcolor', 'blockAttributes']).set('span', ['$color', '$background-color', '$text-decoration', '$font-size', '@data-mce-bogus', '@data-mce-type', '@id' // Required to support TinyMCE's way of text formatting.
]).set('iframe', ['@width', '@height', '@src', '@frameborder', '@allow', '@allowfullscreen', '@csp']).freeze(); // Based on the Element descriptions in the subpages of https://developer.mozilla.org/en-US/docs/Web/HTML/Element.
// Some aliases are added purely for convenience.

var childNodeAliasMap = new _util_AliasMap__WEBPACK_IMPORTED_MODULE_10__["default"]().set('headerAndFooter', ['HEADER', 'FOOTER']).set('headings', ['H1', 'H2', 'H3', 'H4', 'H5', 'H6']).set('headingContent', ['headings', 'HGROUP']).set('sectioningContent', ['ARTICLE', 'ASIDE', 'SECTION', 'NAV']).set('outlineContent', ['headerAndFooter', 'headingContent', 'sectioningContent']).set('phrasingContent', ['ABBR', 'B', 'BIG', 'BDO', 'BDI', 'BR', 'CITE', 'CODE', 'DATA', 'DFN', 'EM', 'I', 'IFRAME', 'IMG', 'KBD', 'MARK', 'Q', 'S', 'SAMP', 'SMALL', 'SPAN', 'STRONG', 'SUB', 'SUP', 'TIME', 'TW-SPAN', 'VAR', 'VIDEO', '#text', 'A', 'DEL', 'INS', 'U']).set('flowContent', ['outlineContent', 'A', 'ABBR', 'ADDRESS', 'B', 'BIG', 'BDO', 'BDI', 'BLOCKQUOTE', 'BR', 'CITE', 'CODE', 'DATA', 'DEL', 'DFN', 'DIV', 'DL', 'EM', 'FIGURE', 'HR', 'I', 'IFRAME', 'IMG', 'INS', 'KBD', 'MAIN', 'MARK', 'OL', 'P', 'PRE', 'Q', 'S', 'SAMP', 'SMALL', 'SPAN', 'STRONG', 'SUB', 'SUP', 'TABLE', 'TIME', 'TW-SPAN', 'UL', 'VAR', 'VIDEO', '#text', 'U']).set('tableContent', ['CAPTION', 'COLGROUP', 'THEAD', 'TBODY', 'TFOOT', 'TR']).set('rootContent', ['outlineContent', 'ADDRESS', 'BLOCKQUOTE', 'DIV', 'FIGURE', 'OL', 'P', 'TABLE', 'UL', 'HR', 'PRE']).freeze();
/* harmony default export */ __webpack_exports__["default"] = ({
  nodes: nodes,
  formats: formats,
  attributeAliasMap: attributeAliasMap,
  childNodeAliasMap: childNodeAliasMap
});

/***/ }),

/***/ "./src/index.js":
/*!**********************!*\
  !*** ./src/index.js ***!
  \**********************/
/*! exports provided: VNodeConfig, ElementVNode, registerTinyMcePlugin, registerCodeMirrorPlugin, InlineComments */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _config_VNodeConfig__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./config/VNodeConfig */ "./src/config/VNodeConfig.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VNodeConfig", function() { return _config_VNodeConfig__WEBPACK_IMPORTED_MODULE_0__["default"]; });

/* harmony import */ var _nodes_ElementVNode__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./nodes/ElementVNode */ "./src/nodes/ElementVNode.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ElementVNode", function() { return _nodes_ElementVNode__WEBPACK_IMPORTED_MODULE_1__["default"]; });

/* harmony import */ var _tinymce_plugins_ot_Plugin__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./tinymce/plugins/ot/Plugin */ "./src/tinymce/plugins/ot/Plugin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "registerTinyMcePlugin", function() { return _tinymce_plugins_ot_Plugin__WEBPACK_IMPORTED_MODULE_2__["register"]; });

/* harmony import */ var _codeMirror_plugin__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./codeMirror/plugin */ "./src/codeMirror/plugin.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "registerCodeMirrorPlugin", function() { return _codeMirror_plugin__WEBPACK_IMPORTED_MODULE_3__["register"]; });

/* harmony import */ var _util_inlineComments__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./util/inlineComments */ "./src/util/inlineComments.js");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InlineComments", function() { return _util_inlineComments__WEBPACK_IMPORTED_MODULE_4__["InlineComments"]; });







/***/ }),

/***/ "./src/nodes/AVNode.js":
/*!*****************************!*\
  !*** ./src/nodes/AVNode.js ***!
  \*****************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AVNode; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _ElementVNode__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./ElementVNode */ "./src/nodes/ElementVNode.js");
/* harmony import */ var _config_VNodeConfig__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../config/VNodeConfig */ "./src/config/VNodeConfig.js");








var AVNode =
/*#__PURE__*/
function (_ElementVNode) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(AVNode, _ElementVNode);

  function AVNode() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, AVNode);

    return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(AVNode).apply(this, arguments));
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(AVNode, null, [{
    key: "config",
    value: function config(attributeNames, validChildNodes) {
      return new _config_VNodeConfig__WEBPACK_IMPORTED_MODULE_6__["default"](AVNode, 'A', 'structure').withAttributeNames(attributeNames).withValidChildNodes(validChildNodes).withCustomElementName('ot-built-in-a');
    }
  }]);

  return AVNode;
}(_ElementVNode__WEBPACK_IMPORTED_MODULE_5__["default"]);



/***/ }),

/***/ "./src/nodes/ElementVNode.js":
/*!***********************************!*\
  !*** ./src/nodes/ElementVNode.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ElementVNode; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _VNode__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./VNode */ "./src/nodes/VNode.js");
/* harmony import */ var _config_VNodeConfig__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../config/VNodeConfig */ "./src/config/VNodeConfig.js");
/* harmony import */ var _util_misc__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../util/misc */ "./src/util/misc.js");








var ignoredAttributeNames = Object.create(null);
ignoredAttributeNames['@contenteditable'] = true;
ignoredAttributeNames['@data-mce-selected'] = true;
ignoredAttributeNames['@data-mce-first-selected'] = true;
ignoredAttributeNames['@data-mce-last-selected'] = true;
ignoredAttributeNames['@style'] = true;
ignoredAttributeNames['@is'] = true;
var mutationObservers = new WeakMap();

function handleMutations(mutations) {
  for (var i = 0, l = mutations.length; i < l; ++i) {
    var _mutations$i = mutations[i],
        target = _mutations$i.target,
        attributeName = _mutations$i.attributeName,
        attributeNamespace = _mutations$i.attributeNamespace,
        oldValue = _mutations$i.oldValue;
    var newValue = target.getAttribute(attributeName);
    var attributeChangedCallback = target.attributeChangedCallback;

    if (typeof attributeChangedCallback === 'function') {
      attributeChangedCallback.call(target, attributeName, oldValue, newValue, attributeNamespace);
    }
  }
}

var ElementVNode =
/*#__PURE__*/
function (_VNode) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(ElementVNode, _VNode);

  function ElementVNode() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, ElementVNode);

    return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(ElementVNode).apply(this, arguments));
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(ElementVNode, [{
    key: "updateVAttributes",
    value: function updateVAttributes() {
      this.attributes = this.attributeNames ? this.getAttributesFromRealNode(true) : null;
    }
  }, {
    key: "createRealNode",
    value: function createRealNode(document) {
      return document.createElement(this.nodeName);
    } // Upgrades the specified built-in element to a customized built-in element.
    // See https://html.spec.whatwg.org/multipage/custom-elements.html#customized-built-in-element.
    // The problem is that we always want certain built-in elements to be customized within the editor,
    // however, there's no way to configure TinyMCE to create those customized elements for us.
    // Since TinyMCE creates just standard elements (without any "is" attributes), those elements would
    // never be updated according to the spec. So, the upgrade we perform here is not a polyfill but a kind
    // of an extension of the spec, which allows any built-in elements to be automatically upgraded to custom elements.
    // As the "fake custom elements" created by this function are not native custom elements, they can't leverage
    // the native implementation and must emulate it instead, which results in some limitations:
    // - all initialization must happen in an `init` function.
    // - during the "upgrade", the `init` function is called instead of the `constructor`.
    // - the `connectedCallback` and `disconnectedCallback` functions depend on the `Sync` class in `ot-client`.
    // - a `MutationObserver` is created per node to detect attribute changes.
    // - all callbacks are always asynchronous.
    // - the `adoptedCallback` is not supported.

  }, {
    key: "upgradeRealNode",
    value: function upgradeRealNode(realNode) {
      if (this.nodeType !== 'structure' && this.nodeType !== 'embed' && this.nodeType !== 'format') {
        // Not a node we'd like to upgrade (root or unknown).
        // The client code is responsible for creating the "root" node,
        // so we should never replace it with anything else.
        // The "unknown" nodes are removed promptly,
        // so there's no point even trying to upgrade them.
        return;
      }

      var realNodeName = realNode.nodeName;

      if (realNodeName.indexOf('-') >= 0) {
        return; // Not a built-in element.
      }

      var customElementName = this.customElementName;

      if (customElementName.indexOf('-') < 0) {
        return; // Not a custom element name.
      }

      var document = realNode.ownerDocument;
      var window = document.defaultView;

      if (!window) {
        return; // The document is no longer attached to a window.
      }

      var customElements = window.customElements;
      var Class = customElements.get(customElementName);

      if (!Class) {
        return; // No custom element registered for this name.
      }

      if (Object.prototype.isPrototypeOf.call(Class.prototype, realNode)) {
        return; // Already customized.
      }

      if ('connectedCallback' in realNode || 'disconnectedCallback' in realNode || 'adoptedCallback' in realNode || 'attributeChangedCallback' in realNode) {
        return; // Already customized using a different class.
      }

      if (typeof Class.prototype.init !== 'function') {
        // No `init` function. We require it as a sign that this `Class` supports
        // the "fake upgrade" we're about to perform.
        return;
      }

      Object.setPrototypeOf(realNode, Class.prototype);
      Class.prototype.init.call(realNode);
      realNode[_util_misc__WEBPACK_IMPORTED_MODULE_7__["fakeCustomElementKey"]] = true;
      var mutationObserver = mutationObservers.get(window);

      if (!mutationObserver) {
        mutationObserver = new window.MutationObserver(handleMutations);
        mutationObservers.set(window, mutationObserver);
      }

      var attributeFilter = Class.observedAttributes;

      if (Array.isArray(attributeFilter)) {
        mutationObserver.observe(realNode, {
          attributes: true,
          attributeOldValue: true,
          attributeFilter: attributeFilter
        });
      }
    } // Converts a real attribute name to a virtual one.
    // Returns null, if the attribute should be ignored.

  }, {
    key: "realToVirtualAttributeName",
    value: function realToVirtualAttributeName(attributeName) {
      return ignoredAttributeNames[attributeName] ? null : attributeName;
    } // Converts a virtual attribute name to a real one.
    // Returns null, if the attribute should be ignored.

  }, {
    key: "virtualToRealAttributeName",
    value: function virtualToRealAttributeName(attributeName) {
      return ignoredAttributeNames[attributeName] ? null : attributeName;
    } // Determines, if the specified attribute is supported by this VNode and will be synchronized.

  }, {
    key: "supportsAttribute",
    value: function supportsAttribute(checkedAttributeName) {
      var attributeNames = this.attributeNames;

      for (var i = 0, l = attributeNames.length; i < l; ++i) {
        var rawAttributeName = attributeNames[i];
        var lastCharacterIndex = rawAttributeName.length - 1;
        var wildcard = rawAttributeName[lastCharacterIndex] === '=';
        var attributeName = wildcard ? rawAttributeName.substring(0, lastCharacterIndex) : rawAttributeName;

        if (checkedAttributeName < attributeName) {
          return false;
        } else if (checkedAttributeName === attributeName) {
          return true;
        }
      }

      return false;
    } // Gets a list of virtual attribute names from `this.realNode`.

  }, {
    key: "getAttributeNamesFromRealNode",
    value: function getAttributeNamesFromRealNode() {
      var attributeNames = [];
      var attributes = Object(_util_misc__WEBPACK_IMPORTED_MODULE_7__["getAttributeNames"])(this.realNode);
      var styles = this.realNode.style;

      for (var i = 0, l = styles.length; i < l; ++i) {
        var attributeName = this.realToVirtualAttributeName('$' + styles[i]);

        if (attributeName !== null) {
          attributeNames.push(attributeName);
        }
      }

      for (var _i = 0, _l = attributes.length; _i < _l; ++_i) {
        var _attributeName = this.realToVirtualAttributeName('@' + attributes[_i]);

        if (_attributeName !== null) {
          attributeNames.push(_attributeName);
        }
      }

      return attributeNames.sort();
    }
  }, {
    key: "setRealAttribute",
    value: function setRealAttribute(virtualAttributeName, value) {
      var realAttributeName = this.virtualToRealAttributeName(virtualAttributeName);

      if (realAttributeName !== null) {
        if (realAttributeName[0] === '@') {
          this.realNode.setAttribute(realAttributeName.substr(1), value);
        } else {
          this.realNode.style.setProperty(realAttributeName.substr(1), value);
        }
      }
    }
  }, {
    key: "removeRealAttribute",
    value: function removeRealAttribute(virtualAttributeName) {
      var realAttributeName = this.virtualToRealAttributeName(virtualAttributeName);

      if (realAttributeName !== null) {
        if (realAttributeName[0] === '@') {
          this.realNode.removeAttribute(realAttributeName.substr(1));
        } else {
          this.realNode.style.removeProperty(realAttributeName.substr(1));
        }
      }
    }
  }, {
    key: "getRealAttribute",
    value: function getRealAttribute(virtualAttributeName) {
      var realAttributeName = this.virtualToRealAttributeName(virtualAttributeName);
      return realAttributeName === null ? null : realAttributeName[0] === '@' ? this.realNode.getAttribute(realAttributeName.substr(1)) : this.realNode.style.getPropertyValue(realAttributeName.substr(1)) || null;
    }
  }, {
    key: "includeRealAttribute",
    value: function includeRealAttribute(virtualAttributeName, value) {
      var realAttributeName = this.virtualToRealAttributeName(virtualAttributeName);

      if (realAttributeName === null) {
        return;
      }

      var isBasicAttribute = realAttributeName[0] === '@';
      var nativeAttributeName = realAttributeName.substring(1);
      var currentValue = isBasicAttribute ? this.realNode.getAttribute(nativeAttributeName) || '' : this.realNode.style.getPropertyValue(nativeAttributeName) || '';
      var newValue = (currentValue + ' ' + value).split(/\s+/).sort().filter(function (v, index, array) {
        return v.length > 0 && (index === 0 || v !== array[index - 1]);
      }).join(' ');

      if (newValue) {
        if (isBasicAttribute) {
          this.realNode.setAttribute(nativeAttributeName, newValue);
        } else {
          this.realNode.style.setProperty(nativeAttributeName, newValue);
        }
      } else {
        if (isBasicAttribute) {
          this.realNode.removeAttribute(nativeAttributeName);
        } else {
          this.realNode.style.removeProperty(nativeAttributeName);
        }
      }
    }
  }, {
    key: "excludeRealAttribute",
    value: function excludeRealAttribute(virtualAttributeName, value) {
      var realAttributeName = this.virtualToRealAttributeName(virtualAttributeName);

      if (realAttributeName === null) {
        return;
      }

      var isBasicAttribute = realAttributeName[0] === '@';
      var nativeAttributeName = realAttributeName.substring(1);
      var currentValue = isBasicAttribute ? this.realNode.getAttribute(nativeAttributeName) || '' : this.realNode.style.getPropertyValue(nativeAttributeName) || '';
      var newValue = currentValue.split(/\s+/).sort().filter(function (v, index, array) {
        return v !== value && v.length > 0 && (index === 0 || v !== array[index - 1]);
      }).join(' ');

      if (newValue) {
        if (isBasicAttribute) {
          this.realNode.setAttribute(nativeAttributeName, newValue);
        } else {
          this.realNode.style.setProperty(nativeAttributeName, newValue);
        }
      } else {
        if (isBasicAttribute) {
          this.realNode.removeAttribute(nativeAttributeName);
        } else {
          this.realNode.style.removeProperty(nativeAttributeName);
        }
      }
    }
  }, {
    key: "setOrIncludeRealAttribute",
    value: function setOrIncludeRealAttribute(virtualAttributeName, value) {
      var indexOfValueInName = virtualAttributeName.indexOf('=');

      if (indexOfValueInName >= 0) {
        this.includeRealAttribute(virtualAttributeName.substring(0, indexOfValueInName), virtualAttributeName.substring(indexOfValueInName + 1));
      } else {
        this.setRealAttribute(virtualAttributeName, value);
      }
    }
  }, {
    key: "removeOrExcludeRealAttribute",
    value: function removeOrExcludeRealAttribute(virtualAttributeName) {
      var indexOfValueInName = virtualAttributeName.indexOf('=');

      if (indexOfValueInName >= 0) {
        this.excludeRealAttribute(virtualAttributeName.substring(0, indexOfValueInName), virtualAttributeName.substring(indexOfValueInName + 1));
      } else {
        this.removeRealAttribute(virtualAttributeName);
      }
    }
  }, {
    key: "updateRealAttributes",
    value: function updateRealAttributes(oldAttributes) {
      var newAttributes = this.attributes;

      if (Object(_util_misc__WEBPACK_IMPORTED_MODULE_7__["areArraysEqual"])(newAttributes, oldAttributes)) {
        // Most of the time attributes are going to be the same, so we may exit early.
        return;
      }

      var i1 = 0; // index for oldAttributes

      var i2 = 0; // index for newAttributes

      var l1 = oldAttributes.length;
      var l2 = newAttributes.length;

      while (i1 < l1 && i2 < l2) {
        var oldName = oldAttributes[i1];
        var newName = newAttributes[i2];

        if (oldName === newName) {
          // the same attribute in oldAttributes and newAttributes
          var oldValue = oldAttributes[i1 + 1];
          var newValue = newAttributes[i2 + 1];

          if (oldValue !== newValue) {
            this.setOrIncludeRealAttribute(newName, newValue);
          }

          i1 += 2;
          i2 += 2;
        } else if (oldName < newName) {
          // attribute only in oldAttributes
          this.removeOrExcludeRealAttribute(oldName);
          i1 += 2;
        } else {
          // attribute only in newAttributes
          this.setOrIncludeRealAttribute(newName, newAttributes[i2 + 1]);
          i2 += 2;
        }
      }

      while (i1 < l1) {
        // attribute only in oldAttributes
        this.removeOrExcludeRealAttribute(oldAttributes[i1]);
        i1 += 2;
      }

      while (i2 < l2) {
        // attribute only in newAttributes
        this.setOrIncludeRealAttribute(newAttributes[i2], newAttributes[i2 + 1]);
        i2 += 2;
      }

      this.updateVAttributes();
    } // Gets attributes and styles, filtered by `this.attributeNames`, from `this.realNode`.
    // The result is returned as an array, where the even indexes hold attribute names and
    // the odd indexes hold the corresponding attribute values.
    //
    // If `removeExtraneous` is true, removes attributes and styles from `realNode` that are not in `attributeNames`.

  }, {
    key: "getAttributesFromRealNode",
    value: function getAttributesFromRealNode(removeExtraneous) {
      var _this = this;

      var attributeNames = this.attributeNames;
      var attributeNamesFromRealNode = this.getAttributeNamesFromRealNode();
      var attributes = [];
      var i1 = 0; // index for attributeNames

      var i2 = 0; // index for attributeNamesFromRealNode

      var i3 = 0; // index for attributes

      var l1 = attributeNames.length;
      var l2 = attributeNamesFromRealNode.length;

      var removeRedundantAttribute = function removeRedundantAttribute(attributeName) {
        if (removeExtraneous) {
          // Don't remove styles (eg text-decoration-line) which form a shorthand style
          // (eg text-decoration), if the latter is in `attributeNames`.
          if (attributeName[0] !== '@' && i1 > 0) {
            var previousAttributeName = attributeNames[i1 - 1];

            if (previousAttributeName === attributeName.substr(0, previousAttributeName.length)) {
              return;
            }
          }

          _this.removeRealAttribute(attributeName);
        }
      };

      var _loop = function _loop() {
        var realNodeAttributeName = attributeNamesFromRealNode[i2];
        var rawAttributeName = attributeNames[i1];
        var lastCharacterIndex = rawAttributeName.length - 1;
        var wildcard = rawAttributeName[lastCharacterIndex] === '=';
        var attributeName = wildcard ? rawAttributeName.substring(0, lastCharacterIndex) : rawAttributeName;

        if (realNodeAttributeName < attributeName) {
          // Remove real attribute because it is not in this.attributeNames.
          i2++;
          removeRedundantAttribute(realNodeAttributeName);
        } else if (realNodeAttributeName === attributeName) {
          var attributeValue = _this.getRealAttribute(attributeName);

          i1++;
          i2++;

          if (attributeValue !== null) {
            if (wildcard) {
              // Map a single real attribute to multiple virtual attributes.
              var newValue = attributeValue.split(/\s+/).sort().filter(function (value, index, array) {
                if (value.length > 0 && (index === 0 || value !== array[index - 1])) {
                  attributes[i3++] = rawAttributeName + value;
                  attributes[i3++] = '';
                  return true;
                }

                return false;
              }).join(' ') || null;

              if (newValue !== attributeValue) {
                if (newValue) {
                  _this.setRealAttribute(attributeName, newValue);
                } else {
                  _this.removeRealAttribute(attributeName);
                }
              }
            } else {
              // Copy a supported attribute from the real node.
              attributes[i3++] = attributeName;
              attributes[i3++] = attributeValue;
            }
          }
        } else {
          // A supported real attribute is not present (unless it's a shorthand style).
          i1++;

          if (attributeName[0] !== '@') {
            // The shorthands like `text-decoration` are not discovered by iterating `realNode.style` by index,
            // so we just have to try to get the style.
            var _attributeValue = _this.getRealAttribute(attributeName);

            if (_attributeValue !== null) {
              attributes[i3++] = attributeName;
              attributes[i3++] = _attributeValue;
            }
          }
        }
      };

      while (i1 < l1 && i2 < l2) {
        _loop();
      } // present only in attributeNamesFromRealNode


      while (i2 < l2) {
        removeRedundantAttribute(attributeNamesFromRealNode[i2++]);
      } // `while (i1 < l1)`... is not needed because we already ran out of real attributes, so the values for
      // all remaining `attributeNames` are going to be `null` anyway.


      return attributes;
    }
  }, {
    key: "toHtml",
    value: function toHtml() {
      if (this.isFormattingHelper()) {
        return '';
      }

      switch (this.nodeType) {
        case 'format':
        case 'structure':
          {
            var nodeName = Object(_util_misc__WEBPACK_IMPORTED_MODULE_7__["escapeHtml"])(this.nodeName.toLowerCase());
            return "<".concat(nodeName).concat(this.attributesToHtml(), ">").concat(this.contentToHtml(), "</").concat(nodeName, ">");
          }

        case 'embed':
          {
            var _nodeName = Object(_util_misc__WEBPACK_IMPORTED_MODULE_7__["escapeHtml"])(this.nodeName.toLowerCase());

            var contentEditable = this.empty ? '' : ' contenteditable="false"';
            var closingTag = this.empty ? '' : "</".concat(_nodeName, ">");
            return "<".concat(_nodeName).concat(contentEditable).concat(this.attributesToHtml(), ">").concat(closingTag);
          }

        case 'unknown':
        case 'root':
          return this.contentToHtml();

        default:
          return '';
      }
    }
  }, {
    key: "contentToHtml",
    value: function contentToHtml() {
      if (!this.childNodes) {
        return '';
      }

      var html = '';

      for (var i = 0, l = this.childNodes.length; i < l; ++i) {
        html += this.childNodes[i].toHtml();
      }

      return html;
    }
  }, {
    key: "attributesToHtml",
    value: function attributesToHtml() {
      var html = '';
      var styleAttribute = '';

      for (var i = 0, l = this.attributes.length; i < l;) {
        var name = this.attributes[i++];
        var value = this.attributes[i++];
        var indexOfValueInName = name.indexOf('=');

        if (indexOfValueInName > 0) {
          var prefix = name.substring(0, indexOfValueInName + 1);
          value = name.substring(indexOfValueInName + 1);
          name = name.substring(0, indexOfValueInName);

          while (i < l && this.attributes[i].substring(0, indexOfValueInName + 1) === prefix) {
            value += ' ' + this.attributes[i].substring(indexOfValueInName + 1);
            i += 2;
          }
        }

        if (name[0] === '@') {
          html += " ".concat(Object(_util_misc__WEBPACK_IMPORTED_MODULE_7__["escapeHtml"])(name.substr(1)), "=\"").concat(Object(_util_misc__WEBPACK_IMPORTED_MODULE_7__["escapeHtml"])(value), "\"");
        } else if (name[0] === '$') {
          styleAttribute += "".concat(Object(_util_misc__WEBPACK_IMPORTED_MODULE_7__["escapeHtml"])(name.substr(1)), ":").concat(Object(_util_misc__WEBPACK_IMPORTED_MODULE_7__["escapeHtml"])(value), ";");
        }
      }

      if (styleAttribute !== '') {
        html += " style=\"".concat(styleAttribute, "\"");
      }

      return html;
    }
  }, {
    key: "isFormattingHelper",
    value: function isFormattingHelper() {
      return this.nodeType === 'format' && this.childNodes.length === 1 ? this.childNodes[0].isFormattingHelper() : false;
    }
  }], [{
    key: "embedConfig",
    value: function embedConfig(nodeName, attributeNames) {
      return new _config_VNodeConfig__WEBPACK_IMPORTED_MODULE_6__["default"](ElementVNode, nodeName, 'embed').withAttributeNames(attributeNames);
    }
  }, {
    key: "formatConfig",
    value: function formatConfig(nodeName, attributeNames, validChildNodes) {
      return new _config_VNodeConfig__WEBPACK_IMPORTED_MODULE_6__["default"](ElementVNode, nodeName, 'format').withAttributeNames(attributeNames).withValidChildNodes(validChildNodes);
    }
  }, {
    key: "structureConfig",
    value: function structureConfig(nodeName, needsBr, attributeNames, validChildNodes) {
      return new _config_VNodeConfig__WEBPACK_IMPORTED_MODULE_6__["default"](ElementVNode, nodeName, 'structure').withNeedsBr(needsBr).withAttributeNames(attributeNames).withValidChildNodes(validChildNodes);
    }
  }, {
    key: "unknownConfig",
    value: function unknownConfig() {
      return new _config_VNodeConfig__WEBPACK_IMPORTED_MODULE_6__["default"](ElementVNode, '#unknown', 'unknown');
    }
  }]);

  return ElementVNode;
}(_VNode__WEBPACK_IMPORTED_MODULE_5__["default"]);



/***/ }),

/***/ "./src/nodes/HeadingVNode.js":
/*!***********************************!*\
  !*** ./src/nodes/HeadingVNode.js ***!
  \***********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return HeadingVNode; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _ElementVNode__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./ElementVNode */ "./src/nodes/ElementVNode.js");
/* harmony import */ var _config_VNodeConfig__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../config/VNodeConfig */ "./src/config/VNodeConfig.js");
/* harmony import */ var _util_misc__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../util/misc */ "./src/util/misc.js");










var HeadingVNode =
/*#__PURE__*/
function (_ElementVNode) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(HeadingVNode, _ElementVNode);

  function HeadingVNode() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, HeadingVNode);

    return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(HeadingVNode).apply(this, arguments));
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(HeadingVNode, [{
    key: "getRealAttribute",
    value: function getRealAttribute(virtualAttributeName) {
      // If the ID is auto-generated, than just ignore it.
      if (virtualAttributeName === '@id' && this.realNode.getAttribute('data-ot-auto-id') === 'true') {
        return null;
      }

      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(HeadingVNode.prototype), "getRealAttribute", this).call(this, virtualAttributeName);
    }
  }, {
    key: "toHtml",
    value: function toHtml() {
      var nodeName = Object(_util_misc__WEBPACK_IMPORTED_MODULE_8__["escapeHtml"])(this.nodeName.toLowerCase());
      var autoId = this.realNode ? this.realNode.getAttribute('data-ot-auto-id') === 'true' : false;
      var id = this.realNode ? this.realNode.getAttribute('id') : null; // If autoId is true, then we must add the ID attribute manually because it's been ignored by `getRealAttribute`.

      var idAttribute = autoId && id !== null ? " id=\"".concat(Object(_util_misc__WEBPACK_IMPORTED_MODULE_8__["escapeHtml"])(id), "\"") : '';
      var anchor = id ? "<a class=\"ot-anchor\" data-mce-bogus=\"all\" href=\"#".concat(Object(_util_misc__WEBPACK_IMPORTED_MODULE_8__["escapeHtml"])(id), "\"></a>") : '';
      return "<".concat(nodeName).concat(idAttribute).concat(this.attributesToHtml(), ">").concat(anchor).concat(this.contentToHtml(), "</").concat(nodeName, ">");
    }
  }], [{
    key: "config",
    value: function config(nodeName, attributeNames, validChildNodes) {
      return new _config_VNodeConfig__WEBPACK_IMPORTED_MODULE_7__["default"](HeadingVNode, nodeName, 'structure').withNeedsBr(true).withAttributeNames(attributeNames).withValidChildNodes(validChildNodes).withCustomElementName("ot-built-in-".concat(nodeName.toLowerCase()));
    }
  }]);

  return HeadingVNode;
}(_ElementVNode__WEBPACK_IMPORTED_MODULE_6__["default"]);



/***/ }),

/***/ "./src/nodes/IFrameVNode.js":
/*!**********************************!*\
  !*** ./src/nodes/IFrameVNode.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return IFrameVNode; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _ElementVNode__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./ElementVNode */ "./src/nodes/ElementVNode.js");
/* harmony import */ var _config_VNodeConfig__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../config/VNodeConfig */ "./src/config/VNodeConfig.js");








var IFrameVNode =
/*#__PURE__*/
function (_ElementVNode) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(IFrameVNode, _ElementVNode);

  function IFrameVNode() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, IFrameVNode);

    return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(IFrameVNode).apply(this, arguments));
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(IFrameVNode, null, [{
    key: "config",
    value: function config(attributeNames) {
      return new _config_VNodeConfig__WEBPACK_IMPORTED_MODULE_6__["default"](IFrameVNode, 'IFRAME', 'embed').withAttributeNames(attributeNames).withCustomElementName('ot-built-in-iframe');
    }
  }]);

  return IFrameVNode;
}(_ElementVNode__WEBPACK_IMPORTED_MODULE_5__["default"]);



/***/ }),

/***/ "./src/nodes/ImgVNode.js":
/*!*******************************!*\
  !*** ./src/nodes/ImgVNode.js ***!
  \*******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ImgVNode; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _ElementVNode__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./ElementVNode */ "./src/nodes/ElementVNode.js");
/* harmony import */ var _config_VNodeConfig__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../config/VNodeConfig */ "./src/config/VNodeConfig.js");









var ImgVNode =
/*#__PURE__*/
function (_ElementVNode) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(ImgVNode, _ElementVNode);

  function ImgVNode() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, ImgVNode);

    return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(ImgVNode).apply(this, arguments));
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(ImgVNode, [{
    key: "realToVirtualAttributeName",
    value: function realToVirtualAttributeName(attributeName) {
      switch (attributeName) {
        case '@data-ot-src':
          return '@src';

        case '@data-ot-width':
          return '@width';

        case '@data-ot-height':
          return '@height';

        case '@src':
        case '@width':
        case '@height':
          return null;

        default:
          return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(ImgVNode.prototype), "realToVirtualAttributeName", this).call(this, attributeName);
      }
    }
  }, {
    key: "virtualToRealAttributeName",
    value: function virtualToRealAttributeName(attributeName) {
      switch (attributeName) {
        case '@src':
          return '@data-ot-src';

        case '@width':
          return '@data-ot-width';

        case '@height':
          return '@data-ot-height';

        case '@data-ot-src':
        case '@data-ot-width':
        case '@data-ot-height':
          return null;

        default:
          return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(ImgVNode.prototype), "virtualToRealAttributeName", this).call(this, attributeName);
      }
    }
  }], [{
    key: "config",
    value: function config(attributeNames) {
      return new _config_VNodeConfig__WEBPACK_IMPORTED_MODULE_7__["default"](ImgVNode, 'IMG', 'embed').withAttributeNames(attributeNames).withEmpty(true).withCustomElementName('ot-built-in-img');
    }
  }]);

  return ImgVNode;
}(_ElementVNode__WEBPACK_IMPORTED_MODULE_6__["default"]);



/***/ }),

/***/ "./src/nodes/PreVNode.js":
/*!*******************************!*\
  !*** ./src/nodes/PreVNode.js ***!
  \*******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return PreVNode; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/get */ "./node_modules/@babel/runtime/helpers/get.js");
/* harmony import */ var _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _ElementVNode__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./ElementVNode */ "./src/nodes/ElementVNode.js");
/* harmony import */ var _config_VNodeConfig__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../config/VNodeConfig */ "./src/config/VNodeConfig.js");









var PreVNode =
/*#__PURE__*/
function (_ElementVNode) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(PreVNode, _ElementVNode);

  function PreVNode() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, PreVNode);

    return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(PreVNode).apply(this, arguments));
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(PreVNode, [{
    key: "realToVirtualAttributeName",
    value: function realToVirtualAttributeName(attributeName) {
      return attributeName === '@class' && this.nodeType === 'embed' ? null : _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(PreVNode.prototype), "realToVirtualAttributeName", this).call(this, attributeName);
    }
  }, {
    key: "virtualToRealAttributeName",
    value: function virtualToRealAttributeName(attributeName) {
      return attributeName === '@class' && this.nodeType === 'embed' ? null : _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(PreVNode.prototype), "virtualToRealAttributeName", this).call(this, attributeName);
    }
  }, {
    key: "toHtml",
    value: function toHtml() {
      if (this.nodeType === 'embed') {
        var content = this.realNode ? this.realNode.innerHTML : '';
        var classAttribute = this.realNode ? " class=\"".concat(this.realNode.getAttribute('class'), "\"") : '';
        return "<pre contenteditable=\"false\"".concat(classAttribute).concat(this.attributesToHtml(), ">").concat(content, "</pre>");
      }

      return _babel_runtime_helpers_get__WEBPACK_IMPORTED_MODULE_4___default()(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(PreVNode.prototype), "toHtml", this).call(this);
    }
  }], [{
    key: "structureConfig",
    value: function structureConfig(attributeNames, validChildNodes) {
      return new _config_VNodeConfig__WEBPACK_IMPORTED_MODULE_7__["default"](PreVNode, 'PRE', 'structure').withNeedsBr(true).withAttributeNames(attributeNames).withValidChildNodes(validChildNodes);
    }
  }, {
    key: "embedConfig",
    value: function embedConfig(attributeNames) {
      return new _config_VNodeConfig__WEBPACK_IMPORTED_MODULE_7__["default"](PreVNode, 'PRE', 'embed').withAttributeNames(attributeNames).withCustomElementName('ot-built-in-pre');
    }
  }]);

  return PreVNode;
}(_ElementVNode__WEBPACK_IMPORTED_MODULE_6__["default"]);



/***/ }),

/***/ "./src/nodes/RootVNode.js":
/*!********************************!*\
  !*** ./src/nodes/RootVNode.js ***!
  \********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return RootVNode; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _ElementVNode__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./ElementVNode */ "./src/nodes/ElementVNode.js");
/* harmony import */ var _config_VNodeConfig__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../config/VNodeConfig */ "./src/config/VNodeConfig.js");








var RootVNode =
/*#__PURE__*/
function (_ElementVNode) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(RootVNode, _ElementVNode);

  function RootVNode() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, RootVNode);

    return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(RootVNode).apply(this, arguments));
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(RootVNode, [{
    key: "realToVirtualAttributeName",
    value: function realToVirtualAttributeName(attributeName) {
      return this.attributeNames.indexOf(attributeName) < 0 ? null : attributeName;
    }
  }, {
    key: "virtualToRealAttributeName",
    value: function virtualToRealAttributeName(attributeName) {
      return this.attributeNames.indexOf(attributeName) < 0 ? null : attributeName;
    }
  }], [{
    key: "config",
    value: function config(attributeNames, validChildNodes) {
      return new _config_VNodeConfig__WEBPACK_IMPORTED_MODULE_6__["default"](RootVNode, '#root', 'root').withAttributeNames(attributeNames).withValidChildNodes(validChildNodes);
    }
  }]);

  return RootVNode;
}(_ElementVNode__WEBPACK_IMPORTED_MODULE_5__["default"]);



/***/ }),

/***/ "./src/nodes/TextVNode.js":
/*!********************************!*\
  !*** ./src/nodes/TextVNode.js ***!
  \********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return TextVNode; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _VNode__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./VNode */ "./src/nodes/VNode.js");
/* harmony import */ var _config_VNodeConfig__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../config/VNodeConfig */ "./src/config/VNodeConfig.js");
/* harmony import */ var _util_misc__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../util/misc */ "./src/util/misc.js");








var isIE11 = document.documentMode === 11;

function ie11StringReplacer(match) {
  return Object(_util_misc__WEBPACK_IMPORTED_MODULE_7__["repeatString"])("\xA0", match.length - 1) + ' ';
}

var TextVNode =
/*#__PURE__*/
function (_VNode) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(TextVNode, _VNode);

  function TextVNode() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, TextVNode);

    return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(TextVNode).apply(this, arguments));
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(TextVNode, [{
    key: "normalizeNodeValue",
    // Prepares nodeValue for the OT model by replacing \u00A0 (non-breaking space) with \u0020 (space),
    // and by removing \uFEFF (zero-width non-breaking space).
    value: function normalizeNodeValue(nodeValue) {
      return nodeValue === "\uFEFF" ? nodeValue : nodeValue.replace(/\uFEFF/g, '').replace(/\u00A0/g, ' ');
    } // Prepares nodeValue for use in the DOM by replacing some \u0020 (space) with \u00A0 (non-breaking space).

  }, {
    key: "denormalizeNodeValue",
    value: function denormalizeNodeValue(nodeValue) {
      return isIE11 ? nodeValue.replace(/  +/g, ie11StringReplacer) : nodeValue.replace(/ {2}/g, "\xA0 ").replace(/ {2}/g, " \xA0").replace(/^ /, "\xA0").replace(/ $/, "\xA0");
    }
  }, {
    key: "createRealNode",
    value: function createRealNode(document) {
      return document.createTextNode('');
    }
  }, {
    key: "updateRealNodeValue",
    value: function updateRealNodeValue(oldNodeValue) {
      // If `this.nodeValue === oldNodeValue`, then `this.realNode.nodeValue` is guaranteed to be prepared for
      // rendering (ie it contains &nbsp; characters), because it's set to `denormalizedNodeValue` when real
      // nodes are created from virtual nodes, on mutation and when creating new vNodes from real nodes.
      if (this.nodeValue !== oldNodeValue) {
        var normalizedNodeValue = this.normalizeNodeValue(this.nodeValue);
        var denormalizedNodeValue = this.denormalizeNodeValue(normalizedNodeValue);
        this.nodeValue = normalizedNodeValue;
        this.realNode.nodeValue = denormalizedNodeValue;
      }
    }
  }, {
    key: "updateVNodeValue",
    value: function updateVNodeValue() {
      var realNode = this.realNode;
      var realNodeValue = realNode.nodeValue;
      var normalizedNodeValue = this.normalizeNodeValue(realNodeValue);
      var denormalizedNodeValue = this.denormalizeNodeValue(normalizedNodeValue);
      this.nodeValue = normalizedNodeValue;

      if (realNodeValue !== denormalizedNodeValue) {
        // The selection is explicitly reset to prevent it from jumping to the start of the text node,
        // when the `nodeValue` is set.
        var _document = realNode.ownerDocument;
        var window = _document.defaultView;

        if (!window) {
          realNode.nodeValue = denormalizedNodeValue;
          return;
        }

        var selection = window.getSelection();

        if (selection.rangeCount === 0) {
          realNode.nodeValue = denormalizedNodeValue;
          return;
        }

        var anchorNode = selection.anchorNode,
            anchorOffset = selection.anchorOffset,
            focusNode = selection.focusNode,
            focusOffset = selection.focusOffset;

        if (anchorNode !== realNode && focusNode !== realNode) {
          realNode.nodeValue = denormalizedNodeValue;
          return;
        }

        if (isIE11) {
          // IE11 cannot correctly handle nodeValue modification and resetting the
          // selection, so we avoid doing it altogether.
          // See https://digitalcrew.teamwork.com/#/projects/284815/tasks/14210644
          return;
        }

        realNode.nodeValue = denormalizedNodeValue;
        var nodeValueLength = denormalizedNodeValue.length;
        var newAnchorOffset = anchorNode !== realNode ? anchorOffset : Math.min(nodeValueLength, anchorOffset);
        var newFocusOffset = focusNode !== realNode ? focusOffset : Math.min(nodeValueLength, focusOffset);
        Object(_util_misc__WEBPACK_IMPORTED_MODULE_7__["setSelection"])(selection, anchorNode, newAnchorOffset, focusNode, newFocusOffset);
      }
    }
  }, {
    key: "toHtml",
    value: function toHtml() {
      return this.isFormattingHelper() ? '' : Object(_util_misc__WEBPACK_IMPORTED_MODULE_7__["escapeHtml"])(this.denormalizeNodeValue(this.normalizeNodeValue(this.nodeValue)));
    }
  }, {
    key: "validateNodeValue",
    value: function validateNodeValue() {
      return isIE11 ? this.normalizeNodeValue(this.realNode.nodeValue) === this.normalizeNodeValue(this.nodeValue) : this.realNode.nodeValue === this.denormalizeNodeValue(this.normalizeNodeValue(this.nodeValue));
    }
  }, {
    key: "isFormattingHelper",
    value: function isFormattingHelper() {
      return this.nodeValue === "\uFEFF";
    }
  }], [{
    key: "config",
    value: function config() {
      return new _config_VNodeConfig__WEBPACK_IMPORTED_MODULE_6__["default"](TextVNode, '#text', 'text');
    }
  }]);

  return TextVNode;
}(_VNode__WEBPACK_IMPORTED_MODULE_5__["default"]);



/***/ }),

/***/ "./src/nodes/VNode.js":
/*!****************************!*\
  !*** ./src/nodes/VNode.js ***!
  \****************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return VNode; });
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/wrapNativeSuper */ "./node_modules/@babel/runtime/helpers/wrapNativeSuper.js");
/* harmony import */ var _babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _util_misc__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../util/misc */ "./src/util/misc.js");








var ValidationError =
/*#__PURE__*/
function (_Error) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(ValidationError, _Error);

  function ValidationError(message, vNode, realNode) {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, ValidationError);

    _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(ValidationError).call(this, message));
    _this.vNode = vNode;
    _this.realNode = realNode || vNode.realNode;
    return _this;
  }

  return ValidationError;
}(_babel_runtime_helpers_wrapNativeSuper__WEBPACK_IMPORTED_MODULE_5___default()(Error));

var VNode =
/*#__PURE__*/
function () {
  function VNode(config, nodeValue, realNode) {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, VNode);

    this.config = config;
    this.childNodes = config.hasChildNodes ? [] : null;
    this.attributes = null;
    this.nodeValue = !config.hasNodeValue ? '' : nodeValue != null ? nodeValue : config.nodeType === 'text' ? '' : // Reuse the existing nodeValue, if possible.
    realNode && realNode[_util_misc__WEBPACK_IMPORTED_MODULE_6__["vNodeKey"]] && realNode[_util_misc__WEBPACK_IMPORTED_MODULE_6__["vNodeKey"]].nodeValue || // A random Unicode character in the Private Use Area of the Basic Multilingual Plane.
    String.fromCharCode(0xe000 + Math.random() * 6400);
    this.realNode = null;
    this.modelStartOffset = 0;
    this.modelEndOffset = 0;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_0___default()(VNode, [{
    key: "createRealNode",
    value: function createRealNode(_document) {
      return null;
    }
  }, {
    key: "upgradeRealNode",
    value: function upgradeRealNode(_realNode) {}
  }, {
    key: "updateRealNodeValue",
    value: function updateRealNodeValue(_oldNodeValue) {}
  }, {
    key: "updateRealAttributes",
    value: function updateRealAttributes(_oldAttributes) {}
  }, {
    key: "updateVNodeValue",
    value: function updateVNodeValue() {}
  }, {
    key: "updateVAttributes",
    value: function updateVAttributes() {}
  }, {
    key: "toHtml",
    value: function toHtml() {
      return '';
    }
  }, {
    key: "appendTo",
    value: function appendTo(parentVNode) {
      parentVNode.childNodes.push(this);
      return this;
    } // Quickly checks, if this node is similar to another node.

  }, {
    key: "isSimilarTo",
    value: function isSimilarTo(vNode) {
      return this.nodeName === vNode.nodeName && this.nodeType === vNode.nodeType && (this.nodeType === 'text' || this.nodeValue === vNode.nodeValue);
    }
  }, {
    key: "linkRealNode",
    value: function linkRealNode(realNode) {
      if (this.realNode) {
        throw new Error('This vNode is already linked to a realNode');
      }

      var connected = !realNode[_util_misc__WEBPACK_IMPORTED_MODULE_6__["vNodeKey"]];
      this.realNode = realNode;
      realNode[_util_misc__WEBPACK_IMPORTED_MODULE_6__["vNodeKey"]] = this;

      if (connected && realNode[_util_misc__WEBPACK_IMPORTED_MODULE_6__["fakeCustomElementKey"]]) {
        var connectedCallback = realNode.connectedCallback;

        if (typeof connectedCallback === 'function') {
          connectedCallback.call(realNode);
        }
      }

      return realNode;
    }
  }, {
    key: "unlinkRealNode",
    value: function unlinkRealNode() {
      var realNode = this.realNode;
      var childNodes = this.childNodes;
      this.realNode[_util_misc__WEBPACK_IMPORTED_MODULE_6__["vNodeKey"]] = null;
      this.realNode = null;

      if (childNodes) {
        for (var i = 0, l = childNodes.length; i < l; ++i) {
          childNodes[i].unlinkRealNode();
        }
      }

      if (realNode[_util_misc__WEBPACK_IMPORTED_MODULE_6__["fakeCustomElementKey"]]) {
        var disconnectedCallback = realNode.disconnectedCallback;

        if (typeof disconnectedCallback === 'function') {
          disconnectedCallback.call(realNode);
        }
      }
    }
  }, {
    key: "resetNodeId",
    value: function resetNodeId() {
      var nodeId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "\uE000";

      if (this.hasNodeValue && this.nodeType !== 'text') {
        this.nodeValue = nodeId;
      }

      var childNodes = this.childNodes;

      if (childNodes) {
        for (var i = 0, l = childNodes.length; i < l; ++i) {
          childNodes[i].resetNodeId(nodeId);
        }
      }
    } // Recursively sets this.nodeValue to vNode.nodeValue, if nodes are the same (except for nodeValue and childNodes).
    //
    // NOTE The recursive algorithm works on the best effort basis because this function is used only as an
    // optimization and does not affect the correctness of the whole system.

  }, {
    key: "restoreNodeId",
    value: function restoreNodeId(vNode) {
      if (this.nodeType !== 'structure' && this.nodeType !== 'embed' && this.nodeType !== 'root') {
        return true;
      }

      if (this.config === vNode.config && Object(_util_misc__WEBPACK_IMPORTED_MODULE_6__["areArraysEqual"])(this.attributes, vNode.attributes)) {
        this.nodeValue = vNode.nodeValue;

        if (this.childNodes !== null) {
          var thisStartIndex = 0;
          var thisEndIndex = this.childNodes.length - 1;
          var thatStartIndex = 0;
          var thatEndIndex = vNode.childNodes.length - 1; // Restore node IDs for the child nodes at the start.

          while (thisStartIndex <= thisEndIndex && thatStartIndex <= thatEndIndex && this.childNodes[thisStartIndex].restoreNodeId(vNode.childNodes[thatStartIndex])) {
            thisStartIndex++;
            thatStartIndex++;
          } // Restore node IDs for the child nodes at the end.


          while (thisStartIndex <= thisEndIndex && thatStartIndex <= thatEndIndex && this.childNodes[thisEndIndex].restoreNodeId(vNode.childNodes[thatEndIndex])) {
            thisEndIndex--;
            thatEndIndex--;
          }
        }

        return true;
      }

      return false;
    }
  }, {
    key: "validate",
    value: function validate() {
      try {
        this.validateVirtualNode();
        this.validateRealNode(this.realNode);
        this.validateNodesEqual();
        return null;
      } catch (error) {
        console.error(error, error.vNode, error.realNode);
        return error;
      }
    } // Recursively checks that `realNode[vNodeKey].realNode === realNode`.

  }, {
    key: "validateRealNode",
    value: function validateRealNode(realNode) {
      if (Object(_util_misc__WEBPACK_IMPORTED_MODULE_6__["isIgnoredNode"])(realNode)) {
        return;
      }

      var vNode = realNode[_util_misc__WEBPACK_IMPORTED_MODULE_6__["vNodeKey"]];

      if (!vNode) {
        throw new ValidationError('vNode missing', vNode, realNode);
      }

      if (vNode.realNode !== realNode) {
        throw new ValidationError('Invalid realNode', vNode, realNode);
      }

      if (vNode.childNodes !== null) {
        var childNodes = realNode.childNodes;

        for (var i = 0, l = childNodes.length; i < l; ++i) {
          this.validateRealNode(childNodes[i]);
        }
      }
    } // Recursively checks that `this.realNode[vNodeKey] === this`.

  }, {
    key: "validateVirtualNode",
    value: function validateVirtualNode() {
      if (!this.realNode) {
        throw new ValidationError('realNode missing', this);
      }

      if (this.realNode[_util_misc__WEBPACK_IMPORTED_MODULE_6__["vNodeKey"]] !== this) {
        throw new ValidationError('Invalid vNode', this);
      }

      if (this.childNodes) {
        for (var i = 0, l = this.childNodes.length; i < l; ++i) {
          this.childNodes[i].validateVirtualNode();
        }
      }
    } // Recursively checks that the 2 nodes are equal.

  }, {
    key: "validateNodesEqual",
    value: function validateNodesEqual() {
      var realNode = this.realNode;

      if (this.nodeName !== '#root' && this.nodeName !== '#unknown' && this.nodeName !== realNode.nodeName) {
        throw new ValidationError('nodeName mismatch', this);
      }

      if (this.nodeType === 'text' && !this.validateNodeValue()) {
        throw new ValidationError('nodeValue mismatch', this);
      }

      if (this.attributeNames) {
        if (!this.attributes) {
          throw new ValidationError('attributes missing', this);
        } else if (!Object(_util_misc__WEBPACK_IMPORTED_MODULE_6__["areArraysEqual"])(this.attributes, this.getAttributesFromRealNode(false))) {
          throw new ValidationError('attributes mismatch', this);
        }
      } else if (this.attributes) {
        throw new ValidationError('attributes unexpected', this);
      }

      if (this.childNodes) {
        var realChildNodes = realNode.childNodes;
        var i1 = 0; // index for this.childNodes

        var i2 = 0; // index for realChildNodes

        var l1 = this.childNodes.length;
        var l2 = realChildNodes.length;

        while (i1 < l1 && i2 < l2) {
          var realChild = realChildNodes[i2++];

          if (!Object(_util_misc__WEBPACK_IMPORTED_MODULE_6__["isIgnoredNode"])(realChild)) {
            this.childNodes[i1++].validateNodesEqual();
          }
        }

        while (i1 < l1) {
          throw new ValidationError('An extraneous virtual node found at index ' + i1, this);
        }

        while (i2 < l2) {
          if (!Object(_util_misc__WEBPACK_IMPORTED_MODULE_6__["isIgnoredNode"])(realChildNodes[i2])) {
            throw new ValidationError('An extraneous real node found at index ' + i2, this);
          }

          i2++;
        }
      }
    }
  }, {
    key: "validateNodeValue",
    value: function validateNodeValue() {
      return true;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        nodeName: this.nodeName,
        nodeType: this.nodeType,
        nodeValue: this.nodeValue,
        modelStartOffset: this.modelStartOffset,
        modelEndOffset: this.modelEndOffset,
        attributes: this.attributes,
        childNodes: this.childNodes
      };
    }
  }, {
    key: "isFormattingHelper",
    value: function isFormattingHelper() {
      return false;
    }
  }, {
    key: "nodeName",
    get: function get() {
      return this.config.nodeName;
    }
  }, {
    key: "nodeType",
    get: function get() {
      return this.config.nodeType;
    }
  }, {
    key: "needsBr",
    get: function get() {
      return this.config.needsBr;
    }
  }, {
    key: "attributeNames",
    get: function get() {
      return this.config.attributeNames;
    }
  }, {
    key: "hasChildNodes",
    get: function get() {
      return this.config.hasChildNodes;
    }
  }, {
    key: "hasNodeValue",
    get: function get() {
      return this.config.hasNodeValue;
    }
  }, {
    key: "defaultChildNode",
    get: function get() {
      return this.config.defaultChildNode;
    }
  }, {
    key: "validChildNodes",
    get: function get() {
      return this.config.validChildNodes;
    }
  }, {
    key: "empty",
    get: function get() {
      return this.config.empty;
    }
  }, {
    key: "customElementName",
    get: function get() {
      return this.config.customElementName;
    }
  }]);

  return VNode;
}();



/***/ }),

/***/ "./src/nodes/VideoVNode.js":
/*!*********************************!*\
  !*** ./src/nodes/VideoVNode.js ***!
  \*********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return VideoVNode; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _ElementVNode__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./ElementVNode */ "./src/nodes/ElementVNode.js");
/* harmony import */ var _config_VNodeConfig__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../config/VNodeConfig */ "./src/config/VNodeConfig.js");








var VideoVNode =
/*#__PURE__*/
function (_ElementVNode) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_4___default()(VideoVNode, _ElementVNode);

  function VideoVNode() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, VideoVNode);

    return _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(VideoVNode).apply(this, arguments));
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(VideoVNode, [{
    key: "toHtml",
    value: function toHtml() {
      return "<video".concat(this.attributesToHtml(), "></video>");
    }
  }], [{
    key: "config",
    value: function config(attributeNames) {
      return new _config_VNodeConfig__WEBPACK_IMPORTED_MODULE_6__["default"](VideoVNode, 'VIDEO', 'embed').withAttributeNames(attributeNames).withCustomElementName('ot-built-in-video');
    }
  }]);

  return VideoVNode;
}(_ElementVNode__WEBPACK_IMPORTED_MODULE_5__["default"]);



/***/ }),

/***/ "./src/tinymce/TinyMcePresence.js":
/*!****************************************!*\
  !*** ./src/tinymce/TinyMcePresence.js ***!
  \****************************************/
/*! exports provided: TinyMcePresence */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TinyMcePresence", function() { return TinyMcePresence; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "./node_modules/@babel/runtime/helpers/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var events__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! events */ "./node_modules/events/events.js");
/* harmony import */ var events__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(events__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var scroll_into_view_if_needed__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! scroll-into-view-if-needed */ "./node_modules/scroll-into-view-if-needed/es/index.js");
/* harmony import */ var _util_misc__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../util/misc */ "./src/util/misc.js");
/* harmony import */ var _util_colors__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../util/colors */ "./src/util/colors.js");










var styles = "\n.ot-caret {\n    position: absolute;\n    padding: 8px 6px 0 6px;\n    margin: -8px 0 0 -6px;\n    width: 0;\n    box-sizing: content-box;\n}\n\n.ot-caret__bar {\n    height: 100%;\n    width: 2px;\n    margin-left: -1px;\n}\n\n.ot-caret__bar::before {\n    content: '';\n    position: absolute;\n    background: inherit;\n    display: block;\n    width: 8px;\n    height: 8px;\n    margin: -8px 0 0 -3px;\n    opacity: 0.9;\n    transition: opacity 0.15s ease;\n    border-radius: 4px;\n}\n\n.ot-caret--hasLabel.ot-caret--active > .ot-caret__bar::before {\n    opacity: 0;\n}\n\n.ot-caret__label {\n    position: absolute;\n    bottom: 100%;\n    padding: 2px 4px;\n    margin: 0 0 -8px -4px;\n    white-space: nowrap;\n    opacity: 0;\n    transition: opacity 0.15s ease;\n    z-index: 1;\n    border-radius: 4px;\n}\n\n.ot-caret__avatar {\n    width: 16px;\n    height: 16px;\n    max-width: none;\n    margin: 0 3px -4px 0;\n    border-radius: 8px;\n    border: 1px solid;\n}\n\n.ot-caret__avatar--error,\n.ot-caret__avatar:not([src]) {\n    display: none;\n}\n\n.ot-caret--hasLabel.ot-caret--active > .ot-caret__label {\n    opacity: 0.9;\n}\n\n.ot-selection {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 0;\n    height: 0;\n    opacity: 0.2;\n}\n\n.ot-selection--fade-out {\n    opacity: 0;\n    transition: opacity 15s ease-in 5s;\n}\n\n.ot-selection__item {\n    position: absolute;\n    background: inherit;\n    color: inherit;\n}\n";
var TinyMcePresence =
/*#__PURE__*/
function (_EventEmitter) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_5___default()(TinyMcePresence, _EventEmitter);

  function TinyMcePresence(src, userId, containerNode) {
    var _this;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, TinyMcePresence);

    _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_2___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_3___default()(TinyMcePresence).call(this));
    var document = containerNode.ownerDocument;
    _this.onDeactivationTimeout = _this.onDeactivationTimeout.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this));
    _this.deactivationTimeoutHandle = null;
    _this.src = src;
    _this.userId = userId;
    _this.containerNode = containerNode;
    _this.color = '#fff';
    _this.backgroundColor = Object(_util_colors__WEBPACK_IMPORTED_MODULE_9__["claimColor"])(_this.containerNode, _this.userId);
    _this.deactivationDelay = 1000;
    _this.numberOfChanges = 0;
    _this.selectionFadedOut = false; // Specifies the position and size of the visible part of the edited document.
    // All values are expressed in the coordinate system of this.containerNode.

    _this.viewport = null; // The position on the screen and the size of this.containerNode.

    _this.containerRect = null; // The position on the screen and the size of the caret marker.

    _this.caretRect = null; // The positions on the screen and the sizes of the selection markers.

    _this.selectionRects = null; // NOTE All caret and selection marker positions are relative to the viewport (screen), so they
    // must converted to positions in this.containerNode by subtracting the position of this.containerRect,
    // so that the marker nodes appear in the expected places, when added to this.containerNode.
    //
    // this.caretRect and this.selectionRects are not adjusted beforehand because the rectangles are read-only,
    // so many new objects would need to be created, which would be inefficient. All the rectangles are created
    // by getClientRects and getBoundingClientRect methods.

    _this.caretNode = document.createElement('DIV');

    _this.caretNode.classList.add('ot-caret');

    _this.containerNode.appendChild(_this.caretNode);

    _this.barNode = document.createElement('DIV');
    _this.barNode.style.color = _this.color;
    _this.barNode.style.backgroundColor = _this.backgroundColor;

    _this.barNode.classList.add('ot-caret__bar');

    _this.caretNode.appendChild(_this.barNode);

    _this.labelNode = document.createElement('DIV');
    _this.labelNode.style.color = _this.color;
    _this.labelNode.style.backgroundColor = _this.backgroundColor;

    _this.labelNode.classList.add('ot-caret__label');

    _this.caretNode.appendChild(_this.labelNode);

    _this.avatarNode = document.createElement('IMG');
    _this.avatarNode.style.borderColor = _this.color;

    _this.avatarNode.classList.add('ot-caret__avatar');

    _this.avatarNode.addEventListener('error', function () {
      _this.avatarNode.classList.add('ot-caret__avatar--error');
    });

    _this.labelNode.appendChild(_this.avatarNode);

    _this.labelTextNode = document.createTextNode('');

    _this.labelNode.appendChild(_this.labelTextNode);

    _this.selectionNode = document.createElement('DIV');
    _this.selectionNode.style.color = _this.color;
    _this.selectionNode.style.backgroundColor = _this.backgroundColor;

    _this.selectionNode.classList.add('ot-selection');

    _this.selectionNode.addEventListener('transitionend', _this.onSelectionTransitionEnd.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_4___default()(_this)));

    _this.containerNode.appendChild(_this.selectionNode);

    _this.label = '';
    _this.avatar = '';
    _this.active = false;
    _this.hovered = false;
    _this.custom = null;

    _this.ensureStyles();

    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(TinyMcePresence, [{
    key: "dispose",
    value: function dispose() {
      Object(_util_colors__WEBPACK_IMPORTED_MODULE_9__["releaseColor"])(this.containerNode, this.userId);
      this.removeCaretNode();
      this.removeSelectionNode();
    }
  }, {
    key: "reportActivity",
    value: function reportActivity(numberOfChanges) {
      var madeChanges = this.numberOfChanges !== numberOfChanges;
      this.numberOfChanges = numberOfChanges;
      this.active = true;
      this.emit('activity', madeChanges);
    }
  }, {
    key: "scrollIntoView",
    value: function scrollIntoView() {
      Object(scroll_into_view_if_needed__WEBPACK_IMPORTED_MODULE_7__["default"])(this.caretNode, {
        scrollMode: 'if-needed'
      });

      this.active = true;
    }
  }, {
    key: "containsPoint",
    value: function containsPoint(x, y) {
      return x >= 0 && y >= 0 && (Object(_util_misc__WEBPACK_IMPORTED_MODULE_8__["nodeContainsPoint"])(this.caretNode, x, y) || this.active && Object(_util_misc__WEBPACK_IMPORTED_MODULE_8__["nodeContainsPoint"])(this.labelNode, x, y));
    }
  }, {
    key: "beforeUpdate",
    value: function beforeUpdate(submitted) {
      if (submitted) {
        this.selectionNode.classList.remove('ot-selection--fade-out');
      }
    }
  }, {
    key: "update",
    value: function update(submitted) {
      if (submitted && this.selectionFadedOut) {
        this.selectionFadedOut = false;
      }

      this.updateCaret();
      this.updateSelection();
    } // Called after carets and selections have been set for all presence objects and after a forced reflow.
    // This function enables reliable updates to animated properties (see https://stackoverflow.com/a/16575811/706807)
    // while requiring only one forced reflow.

  }, {
    key: "afterUpdate",
    value: function afterUpdate(submitted) {
      if (submitted) {
        this.selectionNode.classList.add('ot-selection--fade-out');
      }
    }
  }, {
    key: "ensureStyles",
    value: function ensureStyles() {
      var children = this.containerNode.children;

      for (var i = 0, l = children.length; i < l; ++i) {
        var child = children[i];

        if (child.nodeName === 'STYLE' && child.getAttribute('data-source') === 'ot-client') {
          return;
        }
      }

      var document = this.containerNode.ownerDocument;
      var styleNode = document.createElement('STYLE');
      styleNode.setAttribute('type', 'text/css');
      styleNode.setAttribute('data-source', 'ot-client');
      styleNode.textContent = styles;
      this.containerNode.insertBefore(styleNode, this.containerNode.childNodes[0]);
    }
  }, {
    key: "addCaretNode",
    value: function addCaretNode() {
      if (this.caretNode.parentNode !== this.containerNode) {
        this.containerNode.appendChild(this.caretNode);
      }
    }
  }, {
    key: "removeCaretNode",
    value: function removeCaretNode() {
      if (this.caretNode.parentNode === this.containerNode) {
        this.containerNode.removeChild(this.caretNode);
      }
    }
  }, {
    key: "addSelectionNode",
    value: function addSelectionNode() {
      if (this.selectionNode.parentNode !== this.containerNode) {
        this.containerNode.appendChild(this.selectionNode);
      }
    }
  }, {
    key: "removeSelectionNode",
    value: function removeSelectionNode() {
      if (this.selectionNode.parentNode === this.containerNode) {
        this.containerNode.removeChild(this.selectionNode);
      }
    }
  }, {
    key: "setUpDeactivationTimeout",
    value: function setUpDeactivationTimeout(reset) {
      var needsTimeout = this.active && !this.hovered;
      var hasTimeout = this.deactivationTimeoutHandle != null;

      if (hasTimeout && (!needsTimeout || reset)) {
        clearTimeout(this.deactivationTimeoutHandle);
        this.deactivationTimeoutHandle = null;
        hasTimeout = false;
      }

      if (needsTimeout && !hasTimeout) {
        this.deactivationTimeoutHandle = setTimeout(this.onDeactivationTimeout, this.deactivationDelay);
      }
    }
  }, {
    key: "onDeactivationTimeout",
    value: function onDeactivationTimeout() {
      this.deactivationTimeoutHandle = null;
      this.active = false;
    }
  }, {
    key: "onSelectionTransitionEnd",
    value: function onSelectionTransitionEnd(event) {
      if (event.target === this.selectionNode && !event.pseudoElement && event.propertyName === 'opacity') {
        this.selectionFadedOut = true;
        this.removeSelectionNode();
      }
    }
  }, {
    key: "updateCaret",
    value: function updateCaret() {
      var rect = this.caretRect;

      if (!rect) {
        this.removeCaretNode();
        return;
      }

      this.addCaretNode();
      this.caretNode.style.left = rect.left - this.containerRect.left + 'px';
      this.caretNode.style.top = rect.top - this.containerRect.top + 'px';
      this.caretNode.style.height = rect.height + 'px';
    }
  }, {
    key: "updateSelection",
    value: function updateSelection() {
      if (this.selectionFadedOut) {
        return;
      }

      var rects = this.selectionRects;

      if (!rects) {
        this.removeSelectionNode();
        return;
      }

      this.addSelectionNode();
      var containerRect = this.containerRect;
      var document = this.selectionNode.ownerDocument;
      var viewportTop = this.viewport.top;
      var viewportBottom = this.viewport.bottom;
      var node = this.selectionNode.firstChild;

      for (var i = 0, l = rects.length; i < l; ++i) {
        var rect = rects[i];
        var top = rect.top - containerRect.top;
        var height = rect.height;
        var bottom = top + height;

        if (top > viewportBottom || bottom < viewportTop) {
          continue;
        }

        if (!node) {
          node = document.createElement('DIV');
          node.classList.add('ot-selection__item');
          this.selectionNode.appendChild(node);
        }

        node.style.left = rect.left - containerRect.left + 'px';
        node.style.top = top + 'px';
        node.style.width = rect.width + 'px';
        node.style.height = height + 'px';
        node = node.nextSibling;
      }

      while (node) {
        var nextSibling = node.nextSibling;
        this.selectionNode.removeChild(node);
        node = nextSibling;
      }
    }
  }, {
    key: "label",
    get: function get() {
      return this._label;
    },
    set: function set(label) {
      this._label = '' + label;
      var hasLabel = this._label.length > 0;
      this.labelTextNode.data = this._label;
      Object(_util_misc__WEBPACK_IMPORTED_MODULE_8__["toggleClass"])(this.caretNode, 'ot-caret--hasLabel', hasLabel);
      Object(_util_misc__WEBPACK_IMPORTED_MODULE_8__["toggleClass"])(this.caretNode, 'ot-caret--noLabel', !hasLabel);
    }
  }, {
    key: "avatar",
    get: function get() {
      return this._avatar;
    },
    set: function set(avatar) {
      this._avatar = '' + avatar;
      this.avatarNode.classList.remove('ot-caret__avatar--error');
      var hasAvatar = !!this._avatar;

      if (hasAvatar) {
        this.avatarNode.setAttribute('src', this._avatar);
      } else {
        this.avatarNode.removeAttribute('src');
      }
    }
  }, {
    key: "hovered",
    get: function get() {
      return this._hovered;
    },
    set: function set(hovered) {
      this._hovered = hovered = !!hovered;

      if (hovered && !this.active) {
        this.active = true;
      }

      this.setUpDeactivationTimeout(false);
    }
  }, {
    key: "active",
    get: function get() {
      return this._active;
    },
    set: function set(active) {
      active = !!active;

      if (this._active !== active) {
        this._active = active;
        Object(_util_misc__WEBPACK_IMPORTED_MODULE_8__["toggleClass"])(this.caretNode, 'ot-caret--active', active);
        Object(_util_misc__WEBPACK_IMPORTED_MODULE_8__["toggleClass"])(this.caretNode, 'ot-caret--inactive', !active);
      }

      this.setUpDeactivationTimeout(true);
    }
  }]);

  return TinyMcePresence;
}(events__WEBPACK_IMPORTED_MODULE_6__["EventEmitter"]);

/***/ }),

/***/ "./src/tinymce/TinyMceSync.js":
/*!************************************!*\
  !*** ./src/tinymce/TinyMceSync.js ***!
  \************************************/
/*! exports provided: TinyMceSync */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TinyMceSync", function() { return TinyMceSync; });
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "./node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "./node_modules/@babel/runtime/helpers/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "./node_modules/@babel/runtime/helpers/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "./node_modules/@babel/runtime/helpers/inherits.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var events__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! events */ "./node_modules/events/events.js");
/* harmony import */ var events__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(events__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! lodash.throttle */ "./node_modules/lodash.throttle/index.js");
/* harmony import */ var lodash_throttle__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_throttle__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var scroll_into_view_if_needed__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! scroll-into-view-if-needed */ "./node_modules/scroll-into-view-if-needed/es/index.js");
/* harmony import */ var _teamwork_ot_rich_text_lib_Operation__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @teamwork/ot-rich-text/lib/Operation */ "./node_modules/@teamwork/ot-rich-text/lib/Operation.js");
/* harmony import */ var _teamwork_ot_rich_text_lib_Operation__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_teamwork_ot_rich_text_lib_Operation__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @teamwork/ot-rich-text/lib/Action */ "./node_modules/@teamwork/ot-rich-text/lib/Action.js");
/* harmony import */ var _teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _util_misc__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../util/misc */ "./src/util/misc.js");
/* harmony import */ var _TinyMcePresence__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./TinyMcePresence */ "./src/tinymce/TinyMcePresence.js");
/* harmony import */ var _util_ReadOnlyRect__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../util/ReadOnlyRect */ "./src/util/ReadOnlyRect.js");















var formatAttributes = [];
var formatIndexes = [];
var noSelection = Object.freeze({
  node: null,
  offset: 0
});

var selectionComparator = function selectionComparator(position, preferEarlierNode) {
  return preferEarlierNode ? function (node) {
    return node.modelStartOffset >= position ? -1 : node.modelEndOffset < position ? 1 : 0;
  } : function (node) {
    return node.modelStartOffset > position ? -1 : node.modelEndOffset <= position ? 1 : 0;
  };
}; // Maps a TextVNode to an OT model position and action for inserting an \uFEFF character, which TinyMCE uses
// to implement formatting support.
// A WeakMap is used instead of adding a property to TextVNode to avoid changing the object's "shape" and/or increasing
// memory usage for a property which is very rarely set.
// The information in this map could be generated on demand from a VNode, however, it would introduce unnecessary
// complexity. It's just easier and faster to just capture the information when it's naturally available.


var textNodeToFormattingHelper = new WeakMap(); // Used to differentiate formatting helper actions from similar actions with 100% accuracy.

var formattingHelperActions = new WeakMap(); // Synchronizes a DOM node with a ot-rich-text model.

var TinyMceSync =
/*#__PURE__*/
function (_EventEmitter) {
  _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_6___default()(TinyMceSync, _EventEmitter);

  function TinyMceSync() {
    var _this;

    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        config = _ref.config,
        doc = _ref.doc,
        domNode = _ref.domNode,
        _ref$presenceEnabled = _ref.presenceEnabled,
        presenceEnabled = _ref$presenceEnabled === void 0 ? true : _ref$presenceEnabled,
        _ref$debug = _ref.debug,
        debug = _ref$debug === void 0 ? false : _ref$debug,
        _ref$presenceDelay = _ref.presenceDelay,
        presenceDelay = _ref$presenceDelay === void 0 ? 500 : _ref$presenceDelay,
        _ref$asyncScrollUpdat = _ref.asyncScrollUpdate,
        asyncScrollUpdate = _ref$asyncScrollUpdat === void 0 ? false : _ref$asyncScrollUpdat;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, TinyMceSync);

    _this = _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_3___default()(this, _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_4___default()(TinyMceSync).call(this));
    _this._document = domNode.ownerDocument;
    var window = _this._document.defaultView;
    var parentWindow = Object(_util_misc__WEBPACK_IMPORTED_MODULE_12__["getIframeElement"])(window) ? window.parent : null; // Store the reference to ensure that the event listener will be removed in dispose.

    _this._parentWindow = parentWindow;
    _this._formats = config.formats;
    _this._formatsByDom = config.formatsByDom;
    _this._formatsByOt = config.formatsByOt;
    _this._configByNodeName = config.configByNodeName;

    _this._formats.forEach(function (value, index) {
      // Initialize helper variables to avoid allocations later on.
      formatAttributes[index] = null;
      formatIndexes[index] = 0;
    });

    _this._doc = doc;
    _this._undoManager = doc.connection.createUndoManager();
    _this._realDom = domNode;

    _this._addRealDomStyles();

    _this._presenceEnabled = false;
    _this._virtualDom = _this.createVNodeFromRealNode(_this._realDom, true);
    _this.debug = debug;
    _this._asyncScrollUpdate = asyncScrollUpdate;

    if (_this.debug) {
      _this._virtualDom.validate();
    } // A container for the DOM nodes used to display other users' carets and selections.


    _this._presenceInnerNode = _this._document.createElement('DIV');
    _this._presenceInnerNode.style.display = 'block';
    _this._presenceInnerNode.style.position = 'absolute';
    _this._presenceInnerNode.style.top = '0';
    _this._presenceInnerNode.style.left = '0';
    _this._presenceInnerNode.style.width = '100%';
    _this._presenceInnerNode.style.height = '100%';
    _this._presenceNode = _this._document.createElement('DIV');

    _this._presenceNode.classList.add('ot-presence');

    _this._presenceNode.setAttribute('data-mce-bogus', 'all');

    _this._presenceNode.setAttribute('contenteditable', 'false');

    _this._presenceNode.style.userSelect = 'none';
    _this._presenceNode.style.pointerEvents = 'none';
    _this._presenceNode.style.display = 'block';
    _this._presenceNode.style.position = 'static';
    _this._presenceNode.style.width = '100%';
    _this._presenceNode.style.height = '0';

    _this._presenceNode.appendChild(_this._presenceInnerNode);

    _this._presence = Object.create(null);
    _this._updatedPresence = Object.create(null);
    _this._changeNumber = 0;
    _this._lastSelection = {
      anchor: -1,
      focus: -1
    };
    _this._mouseX = -1;
    _this._mouseY = -1;
    _this._selectingWithMouse = false;
    _this._handleMouse = lodash_throttle__WEBPACK_IMPORTED_MODULE_8___default()(_this._handleMouse.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default()(_this)), null, {
      leading: false
    });
    _this._updatePresence = lodash_throttle__WEBPACK_IMPORTED_MODULE_8___default()(_this._updatePresence.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default()(_this)), null, {
      leading: false
    });
    _this._updatePresenceViewport = lodash_throttle__WEBPACK_IMPORTED_MODULE_8___default()(_this._updatePresenceViewport.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default()(_this)), null, {
      leading: false
    });
    _this._triggerSelectionChange = lodash_throttle__WEBPACK_IMPORTED_MODULE_8___default()(_this._handleSelectionChange.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default()(_this)), null, {
      leading: false
    });
    _this._scheduleSubmitPresence = lodash_throttle__WEBPACK_IMPORTED_MODULE_8___default()(_this._submitPresence.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default()(_this)), presenceDelay, {
      leading: false
    });

    _this._doc.on('load', _this._onLoad = _this._onLoad.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default()(_this)));

    _this._doc.on('op', _this._onOperation = _this._onOperation.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default()(_this)));

    _this._doc.on('presence', _this._onPresenceChange = _this._onPresenceChange.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default()(_this)));

    _this._document.addEventListener('selectionchange', _this._onSelectionChange = _this._onSelectionChange.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default()(_this)));

    window.addEventListener('resize', _this._onResize = _this._onResize.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default()(_this)));
    window.addEventListener('scroll', _this._onScroll = _this._onScroll.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default()(_this)));
    parentWindow && parentWindow.addEventListener('scroll', _this._onScroll);

    _this._realDom.addEventListener('mousemove', _this._onMouseMove = _this._onMouseMove.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default()(_this)));

    _this._realDom.addEventListener('mouseleave', _this._onMouseLeave = _this._onMouseLeave.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default()(_this)));

    _this._document.addEventListener('mousedown', _this._onMouseDown = _this._onMouseDown.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default()(_this)), true);

    _this._document.addEventListener('mouseup', _this._onMouseUp = _this._onMouseUp.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default()(_this)), true);

    _this._aboutToProcessMutations = false;
    _this._pendingMutationsToPrepend = [];
    _this._pendingMutationsToAppend = [];
    _this._mutationObserverConfig = {
      childList: true,
      attributes: true,
      characterData: true,
      subtree: true
    };
    _this._mutationObserver = new MutationObserver(_this._onRealDomChange.bind(_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_5___default()(_this)));

    _this._watchRealDom();

    _this._updateRealDom();

    _this.presenceEnabled = presenceEnabled;
    return _this;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(TinyMceSync, [{
    key: "dispose",
    value: function dispose() {
      var window = this._document.defaultView;
      var parentWindow = this._parentWindow;

      this._unwatchRealDom();

      this._removeRealDomStyles();

      this._doc.removeListener('load', this._onLoad);

      this._doc.removeListener('op', this._onOperation);

      this._doc.removeListener('presence', this._onPresenceChange);

      this._document.removeEventListener('selectionchange', this._onSelectionChange);

      window && window.removeEventListener('resize', this._onResize);
      window && window.removeEventListener('scroll', this._onScroll);
      parentWindow && parentWindow.removeEventListener('scroll', this._onScroll);

      this._realDom.removeEventListener('mousemove', this._onMouseMove);

      this._realDom.removeEventListener('mouseleave', this._onMouseLeave);

      this._document.removeEventListener('mousedown', this._onMouseDown, true);

      this._document.removeEventListener('mouseup', this._onMouseUp, true);

      this._virtualDom.unlinkRealNode();

      this._handleMouse.cancel();

      this._updatePresence.cancel();

      this._updatePresenceViewport.cancel();

      this._triggerSelectionChange.cancel();

      this._scheduleSubmitPresence.cancel();

      if (this._presenceNode.parentNode) {
        this._presenceNode.parentNode.removeChild(this._presenceNode);
      }
    }
  }, {
    key: "canUndo",
    value: function canUndo() {
      return this._undoManager.canUndo();
    }
  }, {
    key: "undo",
    value: function undo() {
      this._undoManager.undo({
        source: 'undo'
      });
    }
  }, {
    key: "canRedo",
    value: function canRedo() {
      return this._undoManager.canRedo();
    }
  }, {
    key: "redo",
    value: function redo() {
      this._undoManager.redo({
        source: 'redo'
      });
    }
  }, {
    key: "_watchRealDom",
    value: function _watchRealDom() {
      this._mutationObserver.observe(this._realDom, this._mutationObserverConfig);

      if (this._pendingMutationsToPrepend.length > 0) {
        // We have some mutations which won't trigger the mutation observer's callback and won't be
        // passed in as params, so we trigger the callback using a fake mutation. The callback will
        // process this._pendingMutationsToPrepend first, before the mutations passed in as params.
        this._realDom.setAttribute('data-trigger-mutation-observer', '');

        this._realDom.removeAttribute('data-trigger-mutation-observer');
      }
    }
  }, {
    key: "_unwatchRealDom",
    value: function _unwatchRealDom() {
      // We need to save any unprocessed mutations before disconnecting, so that they are not lost,
      // which would get the real and virtual DOMs out of sync.
      var pendingMutations = this._mutationObserver.takeRecords();

      if (this._aboutToProcessMutations) {
        var _this$_pendingMutatio;

        // We're already in the mutation observer's callback but before we started actually processing
        // the mutations. `pendingMutations` will be appended to the list of mutations passed into
        // the callback and processed in the same callback execution.
        (_this$_pendingMutatio = this._pendingMutationsToAppend).push.apply(_this$_pendingMutatio, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()(pendingMutations));
      } else {
        var _this$_pendingMutatio2;

        // We record the mutations for processing the next time the mutation observer's callback is executed.
        // These mutations will be prepended to the list of mutations passed into the observer's callback.
        (_this$_pendingMutatio2 = this._pendingMutationsToPrepend).push.apply(_this$_pendingMutatio2, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()(pendingMutations));
      }

      this._mutationObserver.disconnect();
    }
  }, {
    key: "_addRealDomStyles",
    value: function _addRealDomStyles() {
      var window = this._document.defaultView;

      if (!window) {
        return;
      }

      var computedPosition = window.getComputedStyle(this._realDom).getPropertyValue('position');

      this._realDom.setAttribute('data-initial-style-position', this._realDom.style.position);

      this._realDom.style.position = computedPosition && computedPosition !== 'static' ? computedPosition : 'relative';
    }
  }, {
    key: "_removeRealDomStyles",
    value: function _removeRealDomStyles() {
      this._realDom.style.position = this._realDom.getAttribute('data-initial-style-position') || '';

      this._realDom.removeAttribute('data-initial-style-position');
    }
  }, {
    key: "_getScrollParent",
    value: function _getScrollParent() {
      var overflowY;

      var node = Object(_util_misc__WEBPACK_IMPORTED_MODULE_12__["getIframeElement"])(this._document.defaultView) || this._realDom;

      var window = node.ownerDocument.defaultView;
      var documentElement = node.ownerDocument.documentElement;

      if (!window) {
        return null;
      }

      do {
        node = node.parentNode;
      } while (node && node !== documentElement && (overflowY = window.getComputedStyle(node).overflowY) !== 'scroll' && overflowY !== 'auto');

      return node;
    }
  }, {
    key: "_ensurePresenceNodeIsFirst",
    value: function _ensurePresenceNodeIsFirst() {
      var previousSibling = this._presenceNode.previousSibling;

      if (previousSibling && previousSibling.nodeType === Node.ELEMENT_NODE && previousSibling.getAttribute('data-mce-caret') === 'before') {
        this._unwatchRealDom(); // Remove the fake caret container added by TinyMCE.


        previousSibling.parentNode.removeChild(previousSibling); // Remove the fake caret added by TinyMCE.

        var fakeCaret = this._realDom.querySelector('.mce-visual-caret');

        if (fakeCaret) {
          fakeCaret.parentNode.removeChild(fakeCaret);
        }

        this._watchRealDom();
      }

      var nextSibling = this._presenceNode.nextSibling;

      if (nextSibling && nextSibling.nodeType === Node.ELEMENT_NODE && nextSibling.getAttribute('data-mce-caret') === 'after') {
        this._unwatchRealDom(); // Remove the fake caret container added by TinyMCE.


        nextSibling.parentNode.removeChild(nextSibling); // Remove the fake caret added by TinyMCE.

        var _fakeCaret = this._realDom.querySelector('.mce-visual-caret');

        if (_fakeCaret) {
          _fakeCaret.parentNode.removeChild(_fakeCaret);
        }

        this._watchRealDom();
      } // Insert _presenceNode as the first child of _realDom.


      if (this._presenceNode !== this._realDom.firstChild) {
        this._unwatchRealDom();

        this._realDom.insertBefore(this._presenceNode, this._realDom.firstChild);

        this._watchRealDom();
      } // Make sure the selection is in order.


      this._fixSelection();
    }
    /*
    88888888ba,      ,ad8888ba,    88b           d88                "8a              ,ad8888ba,    888888888888
    88      `"8b    d8"'    `"8b   888b         d888                  "8a           d8"'    `"8b        88
    88        `8b  d8'        `8b  88`8b       d8'88                    "8a        d8'        `8b       88
    88         88  88          88  88 `8b     d8' 88                      "8a      88          88       88
    88         88  88          88  88  `8b   d8'  88      aaaaaaaa        a8"      88          88       88
    88         8P  Y8,        ,8P  88   `8b d8'   88      """"""""      a8"        Y8,        ,8P       88
    88      .a8P    Y8a.    .a8P   88    `888'    88                  a8"           Y8a.    .a8P        88
    88888888Y"'      `"Y8888Y"'    88     `8'     88                a8"              `"Y8888Y"'         88
     */

  }, {
    key: "_onRealDomChange",
    value: function _onRealDomChange(mutations) {
      this._aboutToProcessMutations = true;

      if (this.presenceEnabled) {
        this._ensurePresenceNodeIsFirst();
      }

      this._updateOtModel(mutations);

      console.assert(!this._aboutToProcessMutations, 'Sync._aboutToProcessMutations was not reset');
    } // Updates `otModel` based on `realDom`.

  }, {
    key: "_updateOtModel",
    value: function _updateOtModel(mutations) {
      var virtualDomChanged = this._updateVirtualDomWithMutations(mutations);

      if (this.debug) {
        this._virtualDom.validate();
      }

      if (!virtualDomChanged || this.otModel === null) {
        return;
      }

      var otModel = this.createOtModelFromVirtualDom();
      var undoable = true;
      var source = 'user';
      var lastSelection = this._lastSelection;
      var currentSelection = this.getSelection();
      var lastAnchor = lastSelection.anchor,
          lastFocus = lastSelection.focus;
      var currentAnchor = currentSelection.anchor,
          currentFocus = currentSelection.focus;
      var lastStart = Math.min(lastAnchor, lastFocus);
      var lastEnd = Math.max(lastAnchor, lastFocus);
      var currentStart = Math.min(currentAnchor, currentFocus);
      var currentEnd = Math.max(currentAnchor, currentFocus);
      var diffHint = {
        oldRange: lastStart < 0 ? null : {
          index: lastStart,
          length: lastEnd - lastStart
        },
        newRange: currentStart < 0 ? null : {
          index: currentStart,
          length: currentEnd - currentStart
        }
      };
      this._lastSelection = currentSelection;

      this._doc.submitSnapshot(otModel, {
        undoable: undoable,
        source: source,
        diffHint: diffHint
      });
    }
  }, {
    key: "createVNodeFromRealNode",
    value: function createVNodeFromRealNode(realNode, isRoot) {
      if (!isRoot && Object(_util_misc__WEBPACK_IMPORTED_MODULE_12__["isIgnoredNode"])(realNode)) {
        return null;
      }

      var nodeName = isRoot ? '#root' : realNode.nodeName;
      var configByNodeType = this._configByNodeName[nodeName];
      var config = !configByNodeType ? this._configByNodeName['#unknown']['$default'] : !realNode.getAttribute ? configByNodeType['$default'] : realNode.getAttribute('data-mce-bogus') === '1' ? this._configByNodeName['#unknown']['$default'] : realNode.getAttribute('contenteditable') === 'false' && configByNodeType['embed'] || configByNodeType['$default'];
      var vNode = config.createVNode(null, realNode);
      var vChildNodes = vNode.childNodes;
      vNode.upgradeRealNode(realNode);
      vNode.linkRealNode(realNode);
      vNode.updateVNodeValue();
      vNode.updateVAttributes();

      if (vChildNodes) {
        var realChildNodes = vNode.realNode.childNodes;

        for (var i = 0, l = realChildNodes.length; i < l; ++i) {
          var vChildNode = this.createVNodeFromRealNode(realChildNodes[i], false);

          if (vChildNode) {
            vChildNodes.push(vChildNode);
          }
        }
      }

      return vNode;
    } // Updates `this._virtualDom` based on the provided `this._realDom` `mutations`.

  }, {
    key: "_updateVirtualDomWithMutations",
    value: function _updateVirtualDomWithMutations(mutations) {
      var nodesToAdd = [];
      var virtualDomChanged = false;
      var replacedVNodes = new Map();

      this._unwrapImageFromFormats();

      this._unwatchRealDom();

      this._aboutToProcessMutations = false;

      if (this._pendingMutationsToPrepend.length > 0 || this._pendingMutationsToAppend.length > 0) {
        // Process any mutations which are not in the list passed in as a parameter. These mutations are recorded
        // in `this._unwatchRealDom()` just before it calls `this._mutationObserver.disconnect()`.
        mutations = this._pendingMutationsToPrepend.concat(mutations, this._pendingMutationsToAppend);
        this._pendingMutationsToPrepend.length = 0;
        this._pendingMutationsToAppend.length = 0;
      }

      if (this._document.documentMode === 11) {
        // The reported mutations in IE11 are very unreliable, so we ignore them completely
        // and walk the entire real DOM instead, which is slow but at least works reliably.
        mutations = [];
        this._virtualDom = this.createVNodeFromRealNode(this._realDom, true);
        virtualDomChanged = true;
      }

      for (var i = 0, l = mutations.length; i < l; ++i) {
        var mutation = mutations[i];
        var mutationType = mutation.type;
        var attributeName = mutation.attributeName;
        var addedNodes = mutation.addedNodes;
        var removedNodes = mutation.removedNodes;
        var realNode = mutation.target;

        if (mutationType === 'attributes' && realNode !== this._realDom) {
          if (attributeName === 'data-mce-bogus') {
            // Adding/removing data-mce-bogus=all attribute is like removing/adding a DOM node respectively,
            // so we need a bit of custom logic.
            var childNode = realNode;
            var parentNode = childNode.parentNode;

            if (!parentNode) {
              // The node is no longer attached to the document and its removal was already handled properly.
              continue;
            } // This node was not actually added to/removed from the real DOM
            // but we need to update the virtual DOM as if it was.


            var handleAsAdded = childNode.getAttribute('data-mce-bogus') !== 'all';

            if (handleAsAdded && childNode[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]] && parentNode[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]] && parentNode[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]].childNodes && parentNode[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]].childNodes.indexOf(childNode[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]]) >= 0) {
              // data-mce-bogus !== "all" now and before the mutation, so a virtual node already exists.
              continue;
            }

            mutationType = 'childList';
            attributeName = null;

            if (handleAsAdded) {
              addedNodes = [childNode];
              removedNodes = [];
            } else {
              addedNodes = [];
              removedNodes = [childNode];
            }

            realNode = parentNode;
          } else if (attributeName === 'contenteditable') {
            // Adding contenteditable=false attribute turns any element into an embed,
            // so we need a bit of custom logic for this case.
            var _childNode = realNode;
            var _parentNode = _childNode.parentNode;

            if (!_parentNode) {
              // The node is no longer attached to the document and its removal was already handled properly.
              continue;
            }

            if (_childNode[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]] && _childNode[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]].nodeType === 'embed' && _childNode.getAttribute('contenteditable') === 'false') {
              // Adding contenteditable=false to an embed does not change its type.
              continue;
            } // We recreate the VNode, so that is can change its nodeType, if necessary.
            // It's possible that we recreate it unnecessarily but that should be rare.


            mutationType = 'childList';
            attributeName = null; // Normally this would be 2 mutations: 1 for add and 1 for remove, because the mutation concerns
            // the same childNode, however, the childList handler below can deal with the same node in both
            // addedNodes and removedNodes, so we take a shortcut and use only one mutation.

            addedNodes = [_childNode];
            removedNodes = [_childNode];
            realNode = _parentNode;
          } else if (attributeName === 'data-mce-selected') {
            // Firefox does not emit selectionchange event in the following situation,
            // so it has to be emulated:
            //
            // 1. Select multiple cells using the mouse and keep the mouse button down.
            // 2. Move the cursor back over the cell where the selection started.
            this._triggerSelectionChange();
          }
        }

        var vNode = realNode[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]];

        if (!vNode || Object(_util_misc__WEBPACK_IMPORTED_MODULE_12__["isIgnoredNode"])(realNode)) {
          continue;
        }

        if (mutationType === 'characterData') {
          vNode.updateVNodeValue();
        } else if (mutationType === 'attributes') {
          if (attributeName !== 'style') {
            // This is just a performance optimization which allows the algorithm to exit early when irrelevant
            // attributes are modified, especially those added by TinyMCE.
            var virtualAttributeName = vNode.realToVirtualAttributeName('@' + attributeName);

            if (virtualAttributeName === null) {
              // just ignore this attribute
              continue;
            } else if (!vNode.supportsAttribute(virtualAttributeName)) {
              realNode.removeAttribute(attributeName);
              continue;
            }
          } else if (realNode === this._realDom) {
            // Ignore style attribute changes on the root node.
            // This is a workaround for a Firefox issue, which seems to trigger the mutation handler again
            // after the style attribute is read in the mutation handler. The issue was observed when trying
            // to edit a Notebook in Teamwork Projects.
            continue;
          }

          vNode.updateVAttributes();
        } else if (mutationType === 'childList') {
          if (!vNode.childNodes) {
            continue;
          }

          if (Array.prototype.every.call(addedNodes, _util_misc__WEBPACK_IMPORTED_MODULE_12__["isIgnoredNode"]) && Array.prototype.every.call(removedNodes, _util_misc__WEBPACK_IMPORTED_MODULE_12__["isIgnoredNode"])) {
            continue;
          } // Store the references to the old VNodes when some real nodes are replaced,
          // so that the node IDs can be restored, if the new nodes are the same as, or similar to, the old nodes.
          // This is just an optimization, so the algorithm below works on the best effort basis and may miss
          // some edge cases, which does not affect the correctness of the system.


          if (removedNodes.length > 0 && addedNodes.length > 0) {
            var removedStartIndex = 0;
            var removedEndIndex = removedNodes.length - 1;
            var addedStartIndex = 0;
            var addedEndIndex = addedNodes.length - 1;

            while (addedStartIndex <= addedEndIndex && removedStartIndex <= removedEndIndex) {
              var addedNode = addedNodes[addedStartIndex];
              var removedNode = removedNodes[removedStartIndex];
              var removedVNode = removedNode[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]];

              if (Object(_util_misc__WEBPACK_IMPORTED_MODULE_12__["isIgnoredNode"])(addedNode)) {
                addedStartIndex++;
              } else if (Object(_util_misc__WEBPACK_IMPORTED_MODULE_12__["isIgnoredNode"])(removedNode)) {
                removedStartIndex++;
              } else if (removedVNode && removedNode.nodeName === addedNode.nodeName) {
                replacedVNodes.set(addedNode, removedVNode);
                addedStartIndex++;
                removedStartIndex++;
              } else {
                break;
              }
            }

            while (addedStartIndex <= addedEndIndex && removedStartIndex <= removedEndIndex) {
              var _addedNode = addedNodes[addedEndIndex];
              var _removedNode = removedNodes[removedEndIndex];
              var _removedVNode = _removedNode[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]];

              if (Object(_util_misc__WEBPACK_IMPORTED_MODULE_12__["isIgnoredNode"])(_addedNode)) {
                addedEndIndex--;
              } else if (Object(_util_misc__WEBPACK_IMPORTED_MODULE_12__["isIgnoredNode"])(_removedNode)) {
                removedEndIndex--;
              } else if (_removedVNode && _removedNode.nodeName === _addedNode.nodeName) {
                replacedVNodes.set(_addedNode, _removedVNode);
                addedEndIndex--;
                removedEndIndex--;
              } else {
                break;
              }
            }
          } // Handle `removedNodes` before `addedNodes`.


          for (var _i = 0, _l = removedNodes.length; _i < _l; ++_i) {
            var _removedNode2 = removedNodes[_i];
            var removedNodeVNode = _removedNode2[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]];
            var nodesToAddIndex = nodesToAdd.indexOf(_removedNode2);

            if (nodesToAddIndex >= 0) {
              nodesToAdd.splice(nodesToAddIndex, 1);
            }

            if (removedNodeVNode) {
              var childNodesIndex = vNode.childNodes.indexOf(removedNodeVNode);

              if (childNodesIndex >= 0) {
                // We should always find the child node index.
                vNode.childNodes.splice(childNodesIndex, 1);
              }

              removedNodeVNode.unlinkRealNode();
            }
          } // Defer processing of `addedNodes` to minimize unnecessary work and avoid edge cases.


          for (var _i2 = 0, _l2 = addedNodes.length; _i2 < _l2; ++_i2) {
            var _addedNode2 = addedNodes[_i2];

            if (_addedNode2.nodeType === Node.TEXT_NODE && _addedNode2.nodeValue === '') {
              // Remove empty text nodes straight-away to avoid problems with processing of
              // trailing BR elements. Empty text nodes are created in practice when creating
              // a new line using Shift+Enter in Chrome.
              if (_addedNode2.parentNode) {
                _addedNode2.parentNode.removeChild(_addedNode2);
              }
            } else if (nodesToAdd.indexOf(_addedNode2) < 0) {
              nodesToAdd.push(_addedNode2);
            }
          }
        } else {
          continue;
        }

        virtualDomChanged = true;
      }

      for (var _i3 = 0, _l3 = nodesToAdd.length; _i3 < _l3; ++_i3) {
        var realChild = nodesToAdd[_i3]; // Make sure we have not processed this node yet.

        if (realChild[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]]) {
          continue;
        }

        var realParent = realChild.parentNode;

        while (realParent && !realParent[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]]) {
          realChild = realParent;
          realParent = realChild.parentNode;
        }

        if (!Object(_util_misc__WEBPACK_IMPORTED_MODULE_12__["containsNode"])(this._realDom, realParent)) {
          continue;
        }

        var vChild = this.createVNodeFromRealNode(realChild, false);

        if (!vChild) {
          continue;
        } // Restore the previous node IDs for the nodes which were replaced by (nearly) identical new nodes.
        // This is just an optimization which avoids creation of excessive diffs.


        if (replacedVNodes.has(realChild)) {
          vChild.restoreNodeId(replacedVNodes.get(realChild));
        }

        var vChildNodes = realParent[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]].childNodes;
        var realNextSibling = realChild.nextSibling;

        while (realNextSibling && !realNextSibling[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]]) {
          realNextSibling = realNextSibling.nextSibling;
        }

        if (realNextSibling) {
          var vChildIndex = vChildNodes.indexOf(realNextSibling[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]]);
          vChildNodes.splice(vChildIndex, 0, vChild);
        } else {
          vChildNodes.push(vChild);
        }
      } // A workaround for TinyMCE sometimes using a BR element instead of the usual
      // formatting helper (SPAN + '\uFEFF' text node) for handling inline styles.


      this._insertFormattingHelper();

      this._watchRealDom();

      return virtualDomChanged;
    }
  }, {
    key: "createOtModelFromVirtualDom",
    value: function createOtModelFromVirtualDom(virtualDom) {
      return this._populateOtModelFromVirtualNode(virtualDom || this._virtualDom, [], {
        formattingStack: [],
        modelOffset: 0
      });
    }
  }, {
    key: "_populateOtModelFromVirtualNode",
    value: function _populateOtModelFromVirtualNode(node, model, context) {
      var formattingStack = context.formattingStack;
      var nodeName = node.nodeName;
      var childNodes = node.childNodes;
      node.modelStartOffset = context.modelOffset;

      switch (node.nodeType) {
        case 'root':
        case 'structure':
          ++context.modelOffset;
          Object(_teamwork_ot_rich_text_lib_Operation__WEBPACK_IMPORTED_MODULE_10__["append"])(model, Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["createInsertOpen"])(node.nodeValue + nodeName, node.attributes));

          for (var i = 0, l = childNodes.length; i < l; ++i) {
            this._populateOtModelFromVirtualNode(childNodes[i], model, context);
          } // NOTE BR-elements (see at the end of this file)


          if (node.needsBr && Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["getNodeName"])(model[model.length - 1]) === 'BR') {
            var lastChild = node; // Find the BR VNode. We have to search recursively because the BR may be
            // nested in "format" or "unknown" nodes.

            while (lastChild.childNodes && lastChild.childNodes.length > 0) {
              lastChild = lastChild.childNodes[lastChild.childNodes.length - 1];
            } // Make sure that `lastChild` is indeed a BR. It's necessary because it could
            // also be a formatting helper, which is ignored when creating the OT model.


            if (lastChild.nodeName === 'BR') {
              // Remove the trailing BR from the model.
              --model.length; // Reduce context.modelOffset to account for the removed BR.

              --context.modelOffset; // Reduce the modelOffset of the last child node to account for the removed BR.
              // Normally the last child should be the BR, however, it may happen that it's
              // nested in format or unknown nodes, so we have to perform the action recursively.

              lastChild = childNodes[childNodes.length - 1];

              do {
                --lastChild.modelEndOffset;
                lastChild = lastChild.childNodes && lastChild.childNodes.length > 0 ? lastChild.childNodes[lastChild.childNodes.length - 1] : null;
              } while (lastChild);
            }
          }

          ++context.modelOffset;
          Object(_teamwork_ot_rich_text_lib_Operation__WEBPACK_IMPORTED_MODULE_10__["append"])(model, Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["createInsertClose"])(node.nodeValue + nodeName));
          break;

        case 'text':
          {
            var insert = node.nodeValue;

            if (insert !== '') {
              var action = Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["createInsertText"])(insert); // add attributes based on the formattingStack

              for (var _i4 = 0, _l4 = formattingStack.length; _i4 < _l4; ++_i4) {
                var _formattingStack$_i = formattingStack[_i4],
                    attributes = _formattingStack$_i.attributes,
                    _nodeName = _formattingStack$_i.nodeName;
                var format = this._formatsByDom[_nodeName];

                if (format) {
                  // the format is defined by a DOM node only,
                  // eg <STRONG>
                  Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["setAttribute"])(action, format.name, '');
                } else {
                  for (var _i5 = 0, _l5 = attributes.length; _i5 < _l5;) {
                    var attributeName = attributes[_i5++];
                    var attributeValue = attributes[_i5++];
                    var _format = this._formatsByDom[_nodeName + attributeName];

                    if (_format) {
                      // the format is defined by a DOM node with an attribute or style,
                      // eg <ABBR title="Abbreviation"> or <span style="color: red">
                      Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["setAttribute"])(action, _format.name, attributeValue);
                    } else {
                      var _format2 = this._formatsByDom[_nodeName + attributeName + '=' + attributeValue];

                      if (_format2) {
                        // the format is defined by a DOM node with
                        // an attribute or style and a specific value,
                        // eg <SPAN style="text-decoration: underline">
                        Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["setAttribute"])(action, _format2.name, '');
                      } else if (attributeValue === '') {
                        var indexOfValueInName = attributeName.indexOf('=');

                        if (indexOfValueInName > 0) {
                          // If there's '=' in the attribute's name and the attribute value is empty,
                          // we assume that the actual attribute name is the string before '=' and
                          // the actual attribute value is the string after '='.
                          // This assumption is guaranteed to be correct thanks to attribute name
                          // validation in `Config`, which bans '=' in attribute names, except for
                          // those which store the attribute's value in the attribute's name.
                          var _format3 = this._formatsByDom[_nodeName + attributeName.substring(0, indexOfValueInName + 1)];

                          if (_format3) {
                            // the format is defined by a DOM node with
                            // an attribute containing a set of values,
                            // eg <SPAN data-tw-inline-comments="123 124 127">
                            // Each of those space-separated values maps to a separate attribute
                            // in ElementVNode an OT model action, and both the name and value are
                            // encoded in the attribute's name, separated by '='.
                            Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["setAttribute"])(action, _format3.name + attributeName.substring(indexOfValueInName + 1), '');
                          }
                        }
                      }
                    }
                  }
                }
              }

              if (insert === "\uFEFF") {
                Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["setAttribute"])(action, '@data-mce-bogus', '1');
                Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["setAttribute"])(action, '@data-mce-type', 'format-caret');
                Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["setAttribute"])(action, '@id', '_mce_caret');
                textNodeToFormattingHelper.set(node, {
                  position: node.modelStartOffset,
                  action: action
                });
              } else {
                context.modelOffset += insert.length;
                Object(_teamwork_ot_rich_text_lib_Operation__WEBPACK_IMPORTED_MODULE_10__["append"])(model, action);
              }
            }

            break;
          }

        case 'format':
          formattingStack.push(node);

          for (var _i6 = 0, _l6 = childNodes.length; _i6 < _l6; ++_i6) {
            this._populateOtModelFromVirtualNode(childNodes[_i6], model, context);
          }

          formattingStack.pop();
          break;

        case 'embed':
          ++context.modelOffset;
          Object(_teamwork_ot_rich_text_lib_Operation__WEBPACK_IMPORTED_MODULE_10__["append"])(model, Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["createInsertEmbed"])(node.nodeValue + nodeName, node.attributes));
          break;

        case 'unknown':
          for (var _i7 = 0, _l7 = childNodes.length; _i7 < _l7; ++_i7) {
            this._populateOtModelFromVirtualNode(childNodes[_i7], model, context);
          }

          break;
      }

      node.modelEndOffset = context.modelOffset;
      return model;
    } // If necessary, inserts a formatting helper (SPAN + '\uFEFF' text node) to support inline styles.
    // The problem is that TinyMCE sometimes uses a BR element instead of a formatting helper. If that's
    // the case, the formatting helper is inserted before the BR.

  }, {
    key: "_insertFormattingHelper",
    value: function _insertFormattingHelper() {
      var window = this._document.defaultView;

      if (!window) {
        return;
      }

      var selection = window.getSelection();
      var anchorNode = selection.anchorNode,
          anchorOffset = selection.anchorOffset,
          isCollapsed = selection.isCollapsed;

      if (!anchorNode || !isCollapsed) {
        return;
      }

      var vNode = anchorNode[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]];

      if (!vNode || vNode.nodeType !== 'format' || anchorOffset >= anchorNode.childNodes.length || !Object(_util_misc__WEBPACK_IMPORTED_MODULE_12__["containsNode"])(this._realDom, anchorNode)) {
        return;
      }

      var brNode = anchorNode.childNodes[anchorOffset];

      if (brNode.nodeName !== 'BR') {
        return;
      }

      var brVNode = brNode[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]];

      if (!brVNode) {
        return;
      }

      var brVNodeIndex = vNode.childNodes.indexOf(brVNode);

      if (brVNodeIndex < 0) {
        return;
      }

      var formattingHelper = this._document.createElement('SPAN');

      formattingHelper.setAttribute('id', '_mce_caret');
      formattingHelper.setAttribute('data-mce-type', 'format-caret');
      formattingHelper.setAttribute('data-mce-bogus', '1');
      formattingHelper.textContent = "\uFEFF";
      anchorNode.insertBefore(formattingHelper, brNode);
      selection.collapse(formattingHelper.firstChild, 1);
      vNode.childNodes.splice(brVNodeIndex, 0, this.createVNodeFromRealNode(formattingHelper, false));
    } // If inserting an image from a local file system, TinyMCE caches the image's reference and uploads the image.
    // If that image is wrapped in a "format" node when ot-client compares virtual DOMs and updates the real DOM,
    // it removes that image and creates a new unwrapped one. Unfortunately, TinyMCE is still uploading the original
    // image and not the new one. This leads to console errors and image not showing up in the editor.
    // To prevent this situation we unwrap the image manually just before processing the DOM mutations.

  }, {
    key: "_unwrapImageFromFormats",
    value: function _unwrapImageFromFormats() {
      var document = this._document;
      var window = document.defaultView;

      if (!window) {
        return; // No window - should never happen.
      }

      var _window$getSelection = window.getSelection(),
          anchorNode = _window$getSelection.anchorNode,
          focusNode = _window$getSelection.focusNode,
          focusOffset = _window$getSelection.focusOffset,
          rangeCount = _window$getSelection.rangeCount;

      if (rangeCount === 0 || anchorNode !== focusNode || focusOffset === 0 || anchorNode.nodeType !== Node.ELEMENT_NODE) {
        return; // Caret must be right after the image, or the image must be selected.
      }

      var image = anchorNode.childNodes[focusOffset - 1];

      if (image[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]] || // It was already inserted properly.
      image.nodeName !== 'IMG' || // Not an image.
      !Object(_util_misc__WEBPACK_IMPORTED_MODULE_12__["containsNode"])(this._realDom, image) // Not in the editable content.
      ) {
          return;
        }

      var parentVNode = image.parentNode[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]];

      if (!parentVNode || parentVNode.nodeType !== 'format') {
        return; // Not wrapped in a format.
      } // We need to unwrap this image.


      var node = image;
      var parentNode = node.parentNode;

      while (parentNode[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]].nodeType === 'format') {
        var grandParentNode = parentNode.parentNode;
        var clonedParentNode = parentNode.cloneNode(false);
        var nextSibling = void 0;

        while (nextSibling = node.nextSibling) {
          clonedParentNode.appendChild(nextSibling);
        }

        grandParentNode.insertBefore(clonedParentNode, parentNode.nextSibling);
        node = parentNode;
        parentNode = grandParentNode;
      }

      parentNode.insertBefore(image, node.nextSibling);
    }
    /*
    ,ad8888ba,    888888888888                "8a            88888888ba,      ,ad8888ba,    88b           d88
    d8"'    `"8b        88                       "8a          88      `"8b    d8"'    `"8b   888b         d888
    d8'        `8b       88                         "8a        88        `8b  d8'        `8b  88`8b       d8'88
    88          88       88                           "8a      88         88  88          88  88 `8b     d8' 88
    88          88       88           aaaaaaaa        a8"      88         88  88          88  88  `8b   d8'  88
    Y8,        ,8P       88           """"""""      a8"        88         8P  Y8,        ,8P  88   `8b d8'   88
    Y8a.    .a8P        88                       a8"          88      .a8P    Y8a.    .a8P   88    `888'    88
    `"Y8888Y"'         88                     a8"            88888888Y"'      `"Y8888Y"'    88     `8'     88
     */

  }, {
    key: "_onLoad",
    value: function _onLoad() {
      if (!this._doc.type) {
        this._doc.create(this.createOtModelFromVirtualDom(), 'ot-rich-text');
      }

      this._updateRealDom();

      this._fixSelection();

      this._scheduleSubmitPresence();
    }
  }, {
    key: "_onOperation",
    value: function _onOperation(operation, source) {
      this._updateRealDom(source, operation);

      this._fixSelection();

      this._scheduleUpdatePresence();

      this._updatePresence.flush();
    } // Updates `realDom` based on `otModel`.

  }, {
    key: "_updateRealDom",
    value: function _updateRealDom(source, operation) {
      var otModel = this.otModel;

      if (otModel === null) {
        return;
      }

      var selection = operation == null || source === 'user' ? this.getSelection() : source === 'undo' || source === 'redo' ? this._getSelectionFromOperation(operation) : this.transformSelection(this.getSelection(), operation); // The formatting helper is needed to support TinyMCE's way of adding formats when adding new content.

      var formattingHelper = operation != null && source !== 'undo' && source !== 'redo' && this._getFormattingHelper();

      if (formattingHelper) {
        if (source !== 'user') {
          // Transform the position of the formatting helper by the incoming operation,
          // so that we can restore the helper at the correct position.
          // In case of the source==='user' operations we must not transform the position
          // because the DOM has been already updated, so the position we've got is correct.
          formattingHelper.position = this.transformSelection({
            anchor: formattingHelper.position,
            focus: formattingHelper.position
          }, operation).anchor;
        } // NOTE assume that `apply` does not modify the original model


        otModel = Object(_teamwork_ot_rich_text_lib_Operation__WEBPACK_IMPORTED_MODULE_10__["apply"])(otModel, [Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["createRetain"])(formattingHelper.position), formattingHelper.action]);

        if (otModel.length > this.otModel.length) {
          formattingHelperActions.set(formattingHelper.action, true);
        } else {
          // `formattingHelper.action` got merged into another action. This could happen only if someone
          // intentionally set specific unsupported attributes on an insert text action. If that happens,
          // we just ignore the helper action to avoid problems later on.
          otModel = this.otModel;
        }
      }

      var operationOffset = operation && operation.length > 0 && Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["isRetain"])(operation[0]) ? Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["getLength"])(operation[0]) : 0;
      var focusOffset = selection.focus;
      var scrollParent = operationOffset < focusOffset ? this._getScrollParent() : null;
      var scrollTop = scrollParent ? scrollParent.scrollTop : 0;
      var scrollHeight = scrollParent ? scrollParent.scrollHeight : 0;
      var oldVirtualDom = this._virtualDom;
      var newVirtualDom = this._virtualDom = this.createVirtualDomFromOtModel(otModel);

      this._unwatchRealDom();

      this._updateRealNode(newVirtualDom, oldVirtualDom);

      this._watchRealDom();

      if (operation != null && source !== 'user' && source !== 'undo' && source !== 'redo' && scrollParent) {
        if (this._asyncScrollUpdate) {
          Object(_util_misc__WEBPACK_IMPORTED_MODULE_12__["nextTick"])(function () {
            scrollParent.scrollTop = scrollTop + scrollParent.scrollHeight - scrollHeight;
          });
        } else {
          scrollParent.scrollTop = scrollTop + scrollParent.scrollHeight - scrollHeight;
        }
      }

      if (this.debug) {
        this._virtualDom.validate();
      } // Create OT Model first to update OT Model offsets on the VNodes,
      // because they are used by `this.setSelection`.


      var newOtModel = this.createOtModelFromVirtualDom(); // Restore the selection.

      this.setSelection(selection);

      if (source === 'undo' || source === 'redo') {
        this.scrollCaretIntoView();
      } // Let other users know that we changed the document.


      if (source === 'user' || source === 'undo' || source === 'redo') {
        this._changeNumber++;

        this._submitPresence();
      } // Submit the final snapshot to ensure that `this.otModel` is in sync with the DOM.
      // Discrepencies usually arise when building virtual DOM from an invalid OT Model.


      this._doc.submitSnapshot(newOtModel, {
        source: 'script',
        skipNoop: true,
        fixUp: true
      });
    } // Creates a new VNode.
    // Returns null, if no comfig is registered for nodeName/nodeType combination.
    // nodes/Config provides certain guarantees, so that it's not always necessary to check for the null return value.

  }, {
    key: "_createVNodeFromParams",
    value: function _createVNodeFromParams(nodeName, nodeType, nodeValue, attributes) {
      var configByNodeType = this._configByNodeName[nodeName];

      if (!configByNodeType) {
        return null;
      }

      var config = configByNodeType[nodeType] || // Allow lossless data migration from "embed" to "structure" element type.
      nodeType === 'embed' && configByNodeType['structure'];

      if (!config) {
        return null;
      }

      var vNode = config.createVNode(nodeValue, null);

      if (attributes) {
        vNode.attributes = attributes;
      }

      return vNode;
    }
  }, {
    key: "_createVNodeFromAction",
    value: function _createVNodeFromAction(action, nodeType) {
      var vNode = this._createVNodeFromParams(Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["getNodeName"])(action), nodeType, Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["getNodeId"])(action));

      if (vNode) {
        vNode.attributes = Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["getAttributes"])(action, vNode.attributeNames);
      }

      return vNode;
    }
  }, {
    key: "_createDefaultChild",
    value: function _createDefaultChild(vParentNode) {
      return this._createVNodeFromParams(vParentNode.defaultChildNode, 'structure', null, []).appendTo(vParentNode);
    }
  }, {
    key: "_createFormattingHelperVNode",
    value: function _createFormattingHelperVNode() {
      return this._createVNodeFromParams('SPAN', 'format', null, ['@data-mce-bogus', '1', '@data-mce-type', 'format-caret', '@id', '_mce_caret']);
    }
  }, {
    key: "createVirtualDomFromOtModel",
    value: function createVirtualDomFromOtModel(model) {
      if (model.length > 0 && Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["isInsertOpen"])(model[0]) && Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["getNodeName"])(model[0]) === '#root') {
        var _vDom = this._createVNodeFromAction(model[0], 'root');

        this._populateVNodeFromOtModel(_vDom, model, 1, [], 0);

        return _vDom;
      }

      var vDom = this._createVNodeFromParams('#root', 'root', "\uE000", []);

      this._populateVNodeFromOtModel(vDom, model, 0, [], 0);

      return vDom;
    } // Populates `vRootNode` with the actions from `model` starting at `modelIndex`.
    // Returns the index of the first unprocessed action.

  }, {
    key: "_populateVNodeFromOtModel",
    value: function _populateVNodeFromOtModel(vRootNode, model, modelIndex, stack, defaultNodesOnStack) {
      var modelLength = model.length;
      stack.push(vRootNode);

      MAIN_LOOP: while (modelIndex < modelLength) {
        var action = model[modelIndex++];

        if (Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["isInsertText"])(action)) {
          // handle text and formatting
          var _vNode = vRootNode;
          var formatIndexesLength = 0; // prepare the formats based on the attributes

          for (var i = Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["getAttributesIndex"])(action), l = action.length; i < l;) {
            var name = action[i++];
            var value = action[i++];
            var format = this._formatsByOt[name];

            if (format) {
              var index = format.index;
              var attributeName = format.attributeName,
                  attributeValue = format.attributeValue;
              formatAttributes[index] = attributeName === null ? [] : [attributeName, attributeValue !== null ? attributeValue : value];
              formatIndexes[formatIndexesLength++] = index;
            } else if (value === '') {
              var indexOfValueInName = name.indexOf('=');

              if (indexOfValueInName > 0) {
                // If the name contains '=' and the value is empty, we assume that the actual name is the
                // string before '=' and the actual value is the string after '='.
                // This assumption is guaranteed to be correct thanks to the format name validation in
                // `Config`, which bans '=' in format names, except for those which store attribute's value
                // in the attribute's name.
                var _format4 = this._formatsByOt[name.substring(0, indexOfValueInName + 1)];

                if (_format4) {
                  var _attributeName = _format4.attributeName,
                      _index = _format4.index;
                  var lastIndex = formatIndexesLength > 0 ? formatIndexes[formatIndexesLength - 1] : -1;

                  var nameAndValue = _attributeName + name.substring(indexOfValueInName + 1);

                  if (_index === lastIndex) {
                    formatAttributes[_index].push(nameAndValue, '');
                  } else {
                    formatAttributes[_index] = [nameAndValue, ''];
                    formatIndexes[formatIndexesLength++] = _index;
                  }
                }
              }
            }
          }

          if (formatIndexesLength > 0) {
            if (formatIndexesLength === 1) {// One element - no sorting needed.
            } else if (formatIndexesLength === 2) {
              if (formatIndexes[0] > formatIndexes[1]) {
                var temp = formatIndexes[0];
                formatIndexes[0] = formatIndexes[1];
                formatIndexes[1] = temp;
              }
            } else {
              formatIndexes.length = formatIndexesLength;
              formatIndexes.sort();
            } // Go through all supported formats in order and create an appropriate
            // virtual node structure, reusing existing nodes, if possible.


            for (var _i8 = 0; _i8 < formatIndexesLength; ++_i8) {
              var _index2 = formatIndexes[_i8];
              var attributes = formatAttributes[_index2];
              var nodeName = this._formats[_index2].nodeName;
              var lastChild = _vNode.childNodes[_vNode.childNodes.length - 1];

              if (lastChild && lastChild.nodeName === nodeName && Object(_util_misc__WEBPACK_IMPORTED_MODULE_12__["areArraysEqual"])(lastChild.attributes, attributes)) {
                _vNode = lastChild; // reuse `lastChild`

                continue;
              }

              var _vChildNode = this._createVNodeFromParams(nodeName, 'format', null, attributes); // create a new child node and add it to `vNode`


              if (_vNode !== vRootNode) {
                // vNode must be a format and Config guarantees that each can accept any other format.
                _vNode = _vChildNode.appendTo(_vNode);
              } else if (this._shouldParentAppendChildNode(_vChildNode.nodeName, stack, defaultNodesOnStack)) {
                --modelIndex;
                break MAIN_LOOP;
              } else if (vRootNode.validChildNodes.has(_vChildNode.nodeName)) {
                _vNode = _vChildNode.appendTo(vRootNode);
              } else if (vRootNode.defaultChildNode) {
                modelIndex = this._populateVNodeFromOtModel(this._createDefaultChild(vRootNode), model, modelIndex - 1, stack, defaultNodesOnStack + 1);
                continue MAIN_LOOP;
              }
            }
          } // create a text node


          var text = Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["getText"])(action);

          var vChildNode = this._createVNodeFromParams('#text', 'text', text);

          if (_vNode !== vRootNode) {
            // vNode must be a format and Config guarantees that each format can accept a text node.
            if (text === "\uFEFF" && formattingHelperActions.has(action)) {
              _vNode = this._createFormattingHelperVNode().appendTo(_vNode);
            }

            vChildNode.appendTo(_vNode);
          } else if (this._shouldParentAppendChildNode(vChildNode.nodeName, stack, defaultNodesOnStack)) {
            --modelIndex;
            break;
          } else if (vRootNode.validChildNodes.has(vChildNode.nodeName)) {
            if (text === "\uFEFF" && formattingHelperActions.has(action)) {
              _vNode = this._createFormattingHelperVNode().appendTo(_vNode);
            }

            vChildNode.appendTo(_vNode);
          } else if (vRootNode.defaultChildNode) {
            modelIndex = this._populateVNodeFromOtModel(this._createDefaultChild(vRootNode), model, modelIndex - 1, stack, defaultNodesOnStack + 1);
          }
        } else if (Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["isInsertOpen"])(action)) {
          // handle opening tags
          var _vChildNode2 = this._createVNodeFromAction(action, 'structure');

          if (!_vChildNode2) {
            continue;
          } else if (this._shouldParentAppendChildNode(_vChildNode2.nodeName, stack, defaultNodesOnStack)) {
            --modelIndex;
            break;
          } else if (vRootNode.validChildNodes.has(_vChildNode2.nodeName)) {
            modelIndex = this._populateVNodeFromOtModel(_vChildNode2.appendTo(vRootNode), model, modelIndex, stack, 0);
          } else if (vRootNode.defaultChildNode) {
            modelIndex = this._populateVNodeFromOtModel(this._createDefaultChild(vRootNode), model, modelIndex - 1, stack, defaultNodesOnStack + 1);
          }
        } else if (Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["isInsertClose"])(action)) {
          // handle closing tags
          var nodeId = Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["getNodeId"])(action);

          var _nodeName2 = Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["getNodeName"])(action);

          var _lastIndex = stack.length - 1; // If closing the node at the top of the stack, make the caller process the next model item.
          // If closing a node lower on the stack, make the caller re-process the current model item.
          // If closing a non-existent node, just ignore the action.


          for (var _i9 = _lastIndex; _i9 >= 0; --_i9) {
            if (stack[_i9].nodeValue === nodeId && stack[_i9].nodeName === _nodeName2) {
              if (_i9 !== _lastIndex) {
                --modelIndex;
              }

              break MAIN_LOOP;
            }
          }
        } else if (Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["isInsertEmbed"])(action)) {
          // handle embedded content
          var _vChildNode3 = this._createVNodeFromAction(action, 'embed');

          if (!_vChildNode3) {
            continue;
          } else if (this._shouldParentAppendChildNode(_vChildNode3.nodeName, stack, defaultNodesOnStack)) {
            --modelIndex;
            break;
          } else if (vRootNode.validChildNodes.has(_vChildNode3.nodeName)) {
            _vChildNode3.appendTo(vRootNode);
          } else if (vRootNode.defaultChildNode) {
            modelIndex = this._populateVNodeFromOtModel(this._createDefaultChild(vRootNode), model, modelIndex - 1, stack, defaultNodesOnStack + 1);
          }
        }
      }

      var vNode = vRootNode;

      while (vNode.defaultChildNode && vNode.childNodes.length === 0) {
        vNode = this._createDefaultChild(vNode);
      } // NOTE BR-elements (see at the end of this file)


      if (vNode.needsBr && (vNode.childNodes.length === 0 || vNode.childNodes[vNode.childNodes.length - 1].nodeName === 'BR')) {
        this._createVNodeFromParams('BR', 'embed', "\uE000", []).appendTo(vNode);
      }

      stack.pop();
      return modelIndex;
    }
  }, {
    key: "_shouldParentAppendChildNode",
    value: function _shouldParentAppendChildNode(childNodeName, stack, defaultNodesOnStack) {
      var i = stack.length - 1;

      while (--defaultNodesOnStack >= 0 && --i >= 0) {
        if (stack[i].validChildNodes.has(childNodeName)) {
          return true;
        }
      }

      return false;
    }
  }, {
    key: "_updateRealNode",
    value: function _updateRealNode(newVNode, oldVNode) {
      newVNode.linkRealNode(oldVNode.realNode);
      newVNode.updateRealNodeValue(oldVNode.nodeValue);
      newVNode.updateRealAttributes(oldVNode.attributes);
      var newChildNodes = newVNode.childNodes;

      if (newChildNodes) {
        var oldChildNodes = oldVNode.childNodes;
        var realNode = newVNode.realNode;
        var newStartIndex = 0;
        var newEndIndex = newChildNodes.length - 1;
        var oldStartIndex = 0;
        var oldEndIndex = oldChildNodes.length - 1; // Update similar children at the start of the list.

        while (newStartIndex <= newEndIndex && oldStartIndex <= oldEndIndex) {
          if (newChildNodes[newStartIndex].isSimilarTo(oldChildNodes[oldStartIndex])) {
            this._updateRealNode(newChildNodes[newStartIndex++], oldChildNodes[oldStartIndex++]);
          } else {
            break;
          }
        } // Update similar children at the end of the list.


        while (newStartIndex <= newEndIndex && oldStartIndex <= oldEndIndex) {
          if (newChildNodes[newEndIndex].isSimilarTo(oldChildNodes[oldEndIndex])) {
            this._updateRealNode(newChildNodes[newEndIndex--], oldChildNodes[oldEndIndex--]);
          } else {
            break;
          }
        } // Remove old nodes.


        while (oldStartIndex <= oldEndIndex) {
          realNode.removeChild(oldChildNodes[oldStartIndex].realNode);
          oldChildNodes[oldStartIndex++].unlinkRealNode();
        } // Add new nodes.


        if (newStartIndex <= newEndIndex) {
          var referenceRealChild = newEndIndex + 1 < newChildNodes.length ? newChildNodes[newEndIndex + 1].realNode : null;

          do {
            this._createAndInsertRealNodeBefore(newChildNodes[newStartIndex++], realNode, referenceRealChild);
          } while (newStartIndex <= newEndIndex);
        }
      }
    }
  }, {
    key: "_createAndInsertRealNodeBefore",
    value: function _createAndInsertRealNodeBefore(vNode, parentNode, referenceNode) {
      var realNode = vNode.createRealNode(this._document);
      parentNode.insertBefore(realNode, referenceNode);
      vNode.upgradeRealNode(realNode);
      vNode.linkRealNode(realNode);
      vNode.updateRealNodeValue('');
      vNode.updateRealAttributes([]);

      if (vNode.childNodes) {
        for (var i = 0, l = vNode.childNodes.length; i < l; ++i) {
          this._createAndInsertRealNodeBefore(vNode.childNodes[i], realNode, null);
        }
      }
    }
    /*
    88888888ba   88888888ba   88888888888   ad88888ba   88888888888  888b      88    ,ad8888ba,   88888888888
    88      "8b  88      "8b  88           d8"     "8b  88           8888b     88   d8"'    `"8b  88
    88      ,8P  88      ,8P  88           Y8,          88           88 `8b    88  d8'            88
    88aaaaaa8P'  88aaaaaa8P'  88aaaaa      `Y8aaaaa,    88aaaaa      88  `8b   88  88             88aaaaa
    88""""""'    88""""88'    88"""""        `"""""8b,  88"""""      88   `8b  88  88             88"""""
    88           88    `8b    88                   `8b  88           88    `8b 88  Y8,            88
    88           88     `8b   88           Y8a     a8P  88           88     `8888   Y8a.    .a8P  88
    88           88      `8b  88888888888   "Y88888P"   88888888888  88      `888    `"Y8888Y"'   88888888888
     */

  }, {
    key: "_onSelectionChange",
    value: function _onSelectionChange() {
      var _this2 = this;

      if (this._document.documentMode === 11) {
        // Sometimes we need to trigger a fake DOM mutation because IE11 does not do it.
        this._fixIE11MutationReporting(); // IE11 triggers selectionchange event synchronously, which is incorrect and causes
        // problems, so we must delay the handler.


        setTimeout(function () {
          return _this2._handleSelectionChange();
        });
        return;
      }

      this._handleSelectionChange();
    }
  }, {
    key: "_handleSelectionChange",
    value: function _handleSelectionChange() {
      this._removeUnselectedFormattingHelper();

      this._fixSelection();

      this._scheduleSubmitPresence();

      this._lastSelection = this.getSelection();
    }
  }, {
    key: "_onPresenceChange",
    value: function _onPresenceChange(srcList, submitted) {
      this._scheduleUpdatePresence(srcList, submitted);
    }
  }, {
    key: "_onMouseMove",
    value: function _onMouseMove(event) {
      this._mouseX = event.clientX;
      this._mouseY = event.clientY;

      this._handleMouse();
    }
  }, {
    key: "_onMouseLeave",
    value: function _onMouseLeave() {
      this._mouseX = -1;
      this._mouseY = -1;

      this._handleMouse();
    }
  }, {
    key: "_onMouseDown",
    value: function _onMouseDown(event) {
      if (event.button === 0) {
        this._selectingWithMouse = true;
      }
    }
  }, {
    key: "_onMouseUp",
    value: function _onMouseUp(event) {
      if (event.button === 0) {
        this._selectingWithMouse = false;

        this._fixSelection();
      }
    }
  }, {
    key: "_onResize",
    value: function _onResize() {
      this._scheduleUpdatePresence();
    }
  }, {
    key: "_onScroll",
    value: function _onScroll() {
      this._updatePresenceViewport();

      this._handleMouse();
    }
  }, {
    key: "_handleMouse",
    value: function _handleMouse() {
      if (!this.presenceEnabled) {
        return;
      } // Hover over at most one presence.


      var hasHovered = false;

      for (var src in this._presence) {
        var presence = this._presence[src];

        if (hasHovered) {
          presence.hovered = false;
        } else {
          presence.hovered = hasHovered = presence.containsPoint(this._mouseX, this._mouseY);
        }
      }
    }
  }, {
    key: "_submitPresence",
    value: function _submitPresence() {
      if (!this.presenceEnabled || this.otModel === null) {
        this._doc.submitPresence(null);

        return;
      }

      var selections = [];
      var presence = {
        u: '',
        c: this._changeNumber,
        s: selections
      };
      var selection = this.getSelection();

      if (selection.anchor >= 0 && selection.focus >= 0) {
        // Add basic selection
        selections.push([selection.anchor, selection.focus]); // Add table cell selections

        var window = this._document.defaultView;
        var node = window ? window.getSelection().anchorNode : null;
        var vNode = null; // Find a selected TD or TH node.
        // Most of the time the node won't be found, which will save us running querySelectorAll unnecessarily.

        while (node && (vNode = node[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]]) && (vNode.nodeName !== 'TD' && vNode.nodeName !== 'TH' || node.getAttribute('data-mce-selected') !== '1')) {
          node = node.parentNode;
        }

        if (vNode) {
          var selectedNodes = this._realDom.querySelectorAll('[data-mce-selected="1"]');

          for (var i = 0, l = selectedNodes.length; i < l; ++i) {
            var selectedNode = selectedNodes[i];
            var selectedVNode = selectedNode[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]];

            if (selectedVNode && (selectedVNode.nodeName === 'TD' || selectedVNode.nodeName === 'TH')) {
              selections.push([selectedVNode.modelStartOffset, selectedVNode.modelEndOffset]);
            }
          }
        }
      }

      this._doc.submitPresence(presence);
    }
  }, {
    key: "_scheduleUpdatePresence",
    value: function _scheduleUpdatePresence(srcList, reportActivity) {
      if (srcList) {
        for (var i = 0, l = srcList.length; i < l; ++i) {
          var src = srcList[i];

          if (src && (reportActivity || !(src in this._updatedPresence))) {
            this._updatedPresence[src] = reportActivity;
          }
        }
      } else if (this.presenceEnabled) {
        for (var _src in this._doc.presence) {
          if (_src && !(_src in this._updatedPresence)) {
            this._updatedPresence[_src] = false;
          }
        }
      } else {
        for (var _src2 in this._presence) {
          if (_src2 && !(_src2 in this._updatedPresence)) {
            this._updatedPresence[_src2] = false;
          }
        }
      }

      if (Object(_util_misc__WEBPACK_IMPORTED_MODULE_12__["hasKeys"])(this._updatedPresence)) {
        this._updatePresence();
      }
    }
  }, {
    key: "_updatePresenceViewport",
    value: function _updatePresenceViewport() {
      var viewport = this._getViewport();

      this._unwatchRealDom();

      for (var src in this._presence) {
        var presence = this._presence[src];
        presence.viewport = viewport;
        presence.update();
      }

      this._watchRealDom();
    }
  }, {
    key: "_getViewport",
    value: function _getViewport() {
      var window = this._document.defaultView;
      var iframeElement = Object(_util_misc__WEBPACK_IMPORTED_MODULE_12__["getIframeElement"])(window);

      if (!iframeElement && !window) {
        return new _util_ReadOnlyRect__WEBPACK_IMPORTED_MODULE_14__["default"](0, 0, 0, 0);
      }

      var contentElement = iframeElement ? iframeElement : this._presenceInnerNode;
      var containerWindow = iframeElement ? window.parent : window;
      var rect = contentElement.getBoundingClientRect();
      var x = Math.max(0, -rect.left);
      var y = Math.max(0, -rect.top);
      var width = rect.width - x - Math.max(0, rect.right - containerWindow.innerWidth);
      var height = rect.height - y - Math.max(0, rect.bottom - containerWindow.innerHeight);
      return new _util_ReadOnlyRect__WEBPACK_IMPORTED_MODULE_14__["default"](x, y, width, height);
    }
  }, {
    key: "_updatePresence",
    value: function _updatePresence() {
      // Calculate all the positions first
      var srcList = Object.keys(this._updatedPresence);

      var viewport = this._getViewport();

      var presenceRect = this._presenceInnerNode.getBoundingClientRect();

      var caretRectList = new Array(srcList.length);
      var selectionRectsList = new Array(srcList.length);
      var updates = [];

      for (var i = 0, l = srcList.length; i < l; ++i) {
        var src = srcList[i];
        var presenceData = this._doc.presence[src];
        caretRectList[i] = presenceData ? this._getCaretRect(presenceData) : null;
        selectionRectsList[i] = presenceData ? this._getSelectionRects(presenceData) : null;
      } // Update the DOM next - grouping reads and writes minimizes reflows


      this._unwatchRealDom();

      for (var _i10 = 0, _l8 = srcList.length; _i10 < _l8; ++_i10) {
        var _src3 = srcList[_i10];
        var _presenceData = this._doc.presence[_src3];
        var reportActivity = this._updatedPresence[_src3];
        var update = {
          src: _src3,
          presenceData: _presenceData,
          presence: null,
          emitPresence: false,
          reportActivity: reportActivity
        };
        delete this._updatedPresence[_src3];
        updates.push(update);

        if (!_presenceData) {
          if (this._presence[_src3]) {
            this._presence[_src3].dispose();

            delete this._presence[_src3];
            update.emitPresence = true;
          }

          continue;
        }

        var presence = this._presence[_src3];

        if (!presence) {
          presence = this._presence[_src3] = new _TinyMcePresence__WEBPACK_IMPORTED_MODULE_13__["TinyMcePresence"](_src3, _presenceData.u, this._presenceInnerNode);
          update.emitPresence = true;
        }

        update.presence = presence;
        presence.beforeUpdate(reportActivity);
        presence.viewport = viewport;
        presence.containerRect = presenceRect;
        presence.caretRect = caretRectList[_i10];
        presence.selectionRects = selectionRectsList[_i10];
        presence.update(reportActivity);
      }

      this._watchRealDom(); // Access offsetHeight to force a reflow, so that Presence instances can update their animated styles reliably.
      // The condition should be always true.
      // See https://stackoverflow.com/a/16575811/706807


      if (this._presenceInnerNode.offsetHeight != null) {
        this._handleMouse();
      }

      for (var _i11 = 0, _l9 = updates.length; _i11 < _l9; ++_i11) {
        var _updates$_i = updates[_i11],
            _src4 = _updates$_i.src,
            _presence = _updates$_i.presence,
            _presenceData2 = _updates$_i.presenceData,
            emitPresence = _updates$_i.emitPresence,
            _reportActivity = _updates$_i.reportActivity;

        if (emitPresence) {
          this.emit('presence', _src4, _presence);
        }

        if (_presence && _reportActivity) {
          _presence.reportActivity(_presenceData2.c);
        }
      }

      this._unwatchRealDom();

      for (var _i12 = 0, _l10 = updates.length; _i12 < _l10; ++_i12) {
        var _updates$_i2 = updates[_i12],
            _presence2 = _updates$_i2.presence,
            _reportActivity2 = _updates$_i2.reportActivity;

        if (_presence2) {
          _presence2.afterUpdate(_reportActivity2);
        }
      }

      this._watchRealDom();
    }
  }, {
    key: "_getCaretRect",
    value: function _getCaretRect(presence) {
      var _this$getCaretNodeAnd = this.getCaretNodeAndOffset(presence),
          node = _this$getCaretNodeAnd.node,
          offset = _this$getCaretNodeAnd.offset;

      if (node == null) {
        return null;
      }

      if (node.nodeType === Node.TEXT_NODE) {
        var range = this._realDom.ownerDocument.createRange();

        range.setStart(node, offset);
        range.setEnd(node, offset);

        var _rects = range.getClientRects();

        return _rects.length === 1 ? _rects[0] : null;
      }

      var rects = node.getClientRects();

      if (rects.length !== 1) {
        return null;
      }

      var rect = rects[0];
      var vNode = node[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]];
      var caretRect = {
        width: 0,
        left: rect.left,
        right: rect.left,
        height: rect.height,
        top: rect.top,
        bottom: rect.bottom,
        x: rect.x,
        y: rect.y
      };

      if (vNode.childNodes != null) {
        var window = this._document.defaultView;
        var style = window ? window.getComputedStyle(node) : {};
        caretRect.x = caretRect.left = caretRect.right = caretRect.left + (parseFloat(style.borderLeftWidth) || 0) + (parseFloat(style.paddingLeft) || 0);
        caretRect.y = caretRect.top = caretRect.top + (parseFloat(style.borderTopWidth) || 0) + (parseFloat(style.paddingTop) || 0);
        caretRect.height = parseFloat(style.lineHeight) || 0;
        caretRect.bottom = caretRect.top + caretRect.height;
      }

      return caretRect;
    } // Takes a node and offset, and finds a near-by node and offset that are suitable for retrieving client rects from,
    // so that the caret position can be reliably determined in all situations.

  }, {
    key: "getCaretNodeAndOffset",
    value: function getCaretNodeAndOffset(presence) {
      var firstSelection = presence.s[0];

      if (!firstSelection) {
        return {
          node: null,
          offset: 0
        };
      }

      var nodeAndOffset = this._getRealNodeAndOffsetFromPosition(firstSelection[1], true);

      var node = nodeAndOffset.node,
          offset = nodeAndOffset.offset;
      var vNode, childNodes, sibling, parent;

      if (!node || (vNode = node[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]]) && (!vNode.childNodes || vNode.childNodes.length === 0)) {
        return nodeAndOffset;
      } // Look forward
      // eslint-disable-next-line no-constant-condition


      while (true) {
        if (node[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]] && (childNodes = node.childNodes) && offset < childNodes.length) {
          // check the next child node
          node = childNodes[offset];
          offset = 0;

          if ((vNode = node[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]]) && (!vNode.childNodes || vNode.childNodes.length === 0)) {
            return {
              node: node,
              offset: offset
            };
          }
        } else if (sibling = node.nextSibling) {
          // check the next sibling node
          node = sibling;
          offset = 0;

          if ((vNode = node[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]]) && (!vNode.childNodes || vNode.childNodes.length === 0)) {
            return {
              node: node,
              offset: offset
            };
          }
        } else if (node !== this._realDom && (parent = node.parentNode) && parent !== this._realDom) {
          // check the parent node
          offset = Array.prototype.indexOf.call(parent.childNodes, node) + 1;
          node = parent;
        } else {
          break;
        }
      } // Look backward


      ;
      node = nodeAndOffset.node;
      offset = nodeAndOffset.offset;

      // eslint-disable-next-line no-constant-condition
      while (true) {
        if (node[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]] && (childNodes = node.childNodes) && offset > 0) {
          // check the previous child node
          node = childNodes[offset - 1];

          if (vNode = node[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]]) {
            if (vNode.nodeType === 'embed') {
              offset = 0;
              return {
                node: node,
                offset: offset
              };
            } else if (vNode.nodeType === 'text') {
              offset = vNode.nodeValue.length;
              return {
                node: node,
                offset: offset
              };
            } else if (vNode.childNodes.length === 0) {
              offset = 0;
              return {
                node: node,
                offset: offset
              };
            }
          }

          childNodes = node.childNodes;
          offset = childNodes ? childNodes.length : 0;
        } else if (sibling = node.previousSibling) {
          // check the previous sibling node
          node = sibling;

          if (vNode = node[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]]) {
            if (vNode.nodeType === 'embed') {
              offset = 0;
              return {
                node: node,
                offset: offset
              };
            } else if (vNode.nodeType === 'text') {
              offset = vNode.nodeValue.length;
              return {
                node: node,
                offset: offset
              };
            } else if (vNode.childNodes.length === 0) {
              offset = 0;
              return {
                node: node,
                offset: offset
              };
            }
          }

          childNodes = node.childNodes;
          offset = childNodes ? childNodes.length : 0;
        } else if (node !== this._realDom && (parent = node.parentNode) && parent !== this._realDom) {
          // check the parent node
          offset = Array.prototype.indexOf.call(parent.childNodes, node);
          node = parent;
        } else {
          break;
        }
      }

      return {
        node: this._realDom,
        offset: 0
      };
    }
  }, {
    key: "_getSelectionRects",
    value: function _getSelectionRects(presence) {
      var selections = presence.s;

      if (selections.length === 0) {
        return null;
      }

      var rects = [];
      var rectsIndex = 0; // Add table selections.
      // Each selected table cell is represented by an entry in `selections`.
      // The selection start must be right before a table cell.
      // The selection end must be right after the table cell.
      // For simplicity and performance, assume that selection end is correct and simply ignore it.

      for (var i = 1, l = selections.length; i < l; ++i) {
        var selection = selections[i];
        var _start = selection[0];

        var _this$_getRealNodeAnd = this._getRealNodeAndOffsetFromPosition(_start, false),
            _node = _this$_getRealNodeAnd.node,
            _offset = _this$_getRealNodeAnd.offset;

        if (_node) {
          var _childNodes = _node.childNodes;

          if (_childNodes) {
            var tableCell = _childNodes[_offset];

            if (tableCell) {
              var nodeName = tableCell.nodeName;

              if (nodeName === 'TD' || nodeName === 'TH') {
                rects[rectsIndex++] = tableCell.getBoundingClientRect();
              }
            }
          }
        }
      } // Add basic selection


      var firstSelection = selections[0];
      var anchor = firstSelection[0];
      var focus = firstSelection[1];

      if (anchor === focus) {
        return rects;
      }

      var start = anchor < focus ? anchor : focus;
      var end = anchor > focus ? anchor : focus;

      var _this$_getRealNodeAnd2 = this._getRealNodeAndOffsetFromPosition(start, false),
          startNode = _this$_getRealNodeAnd2.node,
          startOffset = _this$_getRealNodeAnd2.offset;

      var _this$_getRealNodeAnd3 = this._getRealNodeAndOffsetFromPosition(end, true),
          endNode = _this$_getRealNodeAnd3.node,
          endOffset = _this$_getRealNodeAnd3.offset;

      if (startNode == null || endNode == null || startNode === endNode && startOffset === endOffset) {
        return rects;
      }

      var node = startNode;
      var offset = startOffset;
      var parent = null;
      var childNodes = null;
      var offsetStack = [];
      var offsetStackLength = 0;

      var range = this._document.createRange();

      while (node != null && (node !== endNode || offset !== endOffset)) {
        var vNode = node[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]]; // Record the selection rects.

        if (vNode != null) {
          if (vNode.nodeType === 'text') {
            range.setStart(node, node === startNode ? startOffset : 0);
            range.setEnd(node, node === endNode ? endOffset : vNode.nodeValue.length);
            var rangeRects = range.getClientRects();

            for (var _i13 = 0, _l11 = rangeRects.length; _i13 < _l11; ++_i13) {
              var rect = rangeRects[_i13];

              if (rect.width > 0 && rect.height > 0) {
                rects[rectsIndex++] = rect;
              }
            }
          } else if (vNode.nodeType === 'embed') {
            var _rect = node.getBoundingClientRect();

            if (_rect.width > 0 && _rect.height > 0) {
              rects[rectsIndex++] = _rect;
            }
          }
        } // Move on to the next node.


        if (vNode && vNode.childNodes && offset < (childNodes = node.childNodes).length) {
          offsetStack[offsetStackLength++] = offset;
          node = childNodes[offset];
          offset = 0;
        } else if (node === endNode) {
          offset = endOffset;
        } else if (node !== this._realDom && (parent = node.parentNode)) {
          offset = (offsetStackLength > 0 ? offsetStack[--offsetStackLength] : Array.prototype.indexOf.call(parent.childNodes, node)) + 1;
          node = parent;
        } else {
          node = null;
        }
      }

      return rects;
    }
    /*
    ad88888ba   88888888888  88           88888888888    ,ad8888ba,   888888888888  88    ,ad8888ba,    888b      88
    d8"     "8b  88           88           88            d8"'    `"8b       88       88   d8"'    `"8b   8888b     88
    Y8,          88           88           88           d8'                 88       88  d8'        `8b  88 `8b    88
    `Y8aaaaa,    88aaaaa      88           88aaaaa      88                  88       88  88          88  88  `8b   88
    `"""""8b,  88"""""      88           88"""""      88                  88       88  88          88  88   `8b  88
        `8b  88           88           88           Y8,                 88       88  Y8,        ,8P  88    `8b 88
    Y8a     a8P  88           88           88            Y8a.    .a8P       88       88   Y8a.    .a8P   88     `8888
    "Y88888P"   88888888888  88888888888  88888888888    `"Y8888Y"'        88       88    `"Y8888Y"'    88      `888
     */

  }, {
    key: "getSelection",
    value: function getSelection() {
      var window = this._document.defaultView;

      if (!window) {
        return {
          anchor: -1,
          focus: -1
        };
      }

      var selection = window.getSelection();

      var anchor = this._getPositionFromRealNodeAndOffset(selection.anchorNode, selection.anchorOffset);

      var focus = selection.isCollapsed ? anchor : this._getPositionFromRealNodeAndOffset(selection.focusNode, selection.focusOffset);
      return {
        anchor: anchor,
        focus: focus
      };
    }
  }, {
    key: "transformSelection",
    value: function transformSelection(_ref2, operation) {
      var anchor = _ref2.anchor,
          focus = _ref2.focus;
      var newAnchor = anchor < 0 ? anchor : Object(_teamwork_ot_rich_text_lib_Operation__WEBPACK_IMPORTED_MODULE_10__["transformCursor"])(anchor, operation, false);
      var newFocus = anchor === focus ? newAnchor : focus < 0 ? focus : Object(_teamwork_ot_rich_text_lib_Operation__WEBPACK_IMPORTED_MODULE_10__["transformCursor"])(focus, operation, false);
      return {
        anchor: newAnchor,
        focus: newFocus
      };
    }
  }, {
    key: "setSelection",
    value: function setSelection(_ref3) {
      var anchor = _ref3.anchor,
          focus = _ref3.focus;
      var window = this._document.defaultView;

      if (!window) {
        return;
      }

      if (anchor === focus) {
        // Focus the TinyMCE's formatting helper, if appropriate.
        var mceCaretNode = this._realDom.querySelector('#_mce_caret');

        if (mceCaretNode) {
          var textNode = mceCaretNode.lastChild;

          if (textNode && textNode.nodeType === Node.TEXT_NODE && textNode.nodeValue === "\uFEFF") {
            var textVNode = textNode[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]];

            if (textVNode && textVNode.modelEndOffset === focus) {
              window.getSelection().collapse(textNode, 1);
              return;
            }
          }
        }
      }

      var _this$getSelection = this.getSelection(),
          currentAnchor = _this$getSelection.anchor,
          currentFocus = _this$getSelection.focus;

      if (anchor === currentAnchor && focus === currentFocus) {
        return;
      }

      var newSelection = _util_misc__WEBPACK_IMPORTED_MODULE_12__["isSelectionExtendSupported"] ? this._getRealDomSelectionFromPositions(anchor, focus) : // Prepare the results in the "forward" order, if a "backward" selection can't be set programmatically.
      this._getRealDomSelectionFromPositions(Math.min(anchor, focus), Math.max(anchor, focus));

      if (!newSelection.anchorNode || !newSelection.focusNode) {
        return;
      }

      Object(_util_misc__WEBPACK_IMPORTED_MODULE_12__["setSelection"])(window.getSelection(), newSelection.anchorNode, newSelection.anchorOffset, newSelection.focusNode, newSelection.focusOffset);
    }
  }, {
    key: "scrollCaretIntoView",
    value: function scrollCaretIntoView() {
      var document = this._document;
      var window = document.defaultView;

      if (!window) {
        return;
      }

      var selection = window.getSelection();
      var node = selection.focusNode;
      var offset = selection.focusOffset;

      if (!Object(_util_misc__WEBPACK_IMPORTED_MODULE_12__["containsNode"])(this._realDom, node)) {
        return;
      }

      while (node && node !== this._realDom && node.nodeType !== Node.ELEMENT_NODE) {
        var parentNode = node.parentNode;
        offset = Array.prototype.indexOf.call(parentNode.childNodes, node);
        node = parentNode;
      }

      if (node && node.nodeType === Node.ELEMENT_NODE) {
        var scrollToNode = document.createElement('SPAN');

        this._unwatchRealDom();

        scrollToNode.setAttribute('data-mce-bogus', 'all');
        node.insertBefore(scrollToNode, node.childNodes[offset]);
        Object(scroll_into_view_if_needed__WEBPACK_IMPORTED_MODULE_9__["default"])(scrollToNode, {
          scrollMode: 'if-needed'
        });
        node.removeChild(scrollToNode);

        this._watchRealDom();
      }
    } // Returns the node and offset in the virtual DOM, which correspond to the node and offset in the real DOM.
    // Goes up the real DOM tree, if necessary, to find a real node with a vNode attached, so that embeds and
    // ignored nodes are handled properly. It also adjusts the offset for the ignored nodes.

  }, {
    key: "_getVirtualNodeAndOffsetFromRealNodeAndOffset",
    value: function _getVirtualNodeAndOffsetFromRealNodeAndOffset(realNode, offset) {
      var node = null; // Find a realNode associated with a vNode, or a realNode with the "mce-offscreen-selection" class.

      while (realNode && !(node = realNode[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]] || null) && !(realNode.classList && realNode.classList.contains('mce-offscreen-selection'))) {
        var childNode = realNode;
        var parentNode = childNode.parentNode;
        realNode = parentNode;
        offset = parentNode ? Array.prototype.indexOf.call(parentNode.childNodes, childNode) : 0;
      }

      if (realNode == null) {
        return {
          node: node,
          offset: 0
        };
      } // Handle mce-offscreen-selection.
      // When a contenteditable=false element is selected, TinyMCE actually selects a bogus element at the end
      // of the content. When that is the case, we need to find the corresponding real element.


      if (node == null) {
        realNode = this._realDom.querySelector('[data-mce-selected="1"]');

        if (realNode == null) {
          return {
            node: node,
            offset: 0
          };
        }

        var _parentNode2 = realNode.parentNode;

        if (_parentNode2 == null) {
          return {
            node: node,
            offset: 0
          };
        }

        offset = Array.prototype.indexOf.call(_parentNode2.childNodes, realNode) + +!!offset;
        realNode = _parentNode2;
        node = realNode[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]] || null;

        if (node == null) {
          return {
            node: node,
            offset: 0
          };
        }
      } // Adjust the offset for any ignored nodes.


      if (realNode.hasChildNodes()) {
        if (!node.childNodes) {
          offset = 0;
        } else {
          var realChildNodes = realNode.childNodes;

          if (offset >= realChildNodes.length) {
            offset = node.childNodes.length;
          } else {
            for (var i = 0, l = offset; i < l; ++i) {
              if (!realChildNodes[i][_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]]) {
                --offset;
              }
            }
          }
        }
      }

      return {
        node: node,
        offset: offset
      };
    } // Returns the node and offset in the real DOM, which correspond to the node and offset in the virtual DOM.
    // It adjusts the offset for ignored nodes.

  }, {
    key: "_getRealNodeAndOffsetFromVirtualNodeAndOffset",
    value: function _getRealNodeAndOffsetFromVirtualNodeAndOffset(node, offset) {
      var realNode = node.realNode;

      if (node.nodeType === 'text') {
        return {
          node: realNode,
          offset: Math.max(0, Math.min(realNode.length, offset))
        };
      } else if (node.nodeType === 'embed') {
        return {
          node: realNode,
          offset: 0
        };
      }

      var childNodes = realNode.childNodes;
      var realOffset = 0;

      for (var i = 0, l = childNodes.length; i < l && offset > 0; ++i, ++realOffset) {
        if (childNodes[i][_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]]) {
          --offset;
        }
      }

      return {
        node: realNode,
        offset: realOffset
      };
    }
  }, {
    key: "_getPositionFromRealNodeAndOffset",
    value: function _getPositionFromRealNodeAndOffset(realNode, realOffset) {
      if (!realNode) {
        return -1;
      }

      var _this$_getVirtualNode = this._getVirtualNodeAndOffsetFromRealNodeAndOffset(realNode, realOffset),
          node = _this$_getVirtualNode.node,
          offset = _this$_getVirtualNode.offset;

      return this._getPositionFromVirtualNodeAndOffset(node, offset);
    }
  }, {
    key: "_getPositionFromVirtualNodeAndOffset",
    value: function _getPositionFromVirtualNodeAndOffset(node, offset) {
      if (!node) {
        return -1;
      }

      if (node.nodeType === 'text') {
        // A \uFEFF character is used by TinyMCE to support formatting - it's not a part of the content.
        return node.modelStartOffset + Math.max(0, Math.min(node.nodeValue.length, node.nodeValue === "\uFEFF" ? 0 : offset));
      }

      if (!node.childNodes) {
        return node.modelStartOffset;
      }

      if (offset <= 0) {
        return node.modelStartOffset + node.nodeValue.length;
      }

      if (offset < node.childNodes.length) {
        return node.childNodes[offset].modelStartOffset;
      }

      return node.modelEndOffset - node.nodeValue.length;
    } // `position` is the offset in the OT model.
    // If `preferEarlierNode` is true, the closest node at `position` is returned, otherwise the furthest one.

  }, {
    key: "_getRealNodeAndOffsetFromPosition",
    value: function _getRealNodeAndOffsetFromPosition(position, preferEarlierNode) {
      var nodeAndOffset = this._getVirtualNodeAndOffsetFromPosition(position, preferEarlierNode);

      if (!nodeAndOffset.node) {
        return nodeAndOffset;
      }

      return this._getRealNodeAndOffsetFromVirtualNodeAndOffset(nodeAndOffset.node, nodeAndOffset.offset);
    } // `position` is the offset in the OT model.
    // If `preferEarlierNode` is true, the closest node at `position` is returned, otherwise the furthest one.

  }, {
    key: "_getVirtualNodeAndOffsetFromPosition",
    value: function _getVirtualNodeAndOffsetFromPosition(position, preferEarlierNode) {
      return this._getVirtualNodeAndOffsetFromPositionImpl(this._virtualDom, position, preferEarlierNode);
    }
  }, {
    key: "_getVirtualNodeAndOffsetFromPositionImpl",
    value: function _getVirtualNodeAndOffsetFromPositionImpl(node, position, preferEarlierNode) {
      if (node.nodeType === 'text') {
        return {
          node: node,
          offset: Math.max(0, Math.min(node.nodeValue.length, position - node.modelStartOffset))
        };
      } else if (node.nodeType === 'embed') {
        return noSelection;
      }

      if (position < node.modelStartOffset + node.nodeValue.length || node.modelEndOffset - node.nodeValue.length < position) {
        return noSelection;
      }

      if (preferEarlierNode && position === node.modelStartOffset + node.nodeValue.length) {
        return {
          node: node,
          offset: 0
        };
      }

      if (!preferEarlierNode && position === node.modelEndOffset - node.nodeValue.length) {
        return {
          node: node,
          offset: node.childNodes.length
        };
      }

      var index = Object(_util_misc__WEBPACK_IMPORTED_MODULE_12__["binaryFindIndex"])(node.childNodes, selectionComparator(position, preferEarlierNode));
      var childNode = node.childNodes[index];

      var nodeAndOffset = this._getVirtualNodeAndOffsetFromPositionImpl(childNode, position, preferEarlierNode);

      if (nodeAndOffset.node) {
        return nodeAndOffset;
      }

      if (preferEarlierNode) {
        return {
          node: node,
          offset: index + 1
        };
      }

      return {
        node: node,
        offset: index
      };
    }
  }, {
    key: "_getRealDomSelectionFromPositions",
    value: function _getRealDomSelectionFromPositions(anchor, focus) {
      var focusNodeAndOffset = this._getRealNodeAndOffsetFromPosition(focus, anchor <= focus);

      var anchorNodeAndOffset = anchor === focus ? focusNodeAndOffset : this._getRealNodeAndOffsetFromPosition(anchor, anchor > focus);

      if (!anchorNodeAndOffset.node && focusNodeAndOffset.node) {
        anchorNodeAndOffset = focusNodeAndOffset;
      } else if (!focusNodeAndOffset.node && anchorNodeAndOffset.node) {
        focusNodeAndOffset = anchorNodeAndOffset;
      }

      return {
        anchorNode: anchorNodeAndOffset.node,
        anchorOffset: anchorNodeAndOffset.offset,
        focusNode: focusNodeAndOffset.node,
        focusOffset: focusNodeAndOffset.offset
      };
    } // This method approximates the previous selection after undo/redo operations.
    // Selections will eventually be stored on the undo/redo stacks, at which point this method won't be needed.

  }, {
    key: "_getSelectionFromOperation",
    value: function _getSelectionFromOperation(operation) {
      var position = 0;

      for (var i = 0, l = operation.length; i < l; ++i) {
        var action = operation[i];

        if (Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["isInsert"])(action) || Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["isRetain"])(action)) {
          position += Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["getLength"])(action);
        }
      }

      return {
        anchor: position,
        focus: position
      };
    }
  }, {
    key: "_getFormattingHelper",
    value: function _getFormattingHelper() {
      var window = this._document.defaultView;

      if (!window) {
        return null;
      }

      var _window$getSelection2 = window.getSelection(),
          anchorNode = _window$getSelection2.anchorNode,
          anchorOffset = _window$getSelection2.anchorOffset,
          isCollapsed = _window$getSelection2.isCollapsed;

      if (anchorOffset !== 1 || !anchorNode || !isCollapsed) {
        return null;
      }

      var vNode = anchorNode[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]];

      if (!vNode || vNode.nodeValue !== "\uFEFF" || !textNodeToFormattingHelper.has(vNode)) {
        return null;
      }

      return textNodeToFormattingHelper.get(vNode);
    } // When a text node becomes empty, IE11 sometimes does not report a mutation, so we trigger a fake one.
    // It does not matter what mutation we trigger, because IE11 mutations are so unreliable that we check
    // the whole DOM tree anyway.
    // See https://digitalcrew.teamwork.com/#tasks/13136706.

  }, {
    key: "_fixIE11MutationReporting",
    value: function _fixIE11MutationReporting() {
      var document = this._document;
      var window = document.defaultView;

      if (!window) {
        return;
      }

      var selection = this._document.defaultView.getSelection();

      var isCollapsed = selection.isCollapsed,
          anchorNode = selection.anchorNode;

      if (!isCollapsed || !anchorNode || anchorNode.nodeType !== Node.TEXT_NODE || anchorNode.nodeValue !== '' || !Object(_util_misc__WEBPACK_IMPORTED_MODULE_12__["containsNode"])(this._realDom, anchorNode)) {
        return;
      }

      this._realDom.setAttribute('data-trigger-mutation-observer', '');

      this._realDom.removeAttribute('data-trigger-mutation-observer');
    }
  }, {
    key: "_removeUnselectedFormattingHelper",
    value: function _removeUnselectedFormattingHelper() {
      var window = this._document.defaultView;

      if (!window) {
        return;
      }

      var formattingHelper = this._realDom.querySelector('#_mce_caret');

      if (!formattingHelper) {
        return;
      }

      var _window$getSelection3 = window.getSelection(),
          anchorNode = _window$getSelection3.anchorNode,
          anchorOffset = _window$getSelection3.anchorOffset,
          isCollapsed = _window$getSelection3.isCollapsed;

      if (isCollapsed && anchorNode === formattingHelper.firstChild && anchorOffset === 1) {
        return;
      }

      if (!Object(_util_misc__WEBPACK_IMPORTED_MODULE_12__["containsNode"])(this._realDom, anchorNode)) {
        // If selection is outside the editor, then leave the formatting helper alone,
        // as the user might be just clicking on a formatting button in a toolbar.
        return;
      }

      formattingHelper.parentNode.removeChild(formattingHelper);
    }
  }, {
    key: "_fixSelection",
    value: function _fixSelection() {
      if (this._selectingWithMouse) {
        // Don't modify the selection when selecting using mouse, so that the mouse selection is not interrupted.
        return;
      }

      var window = this._document.defaultView;

      if (!window) {
        return;
      }

      var selection = window.getSelection();

      if (selection.rangeCount === 0 || !Object(_util_misc__WEBPACK_IMPORTED_MODULE_12__["containsNode"])(this._realDom, selection.anchorNode)) {
        return;
      }

      this._fixSelectionInsideHeadingAnchor(selection);

      this._fixSelectionNearPresenceNode(selection);

      this._fixSelectionNearInlineComponent(selection);

      this._fixSelectionAfterBogusBr(selection);

      this._fixSelectionNearTextNode(selection);
    } // Modify the selection, so that it is not inside an anchor generated by the heading.

  }, {
    key: "_fixSelectionInsideHeadingAnchor",
    value: function _fixSelectionInsideHeadingAnchor(selection) {
      var anchorNode = selection.anchorNode,
          isCollapsed = selection.isCollapsed;

      if (!isCollapsed || anchorNode.nodeName !== 'A' || anchorNode.getAttribute('data-mce-bogus') !== 'all' || anchorNode !== anchorNode.parentNode.firstChild) {
        return;
      }

      var parentName = anchorNode.parentNode.nodeName;

      if (parentName !== 'H1' && parentName !== 'H2' && parentName !== 'H3' && parentName !== 'H4' && parentName !== 'H5' && parentName !== 'H6') {
        return;
      }

      selection.collapse(anchorNode.parentNode, 1);
    } // Modify the selection, so that it is not in nor before _presenceNode,
    // which is always the first node in _realDom.

  }, {
    key: "_fixSelectionNearPresenceNode",
    value: function _fixSelectionNearPresenceNode(selection) {
      if (!this.presenceEnabled) {
        return;
      }

      var anchorNode = selection.anchorNode,
          anchorOffset = selection.anchorOffset,
          focusNode = selection.focusNode,
          focusOffset = selection.focusOffset;

      var anchorValid = this._isValidSelectionNodeAndOffset(anchorNode, anchorOffset);

      var focusValid = this._isValidSelectionNodeAndOffset(focusNode, focusOffset);

      if (anchorValid && focusValid) {
        return;
      }

      var validNode = this._getValidSelectionNode();

      var newAnchorNode = anchorValid ? anchorNode : validNode;
      var newAnchorOffset = anchorValid ? anchorOffset : validNode === this._realDom ? 1 : 0;
      var newFocusNode = focusValid ? focusNode : validNode;
      var newFocusOffset = focusValid ? focusOffset : validNode === this._realDom ? 1 : 0;

      Object(_util_misc__WEBPACK_IMPORTED_MODULE_12__["setSelection"])(selection, newAnchorNode, newAnchorOffset, newFocusNode, newFocusOffset);
    } // If caret is right after an inline component, then insert and select a formatting helper at that position.

  }, {
    key: "_fixSelectionNearInlineComponent",
    value: function _fixSelectionNearInlineComponent(selection) {
      if (!selection.isCollapsed) {
        return;
      }

      var anchorNode = selection.anchorNode,
          anchorOffset = selection.anchorOffset;

      if (!this._hasInlineComponentAt(anchorNode, anchorOffset - 1)) {
        return;
      }

      var formattingHelper = this._document.createElement('SPAN');

      formattingHelper.setAttribute('id', '_mce_caret');
      formattingHelper.setAttribute('data-mce-type', 'format-caret');
      formattingHelper.setAttribute('data-mce-bogus', '1');
      formattingHelper.textContent = "\uFEFF";
      anchorNode.insertBefore(formattingHelper, anchorNode.childNodes[anchorOffset]);
      selection.collapse(formattingHelper.firstChild, 1);
    } // If caret is right after a bogus BR element, move it before that element.

  }, {
    key: "_fixSelectionAfterBogusBr",
    value: function _fixSelectionAfterBogusBr(selection) {
      if (!selection.isCollapsed) {
        return;
      }

      var anchorNode = selection.anchorNode,
          anchorOffset = selection.anchorOffset;

      if (anchorNode.nodeType !== Node.ELEMENT_NODE || anchorNode.childNodes.length !== anchorOffset || !anchorNode.lastChild || anchorNode.lastChild.nodeName !== 'BR' || !anchorNode[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]] || !anchorNode[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]].needsBr) {
        return;
      }

      selection.collapse(anchorNode, anchorOffset - 1);
    } // If caret is near a text node, then move it into that node.

  }, {
    key: "_fixSelectionNearTextNode",
    value: function _fixSelectionNearTextNode(selection) {
      if (!selection.isCollapsed) {
        return;
      }

      var anchorNode = selection.anchorNode,
          anchorOffset = selection.anchorOffset;
      var vNode = anchorNode[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]];

      if (!vNode) {
        return;
      }

      if (vNode.nodeType !== 'structure' && vNode.nodeType !== 'format' && vNode.nodeType !== 'root') {
        return;
      } // Find a text node before caret.


      var node = anchorNode.childNodes[anchorOffset - 1];

      while (node) {
        vNode = node[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]];

        if (!vNode) {
          break;
        }

        if (vNode.nodeType === 'text') {
          selection.collapse(node, node.nodeValue.length);
          return;
        }

        if (vNode.nodeType !== 'format') {
          break;
        }

        node = node.lastChild;
      } // Find a text node after caret.


      node = anchorNode.childNodes[anchorOffset];

      while (node) {
        vNode = node[_util_misc__WEBPACK_IMPORTED_MODULE_12__["vNodeKey"]];

        if (!vNode) {
          break;
        }

        if (vNode.nodeType === 'text') {
          selection.collapse(node, 0);
          return;
        }

        if (vNode.nodeType !== 'format') {
          break;
        }

        node = node.firstChild;
      }
    }
  }, {
    key: "_isValidSelectionNodeAndOffset",
    value: function _isValidSelectionNodeAndOffset(node, offset) {
      if (node === this._realDom && this._realDom.firstChild === this._presenceNode) {
        // If false, selection is before presence node.
        return offset > 0;
      }

      while (node && node !== this._realDom) {
        if (node === this._presenceNode) {
          // Selection is inside this._presenceNode.
          return false;
        }

        node = node.parentNode;
      }

      return true;
    }
  }, {
    key: "_getValidSelectionNode",
    value: function _getValidSelectionNode() {
      var node = this._virtualDom;

      while (node.childNodes && node.childNodes.length > 0 && node.childNodes[0].nodeType !== 'embed') {
        node = node.childNodes[0];
      }

      return node.realNode;
    }
  }, {
    key: "_hasInlineComponentAt",
    value: function _hasInlineComponentAt(node, offset) {
      if (!node || node.nodeType !== Node.ELEMENT_NODE) {
        return false;
      }

      var component = node.childNodes[offset];
      var display;
      return component && component.nodeType === Node.ELEMENT_NODE && component.getAttribute('contenteditable') === 'false' && ((display = component.ownerDocument.defaultView.getComputedStyle(component).display) === 'inline' || display === 'inline-block');
    }
    /*
    88        88  888888888888  88  88
    88        88       88       88  88
    88        88       88       88  88
    88        88       88       88  88
    88        88       88       88  88
    88        88       88       88  88
    Y8a.    .a8P       88       88  88
    `"Y8888Y"'        88       88  88888888888
     */

  }, {
    key: "contentToOtModel",
    value: function contentToOtModel(html) {
      var realNode = this._realDom.ownerDocument.createElement('DIV');

      realNode.innerHTML = html;
      var originalVirtualDom = this.createVNodeFromRealNode(realNode, true);
      originalVirtualDom.unlinkRealNode();
      var originalOtModel = this.createOtModelFromVirtualDom(originalVirtualDom);
      var validVirtualDom = this.createVirtualDomFromOtModel(originalOtModel);
      validVirtualDom.resetNodeId();
      return this.createOtModelFromVirtualDom(validVirtualDom);
    }
  }, {
    key: "getRootAttribute",
    value: function getRootAttribute(attributeName) {
      if (typeof attributeName !== 'string') {
        throw new Error('attributeName must be a string');
      }

      var attributeValue = this.otModel && this.otModel.length > 0 && Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["isInsertOpen"])(this.otModel[0]) && Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["getNodeName"])(this.otModel[0]) === '#root' ? Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["getAttribute"])(this.otModel[0], attributeName) : null;
      return typeof attributeValue === 'string' ? attributeValue : null;
    }
  }, {
    key: "setRootAttribute",
    value: function setRootAttribute(attributeName, attributeValue) {
      if (typeof attributeName !== 'string') {
        throw new Error('attributeName must be a string');
      }

      if (typeof attributeValue !== 'string' && attributeValue !== null) {
        throw new Error('attributeValue must be a string or null');
      }

      var operation = [Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_11__["createRetain"])(1, [attributeName, attributeValue])];

      this._doc.submitOp(operation, {
        undoable: false,
        source: 'script'
      });
    }
  }, {
    key: "otModel",
    get: function get() {
      return this._doc.data || null;
    }
  }, {
    key: "virtualDom",
    get: function get() {
      return this._virtualDom;
    }
  }, {
    key: "realDom",
    get: function get() {
      return this._realDom;
    }
  }, {
    key: "presenceEnabled",
    get: function get() {
      return this._presenceEnabled;
    },
    set: function set(presenceEnabled) {
      presenceEnabled = !!presenceEnabled;

      if (this._presenceEnabled === presenceEnabled) {
        return;
      }

      this._presenceEnabled = presenceEnabled;

      if (this._presenceEnabled) {
        this._ensurePresenceNodeIsFirst();
      } else if (this._presenceNode.parentNode) {
        this._unwatchRealDom();

        this._presenceNode.parentNode.removeChild(this._presenceNode);

        this._watchRealDom();
      }

      this._fixSelection();

      this._submitPresence();

      this._scheduleUpdatePresence();
    }
  }, {
    key: "presence",
    get: function get() {
      return this._presence;
    }
  }]);

  return TinyMceSync;
}(events__WEBPACK_IMPORTED_MODULE_7__["EventEmitter"]); // NOTE BR-elements
// Browsers and TinyMCE insert <BR> at the end of empty lines,
// so that users can click on them and type. So, they are essentially
// added only for presentation purposes and must be excluded from
// the OT model to avoid unexpected new lines when using undo/redo.
// When converting the OT model back to Virtual DOM, the omitted <BR>s are added back.

/***/ }),

/***/ "./src/tinymce/plugins/ot/Plugin.js":
/*!******************************************!*\
  !*** ./src/tinymce/plugins/ot/Plugin.js ***!
  \******************************************/
/*! exports provided: register */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "register", function() { return register; });
/* harmony import */ var _core_ContentEditing__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./core/ContentEditing */ "./src/tinymce/plugins/ot/core/ContentEditing.js");
/* harmony import */ var _core_OtClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./core/OtClient */ "./src/tinymce/plugins/ot/core/OtClient.js");
/* harmony import */ var _api_Commands__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./api/Commands */ "./src/tinymce/plugins/ot/api/Commands.js");
/* harmony import */ var _ui_Buttons__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./ui/Buttons */ "./src/tinymce/plugins/ot/ui/Buttons.js");
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../components */ "./src/components/index.js");
// For consistency with other TinyMCE plugins, the Plugin.js file should automatically add
// the plugin to `tinymce.PluginManager`, however, since ot-client needs to work with both
// WebPack in Spaces and requirejs in Projects, we expose a `register` function which takes
// TinyMCE as a parameter, instead of loading it or relying on a global variable.





function register(tinymce) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      Prism = _ref.Prism,
      customElementsPolyfill = _ref.customElementsPolyfill;

  tinymce.PluginManager.add('ot', function (editor) {
    var plugin = {
      client: null,
      comments: null
    };
    editor.once('init', function () {
      Prism = Prism || window.Prism; // Add Prism to the editor's content window.

      if (Prism) {
        editor.getWin().Prism = Prism;
      } // Polyfill Custom Elements in the editor's content window.


      if (customElementsPolyfill) {
        customElementsPolyfill(editor.getWin());
      }

      Object(_components__WEBPACK_IMPORTED_MODULE_4__["registerComponents"])(editor.getWin());
    });
    _core_OtClient__WEBPACK_IMPORTED_MODULE_1__["register"](editor, plugin);
    _core_ContentEditing__WEBPACK_IMPORTED_MODULE_0__["register"](editor, plugin);
    _api_Commands__WEBPACK_IMPORTED_MODULE_2__["register"](editor, plugin);
    _ui_Buttons__WEBPACK_IMPORTED_MODULE_3__["register"](editor, plugin);
    return plugin;
  });
}

/***/ }),

/***/ "./src/tinymce/plugins/ot/api/Commands.js":
/*!************************************************!*\
  !*** ./src/tinymce/plugins/ot/api/Commands.js ***!
  \************************************************/
/*! exports provided: register */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "register", function() { return register; });
function register(editor, plugin) {
  editor.addCommand('undo', function () {
    return plugin.client && plugin.client.undo();
  });
  editor.addCommand('redo', function () {
    return plugin.client && plugin.client.redo();
  });
}

/***/ }),

/***/ "./src/tinymce/plugins/ot/api/Settings.js":
/*!************************************************!*\
  !*** ./src/tinymce/plugins/ot/api/Settings.js ***!
  \************************************************/
/*! exports provided: getCollectionName, getDocumentId, getPresenceEnabled, getDebug, getShouldConnect, getAccessTokenGetter, getUrl, getOtCustomElements, getInline, getForcedRootBlock, getCustomElements, getInlineCustomElements, getBlockCustomElements, getBetaAuth, getInlineCommentElements */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCollectionName", function() { return getCollectionName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDocumentId", function() { return getDocumentId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPresenceEnabled", function() { return getPresenceEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDebug", function() { return getDebug; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getShouldConnect", function() { return getShouldConnect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAccessTokenGetter", function() { return getAccessTokenGetter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUrl", function() { return getUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOtCustomElements", function() { return getOtCustomElements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInline", function() { return getInline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getForcedRootBlock", function() { return getForcedRootBlock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCustomElements", function() { return getCustomElements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInlineCustomElements", function() { return getInlineCustomElements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBlockCustomElements", function() { return getBlockCustomElements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getBetaAuth", function() { return getBetaAuth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInlineCommentElements", function() { return getInlineCommentElements; });
function getCollectionName(editor) {
  return editor.getParam('ot_collection_name', 'test');
}
function getDocumentId(editor) {
  return editor.getParam('ot_document_id', '1');
}
function getPresenceEnabled(editor) {
  return editor.getParam('ot_presence', true);
}
function getDebug(editor) {
  return editor.getParam('ot_debug', false);
}
function getShouldConnect(editor) {
  return editor.getParam('ot_should_connect', true);
}
function getAccessTokenGetter(editor) {
  return editor.getParam('ot_get_access_token', undefined);
}
function getUrl(editor) {
  return editor.getParam('ot_url', undefined);
}
function getOtCustomElements(editor) {
  return editor.getParam('ot_custom_elements', []);
}
function getInline(editor) {
  return editor.getParam('inline', false);
}
function getForcedRootBlock(editor) {
  return (editor.getParam('forced_root_block', 'P') || 'P').toUpperCase();
}
function getCustomElements(editor) {
  return editor.getParam('custom_elements', '').toUpperCase().split(',').map(function (customElement) {
    return customElement.trim();
  }).filter(function (customElement) {
    return !!customElement;
  });
}
function getInlineCustomElements(editor) {
  return getCustomElements(editor).filter(function (customElement) {
    return customElement[0] === '~';
  }).map(function (customElement) {
    return customElement.substr(1);
  });
}
function getBlockCustomElements(editor) {
  return getCustomElements(editor).filter(function (customElement) {
    return customElement[0] !== '~';
  });
}
function getBetaAuth(editor) {
  return editor.getParam('ot_beta_auth', undefined);
}
function getInlineCommentElements(editor) {
  return editor.getParam('ot_inline_comment_elements', []);
}

/***/ }),

/***/ "./src/tinymce/plugins/ot/core/ContentEditing.js":
/*!*******************************************************!*\
  !*** ./src/tinymce/plugins/ot/core/ContentEditing.js ***!
  \*******************************************************/
/*! exports provided: register */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "register", function() { return register; });
/* harmony import */ var _util_misc__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../../util/misc */ "./src/util/misc.js");


function isInlineComponent(node) {
  var display;
  return node && node.nodeType === Node.ELEMENT_NODE && node.getAttribute('contenteditable') === 'false' && ((display = node.ownerDocument.defaultView.getComputedStyle(node).display) === 'inline' || display === 'inline-block');
}

function isBr(node) {
  return node && node.nodeName === 'BR';
}

function insertHelper(node, offset) {
  var document = node.ownerDocument;
  var window = document.defaultView;
  var helper = document.createTextNode("\uFEFF");
  node.insertBefore(helper, node.childNodes[offset]);
  window.getSelection().collapse(helper, 1);
} // Ensures that TinyMCE exits the current empty block on pressing Enter.


function fixExitBlockOnEnter(event) {
  if (event.defaultPrevented) {
    return;
  }

  if (event.ctrlKey || event.altKey || event.shiftKey || event.metaKey) {
    return;
  }

  var _event$target$ownerDo = event.target.ownerDocument.defaultView.getSelection(),
      isCollapsed = _event$target$ownerDo.isCollapsed,
      anchorNode = _event$target$ownerDo.anchorNode,
      anchorOffset = _event$target$ownerDo.anchorOffset;

  if (isCollapsed && anchorNode && anchorOffset === 1 && anchorNode.nodeName === '#text' && anchorNode.nodeValue === "\uFEFF") {
    anchorNode.parentNode.removeChild(anchorNode);
  }
} // Ensures that TinyMCE can create a new block on pressing Enter, when selection
// is before an inline component.


function fixCreateBlockOnEnter(event, editor) {
  if (event.defaultPrevented) {
    return;
  }

  if (event.ctrlKey || event.altKey || event.shiftKey || event.metaKey) {
    return;
  }

  var rootNode = editor.getBody();
  var document = event.target.ownerDocument;
  var selection = document.defaultView.getSelection();
  var isCollapsed = selection.isCollapsed,
      anchorNode = selection.anchorNode,
      anchorOffset = selection.anchorOffset;

  if (!isCollapsed || !anchorNode) {
    return;
  }

  if (anchorNode.nodeType === Node.TEXT_NODE && anchorOffset < anchorNode.nodeValue.length) {
    return;
  }

  if (anchorNode.nodeType === Node.ELEMENT_NODE && anchorOffset < anchorNode.childNodes.length) {
    if (isInlineComponent(anchorNode.childNodes[anchorOffset])) {
      insertHelper(anchorNode, anchorOffset);
    }

    return;
  }

  var node = anchorNode;

  while (node && node !== rootNode && node[_util_misc__WEBPACK_IMPORTED_MODULE_0__["vNodeKey"]] && node[_util_misc__WEBPACK_IMPORTED_MODULE_0__["vNodeKey"]].nodeType !== 'structure') {
    var nextSibling = node.nextSibling;

    if (nextSibling) {
      if (isInlineComponent(nextSibling)) {
        insertHelper(nextSibling.parentNode, Array.prototype.indexOf.call(nextSibling.parentNode.childNodes, nextSibling));
      }

      return;
    }

    node = node.parentNode;
  }
} // If caret is right after an image at the end of a block and a user presses Shift+Enter,
// TinyMCE creates only 1 <BR> instead of 2 - as it happens in all other cases.
// As a result, a new line is not visible to the user and the Sync module removes that
// trailing BR. To fix this issue we just insert 2 BR elements in this function.


function fixInsertBrAfterImageOnEnter(event, _editor) {
  if (event.defaultPrevented) {
    return;
  }

  if (event.ctrlKey || event.altKey || !event.shiftKey || event.metaKey) {
    return;
  }

  var document = event.target.ownerDocument;
  var selection = document.defaultView.getSelection();

  if (selection.rangeCount === 0) {
    return;
  }

  if (!selection.isCollapsed) {
    // Although the same problem exists when all content after an image is selected,
    // we're currently not addressing it here because:
    // - it would significantly increase the complexity of this function
    // - it's very unlikely to be noticed in normal use
    // - the user impact is that they simply need to press Enter twice - the fist key press
    //   will remove the content and the second will create the new line.
    return;
  }

  var anchorNode = selection.anchorNode,
      anchorOffset = selection.anchorOffset;

  if (anchorNode.nodeType !== Node.ELEMENT_NODE || anchorOffset === 0 || anchorOffset !== anchorNode.childNodes.length || anchorNode.childNodes[anchorOffset - 1].nodeName !== 'IMG') {
    return;
  }

  anchorNode.appendChild(document.createElement('BR'));
  anchorNode.appendChild(document.createElement('BR'));
  selection.collapse(anchorNode, anchorNode.childNodes.length - 1);
  event.preventDefault();
} // If the caret is right after the "presence" node, then pressing
// Backspace would move content from the current block into the "presence" node.
// We avoid that behaviour by preventing the default keydown action.


function protectPresenceNodeOnBackspace(event, editor) {
  if (event.defaultPrevented) {
    return;
  }

  var selection = event.target.ownerDocument.defaultView.getSelection();

  if (selection.rangeCount === 0) {
    return;
  }

  if (!selection.isCollapsed) {
    // A range is selected, which Backspace would remove wothout affecting the presence node.
    return;
  }

  var rootNode = editor.getBody();
  var presenceNode = rootNode.firstChild;

  if (!presenceNode || !presenceNode.classList || !presenceNode.classList.contains('ot-presence')) {
    return;
  }

  var node = selection.focusNode;
  var offset = selection.focusOffset;

  if (node === rootNode && offset <= 1) {
    event.preventDefault();
    return;
  }

  if (offset > 0) {
    return;
  }

  while (node && node !== rootNode) {
    var previousSibling = node.previousSibling;

    if (previousSibling) {
      if (previousSibling === presenceNode) {
        event.preventDefault();
      }

      break;
    }

    node = node.parentNode;
  }
} // TinyMCE doesn't remove a BR before an inline component on Backspace, so we handle that situation here.


function fixRemoveBrOnBackspace(event, editor) {
  if (event.defaultPrevented) {
    return;
  }

  var selection = event.target.ownerDocument.defaultView.getSelection();

  if (selection.rangeCount === 0 || !selection.isCollapsed) {
    return;
  }

  var anchorNode = selection.anchorNode,
      anchorOffset = selection.anchorOffset;

  if (anchorNode.nodeType === Node.TEXT_NODE && anchorOffset > 0 && anchorNode.nodeValue !== "\uFEFF") {
    return;
  }

  if (anchorNode.nodeType === Node.ELEMENT_NODE && anchorOffset > 0) {
    var br = anchorNode.childNodes[anchorOffset - 1];

    if (isBr(br)) {
      anchorNode.removeChild(br);
      event.preventDefault();
    }

    return;
  }

  var rootNode = editor.getBody();
  var node = anchorNode;

  while (node && node !== rootNode && node[_util_misc__WEBPACK_IMPORTED_MODULE_0__["vNodeKey"]] && node[_util_misc__WEBPACK_IMPORTED_MODULE_0__["vNodeKey"]].nodeType !== 'structure') {
    var previousSibling = node.previousSibling;

    if (previousSibling) {
      if (isBr(previousSibling)) {
        selection.collapse(previousSibling, 0);
        previousSibling.parentNode.removeChild(previousSibling);
        event.preventDefault();
      }

      break;
    }

    node = node.parentNode;
  }
} // TinyMCE doesn't remove a BR before an inline component on Delete, so we handle that situation here.


function fixRemoveBrOnDelete(event, editor) {
  if (event.defaultPrevented) {
    return;
  }

  var selection = event.target.ownerDocument.defaultView.getSelection();

  if (selection.rangeCount === 0 || !selection.isCollapsed) {
    return;
  }

  var anchorNode = selection.anchorNode,
      anchorOffset = selection.anchorOffset;

  if (anchorNode.nodeType === Node.TEXT_NODE && anchorOffset < anchorNode.nodeValue.length) {
    return;
  }

  if (anchorNode.nodeType === Node.ELEMENT_NODE && anchorOffset < anchorNode.childNodes.length) {
    var br = anchorNode.childNodes[anchorOffset];

    if (isBr(br) && br.nextSibling) {
      anchorNode.removeChild(br);
      event.preventDefault();
    }

    return;
  }

  var rootNode = editor.getBody();
  var node = anchorNode;

  while (node && node !== rootNode && node[_util_misc__WEBPACK_IMPORTED_MODULE_0__["vNodeKey"]] && node[_util_misc__WEBPACK_IMPORTED_MODULE_0__["vNodeKey"]].nodeType !== 'structure') {
    var nextSibling = node.nextSibling;

    if (nextSibling) {
      if (isBr(nextSibling) && nextSibling.nextSibling) {
        selection.collapse(nextSibling, 0);
        nextSibling.parentNode.removeChild(nextSibling);
        event.preventDefault();
      }

      break;
    }

    node = node.parentNode;
  }
} // Fixes up some content editing actions broken by OtClient.


function register(editor, _plugin) {
  editor.on('KeyDown', function (event) {
    switch (event.keyCode) {
      case 13:
        // Enter
        fixExitBlockOnEnter(event, editor);
        fixCreateBlockOnEnter(event, editor);
        fixInsertBrAfterImageOnEnter(event, editor);
        break;

      case 8:
        // Backspace
        protectPresenceNodeOnBackspace(event, editor);
        fixRemoveBrOnBackspace(event, editor);
        break;

      case 46:
        // Delete
        fixRemoveBrOnDelete(event, editor);
        break;
    }
  });
}

/***/ }),

/***/ "./src/tinymce/plugins/ot/core/OtClient.js":
/*!*************************************************!*\
  !*** ./src/tinymce/plugins/ot/core/OtClient.js ***!
  \*************************************************/
/*! exports provided: register */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "register", function() { return register; });
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _OtClient__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../../OtClient */ "./src/OtClient.js");
/* harmony import */ var _api_Settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../api/Settings */ "./src/tinymce/plugins/ot/api/Settings.js");
/* harmony import */ var _config_Config__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../../config/Config */ "./src/config/Config.js");
/* harmony import */ var _config_default__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../../../config/default */ "./src/config/default.js");
/* harmony import */ var _util_inlineComments__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../../../util/inlineComments */ "./src/util/inlineComments.js");







function createConfig(editor) {
  var forcedRootBlock = _api_Settings__WEBPACK_IMPORTED_MODULE_2__["getForcedRootBlock"](editor);
  var otCustomElements = _api_Settings__WEBPACK_IMPORTED_MODULE_2__["getOtCustomElements"](editor);
  var inlineCommentElements = _api_Settings__WEBPACK_IMPORTED_MODULE_2__["getInlineCommentElements"](editor);
  var inlineCustomElements = _api_Settings__WEBPACK_IMPORTED_MODULE_2__["getInlineCustomElements"](editor);
  var blockCustomElements = _api_Settings__WEBPACK_IMPORTED_MODULE_2__["getBlockCustomElements"](editor);
  var phrasingContent = _config_default__WEBPACK_IMPORTED_MODULE_4__["default"].childNodeAliasMap.get('phrasingContent').concat(inlineCustomElements);
  var flowContent = _config_default__WEBPACK_IMPORTED_MODULE_4__["default"].childNodeAliasMap.get('flowContent').concat(blockCustomElements, inlineCustomElements);
  var rootContent = _config_default__WEBPACK_IMPORTED_MODULE_4__["default"].childNodeAliasMap.get('rootContent').concat(blockCustomElements);
  return _config_Config__WEBPACK_IMPORTED_MODULE_3__["default"].create({
    attributeAliasMap: _config_default__WEBPACK_IMPORTED_MODULE_4__["default"].attributeAliasMap,
    childNodeAliasMap: _config_default__WEBPACK_IMPORTED_MODULE_4__["default"].childNodeAliasMap.clone().set('phrasingContent', phrasingContent).set('flowContent', flowContent).set('rootContent', rootContent),
    formats: _config_default__WEBPACK_IMPORTED_MODULE_4__["default"].formats,
    nodes: _config_default__WEBPACK_IMPORTED_MODULE_4__["default"].nodes.concat(otCustomElements).map(function (vNodeConfig) {
      if (vNodeConfig.nodeName === '#root') {
        return vNodeConfig.clone().withDefaultChildNode(forcedRootBlock);
      }

      if (inlineCommentElements.includes(vNodeConfig.nodeName)) {
        if (vNodeConfig.nodeType === 'embed') {
          return vNodeConfig.clone().withAttributeNames([].concat(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()(vNodeConfig.attributeNames), ['@data-tw-inline-comments=']));
        } else if (vNodeConfig.nodeName !== 'PRE') {
          // The exception for the "PRE" element is needed because it can be both
          // "embed" (code sample) and "struct" (directly editable, pre-formatted block).
          throw new Error("ot-client: ".concat(vNodeConfig.nodeName, " does not support inline comments"));
        }
      }

      return vNodeConfig;
    })
  });
}

function register(editor, plugin) {
  // Disable TinyMCE's UndoManager.
  editor.on('BeforeAddUndo', function () {
    return false;
  });
  editor.once('init', function () {
    // Make `UndoManager#extra` work even though we block adding any
    // undo levels in the `BeforeAddUndo` listener above.
    editor.undoManager.extra = function (_fn1, fn2) {
      return fn2();
    }; // Required for custom elements.


    editor.schema.addCustomElements('~tw-span');
    editor.schema.addValidElements('tw-span[data-tw-inline-comments]');
    editor.schema.addCustomElements('tw-json');
    editor.schema.addValidElements('tw-json[name|type]'); // Expose OtClient.

    plugin.client = new _OtClient__WEBPACK_IMPORTED_MODULE_1__["OtClient"]({
      domNode: editor.getBody(),
      collectionName: _api_Settings__WEBPACK_IMPORTED_MODULE_2__["getCollectionName"](editor),
      documentId: _api_Settings__WEBPACK_IMPORTED_MODULE_2__["getDocumentId"](editor),
      presenceEnabled: _api_Settings__WEBPACK_IMPORTED_MODULE_2__["getPresenceEnabled"](editor),
      debug: _api_Settings__WEBPACK_IMPORTED_MODULE_2__["getDebug"](editor),
      shouldConnect: _api_Settings__WEBPACK_IMPORTED_MODULE_2__["getShouldConnect"](editor),
      getAccessToken: _api_Settings__WEBPACK_IMPORTED_MODULE_2__["getAccessTokenGetter"](editor),
      config: createConfig(editor),
      url: _api_Settings__WEBPACK_IMPORTED_MODULE_2__["getUrl"](editor),
      asyncScrollUpdate: !_api_Settings__WEBPACK_IMPORTED_MODULE_2__["getInline"](editor) && 'autoresize' in editor.plugins,
      betaAuth: _api_Settings__WEBPACK_IMPORTED_MODULE_2__["getBetaAuth"](editor)
    }); // Expose InlineComments.

    plugin.comments = new _util_inlineComments__WEBPACK_IMPORTED_MODULE_5__["InlineComments"](editor.getBody(), {
      inlineCommentElements: _api_Settings__WEBPACK_IMPORTED_MODULE_2__["getInlineCommentElements"](editor)
    }); // Let TinyMCE know that the content has changed.

    plugin.client.on('operation', function () {
      return editor.nodeChanged({
        selectionChange: true
      });
    });
    editor.once('remove', function () {
      plugin.client.dispose();
    });
  });
}

/***/ }),

/***/ "./src/tinymce/plugins/ot/ui/Buttons.js":
/*!**********************************************!*\
  !*** ./src/tinymce/plugins/ot/ui/Buttons.js ***!
  \**********************************************/
/*! exports provided: register */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "register", function() { return register; });
function register(editor, plugin) {
  var undoButton = null;
  var redoButton = null;

  function updateUndoRedo() {
    if (undoButton) {
      undoButton.setDisabled(editor.readonly || !plugin.client || !plugin.client.canUndo());
    }

    if (redoButton) {
      redoButton.setDisabled(editor.readonly || !plugin.client || !plugin.client.canRedo());
    }
  }

  editor.once('init', function () {
    plugin.client.on('load', updateUndoRedo);
    plugin.client.on('operation', updateUndoRedo);
    editor.on('SwitchMode', updateUndoRedo);
  });
  editor.ui.registry.addButton('ot-undo', {
    icon: 'undo',
    tooltip: 'Undo',
    onAction: function onAction() {
      editor.execCommand('undo');
    },
    methodName: 'canUndo',
    disabled: true,
    onSetup: function onSetup(api) {
      undoButton = api;
      updateUndoRedo();
    }
  });
  editor.ui.registry.addButton('ot-redo', {
    icon: 'redo',
    tooltip: 'Redo',
    onAction: function onAction() {
      editor.execCommand('redo');
    },
    methodName: 'canRedo',
    disabled: true,
    onSetup: function onSetup(api) {
      redoButton = api;
      updateUndoRedo();
    }
  });
}

/***/ }),

/***/ "./src/util/AliasMap.js":
/*!******************************!*\
  !*** ./src/util/AliasMap.js ***!
  \******************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return AliasMap; });
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/toConsumableArray */ "./node_modules/@babel/runtime/helpers/toConsumableArray.js");
/* harmony import */ var _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2__);




// Maps strings to arrays of strings. Resolves aliases recursively.
var AliasMap =
/*#__PURE__*/
function () {
  function AliasMap() {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_1___default()(this, AliasMap);

    this._aliases = Object.create(null);
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_2___default()(AliasMap, [{
    key: "set",
    value: function set(name, value) {
      this._validateAliasName(name);

      this._validateAliasValue(value);

      this._aliases[name] = Object.freeze(value.slice(0));
      return this;
    }
  }, {
    key: "get",
    value: function get(name) {
      this._validateAliasName(name);

      return this._aliases[name] || null;
    }
  }, {
    key: "has",
    value: function has(name) {
      this._validateAliasName(name);

      return name in this._aliases;
    }
  }, {
    key: "remove",
    value: function remove(name) {
      this._validateAliasName(name);

      delete this._aliases[name];
      return this;
    }
  }, {
    key: "resolve",
    value: function resolve(name) {
      var maxRecursion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;

      this._validateAliasName(name);

      if (maxRecursion < -1) {
        throw new Error('AliasMap.resolve reached recursion limit');
      }

      var value = this._aliases[name];
      return value ? this.resolveAll(value, maxRecursion - 1) : [name];
    }
  }, {
    key: "resolveAll",
    value: function resolveAll(names) {
      var _ref,
          _this = this;

      var maxRecursion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;

      this._validateAliasValue(names);

      return (_ref = []).concat.apply(_ref, _babel_runtime_helpers_toConsumableArray__WEBPACK_IMPORTED_MODULE_0___default()(names.map(function (name) {
        return _this.resolve(name, maxRecursion);
      })));
    }
  }, {
    key: "clone",
    value: function clone() {
      var clone = new AliasMap();

      for (var name in this._aliases) {
        clone._aliases[name] = this._aliases[name];
      }

      return clone;
    }
  }, {
    key: "freeze",
    value: function freeze() {
      Object.freeze(this._aliases);
      return Object.freeze(this);
    }
  }, {
    key: "_validateAliasName",
    value: function _validateAliasName(name) {
      if (typeof name !== 'string') {
        throw new Error('Alias name must be a string');
      }
    }
  }, {
    key: "_validateAliasValue",
    value: function _validateAliasValue(value) {
      if (!Array.isArray(value) || value.some(function (v) {
        return typeof v !== 'string';
      })) {
        throw new Error('Alias value must be an Array of string');
      }
    }
  }]);

  return AliasMap;
}();



/***/ }),

/***/ "./src/util/ReadOnlyRect.js":
/*!**********************************!*\
  !*** ./src/util/ReadOnlyRect.js ***!
  \**********************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return ReadOnlyRect; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);



function checkNumber(n, message) {
  if (typeof n === 'number' && isFinite(n)) {
    return n;
  }

  if (n == null) {
    return 0;
  }

  throw new TypeError(message);
}

var ReadOnlyRect =
/*#__PURE__*/
function () {
  function ReadOnlyRect(x, y, width, height) {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, ReadOnlyRect);

    x = checkNumber(x, 'x must be a finite number or undefined');
    y = checkNumber(y, 'y must be a finite number or undefined');
    width = checkNumber(width, 'width must be a finite number or undefined');
    height = checkNumber(height, 'height must be a finite number or undefined');
    this._x = x;
    this._y = y;
    this._width = width;
    this._height = height;
    this._top = height < 0 ? y + height : y;
    this._bottom = height < 0 ? y : y + height;
    this._left = width < 0 ? x + width : x;
    this._right = width < 0 ? x : x + width;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(ReadOnlyRect, [{
    key: "x",
    get: function get() {
      return this._x;
    }
  }, {
    key: "y",
    get: function get() {
      return this._y;
    }
  }, {
    key: "width",
    get: function get() {
      return this._width;
    }
  }, {
    key: "height",
    get: function get() {
      return this._height;
    }
  }, {
    key: "top",
    get: function get() {
      return this._top;
    }
  }, {
    key: "bottom",
    get: function get() {
      return this._bottom;
    }
  }, {
    key: "left",
    get: function get() {
      return this._left;
    }
  }, {
    key: "right",
    get: function get() {
      return this._right;
    }
  }]);

  return ReadOnlyRect;
}();



/***/ }),

/***/ "./src/util/ShareDB.js":
/*!*****************************!*\
  !*** ./src/util/ShareDB.js ***!
  \*****************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _teamwork_sharedb_lib_client_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @teamwork/sharedb/lib/client/index */ "./node_modules/@teamwork/sharedb/lib/client/index.js");
/* harmony import */ var _teamwork_sharedb_lib_client_index__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_teamwork_sharedb_lib_client_index__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _teamwork_ot_rich_text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @teamwork/ot-rich-text */ "./node_modules/@teamwork/ot-rich-text/lib/index.js");
/* harmony import */ var _teamwork_ot_rich_text__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_teamwork_ot_rich_text__WEBPACK_IMPORTED_MODULE_1__);


_teamwork_sharedb_lib_client_index__WEBPACK_IMPORTED_MODULE_0___default.a.types.register(_teamwork_ot_rich_text__WEBPACK_IMPORTED_MODULE_1___default.a.type);
/* harmony default export */ __webpack_exports__["default"] = (_teamwork_sharedb_lib_client_index__WEBPACK_IMPORTED_MODULE_0___default.a);

/***/ }),

/***/ "./src/util/colors.js":
/*!****************************!*\
  !*** ./src/util/colors.js ***!
  \****************************/
/*! exports provided: claimColor, releaseColor, colorWithOpacity */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "claimColor", function() { return claimColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "releaseColor", function() { return releaseColor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "colorWithOpacity", function() { return colorWithOpacity; });
// Kelly's 22 colours of maximum contrast.
// The first 2 (white and black) are omitted because they don't work well for displaying user presence.
// https://jsfiddle.net/jalbertbowdenii/7h1uw4yu/
// https://www.researchgate.net/publication/237005166_A_Colour_Alphabet_and_the_Limits_of_Colour_Coding
var colors = ['#FFB300', '#803E75', '#FF6800', '#A6BDD7', '#C10020', '#CEA262', '#817066', '#007D34', '#F6768E', '#00538A', '#FF7A5C', '#53377A', '#FF8E00', '#B32851', '#F4C800', '#7F180D', '#93AA00', '#593315', '#F13A13', '#232C16'];
var userGroups = new WeakMap();

function getUnusedColor(users) {
  OUTER_LOOP: for (var i = 0, l = colors.length; i < l; ++i) {
    var color = colors[i];

    for (var userId in users) {
      var user = users[userId];

      if (user.color === color) {
        continue OUTER_LOOP;
      }
    }

    return color;
  } // All colors are in use, so return a random color.


  return colors[Math.floor(Math.random() * colors.length)];
}

function claimColor(userGroupKey, userId) {
  var users = userGroups.get(userGroupKey);

  if (!users) {
    users = Object.create(null);
    userGroups.set(userGroupKey, users);
  }

  var user = users[userId];

  if (user) {
    user.refCount++;
  } else {
    user = {
      refCount: 1,
      color: getUnusedColor(users)
    };
    users[userId] = user;
  }

  return user.color;
}
function releaseColor(userGroupKey, userId) {
  var users = userGroups.get(userGroupKey);

  if (!users) {
    return;
  }

  var user = users[userId];

  if (!user) {
    return;
  }

  user.refCount--;

  if (user.refCount > 0) {
    return;
  }

  delete users[userId];
}
function colorWithOpacity(color, opacity) {
  var result = /^#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})$/i.exec(color);

  if (!result) {
    return color;
  }

  var red = parseInt(result[1], 16);
  var green = parseInt(result[2], 16);
  var blue = parseInt(result[3], 16);
  return "rgba(".concat(red, ", ").concat(green, ", ").concat(blue, ", ").concat(opacity, ")");
}

/***/ }),

/***/ "./src/util/inlineComments.js":
/*!************************************!*\
  !*** ./src/util/inlineComments.js ***!
  \************************************/
/*! exports provided: getInlineCommentsRange, InlineCommentsRangeIterator, canAddInlineComment, addInlineComment, getInlineCommentNodes, removeInlineComment, getInlineComments, getAllInlineComments, InlineComments */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInlineCommentsRange", function() { return getInlineCommentsRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InlineCommentsRangeIterator", function() { return InlineCommentsRangeIterator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "canAddInlineComment", function() { return canAddInlineComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addInlineComment", function() { return addInlineComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInlineCommentNodes", function() { return getInlineCommentNodes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeInlineComment", function() { return removeInlineComment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getInlineComments", function() { return getInlineComments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAllInlineComments", function() { return getAllInlineComments; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InlineComments", function() { return InlineComments; });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "./node_modules/@babel/runtime/helpers/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "./node_modules/@babel/runtime/helpers/createClass.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _misc__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./misc */ "./src/util/misc.js");


 // Sets the range start. Returns false, if the new start is after the original end, otherwise true.

function setStart(range, container, offset) {
  var expectCollapsed = range.endContainer === container && range.endOffset === offset;
  range.setStart(container, offset);
  return range.collapsed === expectCollapsed;
} // Sets the range end. Returns false, if the new end is before the original start, otherwise true.


function setEnd(range, container, offset) {
  var expectCollapsed = range.startContainer === container && range.startOffset === offset;
  range.setEnd(container, offset);
  return range.collapsed === expectCollapsed;
} // Indicates, if the specified node is an embed suitable for adding inline comments.


function isEmbedNode(node) {
  return node.nodeType === Node.ELEMENT_NODE && node.getAttribute('contenteditable') === 'false' || node.nodeName === 'IMG';
} // Gets the current selection range, if it's fully within rootNode and contains some text or embed nodes.
// The boundries are adjusted to be on text or embed nodes and outside ignored nodes.


function getInlineCommentsRange(rootNode) {
  if (!rootNode || rootNode.nodeType !== Node.ELEMENT_NODE) {
    return null; // Invalid `rootNode`.
  }

  var document = rootNode.ownerDocument;
  var window = document.defaultView;

  if (!window) {
    return null; // No `window`.
  }

  var selection = window.getSelection();

  if (selection.rangeCount === 0) {
    return null; // No selection.
  }

  var range = selection.getRangeAt(0).cloneRange();
  var startAncestors = Object(_misc__WEBPACK_IMPORTED_MODULE_2__["getAncestors"])(range.startContainer, rootNode);
  var endAncestors = Object(_misc__WEBPACK_IMPORTED_MODULE_2__["getAncestors"])(range.endContainer, rootNode);

  if (startAncestors[startAncestors.length - 1] !== rootNode || endAncestors[endAncestors.length - 1] !== rootNode) {
    return null; // Selection is not within `rootNode`.
  }

  for (var i = startAncestors.length - 2; i >= 0; --i) {
    var node = startAncestors[i];

    if (Object(_misc__WEBPACK_IMPORTED_MODULE_2__["isIgnoredNode"])(node)) {
      if (node.classList.contains('mce-offscreen-selection')) {
        // Set range start to the node which is visually selected.
        var selectedNode = rootNode.querySelector('[data-mce-selected="1"]');

        if (selectedNode) {
          setStart(range, selectedNode, 0);
        } else {
          return null;
        }
      } else if ( // Move range start after an ignored node.
      !setStart(range, node.parentNode, Object(_misc__WEBPACK_IMPORTED_MODULE_2__["indexInParentNode"])(node) + 1)) {
        return null;
      }

      break;
    } else if (isEmbedNode(node)) {
      // Move range start to position 0 of the embed.
      if (!setStart(range, node, 0)) {
        return null;
      }

      break;
    } else if (Object(_misc__WEBPACK_IMPORTED_MODULE_2__["isElementNode"])(node)) {
      // Check the nested node.
      continue;
    } else if (Object(_misc__WEBPACK_IMPORTED_MODULE_2__["isTextNode"])(node) && node === range.startContainer) {
      if (range.startOffset === node.nodeValue.length) {
        // Move range start after a text node, if the range start is at the end of that node.
        if (!setStart(range, node.parentNode, Object(_misc__WEBPACK_IMPORTED_MODULE_2__["indexInParentNode"])(node) + 1)) {
          return null;
        }
      }

      break;
    } else {
      // Should never happen.
      return null;
    }
  }

  for (var _i = endAncestors.length - 2; _i >= 0; --_i) {
    var _node = endAncestors[_i];

    if (Object(_misc__WEBPACK_IMPORTED_MODULE_2__["isIgnoredNode"])(_node)) {
      if (_node.classList.contains('mce-offscreen-selection')) {
        // Set range end to the node which is visually selected.
        var _selectedNode = rootNode.querySelector('[data-mce-selected="1"]');

        if (_selectedNode) {
          setEnd(range, _selectedNode, 0);
        } else {
          return null;
        }
      } else if ( // Move range end before an ignored node.
      !setEnd(range, _node.parentNode, Object(_misc__WEBPACK_IMPORTED_MODULE_2__["indexInParentNode"])(_node))) {
        return null;
      }

      break;
    } else if (isEmbedNode(_node)) {
      // Move range end to position 0 of the embed.
      if (!setEnd(range, _node, 0)) {
        return null;
      }

      break;
    } else if (Object(_misc__WEBPACK_IMPORTED_MODULE_2__["isElementNode"])(_node)) {
      // Check the nested node.
      continue;
    } else if (Object(_misc__WEBPACK_IMPORTED_MODULE_2__["isTextNode"])(_node) && _node === range.endContainer) {
      if (range.endOffset === 0) {
        // Move range end before a text node, if the range end is at the start of that node.
        if (!setEnd(range, _node.parentNode, Object(_misc__WEBPACK_IMPORTED_MODULE_2__["indexInParentNode"])(_node))) {
          return null;
        }
      }

      break;
    } else {
      // Should never happen.
      return null;
    }
  }

  if (!Object(_misc__WEBPACK_IMPORTED_MODULE_2__["isTextNode"])(range.startContainer) && !isEmbedNode(range.startContainer)) {
    // Move range start to the next text or embed node.
    var checkChildNodes = range.startOffset < range.startContainer.childNodes.length;

    var _node2 = checkChildNodes ? range.startContainer.childNodes[range.startOffset] : range.startContainer; // eslint-disable-next-line no-constant-condition


    while (true) {
      if (!_node2 || _node2 === rootNode) {
        return null;
      } else if (Object(_misc__WEBPACK_IMPORTED_MODULE_2__["isIgnoredNode"])(_node2)) {
        checkChildNodes = !!_node2.nextSibling;
        _node2 = checkChildNodes ? _node2.nextSibling : _node2.parentNode;
      } else if (isEmbedNode(_node2)) {
        if (!setStart(range, _node2, 0)) return null;
        break;
      } else if (Object(_misc__WEBPACK_IMPORTED_MODULE_2__["isTextNode"])(_node2)) {
        if (!setStart(range, _node2, 0)) return null;
        break;
      } else if (checkChildNodes && Object(_misc__WEBPACK_IMPORTED_MODULE_2__["isElementNode"])(_node2) && !!_node2.firstChild) {
        _node2 = _node2.firstChild;
      } else {
        checkChildNodes = !!_node2.nextSibling;
        _node2 = checkChildNodes ? _node2.nextSibling : _node2.parentNode;
      }
    }
  }

  if (!Object(_misc__WEBPACK_IMPORTED_MODULE_2__["isTextNode"])(range.endContainer) && !isEmbedNode(range.endContainer)) {
    // Move range end to the previous text or embed node.
    var _checkChildNodes = range.endOffset > 0;

    var _node3 = _checkChildNodes ? range.endContainer.childNodes[range.endOffset - 1] : range.endContainer; // eslint-disable-next-line no-constant-condition


    while (true) {
      if (!_node3 || _node3 === rootNode) {
        return null;
      } else if (Object(_misc__WEBPACK_IMPORTED_MODULE_2__["isIgnoredNode"])(_node3)) {
        _checkChildNodes = !!_node3.previousSibling;
        _node3 = _checkChildNodes ? _node3.previousSibling : _node3.parentNode;
      } else if (isEmbedNode(_node3)) {
        if (!setEnd(range, _node3, 0)) return null;
        break;
      } else if (Object(_misc__WEBPACK_IMPORTED_MODULE_2__["isTextNode"])(_node3)) {
        if (!setEnd(range, _node3, _node3.nodeValue.length)) return null;
        break;
      } else if (_checkChildNodes && Object(_misc__WEBPACK_IMPORTED_MODULE_2__["isElementNode"])(_node3) && !!_node3.lastChild) {
        _node3 = _node3.lastChild;
      } else {
        _checkChildNodes = !!_node3.previousSibling;
        _node3 = _checkChildNodes ? _node3.previousSibling : _node3.parentNode;
      }
    }
  }

  if (range.collapsed && !isEmbedNode(range.startContainer)) {
    return null;
  }

  return range;
}
var InlineCommentsRangeIterator =
/*#__PURE__*/
function () {
  function InlineCommentsRangeIterator(range) {
    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, InlineCommentsRangeIterator);

    this._startContainer = range ? range.startContainer : null;
    this._startOffset = range ? range.startOffset : null;
    this._endContainer = range ? range.endContainer : null;
    this._endOffset = range ? range.endOffset : null;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(InlineCommentsRangeIterator, [{
    key: "next",
    value: function next() {
      if (!this._startContainer) {
        return {
          done: true
        };
      }

      var value = {
        node: this._startContainer,
        startOffset: this._startOffset,
        endOffset: !Object(_misc__WEBPACK_IMPORTED_MODULE_2__["isTextNode"])(this._startContainer) ? 0 : this._startContainer === this._endContainer ? this._endOffset : this._startContainer.nodeValue.length
      };

      if (this._startContainer === this._endContainer) {
        this._startContainer = null;
        this._startOffset = 0;
        this._endContainer = null;
        this._endOffset = 0;
      } else {
        var firstChild;
        var nextSibling = this._startContainer.nextSibling;
        var checkChildNodes = !!nextSibling;
        this._startContainer = checkChildNodes ? nextSibling : this._startContainer.parentNode;
        this._startOffset = 0;

        while (this._startContainer) {
          if (Object(_misc__WEBPACK_IMPORTED_MODULE_2__["isIgnoredNode"])(this._startContainer)) {
            nextSibling = this._startContainer.nextSibling;
            checkChildNodes = !!nextSibling;
            this._startContainer = checkChildNodes ? nextSibling : this._startContainer.parentNode;
          } else if (isEmbedNode(this._startContainer)) {
            break;
          } else if (Object(_misc__WEBPACK_IMPORTED_MODULE_2__["isTextNode"])(this._startContainer)) {
            break;
          } else if (checkChildNodes && Object(_misc__WEBPACK_IMPORTED_MODULE_2__["isElementNode"])(this._startContainer) && !!(firstChild = this._startContainer.firstChild)) {
            this._startContainer = firstChild;
          } else {
            nextSibling = this._startContainer.nextSibling;
            checkChildNodes = !!nextSibling;
            this._startContainer = checkChildNodes ? nextSibling : this._startContainer.parentNode;
          }
        }
      }

      return {
        done: false,
        value: value
      };
    }
  }]);

  return InlineCommentsRangeIterator;
}();
function canAddInlineComment(rootNode, inlineCommentElements) {
  var iterator = new InlineCommentsRangeIterator(getInlineCommentsRange(rootNode));

  var _iterator$next = iterator.next(),
      done = _iterator$next.done,
      value = _iterator$next.value;

  while (!done) {
    var _value = value,
        node = _value.node;

    if (isEmbedNode(node) && inlineCommentElements.includes(node.nodeName) || Object(_misc__WEBPACK_IMPORTED_MODULE_2__["isTextNode"])(node)) {
      return true;
    }

    ;

    var _iterator$next2 = iterator.next();

    done = _iterator$next2.done;
    value = _iterator$next2.value;
  }

  return false;
}
function addInlineComment(rootNode, commentId, inlineCommentElements) {
  var iterator = new InlineCommentsRangeIterator(getInlineCommentsRange(rootNode));

  var _iterator$next3 = iterator.next(),
      done = _iterator$next3.done,
      value = _iterator$next3.value;

  if (done) {
    return;
  }

  var selection = rootNode.ownerDocument.defaultView.getSelection();
  var anchorNode = selection.anchorNode,
      anchorOffset = selection.anchorOffset,
      focusNode = selection.focusNode,
      focusOffset = selection.focusOffset;
  var range = selection.getRangeAt(0);
  var isForwardSelection = range.startContainer === anchorNode && range.startOffset === anchorOffset && range.endContainer === focusNode && range.endOffset === focusOffset;

  while (!done) {
    var _value2 = value,
        node = _value2.node,
        startOffset = _value2.startOffset,
        endOffset = _value2.endOffset;

    if (isEmbedNode(node) && inlineCommentElements.includes(node.nodeName)) {
      var currentValue = node.getAttribute('data-tw-inline-comments');
      node.setAttribute('data-tw-inline-comments', currentValue ? currentValue + ' ' + commentId : commentId);
    } else if (Object(_misc__WEBPACK_IMPORTED_MODULE_2__["isTextNode"])(node)) {
      var document = rootNode.ownerDocument;
      var prefix = node.nodeValue.substring(0, startOffset);
      var text = node.nodeValue.substring(startOffset, endOffset);
      var suffix = node.nodeValue.substring(endOffset);
      var commentNode = document.createElement('TW-SPAN');
      commentNode.setAttribute('data-tw-inline-comments', commentId);
      node.nodeValue = text;
      node.parentNode.insertBefore(commentNode, node);
      commentNode.appendChild(node);

      if (prefix) {
        commentNode.parentNode.insertBefore(document.createTextNode(prefix), commentNode);
      }

      if (isForwardSelection) {
        if (node === anchorNode) {
          anchorOffset = 0;
        }
      } else {
        if (node === focusNode) {
          focusOffset = 0;
        }
      }

      if (suffix) {
        commentNode.parentNode.insertBefore(document.createTextNode(suffix), commentNode.nextSibling);
      }

      if (isForwardSelection) {
        if (node === focusNode) {
          focusOffset = node.nodeValue.length;
        }
      } else {
        if (node === anchorNode) {
          anchorOffset = node.nodeValue.length;
        }
      }
    }

    ;

    var _iterator$next4 = iterator.next();

    done = _iterator$next4.done;
    value = _iterator$next4.value;
  }

  Object(_misc__WEBPACK_IMPORTED_MODULE_2__["setSelection"])(selection, anchorNode, anchorOffset, focusNode, focusOffset);
}
function getInlineCommentNodes(rootNode, commentId) {
  if (!rootNode || rootNode.nodeType !== Node.ELEMENT_NODE || typeof commentId !== 'string' || commentId === '') {
    return [];
  }

  return rootNode.querySelectorAll("[data-tw-inline-comments~=\"".concat(commentId.replace(/["\\]/g, '\\$&'), "\"]"));
}
function removeInlineComment(rootNode, commentId) {
  var nodes = getInlineCommentNodes(rootNode, commentId);

  for (var i = 0, l = nodes.length; i < l; ++i) {
    var node = nodes[i];
    node.setAttribute('data-tw-inline-comments', node.getAttribute('data-tw-inline-comments').split(/\s+/).filter(function (v) {
      return v.length > 0 && v !== commentId;
    }).join(' '));
  }
}
function getInlineComments(rootNode) {
  var comments = [];

  if (!rootNode || rootNode.nodeType !== Node.ELEMENT_NODE) {
    return comments;
  }

  var document = rootNode.ownerDocument;
  var window = document.defaultView;

  if (!window) {
    return comments;
  }

  var selection = window.getSelection();

  if (selection.rangeCount === 0 || !Object(_misc__WEBPACK_IMPORTED_MODULE_2__["containsNode"])(rootNode, selection.anchorNode)) {
    return comments;
  }

  var allowOffScreenSelection = true;
  var node = // A node which the caret is on.
  selection.isCollapsed ? selection.anchorNode : // An offscreen selection node.
  Object(_misc__WEBPACK_IMPORTED_MODULE_2__["isTextNode"])(selection.anchorNode) && Object(_misc__WEBPACK_IMPORTED_MODULE_2__["isTextNode"])(selection.focusNode) && selection.anchorNode.parentNode === selection.focusNode.parentNode && Object(_misc__WEBPACK_IMPORTED_MODULE_2__["isElementNode"])(selection.anchorNode.parentNode) && selection.anchorNode.parentNode.classList.contains('mce-offscreen-selection') ? selection.anchorNode.parentNode : // An embed which is the only node in the selection.
  selection.anchorNode === selection.focusNode && Math.abs(selection.anchorOffset - selection.focusOffset) === 1 && Object(_misc__WEBPACK_IMPORTED_MODULE_2__["isElementNode"])(selection.anchorNode) && isEmbedNode(selection.anchorNode.childNodes[Math.min(selection.anchorOffset, selection.focusOffset)]) ? selection.anchorNode.childNodes[Math.min(selection.anchorOffset, selection.focusOffset)] : null;

  while (node && node !== rootNode) {
    if (Object(_misc__WEBPACK_IMPORTED_MODULE_2__["isIgnoredNode"])(node)) {
      comments.length = 0;

      if (allowOffScreenSelection && node.classList.contains('mce-offscreen-selection')) {
        allowOffScreenSelection = false;
        node = rootNode.querySelector('[data-mce-selected="1"]');
      } else {
        node = node.parentNode;
      }

      continue;
    }

    if (isEmbedNode(node)) {
      comments.length = 0;
    }

    if (Object(_misc__WEBPACK_IMPORTED_MODULE_2__["isElementNode"])(node)) {
      var value = node.getAttribute('data-tw-inline-comments');

      if (value) {
        comments.push.apply(comments, value.split(/\s+/));
      }
    }

    node = node.parentNode;
  }

  return comments.sort().filter(function (value, index, array) {
    return value.length > 0 && (index === 0 || value !== array[index - 1]);
  });
}
function getAllInlineComments(rootNode) {
  var comments = [];

  if (!rootNode || rootNode.nodeType !== Node.ELEMENT_NODE) {
    return comments;
  }

  var nodes = rootNode.querySelectorAll('[data-tw-inline-comments]');

  for (var i = 0, l = nodes.length; i < l; ++i) {
    comments.push.apply(comments, nodes[i].getAttribute('data-tw-inline-comments').split(/\s+/));
  }

  return comments.sort().filter(function (value, index, array) {
    return value.length > 0 && (index === 0 || value !== array[index - 1]);
  });
}
var InlineComments =
/*#__PURE__*/
function () {
  function InlineComments(domNode) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref$inlineCommentEle = _ref.inlineCommentElements,
        inlineCommentElements = _ref$inlineCommentEle === void 0 ? [] : _ref$inlineCommentEle;

    _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0___default()(this, InlineComments);

    this.domNode = domNode;
    this.inlineCommentElements = inlineCommentElements;
  }

  _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1___default()(InlineComments, [{
    key: "canAdd",
    value: function canAdd() {
      return canAddInlineComment(this.domNode, this.inlineCommentElements);
    }
  }, {
    key: "add",
    value: function add(commentId) {
      return addInlineComment(this.domNode, commentId, this.inlineCommentElements);
    }
  }, {
    key: "remove",
    value: function remove(commentId) {
      return removeInlineComment(this.domNode, commentId);
    }
  }, {
    key: "get",
    value: function get() {
      return getInlineComments(this.domNode);
    }
  }, {
    key: "getAll",
    value: function getAll() {
      return getAllInlineComments(this.domNode);
    }
  }, {
    key: "getNodes",
    value: function getNodes(commentId) {
      return getInlineCommentNodes(this.domNode, commentId);
    }
  }]);

  return InlineComments;
}();

/***/ }),

/***/ "./src/util/misc.js":
/*!**************************!*\
  !*** ./src/util/misc.js ***!
  \**************************/
/*! exports provided: vNodeKey, fakeCustomElementKey, isIgnoredNode, isTextNode, isElementNode, getAncestors, areArraysEqual, exclude, binaryFindIndex, isSelectionExtendSupported, nodeContainsPoint, toggleClass, hasKeys, nextTick, getIframeElement, escapeHtml, setSelection, createSet, toArray, getAttributeNames, indexInParentNode, containsNode, getTextContent, repeatString, compareOtModels */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "vNodeKey", function() { return vNodeKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fakeCustomElementKey", function() { return fakeCustomElementKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isIgnoredNode", function() { return isIgnoredNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isTextNode", function() { return isTextNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isElementNode", function() { return isElementNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAncestors", function() { return getAncestors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "areArraysEqual", function() { return areArraysEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exclude", function() { return exclude; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "binaryFindIndex", function() { return binaryFindIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isSelectionExtendSupported", function() { return isSelectionExtendSupported; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nodeContainsPoint", function() { return nodeContainsPoint; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toggleClass", function() { return toggleClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasKeys", function() { return hasKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nextTick", function() { return nextTick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIframeElement", function() { return getIframeElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "escapeHtml", function() { return escapeHtml; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setSelection", function() { return setSelection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSet", function() { return createSet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toArray", function() { return toArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAttributeNames", function() { return getAttributeNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "indexInParentNode", function() { return indexInParentNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "containsNode", function() { return containsNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTextContent", function() { return getTextContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "repeatString", function() { return repeatString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compareOtModels", function() { return compareOtModels; });
/* harmony import */ var _teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @teamwork/ot-rich-text/lib/Action */ "./node_modules/@teamwork/ot-rich-text/lib/Action.js");
/* harmony import */ var _teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_0__);
var _this = undefined;

 // The name of property attached to a real DOM Node and referencing a VNode.
// It should not conflict with any existing properties.
// Replace the value with a `Symbol`, once we stop supporting IE11.

var vNodeKey = '__ot__vNode$' + Math.floor(Math.random() * 10000); // The name of property attached to a real DOM Node and indicating if the node is a fake custom element.
// It should not conflict with any existing properties.
// Replace the value with a `Symbol`, once we stop supporting IE11.

var fakeCustomElementKey = '__ot__fakeCustomElement$' + Math.floor(Math.random() * 10000); // Checks, if the specified real DOM node should be ignored.

function isIgnoredNode(node) {
  return !node[vNodeKey] && node.nodeType === Node.ELEMENT_NODE && node.getAttribute('data-mce-bogus') === 'all';
}
function isTextNode(node) {
  return node.nodeType === Node.TEXT_NODE;
}
function isElementNode(node) {
  return node.nodeType === Node.ELEMENT_NODE;
} // Gets ancestors of `node`, until reaching `limitNode`.
// Both `node` and `limitNode` are included in the result.
// `node` is the first element in the returned list.

function getAncestors(node, limitNode) {
  var nodes = [];

  while (node) {
    nodes.push(node);

    if (node === limitNode) {
      break;
    }

    node = node.parentNode;
  }

  return nodes;
} // Compares 2 arrays for equality.

function areArraysEqual(array1, array2) {
  var length = array1.length;

  if (length !== array2.length) {
    return false;
  }

  for (var i = 0; i < length; ++i) {
    if (array1[i] !== array2[i]) {
      return false;
    }
  }

  return true;
} // Returns `list` without elements of `listsOfItemsToExclude`.

var exclude = function exclude(list) {
  for (var _len = arguments.length, listsOfItemsToExclude = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    listsOfItemsToExclude[_key - 1] = arguments[_key];
  }

  return list.filter(function (item) {
    return listsOfItemsToExclude.every(function (listOfItemsToExclude) {
      return listOfItemsToExclude.every(function (itemToExclude) {
        return item !== itemToExclude;
      });
    });
  });
}; // Performs a binary search in a sorted `list`.
// Returns the index in list of the found list element or -1, if not found.
//
// `compare(item: *): number` should return:
//
// 0, if `item` is the searched element and should be the result of `binarySearch`
// -1, if the searched element is before `item`.
// 1, if the searched element is after `item`.

var binaryFindIndex = function binaryFindIndex(list, compare) {
  var min = 0;
  var max = list.length - 1;

  while (min <= max) {
    var middle = min + (max - min >> 1);
    var result = compare(list[middle]);

    if (result < 0) {
      max = middle - 1;
    } else if (result > 0) {
      min = middle + 1;
    } else if (result === 0) {
      return middle;
    } else {
      return -1;
    }
  }

  return -1;
}; // Selection.prototype.extend is needed to programmatically set a "backward" selection.
// It is not supported by IE11.

var isSelectionExtendSupported = !!window.getSelection().extend; // Checks, if the spepcified point (`x`, `y`) is over the specified `node`.

function nodeContainsPoint(node, x, y) {
  var rect = node.getBoundingClientRect();
  return rect.left <= x && x <= rect.right && rect.top <= y && y <= rect.bottom;
} // This function exists because IE11 does not support the `force` param for `toggle`.
// See https://developer.mozilla.org/en-US/docs/Web/API/Element/classList

function toggleClass(node, className, force) {
  if (force == null) {
    node.classList.toggle(className);
  } else if (force) {
    node.classList.add(className);
  } else {
    node.classList.remove(className);
  }
}
function hasKeys(object) {
  for (var key in object) {
    return true;
  }

  return false;
}
var nextTickDomNode = document.createElement('DIV');
var nextTickQueue = [];
var nextTickTriggerValue = 0;
new MutationObserver(function () {
  var queue = nextTickQueue;
  nextTickQueue = [];
  queue.forEach(function (item) {
    item.callback.apply(_this, item.args);
  });
}).observe(nextTickDomNode, {
  attributes: true
});
function nextTick(callback) {
  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  nextTickQueue.push({
    callback: callback,
    args: args
  });
  nextTickTriggerValue = nextTickTriggerValue + 1 | 0;
  nextTickDomNode.setAttribute('trigger', nextTickTriggerValue);
} // If possible, gets the iframe element in the parent document given the iframeWindow.
// Otherwise returns null.

function getIframeElement(iframeWindow) {
  return iframeWindow && iframeWindow.frameElement || null;
}

function replaceHtmlEntity(character) {
  switch (character) {
    case '&':
      return '&amp;';

    case '<':
      return '&lt;';

    case '>':
      return '&gt;';

    case '"':
      return '&quot;';

    case "'":
      return '&#39;';

    default:
      return character;
  }
}

function escapeHtml(string) {
  return string.replace(/[&<>"']/g, replaceHtmlEntity);
}
function setSelection(selection, anchorNode, anchorOffset, focusNode, focusOffset) {
  if (!anchorNode || !focusNode) {
    selection.removeAllRanges();
    return;
  }

  if (isSelectionExtendSupported) {
    selection.collapse(anchorNode, anchorOffset);
    selection.extend(focusNode, focusOffset);
  } else {
    var range = selection.getRangeAt(0); // Must remove and re-add the range to make IE11 change the selection.

    selection.removeAllRanges();
    range.setStart(anchorNode, anchorOffset);
    range.setEnd(focusNode, focusOffset);

    if (range.collapsed && (anchorNode !== focusNode || anchorOffset !== focusOffset)) {
      // This could happen, if the original selection was "backards".
      // Unfortunately, IE11 does not support creating backward selections programmatically,
      // so we just create a forward selection.
      range.setStart(focusNode, focusOffset);
      range.setEnd(anchorNode, anchorOffset);
    }

    selection.addRange(range);
  }
} // Creates a new `Set` containing the specified `items`, if `items.forEach` allows iterating over items.
// This function is needed because `new Set(iterable)` is not supported by IE11.

function createSet(items) {
  var set = new Set();

  if (items && typeof items.forEach === 'function') {
    items.forEach(function (item) {
      return set.add(item);
    });
  }

  return set;
}
function toArray(collection) {
  if (Array.isArray(collection)) {
    return collection;
  }

  var array = [];

  if (collection && typeof collection.forEach === 'function') {
    collection.forEach(function (item) {
      return array.push(item);
    });
  }

  return array;
}
function getAttributeNames(realNode) {
  if (realNode.getAttributeNames) {
    return realNode.getAttributeNames();
  }

  var attributes = realNode.attributes;
  var attributesLength = attributes.length;
  var attributeNames = new Array(attributesLength);

  for (var i = 0; i < attributesLength; ++i) {
    attributeNames[i] = attributes[i].name;
  }

  return attributeNames;
}
function indexInParentNode(childNode) {
  return Array.prototype.indexOf.call(childNode.parentNode.childNodes, childNode);
} // Checks if `node` is `parentNode` or its descendant.
// It's the same as https://developer.mozilla.org/en-US/docs/Web/API/Node/contains but
// works reliably in IE11.

function containsNode(parentNode, node) {
  if (!parentNode) {
    return false;
  }

  while (node) {
    if (node === parentNode) {
      return true;
    }

    node = node.parentNode;
  }

  return false;
}
function getTextContent(node) {
  if (node.nodeType === Node.TEXT_NODE) {
    return node.nodeValue;
  }

  if (node.nodeType !== Node.ELEMENT_NODE || node.getAttribute('data-mce-bogus') === 'all' || node.getAttribute('contenteditable') === 'false') {
    return '';
  }

  return Array.prototype.reduce.call(node.childNodes, function (text, node) {
    return text + getTextContent(node);
  }, '');
}
/**
 * Repeats the string `x` `n` times and returns it.
 * @param {string} x String to repeat.
 * @param {number} n Number of repetitions.
 * @returns The repeated string.
 *
 * Source: https://stackoverflow.com/a/17800645/706807
 */

function repeatString(x, n) {
  var s = '';

  for (;;) {
    if (n & 1) s += x;
    n >>= 1;
    if (n) x += x;else break;
  }

  return s;
}
function compareOtModels(otModel1, otModel2) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$ignoreRootNode = _ref.ignoreRootNode,
      ignoreRootNode = _ref$ignoreRootNode === void 0 ? false : _ref$ignoreRootNode,
      _ref$ignoreNodeIds = _ref.ignoreNodeIds,
      ignoreNodeIds = _ref$ignoreNodeIds === void 0 ? false : _ref$ignoreNodeIds;

  if (!Array.isArray(otModel2) || !Array.isArray(otModel1)) {
    return false;
  }

  if (otModel2 === otModel1) {
    return true;
  }

  if (otModel2.length !== otModel1.length) {
    return false;
  }

  var i = 0;
  var l = otModel1.length;

  if (ignoreRootNode) {
    if (l > i && Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_0__["isInsertOpen"])(otModel2[i]) && Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_0__["isInsertOpen"])(otModel1[i]) && Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_0__["getNodeName"])(otModel2[i]) === '#root' && Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_0__["getNodeName"])(otModel1[i]) === '#root') {
      ++i;
    }

    if (l > i && Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_0__["isInsertClose"])(otModel2[l - 1]) && Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_0__["isInsertClose"])(otModel1[l - 1]) && Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_0__["getNodeName"])(otModel2[l - 1]) === '#root' && Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_0__["getNodeName"])(otModel1[l - 1]) === '#root') {
      --l;
    }
  }

  for (; i < l; ++i) {
    var o1 = otModel2[i];
    var o2 = otModel1[i];

    if (!Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_0__["areTypesEqual"])(o1, o2)) {
      return false;
    }

    if (Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_0__["isInsertText"])(o1)) {
      if (Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_0__["getText"])(o1) !== Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_0__["getText"])(o2)) {
        return false;
      }
    } else {
      if (ignoreNodeIds ? Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_0__["getNodeName"])(o1) !== Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_0__["getNodeName"])(o2) : Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_0__["getNodeIdAndName"])(o1) !== Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_0__["getNodeIdAndName"])(o2)) {
        return false;
      }
    }

    if (!Object(_teamwork_ot_rich_text_lib_Action__WEBPACK_IMPORTED_MODULE_0__["areAttributesEqual"])(o1, o2)) {
      return false;
    }
  }

  return true;
}

/***/ })

/******/ });
});
//# sourceMappingURL=ot-client.js.map